/* eslint-disable @typescript-eslint/no-loss-of-precision */
export const timezones = [
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [44.86486486486484, 37.207352788788754],
          [44.86486486486484, 36.48663124324321],
          [45.225225225225216, 36.48663124324321],
          [45.225225225225216, 35.94609008408405],
          [45.94594594594594, 35.765909697697666],
          [45.94594594594594, 35.40554892492489],
          [46.30630630630628, 35.225368538538504],
          [45.58558558558556, 34.865007765765725],
          [45.58558558558556, 33.60374506106103],
          [45.94594594594594, 33.60374506106103],
          [45.94594594594594, 32.883023515515475],
          [46.66666666666666, 32.883023515515475],
          [47.027027027027, 32.52266274274271],
          [47.38738738738738, 32.52266274274271],
          [47.38738738738738, 32.16230196996993],
          [47.747747747747724, 32.16230196996993],
          [47.747747747747724, 31.081219651651622],
          [48.1081081081081, 31.081219651651622],
          [48.1081081081081, 30.36049810610608],
          [48.468468468468444, 30.36049810610608],
          [48.468468468468444, 29.819956946946917],
          [48.82882882882882, 29.819956946946917],
          [49.189189189189165, 30.0001373333333],
          [49.54954954954954, 29.819956946946917],
          [49.909909909909885, 29.819956946946917],
          [50.27027027027026, 29.459596174174138],
          [49.909909909909885, 29.279415787787755],
          [50.630630630630606, 28.919055015014976],
          [50.99099099099098, 28.55869424224221],
          [50.99099099099098, 28.01815308308305],
          [51.351351351351354, 27.657792310310285],
          [52.072072072072075, 27.657792310310285],
          [52.43243243243242, 27.477611923923888],
          [52.43243243243242, 27.117251151151123],
          [52.43243243243242, 24.774906128128094],
          [52.072072072072075, 24.774906128128094],
          [51.7117117117117, 24.594725741741712],
          [51.7117117117117, 23.693823809809786],
          [52.072072072072075, 23.693823809809786],
          [52.072072072072075, 23.333463037037006],
          [52.43243243243242, 23.333463037037006],
          [52.43243243243242, 22.973102264264227],
          [52.792792792792795, 22.973102264264227],
          [53.15315315315314, 22.792921877877845],
          [54.234234234234236, 22.792921877877845],
          [54.59459459459458, 22.612741491491462],
          [54.95495495495496, 22.612741491491462],
          [55.3153153153153, 22.792921877877845],
          [55.3153153153153, 22.252380718718683],
          [55.67567567567568, 22.0722003323323],
          [55.67567567567568, 21.53165917317314],
          [55.3153153153153, 21.53165917317314],
          [55.3153153153153, 20.45057685485483],
          [54.95495495495496, 20.45057685485483],
          [54.95495495495496, 19.91003569569567],
          [54.59459459459458, 19.91003569569567],
          [54.234234234234236, 19.729855309309286],
          [53.87387387387386, 19.729855309309286],
          [53.15315315315314, 19.369494536536507],
          [52.792792792792795, 19.369494536536507],
          [52.072072072072075, 19.009133763763728],
          [52.072072072072075, 18.46859260460458],
          [52.43243243243242, 18.288412218218184],
          [52.43243243243242, 17.747871059059037],
          [52.792792792792795, 17.56769067267264],
          [52.792792792792795, 16.846969127127096],
          [53.15315315315314, 16.846969127127096],
          [53.15315315315314, 16.48660835435433],
          [52.43243243243242, 16.126247581581552],
          [52.43243243243242, 13.60372217217214],
          [56.03603603603602, 13.60372217217214],
          [56.03603603603602, 10.540655603603582],
          [52.43243243243242, 10.540655603603582],
          [52.43243243243242, -8.017924194194222],
          [44.86486486486484, -8.017924194194222],
          [44.86486486486484, -10.360269217217237],
          [45.225225225225216, -10.720629989990016],
          [45.58558558558556, -10.900810376376398],
          [46.30630630630628, -10.900810376376398],
          [46.66666666666666, -10.720629989990016],
          [47.747747747747724, -10.720629989990016],
          [48.1081081081081, -10.900810376376398],
          [48.82882882882882, -10.900810376376398],
          [49.189189189189165, -10.54044960360362],
          [49.54954954954954, -10.54044960360362],
          [49.909909909909885, -10.900810376376398],
          [50.27027027027026, -11.08099076276278],
          [52.43243243243242, -11.08099076276278],
          [52.43243243243242, -44.954903403403414],
          [48.82882882882882, -44.954903403403414],
          [48.82882882882882, -46.93688765365366],
          [52.43243243243242, -46.93688765365366],
          [52.43243243243242, -65.85582822422423],
          [51.351351351351354, -65.85582822422423],
          [50.27027027027026, -66.216188996997],
          [49.54954954954954, -66.57654976976977],
          [47.747747747747724, -66.57654976976977],
          [47.38738738738738, -67.11709092892893],
          [45.94594594594594, -67.11709092892893],
          [45.58558558558556, -67.47745170170171],
          [44.86486486486484, -67.47745170170171],
          [44.14414414414412, -67.83781247447448],
          [42.70270270270268, -67.83781247447448],
          [41.98198198198196, -68.01799286086087],
          [41.26126126126124, -68.37835363363364],
          [39.8198198198198, -68.55853402002003],
          [39.09909909909908, -68.9188947927928],
          [39.09909909909908, -69.45943595195196],
          [37.65765765765764, -69.45943595195196],
          [37.65765765765764, -47.11706804004005],
          [37.29729729729729, -47.11706804004005],
          [37.29729729729729, -46.75670726726728],
          [37.65765765765764, -46.57652688088089],
          [37.65765765765764, -17.747665059059074],
          [38.73873873873873, -17.207123899899926],
          [39.09909909909908, -17.207123899899926],
          [39.45945945945945, -17.02694351351353],
          [39.8198198198198, -16.666582740740765],
          [40.18018018018017, -16.486402354354368],
          [40.18018018018017, -15.94586119519522],
          [40.90090090090089, -15.585500422422442],
          [40.90090090090089, -12.342253467467486],
          [40.54054054054052, -11.981892694694722],
          [40.54054054054052, -11.261171149149177],
          [40.90090090090089, -11.08099076276278],
          [40.90090090090089, -10.54044960360362],
          [40.18018018018017, -10.54044960360362],
          [40.18018018018017, -10.900810376376398],
          [39.45945945945945, -10.900810376376398],
          [39.45945945945945, -11.08099076276278],
          [38.73873873873873, -11.08099076276278],
          [38.73873873873873, -11.261171149149177],
          [38.01801801801801, -11.261171149149177],
          [37.65765765765764, -11.621531921921942],
          [35.13513513513513, -11.621531921921942],
          [34.774774774774755, -11.44135153553556],
          [34.774774774774755, -10.54044960360362],
          [34.41441441441441, -10.54044960360362],
          [34.41441441441441, -9.639547671671693],
          [33.333333333333314, -9.639547671671693],
          [32.612612612612594, -9.279186898898928],
          [32.612612612612594, -9.099006512512531],
          [31.891891891891873, -9.099006512512531],
          [31.531531531531527, -8.918826126126149],
          [31.531531531531527, -8.55846535335337],
          [30.810810810810807, -8.55846535335337],
          [30.810810810810807, -7.837743807807826],
          [30.450450450450433, -7.657563421421443],
          [30.450450450450433, -7.117022262262282],
          [30.090090090090087, -7.117022262262282],
          [30.090090090090087, -6.756661489489517],
          [29.729729729729712, -6.756661489489517],
          [29.729729729729712, -6.396300716716738],
          [29.369369369369366, -6.396300716716738],
          [29.369369369369366, -5.855759557557576],
          [29.729729729729712, -5.675579171171194],
          [29.369369369369366, -5.3152183983984145],
          [29.369369369369366, -4.414316466466488],
          [29.729729729729712, -4.414316466466488],
          [30.090090090090087, -4.234136080080106],
          [30.090090090090087, -3.8737753073073264],
          [30.450450450450433, -3.8737753073073264],
          [30.450450450450433, -3.5134145345345615],
          [30.810810810810807, -3.333234148148165],
          [30.810810810810807, -2.9728733753754],
          [30.450450450450433, -2.9728733753754],
          [30.450450450450433, -2.4323322162162384],
          [30.810810810810807, -2.4323322162162384],
          [30.810810810810807, -1.3512498978979153],
          [30.450450450450433, -1.3512498978979153],
          [30.090090090090087, -1.1710695115115328],
          [30.090090090090087, -1.531430284284312],
          [29.729729729729712, -1.531430284284312],
          [29.729729729729712, 0.45055396596593766],
          [30.090090090090087, 0.45055396596593766],
          [30.090090090090087, 1.1712755115114817],
          [31.171171171171153, 1.7118166706706432],
          [31.171171171171153, 2.252357829829805],
          [30.810810810810807, 2.4325382162161873],
          [30.810810810810807, 3.693800920920893],
          [30.450450450450433, 3.8739813073072753],
          [30.090090090090087, 3.8739813073072753],
          [30.090090090090087, 4.234342080080054],
          [29.729729729729712, 4.414522466466437],
          [27.927927927927925, 4.414522466466437],
          [27.927927927927925, 4.774883239239216],
          [27.56756756756755, 4.774883239239216],
          [27.56756756756755, 5.135244012011981],
          [27.207207207207205, 5.135244012011981],
          [27.207207207207205, 5.855965557557525],
          [26.84684684684683, 6.036145943943922],
          [26.486486486486484, 6.036145943943922],
          [26.486486486486484, 6.3965067167166865],
          [26.12612612612611, 6.3965067167166865],
          [26.12612612612611, 7.1172282622622305],
          [25.045045045045043, 7.657769421421392],
          [25.40540540540539, 7.8379498078077745],
          [24.68468468468467, 8.198310580580554],
          [24.324324324324323, 8.198310580580554],
          [24.324324324324323, 8.738851739739715],
          [23.603603603603602, 8.738851739739715],
          [23.603603603603602, 10.180294830830803],
          [23.243243243243228, 10.360475217217186],
          [22.882882882882882, 10.720835989989965],
          [22.882882882882882, 11.441557535535509],
          [22.522522522522507, 11.441557535535509],
          [22.522522522522507, 12.702820240240214],
          [21.801801801801787, 12.702820240240214],
          [21.801801801801787, 13.06318101301298],
          [22.16216216216216, 13.06318101301298],
          [22.16216216216216, 13.96408294494492],
          [22.522522522522507, 13.96408294494492],
          [22.522522522522507, 14.864984876876846],
          [22.882882882882882, 14.864984876876846],
          [22.882882882882882, 15.58570642242239],
          [23.243243243243228, 15.765886808808787],
          [23.96396396396395, 15.765886808808787],
          [23.96396396396395, 19.54967492292289],
          [23.96396396396395, 19.91003569569567],
          [25.045045045045043, 19.91003569569567],
          [25.045045045045043, 20.09021608208205],
          [25.045045045045043, 20.270396468468434],
          [25.045045045045043, 20.45057685485483],
          [25.045045045045043, 20.810937627627595],
          [25.045045045045043, 21.171298400400374],
          [25.045045045045043, 21.351478786786757],
          [25.045045045045043, 21.711839559559536],
          [25.045045045045043, 21.89201994594592],
          [25.045045045045043, 22.0722003323323],
          [31.171171171171153, 22.0722003323323],
          [31.531531531531527, 22.252380718718683],
          [31.531531531531527, 22.0722003323323],
          [36.57657657657657, 22.0722003323323],
          [36.93693693693692, 22.0722003323323],
          [36.93693693693692, 21.89201994594592],
          [37.65765765765764, 21.89201994594592],
          [37.65765765765764, 24.234364968968933],
          [37.29729729729729, 24.234364968968933],
          [37.29729729729729, 24.594725741741712],
          [36.93693693693692, 24.774906128128094],
          [36.93693693693692, 25.315447287287256],
          [36.57657657657657, 25.315447287287256],
          [36.57657657657657, 26.0361688328328],
          [35.85585585585585, 26.756890378378344],
          [35.85585585585585, 27.117251151151123],
          [35.495495495495476, 27.477611923923888],
          [35.13513513513513, 27.657792310310285],
          [35.13513513513513, 28.01815308308305],
          [34.774774774774755, 28.01815308308305],
          [34.41441441441441, 28.198333469469432],
          [34.774774774774755, 28.738874628628594],
          [34.774774774774755, 29.279415787787755],
          [36.216216216216196, 29.279415787787755],
          [36.57657657657657, 29.459596174174138],
          [36.57657657657657, 29.819956946946917],
          [36.93693693693692, 30.0001373333333],
          [37.65765765765764, 30.0001373333333],
          [37.65765765765764, 31.081219651651622],
          [36.93693693693692, 31.441580424424387],
          [37.29729729729729, 31.621760810810784],
          [37.65765765765764, 31.621760810810784],
          [38.01801801801801, 31.801941197197166],
          [38.37837837837836, 31.801941197197166],
          [38.73873873873873, 31.98212158358355],
          [39.09909909909908, 31.98212158358355],
          [39.09909909909908, 32.70284312912909],
          [38.73873873873873, 33.06320390190187],
          [38.73873873873873, 33.42356467467464],
          [41.26126126126124, 34.68482737937934],
          [41.26126126126124, 36.48663124324321],
          [41.98198198198196, 36.66681162962959],
          [42.342342342342334, 36.846992016015975],
          [42.342342342342334, 37.207352788788754],
          [42.70270270270268, 37.387533175175136],
          [43.4234234234234, 37.387533175175136],
          [43.783783783783775, 37.207352788788754],
          [44.14414414414412, 37.387533175175136],
          [44.86486486486484, 37.207352788788754],
        ],
      ],
    },
    properties: {
      objectid: 18,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+3',
      map_color6: 3,
      map_color8: 4,
      note: null,
      zone: 3,
      utc_format: 'UTC+03:00',
      time_zone: 'UTC+03:00',
      iso_8601: '2012-05-31T07:33:50+03:00',
      places:
        'Djibouti, Eritrea, Ethiopia, Iraq, Kenya, Madagasca, Saudi Arabia, South Sudan, Sudan, Somalia, South Sudan, Tanzania, Uganda, Yemen',
      dst_places: null,
      tz_name1st: 'Asia/Riyadh',
      tz_namesum: 19,
      cartodb_id: 81,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [84.14414414414415, 60.81098340540535],
          [84.86486486486484, 60.45062263263259],
          [84.5045045045045, 60.270442246246205],
          [84.5045045045045, 59.91008147347344],
          [85.58558558558559, 59.91008147347344],
          [85.94594594594594, 59.91008147347344],
          [87.02702702702703, 59.91008147347344],
          [88.10810810810807, 59.18935992792788],
          [88.10810810810807, 59.369540314314264],
          [88.82882882882882, 59.0091795415415],
          [88.10810810810807, 58.648818768768734],
          [88.10810810810807, 58.10827760960956],
          [88.82882882882882, 58.10827760960956],
          [89.54954954954951, 57.928097223223176],
          [89.18918918918916, 57.56773645045041],
          [88.46846846846847, 57.027195291291264],
          [88.82882882882882, 57.027195291291264],
          [88.46846846846847, 56.84701490490485],
          [88.46846846846847, 56.48665413213209],
          [89.18918918918916, 56.12629335935932],
          [89.18918918918916, 55.76593258658656],
          [88.46846846846847, 55.405571813813765],
          [88.46846846846847, 55.045211041041],
          [88.82882882882882, 54.86503065465462],
          [88.82882882882882, 54.684850268268235],
          [88.46846846846847, 54.32448949549547],
          [88.82882882882882, 54.32448949549547],
          [89.18918918918916, 54.32448949549547],
          [89.18918918918916, 53.96412872272268],
          [89.18918918918916, 53.783948336336294],
          [88.82882882882882, 53.60376794994991],
          [88.82882882882882, 53.42358756356353],
          [89.18918918918916, 53.24340717717715],
          [88.82882882882882, 52.883046404404354],
          [89.18918918918916, 52.883046404404354],
          [88.46846846846847, 52.162324858858824],
          [88.10810810810807, 51.98214447247244],
          [88.10810810810807, 52.162324858858824],
          [87.74774774774772, 51.80196408608606],
          [88.10810810810807, 51.80196408608606],
          [88.10810810810807, 51.441603313313266],
          [88.46846846846847, 51.26142292692688],
          [88.82882882882882, 51.62178369969965],
          [89.54954954954951, 50.90106215415412],
          [89.54954954954951, 50.54070138138135],
          [89.54954954954951, 50.36052099499497],
          [89.54954954954951, 50.54070138138135],
          [89.54954954954951, 50.18034060860856],
          [89.54954954954951, 49.819979835835795],
          [90.27027027027026, 50.18034060860856],
          [90.6306306306306, 50.18034060860856],
          [91.35135135135135, 50.54070138138135],
          [91.7117117117117, 50.720881767767736],
          [92.07207207207205, 50.720881767767736],
          [92.43243243243239, 50.90106215415412],
          [92.7927927927928, 50.720881767767736],
          [93.15315315315314, 50.54070138138135],
          [94.23423423423424, 50.54070138138135],
          [94.23423423423424, 50.18034060860856],
          [94.59459459459458, 50.00016022222218],
          [94.95495495495493, 50.00016022222218],
          [95.67567567567568, 49.45961906306303],
          [95.67567567567568, 48.919077903903855],
          [95.31531531531527, 48.73889751751747],
          [94.59459459459458, 48.73889751751747],
          [94.23423423423424, 48.73889751751747],
          [93.51351351351349, 48.55871713113109],
          [93.51351351351349, 48.198356358358325],
          [93.15315315315314, 48.198356358358325],
          [93.15315315315314, 47.83799558558556],
          [93.51351351351349, 47.47763481281277],
          [94.23423423423424, 47.11727404004],
          [94.23423423423424, 46.75691326726724],
          [93.51351351351349, 46.576732880880854],
          [93.51351351351349, 45.856011335335296],
          [93.15315315315314, 45.856011335335296],
          [93.15315315315314, 44.955109403403355],
          [92.7927927927928, 44.955109403403355],
          [92.43243243243239, 44.955109403403355],
          [92.07207207207205, 44.955109403403355],
          [92.07207207207205, 45.135289789789766],
          [91.7117117117117, 45.135289789789766],
          [91.35135135135135, 45.135289789789766],
          [90.99099099099095, 45.135289789789766],
          [90.6306306306306, 45.31547017617615],
          [90.6306306306306, 45.675830948948914],
          [90.99099099099095, 46.03619172172168],
          [90.99099099099095, 46.93709365365362],
          [90.6306306306306, 46.93709365365362],
          [90.6306306306306, 47.47763481281277],
          [89.90990990990991, 47.83799558558556],
          [89.54954954954951, 48.01817597197194],
          [89.18918918918916, 48.01817597197194],
          [88.82882882882882, 48.198356358358325],
          [88.82882882882882, 48.01817597197194],
          [88.82882882882882, 48.198356358358325],
          [88.46846846846847, 48.198356358358325],
          [88.46846846846847, 48.37853674474471],
          [88.10810810810807, 48.55871713113109],
          [88.10810810810807, 48.73889751751747],
          [87.74774774774772, 48.73889751751747],
          [87.74774774774772, 49.099258290290265],
          [87.38738738738738, 49.099258290290265],
          [87.02702702702703, 49.45961906306303],
          [85.94594594594594, 49.45961906306303],
          [84.86486486486484, 49.819979835835795],
          [84.86486486486484, 50.18034060860856],
          [84.14414414414415, 50.18034060860856],
          [84.14414414414415, 50.720881767767736],
          [83.78378378378375, 50.90106215415412],
          [82.70270270270271, 50.90106215415412],
          [82.70270270270271, 50.720881767767736],
          [81.26126126126127, 50.720881767767736],
          [80.90090090090087, 50.90106215415412],
          [79.81981981981983, 50.720881767767736],
          [79.81981981981983, 51.26142292692688],
          [79.45945945945942, 51.441603313313266],
          [78.73873873873873, 52.162324858858824],
          [78.73873873873873, 52.52268563163159],
          [78.37837837837839, 52.70286601801797],
          [78.01801801801798, 53.24340717717715],
          [76.57657657657654, 53.96412872272268],
          [75.49549549549548, 54.14430910910906],
          [74.77477477477476, 53.783948336336294],
          [74.77477477477476, 53.60376794994991],
          [73.69369369369369, 53.60376794994991],
          [73.33333333333331, 53.96412872272268],
          [72.25225225225225, 53.96412872272268],
          [71.89189189189187, 54.14430910910906],
          [71.17117117117115, 54.14430910910906],
          [71.17117117117115, 54.86503065465462],
          [70.8108108108108, 54.86503065465462],
          [70.45045045045043, 55.22539142742738],
          [70.45045045045043, 55.94611297297294],
          [70.8108108108108, 55.94611297297294],
          [70.8108108108108, 56.48665413213209],
          [71.53153153153153, 56.66683451851847],
          [71.53153153153153, 57.027195291291264],
          [70.8108108108108, 57.38755606406403],
          [70.45045045045043, 57.928097223223176],
          [71.17117117117115, 58.10827760960956],
          [74.05405405405403, 58.10827760960956],
          [75.85585585585585, 59.0091795415415],
          [75.85585585585585, 59.369540314314264],
          [76.57657657657654, 59.54972070070065],
          [76.57657657657654, 59.91008147347344],
          [76.93693693693695, 60.09026185985982],
          [76.93693693693695, 60.81098340540535],
          [79.45945945945942, 60.81098340540535],
          [79.45945945945942, 60.63080301901897],
          [81.98198198198196, 60.63080301901897],
          [83.06306306306305, 60.99116379179176],
          [83.78378378378375, 60.99116379179176],
          [84.14414414414415, 60.81098340540535],
        ],
      ],
    },
    properties: {
      objectid: 27,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+7',
      map_color6: 5,
      map_color8: 1,
      note: 'Reflects 2012 shift in daylight savings time in Russia.',
      zone: 7,
      utc_format: 'UTC+07:00',
      time_zone: 'UTC+07:00',
      iso_8601: '2012-05-31T11:33:50+07:00',
      places: 'Russia (Novosibirsk Oblast), Mongolia (western part)',
      dst_places: null,
      tz_name1st: 'Asia/Omsk',
      tz_namesum: 4,
      cartodb_id: 82,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-37.657657657657666, 83.69389247647644],
          [-35.495495495495504, 83.87407286286282],
          [-30.090090090090087, 83.87407286286282],
          [-24.324324324324323, 83.51371209009005],
          [-22.522522522522536, 82.97317093093088],
          [-20, 82.7929905445445],
          [-20, 82.43262977177173],
          [-16.756756756756772, 82.07226899899896],
          [-13.15315315315317, 82.07226899899896],
          [-11.351351351351354, 81.89208861261255],
          [-9.909909909909913, 81.3515474534534],
          [-14.59459459459461, 80.27046513513508],
          [-16.03603603603605, 80.0902847487487],
          [-17.477477477477493, 79.54974358958955],
          [-22.882882882882882, 79.54974358958955],
          [-22.882882882882882, 75.94613586186182],
          [-20.72072072072072, 75.94613586186182],
          [-20.360360360360374, 75.76595547547544],
          [-18.198198198198213, 75.76595547547544],
          [-17.117117117117118, 75.58577508908905],
          [-16.396396396396398, 75.04523392992988],
          [-17.477477477477493, 74.50469277077073],
          [-18.198198198198213, 74.50469277077073],
          [-19.27927927927928, 73.96415161161156],
          [-19.639639639639654, 73.42361045245241],
          [-21.44144144144144, 72.52270852052047],
          [-21.44144144144144, 72.34252813413408],
          [-22.16216216216216, 71.98216736136132],
          [-23.963963963963977, 72.34252813413408],
          [-24.684684684684697, 71.08126542942938],
          [-24.684684684684697, 70.54072427027023],
          [-23.963963963963977, 70.36054388388385],
          [-22.522522522522536, 70.36054388388385],
          [-21.801801801801815, 70.18036349749747],
          [-21.801801801801815, 69.82000272472467],
          [-22.522522522522536, 69.63982233833829],
          [-23.963963963963977, 69.27946156556553],
          [-25.045045045045043, 68.73892040640635],
          [-26.126126126126138, 68.37855963363359],
          [-27.207207207207205, 68.37855963363359],
          [-27.56756756756758, 68.1983792472472],
          [-28.648648648648646, 68.1983792472472],
          [-30.090090090090087, 67.83801847447444],
          [-31.531531531531527, 67.83801847447444],
          [-32.61261261261262, 67.47765770170165],
          [-32.61261261261262, 67.11729692892888],
          [-35.13513513513513, 65.85603422422417],
          [-36.57657657657657, 65.49567345145141],
          [-37.657657657657666, 65.31549306506503],
          [-37.657657657657666, 65.13531267867864],
          [-37.657657657657666, -4.414316466466488],
          [-36.57657657657657, -4.95485762562565],
          [-36.216216216216225, -4.95485762562565],
          [-35.85585585585585, -4.774677239239267],
          [-35.495495495495504, -4.95485762562565],
          [-35.13513513513513, -4.95485762562565],
          [-35.13513513513513, -5.675579171171194],
          [-34.774774774774784, -5.855759557557576],
          [-34.774774774774784, -6.936841875875899],
          [-34.41441441441441, -7.297202648648664],
          [-34.41441441441441, -7.657563421421443],
          [-34.774774774774784, -7.837743807807826],
          [-34.774774774774784, -8.918826126126149],
          [-35.13513513513513, -9.099006512512531],
          [-35.13513513513513, -9.279186898898928],
          [-35.495495495495504, -9.639547671671693],
          [-35.495495495495504, -9.819728058058075],
          [-35.85585585585585, -10.180088830830854],
          [-36.216216216216225, -10.360269217217237],
          [-36.216216216216225, -10.720629989990016],
          [-36.57657657657657, -10.900810376376398],
          [-36.936936936936945, -10.900810376376398],
          [-36.936936936936945, -11.44135153553556],
          [-37.29729729729729, -11.44135153553556],
          [-37.29729729729729, -11.981892694694722],
          [-37.657657657657666, -12.342253467467486],
          [-37.657657657657666, -52.16211885885887],
          [-44.86486486486487, -52.16211885885887],
          [-44.86486486486487, -54.86482465465466],
          [-37.657657657657666, -54.86482465465466],
          [-37.657657657657666, -74.86484754354355],
          [-37.657657657657666, -78.1080944984985],
          [-43.06306306306308, -78.1080944984985],
          [-45.225225225225245, -77.56755333933934],
          [-50.27027027027029, -77.56755333933934],
          [-52.432432432432435, -77.02701218018018],
          [-52.432432432432435, -33.42335867467469],
          [-53.153153153153156, -33.78371944744746],
          [-53.153153153153156, -34.14408022022023],
          [-53.513513513513516, -34.50444099299301],
          [-54.95495495495496, -35.225162538538555],
          [-55.31531531531532, -35.044982152152166],
          [-56.03603603603604, -35.044982152152166],
          [-56.75675675675676, -34.86480176576578],
          [-56.75675675675676, -35.58552331131133],
          [-57.11711711711712, -35.76570369769771],
          [-57.11711711711712, -36.12606447047048],
          [-56.3963963963964, -36.12606447047048],
          [-56.3963963963964, -37.026966402402415],
          [-56.75675675675676, -37.207146788788805],
          [-56.75675675675676, -37.56750756156158],
          [-57.11711711711712, -38.10804872072073],
          [-58.55855855855856, -38.82877026626628],
          [-59.27927927927928, -39.008950652652665],
          [-60, -39.008950652652665],
          [-60.36036036036036, -39.189131039039054],
          [-61.44144144144144, -39.189131039039054],
          [-61.8018018018018, -39.36931142542544],
          [-61.8018018018018, -39.9098525845846],
          [-62.16216216216216, -40.09003297097099],
          [-62.16216216216216, -40.45039374374376],
          [-61.8018018018018, -40.45039374374376],
          [-61.8018018018018, -40.81075451651653],
          [-62.88288288288288, -41.351295675675686],
          [-63.96396396396396, -41.351295675675686],
          [-64.6846846846847, -40.990934902902914],
          [-64.6846846846847, -42.07201722122124],
          [-63.96396396396396, -41.89183683483485],
          [-63.24324324324324, -42.25219760760762],
          [-63.24324324324324, -42.972919153153164],
          [-63.6036036036036, -42.972919153153164],
          [-65.04504504504506, -43.69364069869871],
          [-65.04504504504506, -44.77472301701703],
          [-65.40540540540542, -44.77472301701703],
          [-65.40540540540542, -45.1350837897898],
          [-65.76576576576578, -45.315264176176186],
          [-66.84684684684686, -45.315264176176186],
          [-66.84684684684686, -45.67562494894896],
          [-67.20720720720722, -45.67562494894896],
          [-67.20720720720722, -46.39634649449451],
          [-66.12612612612614, -46.93688765365366],
          [-65.40540540540542, -47.11706804004005],
          [-65.40540540540542, -48.19815035835837],
          [-65.76576576576578, -48.19815035835837],
          [-67.20720720720722, -48.91887190390391],
          [-67.20720720720722, -49.459413063063074],
          [-67.56756756756758, -49.999954222222236],
          [-68.2882882882883, -50.36031499499501],
          [-68.64864864864866, -50.36031499499501],
          [-68.64864864864866, -51.62157769969971],
          [-68.2882882882883, -51.801758086086096],
          [-68.2882882882883, -52.52247963163164],
          [-67.92792792792794, -52.88284040440441],
          [-67.92792792792794, -53.243201177177184],
          [-67.56756756756758, -53.60356194994996],
          [-65.76576576576578, -54.50446388188189],
          [-63.6036036036036, -54.50446388188189],
          [-63.6036036036036, -55.04500504104105],
          [-65.40540540540542, -55.04500504104105],
          [-66.12612612612614, -55.225185427427434],
          [-67.20720720720722, -54.86482465465466],
          [-68.2882882882883, -54.86482465465466],
          [-68.64864864864866, -54.86482465465466],
          [-68.64864864864866, -52.70266001801803],
          [-68.2882882882883, -52.34229924524526],
          [-68.64864864864866, -52.16211885885887],
          [-69.72972972972974, -52.16211885885887],
          [-69.72972972972974, -51.981938472472486],
          [-71.8918918918919, -51.981938472472486],
          [-72.25225225225226, -51.62157769969971],
          [-72.25225225225226, -50.54049538138139],
          [-72.61261261261262, -50.54049538138139],
          [-72.61261261261262, -50.72067576776778],
          [-72.61261261261262, -50.54049538138139],
          [-72.97297297297298, -50.72067576776778],
          [-73.33333333333334, -50.72067576776778],
          [-73.33333333333334, -50.18013460860862],
          [-73.6936936936937, -50.18013460860862],
          [-73.6936936936937, -49.459413063063074],
          [-72.61261261261262, -48.91887190390391],
          [-72.61261261261262, -48.37833074474476],
          [-72.25225225225226, -48.37833074474476],
          [-72.25225225225226, -48.017969971971986],
          [-72.61261261261262, -47.8377895855856],
          [-72.25225225225226, -47.477428812812825],
          [-71.8918918918919, -47.11706804004005],
          [-71.8918918918919, -47.297248426426435],
          [-71.8918918918919, -45.495444562562575],
          [-71.53153153153154, -45.495444562562575],
          [-71.53153153153154, -44.954903403403414],
          [-71.8918918918919, -44.954903403403414],
          [-71.8918918918919, -44.77472301701703],
          [-71.53153153153154, -44.77472301701703],
          [-71.17117117117118, -44.77472301701703],
          [-71.17117117117118, -44.41436224424426],
          [-71.8918918918919, -44.41436224424426],
          [-71.8918918918919, -43.69364069869871],
          [-71.8918918918919, -43.513460312312326],
          [-71.8918918918919, -43.333279925925936],
          [-72.25225225225226, -43.153099539539554],
          [-72.25225225225226, -42.25219760760762],
          [-71.8918918918919, -42.07201722122124],
          [-71.8918918918919, -42.25219760760762],
          [-71.8918918918919, -40.45039374374376],
          [-71.53153153153154, -40.27021335735737],
          [-71.8918918918919, -40.27021335735737],
          [-71.8918918918919, -40.09003297097099],
          [-71.53153153153154, -40.09003297097099],
          [-71.53153153153154, -39.549491811811826],
          [-71.53153153153154, -38.82877026626628],
          [-71.17117117117118, -38.82877026626628],
          [-70.81081081081082, -38.82877026626628],
          [-70.81081081081082, -38.46840949349351],
          [-71.17117117117118, -38.28822910710712],
          [-71.17117117117118, -37.026966402402415],
          [-71.17117117117118, -36.66660562962964],
          [-71.17117117117118, -36.48642524324326],
          [-70.81081081081082, -36.48642524324326],
          [-70.45045045045046, -36.12606447047048],
          [-70.45045045045046, -35.9458840840841],
          [-70.45045045045046, -34.684621379379394],
          [-70.0900900900901, -34.684621379379394],
          [-70.0900900900901, -34.32426060660662],
          [-69.72972972972974, -34.32426060660662],
          [-69.72972972972974, -33.96389983383385],
          [-69.72972972972974, -33.243178288288306],
          [-70.0900900900901, -33.243178288288306],
          [-70.0900900900901, -32.34227635635637],
          [-70.45045045045046, -32.34227635635637],
          [-70.45045045045046, -31.9819155835836],
          [-70.45045045045046, -31.80173519719721],
          [-70.45045045045046, -31.081013651651666],
          [-70.45045045045046, -30.720652878878894],
          [-70.0900900900901, -30.360292106106122],
          [-70.0900900900901, -29.99993133333335],
          [-70.0900900900901, -30.180111719719733],
          [-70.0900900900901, -29.099029401401417],
          [-69.72972972972974, -29.099029401401417],
          [-69.72972972972974, -28.378307855855873],
          [-69.36936936936938, -28.198127469469483],
          [-69.00900900900902, -27.83776669669671],
          [-69.00900900900902, -27.117045151151167],
          [-68.64864864864866, -27.117045151151167],
          [-68.2882882882883, -27.117045151151167],
          [-68.2882882882883, -26.936864764764785],
          [-68.64864864864866, -26.576503991992013],
          [-68.64864864864866, -25.135060900900925],
          [-68.2882882882883, -25.135060900900925],
          [-68.64864864864866, -24.954880514514528],
          [-68.64864864864866, -24.594519741741763],
          [-68.2882882882883, -24.594519741741763],
          [-68.2882882882883, -24.414339355355366],
          [-67.56756756756758, -24.0539785825826],
          [-67.20720720720722, -24.0539785825826],
          [-67.20720720720722, -22.792715877877896],
          [-66.84684684684686, -22.612535491491514],
          [-66.84684684684686, -22.252174718718734],
          [-66.4864864864865, -22.252174718718734],
          [-66.4864864864865, -22.071994332332352],
          [-66.12612612612614, -22.071994332332352],
          [-66.12612612612614, -21.711633559559573],
          [-65.76576576576578, -22.071994332332352],
          [-65.40540540540542, -22.071994332332352],
          [-65.04504504504506, -22.071994332332352],
          [-64.6846846846847, -22.252174718718734],
          [-64.32432432432432, -22.432355105105117],
          [-64.32432432432432, -22.792715877877896],
          [-64.32432432432432, -22.432355105105117],
          [-63.96396396396396, -22.071994332332352],
          [-63.6036036036036, -22.071994332332352],
          [-62.88288288288288, -22.071994332332352],
          [-62.52252252252252, -22.252174718718734],
          [-62.16216216216216, -22.432355105105117],
          [-62.16216216216216, -22.612535491491514],
          [-62.16216216216216, -22.97289626426428],
          [-61.8018018018018, -22.97289626426428],
          [-61.8018018018018, -23.333257037037058],
          [-61.44144144144144, -23.51343742342344],
          [-61.08108108108108, -23.51343742342344],
          [-61.08108108108108, -23.87379819619622],
          [-60.72072072072072, -23.87379819619622],
          [-60.36036036036036, -24.0539785825826],
          [-60, -24.0539785825826],
          [-59.63963963963964, -24.414339355355366],
          [-58.55855855855856, -24.954880514514528],
          [-58.1981981981982, -24.954880514514528],
          [-57.83783783783784, -24.954880514514528],
          [-57.83783783783784, -25.315241287287307],
          [-57.47747747747748, -25.315241287287307],
          [-57.47747747747748, -25.675602060060072],
          [-57.83783783783784, -25.675602060060072],
          [-57.83783783783784, -26.03596283283285],
          [-58.1981981981982, -26.216143219219234],
          [-58.1981981981982, -26.576503991992013],
          [-58.1981981981982, -26.756684378378395],
          [-58.55855855855856, -27.117045151151167],
          [-58.55855855855856, -27.297225537537557],
          [-58.1981981981982, -27.297225537537557],
          [-57.83783783783784, -27.297225537537557],
          [-57.47747747747748, -27.47740592392394],
          [-57.11711711711712, -27.47740592392394],
          [-56.75675675675676, -27.47740592392394],
          [-56.3963963963964, -27.65758631031033],
          [-56.3963963963964, -27.297225537537557],
          [-56.03603603603604, -27.297225537537557],
          [-55.67567567567568, -27.47740592392394],
          [-55.67567567567568, -27.117045151151167],
          [-55.31531531531532, -27.117045151151167],
          [-55.31531531531532, -26.936864764764785],
          [-54.95495495495496, -26.936864764764785],
          [-54.95495495495496, -26.576503991992013],
          [-54.5945945945946, -26.576503991992013],
          [-54.5945945945946, -25.675602060060072],
          [-54.5945945945946, -24.954880514514528],
          [-54.234234234234236, -24.774700128128146],
          [-54.234234234234236, -23.693617809809822],
          [-53.873873873873876, -23.693617809809822],
          [-53.873873873873876, -23.333257037037058],
          [-53.513513513513516, -23.153076650650675],
          [-53.513513513513516, -22.792715877877896],
          [-52.792792792792795, -22.432355105105117],
          [-52.432432432432435, -22.252174718718734],
          [-52.432432432432435, -21.89181394594597],
          [-52.072072072072075, -21.89181394594597],
          [-52.072072072072075, -21.53145317317319],
          [-51.71171171171173, -21.351272786786808],
          [-51.71171171171173, -20.630551241241264],
          [-51.351351351351354, -20.630551241241264],
          [-51.351351351351354, -20.270190468468485],
          [-50.99099099099101, -20.270190468468485],
          [-50.99099099099101, -19.36928853653656],
          [-51.351351351351354, -19.36928853653656],
          [-51.71171171171173, -19.189108150150176],
          [-52.432432432432435, -18.828747377377397],
          [-52.432432432432435, -18.648566990991014],
          [-52.792792792792795, -18.648566990991014],
          [-52.792792792792795, -18.288206218218235],
          [-53.153153153153156, -18.468386604604618],
          [-53.153153153153156, -16.846763127127147],
          [-52.792792792792795, -16.846763127127147],
          [-52.792792792792795, -16.306221967967986],
          [-52.432432432432435, -16.306221967967986],
          [-52.432432432432435, -15.94586119519522],
          [-52.072072072072075, -15.765680808808824],
          [-51.71171171171173, -15.585500422422442],
          [-51.71171171171173, -15.04495926326328],
          [-51.351351351351354, -15.04495926326328],
          [-50.99099099099101, -15.04495926326328],
          [-50.99099099099101, -14.144057331331354],
          [-50.99099099099101, -13.603516172172192],
          [-50.630630630630634, -13.603516172172192],
          [-50.630630630630634, -12.882794626626648],
          [-50.630630630630634, -12.522433853853869],
          [-50.630630630630634, -10.360269217217237],
          [-50.27027027027029, -10.360269217217237],
          [-50.27027027027029, -9.819728058058075],
          [-52.072072072072075, -9.819728058058075],
          [-52.792792792792795, -9.639547671671693],
          [-54.95495495495496, -9.639547671671693],
          [-55.67567567567568, -9.45936728528531],
          [-56.3963963963964, -9.45936728528531],
          [-56.75675675675676, -9.45936728528531],
          [-57.11711711711712, -9.279186898898928],
          [-57.11711711711712, -8.918826126126149],
          [-57.47747747747748, -8.918826126126149],
          [-57.47747747747748, -8.55846535335337],
          [-57.83783783783784, -8.55846535335337],
          [-57.83783783783784, -7.477383035035061],
          [-58.1981981981982, -7.477383035035061],
          [-58.1981981981982, -6.936841875875899],
          [-58.55855855855856, -6.936841875875899],
          [-58.55855855855856, -6.57648110310312],
          [-58.1981981981982, -6.57648110310312],
          [-58.1981981981982, -6.035939943943973],
          [-57.83783783783784, -5.675579171171194],
          [-57.83783783783784, -5.3152183983984145],
          [-57.47747747747748, -4.774677239239267],
          [-57.47747747747748, -4.414316466466488],
          [-57.11711711711712, -4.053955693693723],
          [-57.11711711711712, -3.5134145345345615],
          [-56.75675675675676, -3.1530537617617824],
          [-56.75675675675676, -2.7926929889890175],
          [-56.3963963963964, -2.4323322162162384],
          [-56.3963963963964, -2.252151829829856],
          [-56.3963963963964, -2.0719714434434735],
          [-56.75675675675676, -2.252151829829856],
          [-56.75675675675676, -2.0719714434434735],
          [-57.11711711711712, -1.8917910570570768],
          [-57.11711711711712, -1.7116106706706944],
          [-57.47747747747748, -1.7116106706706944],
          [-58.1981981981982, -1.3512498978979153],
          [-58.1981981981982, -1.1710695115115328],
          [-58.55855855855856, -0.9908891251251504],
          [-58.55855855855856, -0.8107087387387679],
          [-58.91891891891892, -0.6305283523523713],
          [-58.91891891891892, 1.3514558978978783],
          [-58.91891891891892, 1.1712755115114817],
          [-58.55855855855856, 1.3514558978978783],
          [-58.1981981981982, 1.5316362842842608],
          [-57.83783783783784, 1.7118166706706432],
          [-57.47747747747748, 1.7118166706706432],
          [-57.47747747747748, 1.8919970570570257],
          [-57.11711711711712, 1.8919970570570257],
          [-57.11711711711712, 2.0721774434434224],
          [-57.11711711711712, 1.8919970570570257],
          [-56.75675675675676, 1.8919970570570257],
          [-56.3963963963964, 1.8919970570570257],
          [-56.75675675675676, 2.0721774434434224],
          [-56.75675675675676, 2.4325382162161873],
          [-57.11711711711712, 2.4325382162161873],
          [-57.11711711711712, 2.612718602602584],
          [-57.11711711711712, 2.7928989889889664],
          [-57.11711711711712, 2.973079375375349],
          [-57.11711711711712, 3.1532597617617313],
          [-57.47747747747748, 3.333440148148128],
          [-57.83783783783784, 3.333440148148128],
          [-57.83783783783784, 4.955063625625598],
          [-57.47747747747748, 4.955063625625598],
          [-57.11711711711712, 4.955063625625598],
          [-57.11711711711712, 5.135244012011981],
          [-57.11711711711712, 5.3154243983983775],
          [-57.11711711711712, 5.135244012011981],
          [-57.11711711711712, 5.3154243983983775],
          [-57.47747747747748, 5.3154243983983775],
          [-57.11711711711712, 5.3154243983983775],
          [-57.11711711711712, 6.036145943943922],
          [-57.11711711711712, 6.216326330330304],
          [-54.5945945945946, 6.216326330330304],
          [-54.234234234234236, 6.036145943943922],
          [-53.873873873873876, 6.036145943943922],
          [-53.153153153153156, 5.6757851711711425],
          [-52.792792792792795, 5.6757851711711425],
          [-52.432432432432435, 5.49560478478476],
          [-52.432432432432435, 47.11727404004],
          [-52.432432432432435, 47.83799558558556],
          [-52.432432432432435, 64.59477151951947],
          [-52.792792792792795, 65.13531267867864],
          [-53.873873873873876, 65.67585383783779],
          [-54.234234234234236, 66.03621461061056],
          [-54.234234234234236, 66.57675576976973],
          [-54.5945945945946, 66.9371165425425],
          [-54.234234234234236, 67.47765770170165],
          [-54.234234234234236, 68.01819886086082],
          [-53.513513513513516, 69.09928117917914],
          [-54.5945945945946, 69.27946156556553],
          [-55.67567567567568, 69.82000272472467],
          [-55.31531531531532, 70.00018311111106],
          [-55.67567567567568, 70.54072427027023],
          [-54.95495495495496, 70.901085043043],
          [-55.31531531531532, 71.26144581581576],
          [-56.3963963963964, 71.44162620220214],
          [-56.3963963963964, 73.42361045245241],
          [-58.1981981981982, 73.96415161161156],
          [-58.1981981981982, 74.68487315715711],
          [-58.91891891891892, 74.8650535435435],
          [-61.44144144144144, 75.94613586186182],
          [-63.6036036036036, 75.94613586186182],
          [-64.6846846846847, 77.38757895295291],
          [-66.4864864864865, 79.18938281681676],
          [-66.4864864864865, 79.91010436236232],
          [-68.64864864864866, 80.0902847487487],
          [-68.64864864864866, 80.27046513513508],
          [-68.2882882882883, 80.45064552152147],
          [-66.12612612612614, 80.81100629429426],
          [-61.44144144144144, 82.07226899899896],
          [-59.63963963963964, 82.25244938538535],
          [-58.55855855855856, 82.43262977177173],
          [-55.67567567567568, 82.43262977177173],
          [-52.432432432432435, 82.61281015815811],
          [-52.432432432432435, 90.00020599999996],
          [-37.657657657657666, 83.69389247647644],
        ],
      ],
    },
    properties: {
      objectid: 12,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-3',
      map_color6: 3,
      map_color8: 6,
      note: null,
      zone: -3,
      utc_format: 'UTC-03:00',
      time_zone: 'UTC-03:00',
      iso_8601: '2012-05-31T01:33:50-03:00',
      places: 'Greenland (central part)',
      dst_places: null,
      tz_name1st: 'America/Sao_Paulo',
      tz_namesum: 23,
      cartodb_id: 84,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-58.55855855855856, -62.43240088288289],
          [-58.55855855855856, -61.89185972372373],
          [-58.1981981981982, -61.89185972372373],
          [-58.1981981981982, -62.43240088288289],
          [-58.55855855855856, -62.43240088288289],
        ],
      ],
    },
    properties: {
      objectid: 0,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-3',
      map_color6: 3,
      map_color8: 6,
      note: null,
      zone: -3,
      utc_format: 'UTC-03:00',
      time_zone: 'UTC-03:00',
      iso_8601: '2012-05-30T16:33:50-03:00',
      places: 'Teniente Jubany Station',
      dst_places: null,
      tz_name1st: null,
      tz_namesum: 0,
      cartodb_id: 118,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [157.65765765765764, 76.66685740740735],
          [156.93693693693695, 76.48667702102097],
          [155.4954954954955, 75.40559470270267],
          [154.4144144144144, 75.04523392992988],
          [154.05405405405406, 74.68487315715711],
          [151.89189189189187, 73.60379083883879],
          [151.53153153153153, 73.24343006606603],
          [146.84684684684686, 73.24343006606603],
          [146.84684684684686, 73.06324967967964],
          [131.7117117117117, 73.06324967967964],
          [131.7117117117117, 71.44162620220214],
          [132.07207207207205, 71.08126542942938],
          [132.07207207207205, 70.36054388388385],
          [132.4324324324324, 70.36054388388385],
          [132.7927927927928, 70.36054388388385],
          [133.15315315315314, 69.82000272472467],
          [133.5135135135135, 69.82000272472467],
          [133.5135135135135, 69.63982233833829],
          [133.15315315315314, 69.63982233833829],
          [132.7927927927928, 69.09928117917914],
          [132.4324324324324, 69.09928117917914],
          [132.4324324324324, 68.91910079279276],
          [133.15315315315314, 68.37855963363359],
          [131.7117117117117, 67.65783808808806],
          [131.35135135135135, 67.65783808808806],
          [130.6306306306306, 67.47765770170165],
          [129.9099099099099, 66.9371165425425],
          [129.9099099099099, 66.57675576976973],
          [130.27027027027026, 66.21639499699697],
          [131.7117117117117, 65.49567345145141],
          [131.7117117117117, 65.31549306506503],
          [132.7927927927928, 64.2344107467467],
          [133.15315315315314, 64.2344107467467],
          [133.5135135135135, 64.2344107467467],
          [133.87387387387383, 64.41459113313309],
          [133.87387387387383, 65.13531267867864],
          [134.23423423423424, 65.13531267867864],
          [134.59459459459458, 64.95513229229226],
          [135.31531531531527, 65.13531267867864],
          [136.03603603603602, 65.49567345145141],
          [137.11711711711712, 65.31549306506503],
          [137.47747747747746, 65.31549306506503],
          [138.19819819819816, 65.49567345145141],
          [138.9189189189189, 65.85603422422417],
          [139.27927927927925, 65.67585383783779],
          [139.27927927927925, 65.85603422422417],
          [139.6396396396396, 65.67585383783779],
          [140, 65.85603422422417],
          [140.36036036036035, 65.49567345145141],
          [139.6396396396396, 65.31549306506503],
          [139.27927927927925, 64.95513229229226],
          [140, 64.59477151951947],
          [140.7207207207207, 64.05423036036032],
          [140.7207207207207, 63.513689201201146],
          [140, 63.513689201201146],
          [139.6396396396396, 63.33350881481476],
          [139.6396396396396, 62.792967655655616],
          [140.36036036036035, 62.61278726926923],
          [140.36036036036035, 62.07224611011006],
          [139.6396396396396, 61.53170495095091],
          [138.9189189189189, 61.53170495095091],
          [138.19819819819816, 61.171344178178146],
          [138.19819819819816, 59.72990108708706],
          [137.47747747747746, 59.72990108708706],
          [137.11711711711712, 59.369540314314264],
          [135.31531531531527, 59.369540314314264],
          [135.31531531531527, 59.18935992792788],
          [133.15315315315314, 59.18935992792788],
          [132.7927927927928, 58.82899915515512],
          [132.4324324324324, 58.82899915515512],
          [131.7117117117117, 58.10827760960956],
          [131.7117117117117, 56.48665413213209],
          [130.99099099099095, 56.48665413213209],
          [130.99099099099095, 55.58575220020015],
          [132.7927927927928, 55.58575220020015],
          [132.7927927927928, 55.22539142742738],
          [130.99099099099095, 54.32448949549547],
          [130.6306306306306, 54.32448949549547],
          [130.6306306306306, 53.783948336336294],
          [131.35135135135135, 53.783948336336294],
          [131.35135135135135, 53.24340717717715],
          [131.7117117117117, 53.063226790790765],
          [132.07207207207205, 53.24340717717715],
          [133.15315315315314, 53.24340717717715],
          [133.15315315315314, 53.42358756356353],
          [134.95495495495493, 53.42358756356353],
          [134.59459459459458, 53.063226790790765],
          [134.59459459459458, 52.52268563163159],
          [133.5135135135135, 52.52268563163159],
          [132.4324324324324, 52.162324858858824],
          [132.4324324324324, 51.80196408608606],
          [131.7117117117117, 51.80196408608606],
          [131.35135135135135, 51.62178369969965],
          [131.35135135135135, 51.26142292692688],
          [130.6306306306306, 51.0812425405405],
          [131.35135135135135, 50.36052099499497],
          [131.35135135135135, 49.27943867667665],
          [130.99099099099095, 49.27943867667665],
          [130.99099099099095, 48.919077903903855],
          [130.6306306306306, 48.919077903903855],
          [130.27027027027026, 48.919077903903855],
          [129.9099099099099, 48.919077903903855],
          [129.9099099099099, 49.27943867667665],
          [129.5495495495495, 49.27943867667665],
          [129.5495495495495, 49.45961906306303],
          [129.18918918918916, 49.27943867667665],
          [129.18918918918916, 49.45961906306303],
          [129.18918918918916, 49.27943867667665],
          [128.82882882882882, 49.45961906306303],
          [128.82882882882882, 49.63979944944941],
          [128.46846846846847, 49.63979944944941],
          [128.46846846846847, 49.45961906306303],
          [128.10810810810807, 49.63979944944941],
          [128.10810810810807, 49.45961906306303],
          [128.10810810810807, 49.63979944944941],
          [127.74774774774772, 49.63979944944941],
          [127.38738738738738, 50.00016022222218],
          [127.38738738738738, 50.720881767767736],
          [127.02702702702703, 50.90106215415412],
          [127.02702702702703, 51.26142292692688],
          [126.66666666666663, 51.26142292692688],
          [126.66666666666663, 52.162324858858824],
          [126.30630630630628, 52.52268563163159],
          [125.94594594594594, 52.52268563163159],
          [125.94594594594594, 52.70286601801797],
          [125.94594594594594, 52.883046404404354],
          [125.58558558558559, 52.883046404404354],
          [125.58558558558559, 53.063226790790765],
          [125.22522522522519, 53.24340717717715],
          [124.86486486486484, 53.063226790790765],
          [124.86486486486484, 53.24340717717715],
          [124.86486486486484, 53.063226790790765],
          [124.86486486486484, 53.24340717717715],
          [124.14414414414415, 53.42358756356353],
          [123.78378378378375, 53.60376794994991],
          [123.4234234234234, 53.60376794994991],
          [123.06306306306305, 53.42358756356353],
          [122.3423423423423, 53.42358756356353],
          [121.98198198198196, 53.42358756356353],
          [121.26126126126127, 53.24340717717715],
          [120.90090090090087, 53.24340717717715],
          [120.18018018018017, 52.52268563163159],
          [120.54054054054052, 52.70286601801797],
          [120.90090090090087, 52.342505245245206],
          [120.54054054054052, 51.98214447247244],
          [120.54054054054052, 51.80196408608606],
          [120.18018018018017, 51.62178369969965],
          [119.81981981981983, 51.26142292692688],
          [119.45945945945942, 50.90106215415412],
          [119.45945945945942, 50.54070138138135],
          [119.09909909909908, 50.36052099499497],
          [119.45945945945942, 50.36052099499497],
          [119.09909909909908, 50.00016022222218],
          [118.73873873873873, 50.00016022222218],
          [118.37837837837839, 49.63979944944941],
          [117.65765765765764, 49.45961906306303],
          [116.93693693693695, 49.63979944944941],
          [116.2162162162162, 50.00016022222218],
          [115.85585585585585, 49.819979835835795],
          [115.4954954954955, 49.819979835835795],
          [114.77477477477476, 50.18034060860856],
          [114.41441441441441, 50.18034060860856],
          [114.41441441441441, 50.36052099499497],
          [113.69369369369366, 50.00016022222218],
          [112.61261261261262, 49.45961906306303],
          [111.53153153153153, 49.45961906306303],
          [111.53153153153153, 49.27943867667665],
          [110.81081081081078, 49.27943867667665],
          [110.81081081081078, 49.099258290290265],
          [110.45045045045043, 49.27943867667665],
          [110.09009009009009, 49.099258290290265],
          [109.72972972972974, 49.27943867667665],
          [109.36936936936934, 49.27943867667665],
          [109.00900900900899, 49.27943867667665],
          [108.64864864864865, 49.27943867667665],
          [107.9279279279279, 49.63979944944941],
          [107.9279279279279, 50.00016022222218],
          [107.56756756756755, 50.00016022222218],
          [107.9279279279279, 50.00016022222218],
          [108.2882882882883, 50.36052099499497],
          [108.2882882882883, 51.26142292692688],
          [108.64864864864865, 51.441603313313266],
          [109.72972972972974, 51.441603313313266],
          [110.81081081081078, 51.80196408608606],
          [111.53153153153153, 51.80196408608606],
          [112.97297297297297, 52.52268563163159],
          [113.69369369369366, 52.52268563163159],
          [114.05405405405406, 52.70286601801797],
          [114.05405405405406, 53.783948336336294],
          [114.41441441441441, 53.96412872272268],
          [115.1351351351351, 53.96412872272268],
          [115.1351351351351, 54.32448949549547],
          [115.4954954954955, 54.50466988188185],
          [116.57657657657654, 54.50466988188185],
          [116.93693693693695, 54.684850268268235],
          [116.93693693693695, 55.22539142742738],
          [116.57657657657654, 55.405571813813765],
          [115.85585585585585, 55.405571813813765],
          [115.85585585585585, 56.84701490490485],
          [117.65765765765764, 56.84701490490485],
          [117.29729729729729, 57.207375677677646],
          [117.29729729729729, 58.10827760960956],
          [117.65765765765764, 58.46863838238235],
          [118.37837837837839, 58.28845799599597],
          [118.73873873873873, 58.46863838238235],
          [118.73873873873873, 59.369540314314264],
          [118.01801801801798, 59.369540314314264],
          [117.29729729729729, 59.54972070070065],
          [117.29729729729729, 60.09026185985982],
          [116.93693693693695, 60.09026185985982],
          [116.2162162162162, 60.45062263263259],
          [115.1351351351351, 60.45062263263259],
          [114.41441441441441, 60.09026185985982],
          [114.41441441441441, 59.72990108708706],
          [113.69369369369366, 59.72990108708706],
          [113.69369369369366, 59.369540314314264],
          [113.33333333333331, 59.18935992792788],
          [112.61261261261262, 59.369540314314264],
          [111.89189189189187, 59.18935992792788],
          [110.45045045045043, 59.18935992792788],
          [109.72972972972974, 59.0091795415415],
          [109.36936936936934, 59.18935992792788],
          [109.36936936936934, 59.72990108708706],
          [109.72972972972974, 59.91008147347344],
          [109.72972972972974, 60.45062263263259],
          [110.45045045045043, 61.171344178178146],
          [109.72972972972974, 61.35152456456453],
          [109.72972972972974, 62.07224611011006],
          [109.36936936936934, 62.43260688288285],
          [109.36936936936934, 63.513689201201146],
          [108.2882882882883, 63.513689201201146],
          [108.2882882882883, 64.2344107467467],
          [107.9279279279279, 64.2344107467467],
          [107.56756756756755, 64.2344107467467],
          [107.2072072072072, 64.2344107467467],
          [106.84684684684686, 64.41459113313309],
          [106.48648648648646, 64.59477151951947],
          [106.12612612612611, 64.41459113313309],
          [106.12612612612611, 64.59477151951947],
          [105.76576576576576, 64.41459113313309],
          [105.76576576576576, 64.59477151951947],
          [105.76576576576576, 64.77495190590585],
          [106.12612612612611, 64.77495190590585],
          [106.12612612612611, 64.95513229229226],
          [106.12612612612611, 64.77495190590585],
          [106.48648648648646, 65.13531267867864],
          [106.48648648648646, 65.31549306506503],
          [106.84684684684686, 65.31549306506503],
          [106.48648648648646, 65.67585383783779],
          [106.48648648648646, 66.21639499699697],
          [106.12612612612611, 66.21639499699697],
          [106.48648648648646, 66.57675576976973],
          [106.12612612612611, 66.75693615615612],
          [105.76576576576576, 66.9371165425425],
          [106.48648648648646, 67.29747731531526],
          [106.84684684684686, 67.29747731531526],
          [106.84684684684686, 68.91910079279276],
          [106.12612612612611, 69.27946156556553],
          [106.48648648648646, 69.63982233833829],
          [106.48648648648646, 69.45964195195191],
          [107.9279279279279, 69.63982233833829],
          [108.2882882882883, 69.82000272472467],
          [108.64864864864865, 69.82000272472467],
          [109.00900900900899, 69.82000272472467],
          [109.72972972972974, 70.36054388388385],
          [110.09009009009009, 70.36054388388385],
          [110.09009009009009, 70.54072427027023],
          [110.45045045045043, 70.72090465665661],
          [110.81081081081078, 70.72090465665661],
          [110.81081081081078, 70.901085043043],
          [110.81081081081078, 70.72090465665661],
          [112.25225225225222, 71.08126542942938],
          [112.61261261261262, 71.08126542942938],
          [112.61261261261262, 71.26144581581576],
          [111.89189189189187, 71.44162620220214],
          [111.89189189189187, 72.1623477477477],
          [111.53153153153153, 72.34252813413408],
          [110.81081081081078, 72.52270852052047],
          [110.81081081081078, 73.60379083883879],
          [111.53153153153153, 73.96415161161156],
          [111.17117117117118, 74.32451238438435],
          [112.97297297297297, 74.8650535435435],
          [114.41441441441441, 75.04523392992988],
          [114.41441441441441, 77.92812011211205],
          [120.54054054054052, 77.92812011211205],
          [121.26126126126127, 78.28848088488485],
          [124.86486486486484, 79.18938281681676],
          [127.38738738738738, 79.91010436236232],
          [142.52252252252248, 79.91010436236232],
          [142.52252252252248, 90.00020599999996],
          [157.65765765765764, 84.95515518118114],
          [157.65765765765764, 76.66685740740735],
        ],
      ],
    },
    properties: {
      objectid: 31,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+10',
      map_color6: 2,
      map_color8: 5,
      note: 'Reflects 2012 shift in daylight savings time in Russia.',
      zone: 10,
      utc_format: 'UTC+10:00',
      time_zone: 'UTC+10:00',
      iso_8601: '2012-05-31T14:33:50+10:00',
      places: 'Russia (Zabaykalsky Krai)',
      dst_places: null,
      tz_name1st: 'Asia/Yakutsk',
      tz_namesum: 1,
      cartodb_id: 26,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [172.4324324324324, 51.80196408608606],
          [172.4324324324324, 50.720881767767736],
          [172.4324324324324, 20.810937627627595],
          [160.54054054054052, 20.810937627627595],
          [160.54054054054052, 8.018130194194171],
          [164.14414414414415, 8.018130194194171],
          [164.14414414414415, -2.4323322162162384],
          [172.4324324324324, -2.4323322162162384],
          [172.4324324324324, -32.702637129129144],
          [171.35135135135135, -33.78371944744746],
          [171.35135135135135, -34.14408022022023],
          [170.6306306306306, -34.86480176576578],
          [170.6306306306306, -35.40534292492494],
          [169.9099099099099, -36.12606447047048],
          [169.9099099099099, -36.48642524324326],
          [169.5495495495495, -36.84678601601603],
          [168.82882882882882, -37.74768794794796],
          [168.82882882882882, -38.10804872072073],
          [168.10810810810807, -39.008950652652665],
          [168.10810810810807, -39.36931142542544],
          [167.74774774774772, -39.9098525845846],
          [167.02702702702703, -40.63057413013014],
          [167.02702702702703, -41.171115289289304],
          [165.94594594594594, -42.25219760760762],
          [165.94594594594594, -42.61255838038039],
          [165.2252252252252, -43.513460312312326],
          [165.2252252252252, -54.50446388188189],
          [169.9099099099099, -54.50446388188189],
          [172.4324324324324, -54.50446388188189],
          [172.4324324324324, -77.56755333933934],
          [170.27027027027026, -77.56755333933934],
          [169.5495495495495, -77.20719256656658],
          [167.74774774774772, -77.20719256656658],
          [167.74774774774772, -76.8468317937938],
          [165.94594594594594, -76.8468317937938],
          [165.5855855855856, -77.38737295295296],
          [163.78378378378375, -77.02701218018018],
          [163.78378378378375, -76.30629063463464],
          [163.4234234234234, -75.94592986186187],
          [163.78378378378375, -75.58556908908909],
          [163.4234234234234, -75.04502792992993],
          [164.5045045045045, -74.86484754354355],
          [165.94594594594594, -74.86484754354355],
          [165.94594594594594, -73.96394561161162],
          [166.30630630630628, -73.96394561161162],
          [168.46846846846847, -73.42340445245246],
          [169.18918918918916, -73.78376522522524],
          [170.27027027027026, -73.78376522522524],
          [170.6306306306306, -73.42340445245246],
          [170.27027027027026, -73.06304367967968],
          [170.99099099099095, -72.70268290690692],
          [170.99099099099095, -72.16214174774775],
          [171.35135135135135, -71.98196136136137],
          [170.6306306306306, -71.08105942942943],
          [169.18918918918916, -71.08105942942943],
          [166.66666666666663, -70.36033788388389],
          [164.14414414414415, -70.36033788388389],
          [164.14414414414415, -70.1801574974975],
          [162.3423423423423, -70.1801574974975],
          [161.98198198198196, -69.99997711111112],
          [160.90090090090087, -69.99997711111112],
          [160.90090090090087, -69.63961633833834],
          [159.09909909909908, -69.09907517917918],
          [157.65765765765764, -69.09907517917918],
          [157.65765765765764, -12.162073081081104],
          [157.2972972972973, -11.801712308308325],
          [157.2972972972973, -11.44135153553556],
          [156.2162162162162, -10.360269217217237],
          [156.2162162162162, -9.999908444444472],
          [155.4954954954955, -9.279186898898928],
          [155.1351351351351, -9.099006512512531],
          [155.1351351351351, -8.738645739739766],
          [154.77477477477476, -8.378284966966987],
          [154.4144144144144, -8.198104580580605],
          [154.77477477477476, -7.657563421421443],
          [155.4954954954955, -6.936841875875899],
          [155.85585585585585, -6.936841875875899],
          [155.85585585585585, -6.57648110310312],
          [156.93693693693695, -6.035939943943973],
          [157.2972972972973, -5.675579171171194],
          [157.65765765765764, -5.495398784784811],
          [158.01801801801798, -5.135038012012032],
          [158.73873873873873, -4.774677239239267],
          [160.18018018018017, -4.774677239239267],
          [160.18018018018017, -3.5134145345345615],
          [157.65765765765764, -3.5134145345345615],
          [157.65765765765764, -0.0899871931932239],
          [154.05405405405406, -0.0899871931932239],
          [154.05405405405406, 11.98209869469467],
          [157.65765765765764, 11.98209869469467],
          [157.65765765765764, 50.00016022222218],
          [165.5855855855856, 50.00016022222218],
          [166.30630630630628, 50.54070138138135],
          [167.02702702702703, 50.90106215415412],
          [167.38738738738738, 51.26142292692688],
          [168.10810810810807, 51.62178369969965],
          [168.82882882882882, 52.162324858858824],
          [169.5495495495495, 52.52268563163159],
          [169.5495495495495, 52.883046404404354],
          [169.9099099099099, 53.063226790790765],
          [172.4324324324324, 51.80196408608606],
        ],
        [
          [167.02702702702703, -28.0179470830831],
          [167.02702702702703, -29.99993133333335],
          [169.5495495495495, -29.99993133333335],
          [169.5495495495495, -28.0179470830831],
          [167.02702702702703, -28.0179470830831],
        ],
        [
          [158.3783783783784, -31.081013651651666],
          [158.3783783783784, -31.9819155835836],
          [159.45945945945942, -31.9819155835836],
          [159.45945945945942, -31.081013651651666],
          [158.3783783783784, -31.081013651651666],
        ],
      ],
    },
    properties: {
      objectid: 33,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+11',
      map_color6: 1,
      map_color8: 6,
      note: null,
      zone: 11,
      utc_format: 'UTC+11:00',
      time_zone: 'UTC+11:00',
      iso_8601: '2012-05-31T15:33:50+11:00',
      places: 'New Caledonia, Solomon Islands',
      dst_places: null,
      tz_name1st: 'Pacific/Guadalcanal',
      tz_namesum: 6,
      cartodb_id: 27,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [154.05405405405406, 47.65781519919915],
          [153.33333333333331, 47.11727404004],
          [152.61261261261262, 46.93709365365362],
          [151.53153153153153, 46.03619172172168],
          [149.72972972972974, 45.135289789789766],
          [148.64864864864865, 44.234387857857826],
          [147.56756756756755, 43.87402708508506],
          [146.48648648648646, 43.333485925925885],
          [145.76576576576576, 43.1533055395395],
          [145.76576576576576, 43.51366631231227],
          [145.40540540540542, 43.51366631231227],
          [145.40540540540542, 44.41456824424421],
          [144.68468468468467, 44.234387857857826],
          [143.60360360360357, 44.41456824424421],
          [142.88288288288288, 44.77492901701697],
          [142.52252252252248, 45.135289789789766],
          [142.52252252252248, 45.675830948948914],
          [141.8018018018018, 45.675830948948914],
          [141.08108108108104, 45.856011335335296],
          [141.08108108108104, 46.39655249449444],
          [141.8018018018018, 46.75691326726724],
          [141.8018018018018, 48.919077903903855],
          [141.8018018018018, 51.26142292692688],
          [141.44144144144144, 51.62178369969965],
          [141.08108108108104, 51.441603313313266],
          [141.08108108108104, 50.90106215415412],
          [140.7207207207207, 50.720881767767736],
          [140.7207207207207, 50.36052099499497],
          [141.08108108108104, 50.00016022222218],
          [140.7207207207207, 49.819979835835795],
          [140.7207207207207, 48.919077903903855],
          [140.36036036036035, 48.73889751751747],
          [140.36036036036035, 48.198356358358325],
          [139.6396396396396, 47.65781519919915],
          [139.27927927927925, 47.65781519919915],
          [139.27927927927925, 47.11727404004],
          [138.55855855855856, 46.75691326726724],
          [138.55855855855856, 46.39655249449444],
          [138.19819819819816, 46.21637210810806],
          [138.19819819819816, 45.856011335335296],
          [137.47747747747746, 45.49565056256253],
          [137.47747747747746, 45.31547017617615],
          [136.75675675675672, 44.955109403403355],
          [136.75675675675672, 44.59474863063059],
          [136.03603603603602, 44.234387857857826],
          [135.67567567567568, 43.69384669869865],
          [134.95495495495493, 43.333485925925885],
          [134.95495495495493, 43.1533055395395],
          [133.87387387387383, 42.612764380380355],
          [132.07207207207205, 42.612764380380355],
          [131.7117117117117, 42.432583993993944],
          [130.99099099099095, 42.432583993993944],
          [130.6306306306306, 42.612764380380355],
          [130.27027027027026, 42.612764380380355],
          [130.6306306306306, 42.79294476676674],
          [130.99099099099095, 42.79294476676674],
          [130.99099099099095, 42.97312515315312],
          [131.35135135135135, 43.1533055395395],
          [131.35135135135135, 44.05420747147144],
          [130.99099099099095, 44.41456824424421],
          [130.99099099099095, 44.955109403403355],
          [131.35135135135135, 44.955109403403355],
          [131.7117117117117, 45.31547017617615],
          [132.07207207207205, 45.31547017617615],
          [132.7927927927928, 44.955109403403355],
          [133.15315315315314, 45.135289789789766],
          [133.15315315315314, 45.49565056256253],
          [133.5135135135135, 45.49565056256253],
          [133.5135135135135, 45.856011335335296],
          [133.87387387387383, 46.21637210810806],
          [133.87387387387383, 46.39655249449444],
          [133.87387387387383, 46.75691326726724],
          [134.23423423423424, 46.93709365365362],
          [134.23423423423424, 47.47763481281277],
          [134.59459459459458, 47.47763481281277],
          [134.59459459459458, 48.198356358358325],
          [134.59459459459458, 48.37853674474471],
          [134.23423423423424, 48.37853674474471],
          [133.87387387387383, 48.198356358358325],
          [133.5135135135135, 48.01817597197194],
          [133.15315315315314, 48.01817597197194],
          [133.15315315315314, 48.198356358358325],
          [132.7927927927928, 48.01817597197194],
          [132.4324324324324, 47.65781519919915],
          [132.07207207207205, 47.65781519919915],
          [131.7117117117117, 47.65781519919915],
          [131.35135135135135, 47.65781519919915],
          [130.99099099099095, 47.65781519919915],
          [130.6306306306306, 48.01817597197194],
          [130.99099099099095, 48.37853674474471],
          [130.6306306306306, 48.55871713113109],
          [130.6306306306306, 48.919077903903855],
          [130.99099099099095, 48.919077903903855],
          [130.99099099099095, 49.27943867667665],
          [131.35135135135135, 49.27943867667665],
          [131.35135135135135, 50.36052099499497],
          [130.6306306306306, 51.0812425405405],
          [131.35135135135135, 51.26142292692688],
          [131.35135135135135, 51.62178369969965],
          [131.7117117117117, 51.80196408608606],
          [132.4324324324324, 51.80196408608606],
          [132.4324324324324, 52.162324858858824],
          [133.5135135135135, 52.52268563163159],
          [134.59459459459458, 52.52268563163159],
          [134.59459459459458, 53.063226790790765],
          [134.95495495495493, 53.42358756356353],
          [133.15315315315314, 53.42358756356353],
          [133.15315315315314, 53.24340717717715],
          [132.07207207207205, 53.24340717717715],
          [131.7117117117117, 53.063226790790765],
          [131.35135135135135, 53.24340717717715],
          [131.35135135135135, 53.783948336336294],
          [130.6306306306306, 53.783948336336294],
          [130.6306306306306, 54.32448949549547],
          [130.99099099099095, 54.32448949549547],
          [132.7927927927928, 55.22539142742738],
          [132.7927927927928, 55.58575220020015],
          [130.99099099099095, 55.58575220020015],
          [130.99099099099095, 56.48665413213209],
          [131.7117117117117, 56.48665413213209],
          [131.7117117117117, 58.10827760960956],
          [132.4324324324324, 58.82899915515512],
          [132.7927927927928, 58.82899915515512],
          [133.15315315315314, 59.18935992792788],
          [135.31531531531527, 59.18935992792788],
          [135.31531531531527, 59.369540314314264],
          [137.11711711711712, 59.369540314314264],
          [137.47747747747746, 59.72990108708706],
          [138.19819819819816, 59.72990108708706],
          [138.19819819819816, 61.171344178178146],
          [138.9189189189189, 61.53170495095091],
          [139.6396396396396, 61.53170495095091],
          [140.36036036036035, 62.07224611011006],
          [140.36036036036035, 62.61278726926923],
          [139.6396396396396, 62.792967655655616],
          [139.6396396396396, 63.33350881481476],
          [140, 63.513689201201146],
          [140.7207207207207, 63.513689201201146],
          [140.7207207207207, 64.05423036036032],
          [140, 64.59477151951947],
          [139.27927927927925, 64.95513229229226],
          [139.6396396396396, 65.31549306506503],
          [140.36036036036035, 65.49567345145141],
          [141.8018018018018, 65.49567345145141],
          [144.32432432432432, 64.95513229229226],
          [145.76576576576576, 64.2344107467467],
          [146.1261261261261, 63.87404997397394],
          [145.40540540540542, 63.69386958758756],
          [145.40540540540542, 62.07224611011006],
          [146.1261261261261, 62.07224611011006],
          [146.48648648648646, 61.892065723723675],
          [146.48648648648646, 60.63080301901897],
          [145.76576576576576, 60.63080301901897],
          [145.76576576576576, 60.270442246246205],
          [146.48648648648646, 60.270442246246205],
          [146.48648648648646, 59.91008147347344],
          [147.2072072072072, 59.91008147347344],
          [147.2072072072072, 59.369540314314264],
          [146.84684684684686, 59.369540314314264],
          [146.84684684684686, 54.50466988188185],
          [149.009009009009, 52.342505245245206],
          [149.36936936936934, 52.162324858858824],
          [151.89189189189187, 49.63979944944941],
          [152.25225225225222, 49.45961906306303],
          [154.05405405405406, 47.65781519919915],
        ],
      ],
    },
    properties: {
      objectid: 33,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+11',
      map_color6: 1,
      map_color8: 6,
      note: 'Reflects 2012 shift in daylight savings time in Russia.',
      zone: 11,
      utc_format: 'UTC+11:00',
      time_zone: 'UTC+11:00',
      iso_8601: '2012-05-31T15:33:50+11:00',
      places: 'Russia (Primorsky Krai)',
      dst_places: null,
      tz_name1st: 'Asia/Vladivostok',
      tz_namesum: 2,
      cartodb_id: 28,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-22.522522522522536, 69.63982233833829],
          [-22.522522522522536, 66.75693615615612],
          [-22.882882882882882, 66.75693615615612],
          [-23.963963963963977, 66.21639499699697],
          [-24.324324324324323, 65.85603422422417],
          [-25.045045045045043, 65.67585383783779],
          [-24.684684684684697, 65.31549306506503],
          [-24.324324324324323, 65.31549306506503],
          [-24.324324324324323, 64.59477151951947],
          [-22.882882882882882, 64.59477151951947],
          [-23.243243243243256, 64.2344107467467],
          [-23.243243243243256, 63.69386958758756],
          [-22.522522522522536, 63.69386958758756],
          [-22.522522522522536, 40.270419357357326],
          [-31.891891891891902, 40.270419357357326],
          [-31.891891891891902, 36.48663124324321],
          [-22.522522522522536, 36.48663124324321],
          [-22.522522522522536, 18.46859260460458],
          [-27.56756756756758, 18.46859260460458],
          [-27.56756756756758, 13.423541785785758],
          [-22.522522522522536, 13.423541785785758],
          [-22.522522522522536, -75.40538870270271],
          [-23.243243243243256, -75.58556908908909],
          [-24.684684684684697, -75.58556908908909],
          [-25.045045045045043, -75.58556908908909],
          [-25.765765765765764, -75.58556908908909],
          [-26.84684684684686, -75.94592986186187],
          [-27.927927927927925, -75.94592986186187],
          [-28.2882882882883, -76.12611024824825],
          [-29.369369369369366, -76.12611024824825],
          [-31.17117117117118, -76.66665140740741],
          [-31.891891891891902, -76.66665140740741],
          [-33.69369369369369, -77.02701218018018],
          [-35.495495495495504, -77.38737295295296],
          [-36.936936936936945, -78.1080944984985],
          [-37.657657657657666, -78.1080944984985],
          [-37.657657657657666, -74.86484754354355],
          [-37.657657657657666, -54.86482465465466],
          [-44.86486486486487, -54.86482465465466],
          [-44.86486486486487, -52.16211885885887],
          [-37.657657657657666, -52.16211885885887],
          [-37.657657657657666, -12.342253467467486],
          [-37.29729729729729, -11.981892694694722],
          [-37.29729729729729, -11.44135153553556],
          [-36.936936936936945, -11.44135153553556],
          [-36.936936936936945, -10.900810376376398],
          [-36.57657657657657, -10.900810376376398],
          [-36.216216216216225, -10.720629989990016],
          [-36.216216216216225, -10.360269217217237],
          [-35.85585585585585, -10.180088830830854],
          [-35.495495495495504, -9.819728058058075],
          [-35.495495495495504, -9.639547671671693],
          [-35.13513513513513, -9.279186898898928],
          [-35.13513513513513, -9.099006512512531],
          [-34.774774774774784, -8.918826126126149],
          [-34.774774774774784, -7.837743807807826],
          [-34.41441441441441, -7.657563421421443],
          [-34.41441441441441, -7.297202648648664],
          [-34.774774774774784, -6.936841875875899],
          [-34.774774774774784, -5.855759557557576],
          [-35.13513513513513, -5.675579171171194],
          [-35.13513513513513, -4.95485762562565],
          [-35.495495495495504, -4.95485762562565],
          [-35.85585585585585, -4.774677239239267],
          [-36.216216216216225, -4.95485762562565],
          [-36.57657657657657, -4.95485762562565],
          [-37.657657657657666, -4.414316466466488],
          [-37.657657657657666, 65.13531267867864],
          [-37.657657657657666, 65.31549306506503],
          [-36.57657657657657, 65.49567345145141],
          [-35.13513513513513, 65.85603422422417],
          [-32.61261261261262, 67.11729692892888],
          [-32.61261261261262, 67.47765770170165],
          [-31.531531531531527, 67.83801847447444],
          [-30.090090090090087, 67.83801847447444],
          [-28.648648648648646, 68.1983792472472],
          [-27.56756756756758, 68.1983792472472],
          [-27.207207207207205, 68.37855963363359],
          [-26.126126126126138, 68.37855963363359],
          [-25.045045045045043, 68.73892040640635],
          [-23.963963963963977, 69.27946156556553],
          [-22.522522522522536, 69.63982233833829],
        ],
      ],
    },
    properties: {
      objectid: 13,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-2',
      map_color6: 2,
      map_color8: 7,
      note: null,
      zone: -2,
      utc_format: 'UTC-02:00',
      time_zone: 'UTC-02:00',
      iso_8601: '2012-05-31T02:33:50-02:00',
      places:
        'Brazil (Fernando de Noronha), South Georgia and the South Sandwich Islands',
      dst_places: null,
      tz_name1st: 'Atlantic/South_Georgia',
      tz_namesum: 3,
      cartodb_id: 19,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [7.387387387387378, -69.99997711111112],
          [3.7837837837837753, -69.99997711111112],
          [1.98198198198196, -70.36033788388389],
          [1.98198198198196, -69.81979672472474],
          [0.540540540540519, -69.81979672472474],
          [0.180180180180173, -70.1801574974975],
          [1.621621621621614, -70.90087904304305],
          [0.540540540540519, -70.90087904304305],
          [-0.18018018018020143, -71.26123981581583],
          [-1.9819819819819884, -70.54051827027027],
          [-1.9819819819819884, -70.1801574974975],
          [-2.702702702702709, -69.99997711111112],
          [-4.14414414414415, -70.36033788388389],
          [-4.14414414414415, -71.08105942942943],
          [-5.225225225225245, -71.08105942942943],
          [-4.86486486486487, -70.72069865665667],
          [-5.585585585585591, -70.36033788388389],
          [-6.666666666666686, -70.1801574974975],
          [-7.387387387387406, -70.54051827027027],
          [-7.387387387387406, -41.71165644844846],
          [-14.59459459459461, -41.71165644844846],
          [-14.59459459459461, -35.58552331131133],
          [-7.387387387387406, -35.58552331131133],
          [-7.387387387387406, -9.279186898898928],
          [-16.03603603603605, -9.279186898898928],
          [-16.03603603603605, -5.855759557557576],
          [-7.387387387387406, -5.855759557557576],
          [-7.387387387387406, 4.054161693693672],
          [-7.747747747747752, 4.234342080080054],
          [-8.108108108108127, 4.234342080080054],
          [-8.468468468468473, 4.414522466466437],
          [-8.468468468468473, 4.5947028528528335],
          [-8.828828828828847, 4.774883239239216],
          [-9.189189189189193, 4.774883239239216],
          [-9.549549549549567, 5.135244012011981],
          [-9.909909909909913, 5.3154243983983775],
          [-9.909909909909913, 5.6757851711711425],
          [-10.630630630630634, 6.036145943943922],
          [-10.990990990991008, 6.036145943943922],
          [-10.990990990991008, 6.3965067167166865],
          [-11.351351351351354, 6.576687103103083],
          [-11.711711711711729, 6.576687103103083],
          [-11.711711711711729, 6.937047875875848],
          [-12.072072072072075, 7.1172282622622305],
          [-12.792792792792795, 7.1172282622622305],
          [-13.15315315315317, 7.297408648648627],
          [-13.15315315315317, 8.018130194194171],
          [-13.513513513513516, 8.198310580580554],
          [-13.513513513513516, 9.279392898898877],
          [-13.87387387387389, 9.279392898898877],
          [-13.87387387387389, 9.639753671671642],
          [-14.234234234234236, 10.00011444444442],
          [-14.954954954954957, 10.360475217217186],
          [-15.315315315315331, 10.720835989989965],
          [-15.315315315315331, 10.901016376376347],
          [-16.396396396396398, 10.901016376376347],
          [-16.396396396396398, 11.261377149149126],
          [-16.756756756756772, 11.441557535535509],
          [-16.756756756756772, 12.162279081081053],
          [-17.117117117117118, 12.342459467467435],
          [-17.117117117117118, 14.324443717717685],
          [-17.83783783783784, 14.684804490490464],
          [-17.477477477477493, 15.045165263263229],
          [-17.117117117117118, 15.045165263263229],
          [-17.117117117117118, 15.405526036036008],
          [-16.756756756756772, 15.765886808808787],
          [-16.756756756756772, 16.666788740740714],
          [-16.396396396396398, 17.02714951351348],
          [-16.396396396396398, 19.009133763763728],
          [-16.756756756756772, 19.009133763763728],
          [-16.756756756756772, 19.91003569569567],
          [-16.396396396396398, 19.91003569569567],
          [-16.396396396396398, 20.270396468468434],
          [-17.477477477477493, 20.810937627627595],
          [-17.477477477477493, 20.991118014013978],
          [-17.117117117117118, 21.351478786786757],
          [-17.117117117117118, 22.252380718718683],
          [-16.756756756756772, 22.43256110510508],
          [-16.396396396396398, 22.792921877877845],
          [-16.396396396396398, 23.153282650650624],
          [-16.03603603603605, 23.51364342342339],
          [-16.03603603603605, 24.05418458258255],
          [-15.675675675675677, 24.41454535535533],
          [-14.954954954954957, 24.774906128128094],
          [-14.954954954954957, 25.855988446446418],
          [-14.59459459459461, 26.0361688328328],
          [-14.59459459459461, 26.39652960560558],
          [-13.87387387387389, 26.756890378378344],
          [-13.513513513513516, 27.117251151151123],
          [-18.55855855855856, 27.117251151151123],
          [-18.55855855855856, 33.06320390190187],
          [-18.198198198198213, 33.243384288288254],
          [-16.396396396396398, 35.04518815215212],
          [-16.03603603603605, 35.225368538538504],
          [-13.87387387387389, 37.387533175175136],
          [-13.513513513513516, 37.56771356156153],
          [-11.711711711711729, 39.369517425425386],
          [-11.351351351351354, 39.54969781181177],
          [-9.189189189189193, 41.711862448448414],
          [-9.189189189189193, 41.8920428348348],
          [-8.828828828828847, 42.07222322122118],
          [-8.108108108108127, 42.07222322122118],
          [-8.108108108108127, 41.8920428348348],
          [-6.666666666666686, 41.8920428348348],
          [-6.306306306306311, 41.711862448448414],
          [-6.306306306306311, 41.35150167567565],
          [-6.666666666666686, 41.35150167567565],
          [-6.666666666666686, 40.270419357357326],
          [-7.027027027027032, 40.270419357357326],
          [-7.027027027027032, 39.72987819819815],
          [-7.387387387387406, 39.72987819819815],
          [-7.387387387387406, 39.189337039039],
          [-7.027027027027032, 39.189337039039],
          [-7.027027027027032, 38.82897626626624],
          [-7.387387387387406, 38.82897626626624],
          [-7.387387387387406, 38.28843510710706],
          [-7.027027027027032, 38.28843510710706],
          [-7.027027027027032, 37.9280743343343],
          [-7.387387387387406, 37.9280743343343],
          [-7.387387387387406, 37.02717240240237],
          [-6.666666666666686, 36.846992016015975],
          [-6.666666666666686, 36.48663124324321],
          [-6.306306306306311, 36.30645085685683],
          [-6.306306306306311, 35.94609008408405],
          [-4.86486486486487, 35.94609008408405],
          [-4.86486486486487, 35.58572931131128],
          [-4.504504504504524, 35.40554892492489],
          [-3.4234234234234293, 35.40554892492489],
          [-2.702702702702709, 35.58572931131128],
          [-2.342342342342363, 35.40554892492489],
          [-2.342342342342363, 35.04518815215212],
          [-1.6216216216216424, 34.68482737937934],
          [-1.6216216216216424, 32.883023515515475],
          [-1.261261261261268, 32.52266274274271],
          [-1.261261261261268, 32.16230196996993],
          [-2.702702702702709, 32.16230196996993],
          [-3.7837837837838038, 31.621760810810784],
          [-3.7837837837838038, 30.901039265265226],
          [-4.14414414414415, 30.901039265265226],
          [-4.86486486486487, 30.54067849249246],
          [-4.86486486486487, 30.36049810610608],
          [-5.585585585585591, 30.0001373333333],
          [-5.585585585585591, 29.819956946946917],
          [-6.666666666666686, 29.819956946946917],
          [-8.828828828828847, 28.738874628628594],
          [-8.828828828828847, 27.297431537537506],
          [-7.027027027027032, 26.39652960560558],
          [-7.027027027027032, 26.216349219219182],
          [-4.504504504504524, 24.955086514514477],
          [-4.504504504504524, 24.594725741741712],
          [-4.14414414414415, 24.594725741741712],
          [-3.4234234234234293, 24.234364968968933],
          [-3.4234234234234293, 24.05418458258255],
          [-2.342342342342363, 23.51364342342339],
          [-2.342342342342363, 23.333463037037006],
          [-0.9009009009009219, 22.612741491491462],
          [-0.9009009009009219, 22.43256110510508],
          [0.180180180180173, 21.89201994594592],
          [0.180180180180173, 21.711839559559536],
          [1.2612612612612395, 21.171298400400374],
          [1.2612612612612395, 20.630757241241213],
          [1.621621621621614, 20.630757241241213],
          [1.621621621621614, 20.270396468468434],
          [2.3423423423423344, 20.270396468468434],
          [3.063063063063055, 19.91003569569567],
          [3.063063063063055, 19.009133763763728],
          [3.7837837837837753, 19.009133763763728],
          [4.144144144144121, 19.189314150150125],
          [4.144144144144121, 15.94606719519517],
          [3.7837837837837753, 15.94606719519517],
          [3.7837837837837753, 15.58570642242239],
          [3.423423423423401, 15.405526036036008],
          [2.3423423423423344, 15.405526036036008],
          [2.3423423423423344, 15.225345649649626],
          [1.2612612612612395, 15.225345649649626],
          [1.2612612612612395, 15.045165263263229],
          [0.180180180180173, 15.045165263263229],
          [0.180180180180173, 14.324443717717685],
          [0.540540540540519, 14.324443717717685],
          [0.540540540540519, 13.60372217217214],
          [0.9009009009008935, 13.60372217217214],
          [0.9009009009008935, 13.06318101301298],
          [1.2612612612612395, 13.06318101301298],
          [1.2612612612612395, 12.702820240240214],
          [2.3423423423423344, 12.702820240240214],
          [2.3423423423423344, 11.621737921921891],
          [1.98198198198196, 11.441557535535509],
          [1.2612612612612395, 11.441557535535509],
          [1.2612612612612395, 11.08119676276273],
          [0.9009009009008935, 11.08119676276273],
          [0.9009009009008935, 10.180294830830803],
          [1.2612612612612395, 10.180294830830803],
          [1.2612612612612395, 9.279392898898877],
          [1.621621621621614, 9.279392898898877],
          [1.621621621621614, 6.216326330330304],
          [1.98198198198196, 6.216326330330304],
          [2.3423423423423344, 6.036145943943922],
          [2.7027027027026804, 6.216326330330304],
          [4.144144144144121, 6.216326330330304],
          [4.86486486486487, 5.855965557557525],
          [4.86486486486487, 5.3154243983983775],
          [5.225225225225216, 5.3154243983983775],
          [5.225225225225216, 4.5947028528528335],
          [5.945945945945937, 4.234342080080054],
          [5.945945945945937, 4.054161693693672],
          [6.666666666666657, 4.054161693693672],
          [7.027027027027032, 4.234342080080054],
          [7.387387387387378, 4.234342080080054],
          [7.387387387387378, 1.8919970570570257],
          [7.747747747747752, 1.8919970570570257],
          [7.747747747747752, 1.3514558978978783],
          [7.387387387387378, 1.3514558978978783],
          [7.387387387387378, -0.6305283523523713],
          [2.7027027027026804, -0.6305283523523713],
          [2.7027027027026804, -3.8737753073073264],
          [7.387387387387378, -3.8737753073073264],
          [7.387387387387378, -53.783742336336346],
          [2.3423423423423344, -53.783742336336346],
          [2.3423423423423344, -55.225185427427434],
          [7.387387387387378, -55.225185427427434],
          [7.387387387387378, -69.99997711111112],
        ],
      ],
    },
    properties: {
      objectid: 15,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '0',
      map_color6: 6,
      map_color8: 1,
      note: null,
      zone: 0,
      utc_format: 'UTC+00:00',
      time_zone: 'UTC+00:00',
      iso_8601: '2012-05-31T09:03:50+00:00',
      places:
        "Cote d'Ivoire, Ghana, Senegal, Morocco, Portugal (continental and Madeira), Spain (Canary Islands)",
      dst_places:
        'Morocco, Portugal (continental and Madeira), Spain (Canary Islands)',
      tz_name1st: 'Europe/Lisbon',
      tz_namesum: 21,
      cartodb_id: 67,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [158.3783783783784, -31.081013651651666],
          [159.45945945945942, -31.081013651651666],
          [159.45945945945942, -31.9819155835836],
          [158.3783783783784, -31.9819155835836],
          [158.3783783783784, -31.081013651651666],
        ],
      ],
    },
    properties: {
      objectid: 32,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+10.5',
      map_color6: 3,
      map_color8: 8,
      note: null,
      zone: 10.5,
      utc_format: 'UTC+10:30',
      time_zone: 'UTC+10:30',
      iso_8601: '2012-05-31T15:03:50+10:30',
      places: 'Lord Howe Island',
      dst_places: 'Lord Howe Island',
      tz_name1st: 'Australia/Lord_Howe',
      tz_namesum: 1,
      cartodb_id: 43,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-7.747747747747752, 44.05420747147144],
          [-7.747747747747752, 51.62178369969965],
          [-8.108108108108127, 51.62178369969965],
          [-8.828828828828847, 51.26142292692688],
          [-9.909909909909913, 51.26142292692688],
          [-10.630630630630634, 51.441603313313266],
          [-10.630630630630634, 52.342505245245206],
          [-9.909909909909913, 52.883046404404354],
          [-10.630630630630634, 53.24340717717715],
          [-10.630630630630634, 54.32448949549547],
          [-10.270270270270288, 54.50466988188185],
          [-9.189189189189193, 54.50466988188185],
          [-9.189189189189193, 54.86503065465462],
          [-8.468468468468473, 55.405571813813765],
          [-7.747747747747752, 55.405571813813765],
          [-7.387387387387406, 55.58575220020015],
          [-7.387387387387406, 56.66683451851847],
          [-7.747747747747752, 56.66683451851847],
          [-7.747747747747752, 57.38755606406403],
          [-8.108108108108127, 57.56773645045041],
          [-8.828828828828847, 57.56773645045041],
          [-8.828828828828847, 58.10827760960956],
          [-7.747747747747752, 58.10827760960956],
          [-7.387387387387406, 58.28845799599597],
          [-7.387387387387406, 61.892065723723675],
          [-8.108108108108127, 61.892065723723675],
          [-8.108108108108127, 62.25242649649647],
          [-7.387387387387406, 62.43260688288285],
          [-7.387387387387406, 63.15332842842838],
          [-19.27927927927928, 63.15332842842838],
          [-20, 63.15332842842838],
          [-20.72072072072072, 63.33350881481476],
          [-21.081081081081095, 63.69386958758756],
          [-22.522522522522536, 63.69386958758756],
          [-23.243243243243256, 63.69386958758756],
          [-23.243243243243256, 64.2344107467467],
          [-22.882882882882882, 64.59477151951947],
          [-24.324324324324323, 64.59477151951947],
          [-24.324324324324323, 65.31549306506503],
          [-24.684684684684697, 65.31549306506503],
          [-25.045045045045043, 65.67585383783779],
          [-24.324324324324323, 65.85603422422417],
          [-23.963963963963977, 66.21639499699697],
          [-22.882882882882882, 66.75693615615612],
          [-22.522522522522536, 66.75693615615612],
          [-21.44144144144144, 66.21639499699697],
          [-20.72072072072072, 66.21639499699697],
          [-20, 66.39657538338335],
          [-18.55855855855856, 66.39657538338335],
          [-18.55855855855856, 66.75693615615612],
          [-7.387387387387406, 66.75693615615612],
          [-7.387387387387406, 90.00020599999996],
          [7.387387387387378, 90.00020599999996],
          [7.387387387387378, 84.95515518118114],
          [7.387387387387378, 63.33350881481476],
          [6.666666666666657, 63.15332842842838],
          [5.945945945945937, 62.792967655655616],
          [5.225225225225216, 62.61278726926923],
          [4.504504504504496, 62.25242649649647],
          [4.504504504504496, 61.35152456456453],
          [4.144144144144121, 60.99116379179176],
          [4.504504504504496, 60.81098340540535],
          [4.504504504504496, 59.72990108708706],
          [4.86486486486487, 59.54972070070065],
          [4.86486486486487, 59.0091795415415],
          [5.225225225225216, 59.0091795415415],
          [5.225225225225216, 58.46863838238235],
          [6.306306306306311, 57.928097223223176],
          [7.387387387387378, 57.747916836836794],
          [7.387387387387378, 53.96412872272268],
          [6.666666666666657, 53.96412872272268],
          [5.945945945945937, 53.60376794994991],
          [4.86486486486487, 53.60376794994991],
          [4.504504504504496, 53.42358756356353],
          [4.504504504504496, 52.883046404404354],
          [4.144144144144121, 52.883046404404354],
          [4.144144144144121, 52.162324858858824],
          [2.3423423423423344, 51.26142292692688],
          [1.98198198198196, 51.26142292692688],
          [1.2612612612612395, 50.90106215415412],
          [0.9009009009008935, 50.36052099499497],
          [0.180180180180173, 50.18034060860856],
          [-1.9819819819819884, 50.18034060860856],
          [-2.702702702702709, 50.00016022222218],
          [-3.7837837837838038, 49.45961906306303],
          [-4.504504504504524, 49.45961906306303],
          [-4.86486486486487, 49.27943867667665],
          [-5.585585585585591, 49.27943867667665],
          [-5.585585585585591, 48.37853674474471],
          [-4.86486486486487, 48.198356358358325],
          [-4.86486486486487, 47.83799558558556],
          [-4.504504504504524, 47.65781519919915],
          [-3.7837837837838038, 47.65781519919915],
          [-3.4234234234234293, 47.47763481281277],
          [-3.4234234234234293, 47.11727404004],
          [-3.0630630630630833, 47.11727404004],
          [-2.702702702702709, 46.576732880880854],
          [-1.9819819819819884, 46.576732880880854],
          [-1.9819819819819884, 46.21637210810806],
          [-1.6216216216216424, 46.03619172172168],
          [-1.6216216216216424, 45.675830948948914],
          [-1.261261261261268, 45.49565056256253],
          [-1.6216216216216424, 45.135289789789766],
          [-1.6216216216216424, 43.69384669869865],
          [-2.342342342342363, 43.51366631231227],
          [-2.702702702702709, 43.69384669869865],
          [-5.225225225225245, 43.69384669869865],
          [-5.225225225225245, 43.87402708508506],
          [-7.387387387387406, 43.87402708508506],
          [-7.747747747747752, 44.05420747147144],
        ],
      ],
    },
    properties: {
      objectid: 15,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '0',
      map_color6: 6,
      map_color8: 1,
      note: null,
      zone: 0,
      utc_format: 'UTC+00:00',
      time_zone: 'UTC+00:00',
      iso_8601: '2012-05-31T09:03:50+00:00',
      places: 'Iceland, United Kingdom, Ireland',
      dst_places: 'Ireland, United Kingdom',
      tz_name1st: 'Europe/London',
      tz_namesum: 5,
      cartodb_id: 69,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-142.52252252252254, -6.035939943943973],
          [-142.52252252252254, -6.936841875875899],
          [-142.52252252252254, -13.06297501301303],
          [-139.63963963963965, -13.06297501301303],
          [-137.11711711711712, -13.06297501301303],
          [-136.75675675675677, -13.42333578578581],
          [-136.75675675675677, -13.963876944944971],
          [-136.3963963963964, -14.324237717717736],
          [-136.03603603603602, -14.864778876876898],
          [-136.03603603603602, -15.225139649649677],
          [-135.67567567567568, -15.765680808808824],
          [-135.67567567567568, -16.126041581581603],
          [-135.31531531531533, -16.666582740740765],
          [-135.31531531531533, -17.02694351351353],
          [-134.95495495495496, -17.56748467267269],
          [-134.95495495495496, -17.92784544544547],
          [-134.59459459459458, -18.468386604604618],
          [-134.23423423423424, -18.828747377377397],
          [-134.23423423423424, -19.36928853653656],
          [-133.8738738738739, -19.729649309309323],
          [-133.8738738738739, -20.270190468468485],
          [-133.51351351351352, -20.630551241241264],
          [-133.51351351351352, -21.171092400400426],
          [-133.15315315315314, -21.53145317317319],
          [-133.15315315315314, -22.071994332332352],
          [-133.15315315315314, -26.03596283283285],
          [-133.15315315315314, -26.936864764764785],
          [-140, -26.936864764764785],
          [-140, -28.918849015015034],
          [-142.52252252252254, -28.918849015015034],
          [-142.52252252252254, -75.22520831631633],
          [-143.24324324324323, -75.40538870270271],
          [-146.84684684684686, -75.40538870270271],
          [-146.84684684684686, -75.94592986186187],
          [-149.36936936936937, -75.94592986186187],
          [-151.17117117117118, -76.48647102102103],
          [-151.8918918918919, -76.8468317937938],
          [-157.65765765765767, -76.8468317937938],
          [-157.65765765765767, -24.954880514514528],
          [-163.06306306306305, -24.954880514514528],
          [-163.06306306306305, -22.071994332332352],
          [-167.02702702702703, -22.071994332332352],
          [-167.02702702702703, -13.06297501301303],
          [-168.1081081081081, -13.06297501301303],
          [-168.1081081081081, -10.720629989990016],
          [-168.1081081081081, -8.017924194194222],
          [-168.1081081081081, -5.855759557557576],
          [-159.0990990990991, -5.855759557557576],
          [-158.3783783783784, -5.855759557557576],
          [-156.21621621621622, -5.855759557557576],
          [-155.85585585585585, -6.396300716716738],
          [-155.85585585585585, -6.936841875875899],
          [-155.4954954954955, -7.477383035035061],
          [-155.4954954954955, -8.55846535335337],
          [-155.13513513513513, -9.099006512512531],
          [-155.13513513513513, -9.999908444444472],
          [-154.77477477477478, -10.54044960360362],
          [-154.77477477477478, -10.900810376376398],
          [-154.4144144144144, -11.621531921921942],
          [-151.8918918918919, -11.621531921921942],
          [-150.45045045045046, -11.621531921921942],
          [-150.0900900900901, -11.621531921921942],
          [-150.0900900900901, -11.08099076276278],
          [-150.0900900900901, -9.45936728528531],
          [-150.45045045045046, -9.099006512512531],
          [-150.45045045045046, -8.55846535335337],
          [-150.8108108108108, -8.198104580580605],
          [-150.8108108108108, -7.657563421421443],
          [-151.17117117117118, -7.297202648648664],
          [-151.17117117117118, -6.216120330330355],
          [-151.53153153153153, -5.855759557557576],
          [-151.53153153153153, -5.495398784784811],
          [-151.8918918918919, -4.95485762562565],
          [-151.8918918918919, -4.5944968528528705],
          [-152.25225225225225, -4.053955693693723],
          [-152.25225225225225, -3.5134145345345615],
          [-152.61261261261262, -3.1530537617617824],
          [-152.61261261261262, -2.612512602602621],
          [-152.97297297297297, -2.252151829829856],
          [-152.97297297297297, -1.7116106706706944],
          [-153.33333333333334, -1.3512498978979153],
          [-153.33333333333334, -0.8107087387387679],
          [-153.6936936936937, -0.27016757957960635],
          [-153.6936936936937, 0.09019319319317276],
          [-154.05405405405406, 0.6307343523523343],
          [-154.05405405405406, 0.9910951251250992],
          [-154.4144144144144, 1.5316362842842608],
          [-154.4144144144144, 2.4325382162161873],
          [-154.77477477477478, 2.7928989889889664],
          [-154.77477477477478, 3.333440148148128],
          [-155.13513513513513, 3.693800920920893],
          [-155.13513513513513, 4.234342080080054],
          [-155.4954954954955, 4.955063625625598],
          [-155.85585585585585, 4.955063625625598],
          [-157.65765765765767, 4.955063625625598],
          [-157.65765765765767, 5.49560478478476],
          [-157.65765765765767, 15.045165263263229],
          [-172.43243243243242, 15.045165263263229],
          [-172.43243243243242, 17.56769067267264],
          [-172.43243243243242, 24.955086514514477],
          [-180, 24.955086514514477],
          [-180, 30.0001373333333],
          [-178.19819819819818, 30.0001373333333],
          [-178.19819819819818, 27.657792310310285],
          [-176.3963963963964, 27.657792310310285],
          [-176.3963963963964, 30.0001373333333],
          [-157.65765765765767, 30.0001373333333],
          [-157.65765765765767, 48.01817597197194],
          [-172.43243243243242, 48.01817597197194],
          [-180, 48.01817597197194],
          [-180, 59.54972070070065],
          [-179.63963963963963, 59.72990108708706],
          [-179.27927927927928, 59.91008147347344],
          [-178.9189189189189, 60.270442246246205],
          [-177.47747747747746, 60.99116379179176],
          [-177.11711711711712, 61.35152456456453],
          [-176.75675675675674, 61.53170495095091],
          [-176.03603603603602, 61.892065723723675],
          [-175.3153153153153, 62.07224611011006],
          [-174.59459459459458, 62.43260688288285],
          [-174.59459459459458, 62.61278726926923],
          [-173.87387387387386, 62.973148042042],
          [-173.87387387387386, 62.25242649649647],
          [-173.87387387387386, 59.54972070070065],
          [-172.43243243243242, 58.10827760960956],
          [-172.43243243243242, 57.747916836836794],
          [-170.63063063063063, 55.94611297297294],
          [-170.63063063063063, 55.58575220020015],
          [-170.27027027027026, 55.045211041041],
          [-169.1891891891892, 53.96412872272268],
          [-169.1891891891892, 52.70286601801797],
          [-168.46846846846847, 52.70286601801797],
          [-166.3063063063063, 53.24340717717715],
          [-165.5855855855856, 53.24340717717715],
          [-161.981981981982, 54.14430910910906],
          [-161.26126126126127, 54.14430910910906],
          [-159.81981981981983, 54.50466988188185],
          [-159.45945945945945, 54.50466988188185],
          [-158.73873873873873, 54.86503065465462],
          [-158.018018018018, 54.86503065465462],
          [-156.93693693693695, 55.22539142742738],
          [-155.85585585585585, 55.405571813813765],
          [-155.13513513513513, 55.76593258658656],
          [-154.4144144144144, 55.94611297297294],
          [-153.33333333333334, 56.48665413213209],
          [-152.61261261261262, 56.66683451851847],
          [-151.8918918918919, 57.027195291291264],
          [-151.17117117117118, 57.207375677677646],
          [-150.45045045045046, 57.56773645045041],
          [-149.72972972972974, 57.747916836836794],
          [-148.64864864864865, 58.28845799599597],
          [-147.92792792792793, 58.46863838238235],
          [-147.2072072072072, 58.82899915515512],
          [-146.48648648648648, 59.0091795415415],
          [-145.76576576576576, 59.369540314314264],
          [-144.68468468468467, 59.54972070070065],
          [-143.96396396396398, 59.54972070070065],
          [-143.6036036036036, 59.72990108708706],
          [-142.88288288288288, 59.72990108708706],
          [-142.52252252252254, 59.91008147347344],
          [-142.52252252252254, -6.035939943943973],
        ],
      ],
    },
    properties: {
      objectid: 2,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-10',
      map_color6: 4,
      map_color8: 4,
      note: null,
      zone: -10,
      utc_format: 'UTC-10:00',
      time_zone: 'UTC-10:00',
      iso_8601: '2012-05-30T18:33:50-10:00',
      places: 'United States (Hawaii)',
      dst_places: 'Most of French Polynesia, United States (Aleutian Islands)',
      tz_name1st: 'Pacific/Honolulu',
      tz_namesum: 6,
      cartodb_id: 7,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-7.747747747747752, 44.05420747147144],
          [-8.468468468468473, 43.87402708508506],
          [-8.468468468468473, 43.51366631231227],
          [-9.189189189189193, 43.51366631231227],
          [-9.549549549549567, 43.333485925925885],
          [-9.549549549549567, 42.612764380380355],
          [-9.189189189189193, 42.612764380380355],
          [-9.189189189189193, 41.8920428348348],
          [-9.189189189189193, 41.711862448448414],
          [-11.351351351351354, 39.54969781181177],
          [-11.711711711711729, 39.369517425425386],
          [-13.513513513513516, 37.56771356156153],
          [-13.87387387387389, 37.387533175175136],
          [-16.03603603603605, 35.225368538538504],
          [-16.396396396396398, 35.04518815215212],
          [-18.198198198198213, 33.243384288288254],
          [-18.55855855855856, 33.06320390190187],
          [-18.55855855855856, 27.117251151151123],
          [-13.513513513513516, 27.117251151151123],
          [-13.87387387387389, 26.756890378378344],
          [-14.59459459459461, 26.39652960560558],
          [-14.59459459459461, 26.0361688328328],
          [-14.954954954954957, 25.855988446446418],
          [-14.954954954954957, 24.774906128128094],
          [-15.675675675675677, 24.41454535535533],
          [-16.03603603603605, 24.05418458258255],
          [-16.03603603603605, 23.51364342342339],
          [-16.396396396396398, 23.153282650650624],
          [-16.396396396396398, 22.792921877877845],
          [-16.756756756756772, 22.43256110510508],
          [-17.117117117117118, 22.252380718718683],
          [-17.117117117117118, 21.351478786786757],
          [-17.477477477477493, 20.991118014013978],
          [-17.477477477477493, 20.810937627627595],
          [-16.396396396396398, 20.270396468468434],
          [-16.396396396396398, 19.91003569569567],
          [-16.756756756756772, 19.91003569569567],
          [-16.756756756756772, 19.009133763763728],
          [-16.396396396396398, 19.009133763763728],
          [-16.396396396396398, 17.02714951351348],
          [-16.756756756756772, 16.666788740740714],
          [-16.756756756756772, 15.765886808808787],
          [-17.117117117117118, 15.405526036036008],
          [-17.117117117117118, 15.045165263263229],
          [-17.477477477477493, 15.045165263263229],
          [-17.83783783783784, 14.684804490490464],
          [-17.117117117117118, 14.324443717717685],
          [-17.117117117117118, 12.342459467467435],
          [-16.756756756756772, 12.162279081081053],
          [-16.756756756756772, 11.441557535535509],
          [-16.396396396396398, 11.261377149149126],
          [-16.396396396396398, 10.901016376376347],
          [-15.315315315315331, 10.901016376376347],
          [-15.315315315315331, 10.720835989989965],
          [-14.954954954954957, 10.360475217217186],
          [-14.234234234234236, 10.00011444444442],
          [-13.87387387387389, 9.639753671671642],
          [-13.87387387387389, 9.279392898898877],
          [-13.513513513513516, 9.279392898898877],
          [-13.513513513513516, 8.198310580580554],
          [-13.15315315315317, 8.018130194194171],
          [-13.15315315315317, 7.297408648648627],
          [-12.792792792792795, 7.1172282622622305],
          [-12.072072072072075, 7.1172282622622305],
          [-11.711711711711729, 6.937047875875848],
          [-11.711711711711729, 6.576687103103083],
          [-11.351351351351354, 6.576687103103083],
          [-10.990990990991008, 6.3965067167166865],
          [-10.990990990991008, 6.036145943943922],
          [-10.630630630630634, 6.036145943943922],
          [-9.909909909909913, 5.6757851711711425],
          [-9.909909909909913, 5.3154243983983775],
          [-9.549549549549567, 5.135244012011981],
          [-9.189189189189193, 4.774883239239216],
          [-8.828828828828847, 4.774883239239216],
          [-8.468468468468473, 4.5947028528528335],
          [-8.468468468468473, 4.414522466466437],
          [-8.108108108108127, 4.234342080080054],
          [-7.747747747747752, 4.234342080080054],
          [-7.387387387387406, 4.054161693693672],
          [-7.387387387387406, -5.855759557557576],
          [-16.03603603603605, -5.855759557557576],
          [-16.03603603603605, -9.279186898898928],
          [-7.387387387387406, -9.279186898898928],
          [-7.387387387387406, -35.58552331131133],
          [-14.59459459459461, -35.58552331131133],
          [-14.59459459459461, -41.71165644844846],
          [-7.387387387387406, -41.71165644844846],
          [-7.387387387387406, -70.54051827027027],
          [-8.828828828828847, -71.08105942942943],
          [-9.909909909909913, -70.72069865665667],
          [-10.630630630630634, -70.72069865665667],
          [-10.990990990991008, -71.08105942942943],
          [-12.792792792792795, -71.08105942942943],
          [-13.513513513513516, -71.80178097497497],
          [-13.513513513513516, -72.52250252052053],
          [-15.315315315315331, -72.52250252052053],
          [-15.675675675675677, -72.34232213413414],
          [-17.117117117117118, -72.34232213413414],
          [-17.117117117117118, -72.8828632932933],
          [-16.03603603603605, -72.8828632932933],
          [-17.477477477477493, -73.60358483883884],
          [-16.756756756756772, -74.144125997998],
          [-18.198198198198213, -74.144125997998],
          [-18.198198198198213, -74.50448677077077],
          [-20, -75.22520831631633],
          [-21.081081081081095, -75.40538870270271],
          [-22.522522522522536, -75.40538870270271],
          [-22.522522522522536, 13.423541785785758],
          [-27.56756756756758, 13.423541785785758],
          [-27.56756756756758, 18.46859260460458],
          [-22.522522522522536, 18.46859260460458],
          [-22.522522522522536, 36.48663124324321],
          [-31.891891891891902, 36.48663124324321],
          [-31.891891891891902, 40.270419357357326],
          [-22.522522522522536, 40.270419357357326],
          [-22.522522522522536, 63.69386958758756],
          [-21.081081081081095, 63.69386958758756],
          [-20.72072072072072, 63.33350881481476],
          [-20, 63.15332842842838],
          [-19.27927927927928, 63.15332842842838],
          [-7.387387387387406, 63.15332842842838],
          [-7.387387387387406, 62.43260688288285],
          [-8.108108108108127, 62.25242649649647],
          [-8.108108108108127, 61.892065723723675],
          [-7.387387387387406, 61.892065723723675],
          [-7.387387387387406, 58.28845799599597],
          [-7.747747747747752, 58.10827760960956],
          [-8.828828828828847, 58.10827760960956],
          [-8.828828828828847, 57.56773645045041],
          [-8.108108108108127, 57.56773645045041],
          [-7.747747747747752, 57.38755606406403],
          [-7.747747747747752, 56.66683451851847],
          [-7.387387387387406, 56.66683451851847],
          [-7.387387387387406, 55.58575220020015],
          [-7.747747747747752, 55.405571813813765],
          [-8.468468468468473, 55.405571813813765],
          [-9.189189189189193, 54.86503065465462],
          [-9.189189189189193, 54.50466988188185],
          [-10.270270270270288, 54.50466988188185],
          [-10.630630630630634, 54.32448949549547],
          [-10.630630630630634, 53.24340717717715],
          [-9.909909909909913, 52.883046404404354],
          [-10.630630630630634, 52.342505245245206],
          [-10.630630630630634, 51.441603313313266],
          [-9.909909909909913, 51.26142292692688],
          [-8.828828828828847, 51.26142292692688],
          [-8.108108108108127, 51.62178369969965],
          [-7.747747747747752, 51.62178369969965],
          [-7.747747747747752, 44.05420747147144],
        ],
      ],
    },
    properties: {
      objectid: 14,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-1',
      map_color6: 1,
      map_color8: 8,
      note: null,
      zone: -1,
      utc_format: 'UTC-01:00',
      time_zone: 'UTC-01:00',
      iso_8601: '2012-05-31T03:33:50-01:00',
      places: 'Portugal (Azores), Cape Verde',
      dst_places: null,
      tz_name1st: 'Atlantic/Cape_Verde',
      tz_namesum: 2,
      cartodb_id: 20,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-136.3963963963964, 69.27946156556553],
          [-136.3963963963964, 68.91910079279276],
          [-136.3963963963964, 67.65783808808806],
          [-136.03603603603602, 67.65783808808806],
          [-136.03603603603602, 66.9371165425425],
          [-133.8738738738739, 66.9371165425425],
          [-133.8738738738739, 66.21639499699697],
          [-133.51351351351352, 66.03621461061056],
          [-132.43243243243245, 66.03621461061056],
          [-132.43243243243245, 64.77495190590585],
          [-131.7117117117117, 64.41459113313309],
          [-130.990990990991, 64.41459113313309],
          [-130.990990990991, 64.05423036036032],
          [-130.27027027027026, 63.69386958758756],
          [-129.9099099099099, 63.69386958758756],
          [-129.9099099099099, 62.792967655655616],
          [-129.1891891891892, 62.61278726926923],
          [-129.1891891891892, 62.07224611011006],
          [-128.46846846846847, 62.07224611011006],
          [-127.74774774774775, 61.71188533733729],
          [-127.02702702702703, 61.53170495095091],
          [-127.02702702702703, 60.81098340540535],
          [-124.86486486486487, 60.81098340540535],
          [-124.14414414414415, 60.09026185985982],
          [-123.78378378378379, 59.91008147347344],
          [-119.81981981981983, 59.91008147347344],
          [-119.81981981981983, 57.207375677677646],
          [-120.54054054054055, 57.38755606406403],
          [-121.26126126126127, 57.207375677677646],
          [-123.42342342342343, 57.207375677677646],
          [-123.78378378378379, 57.027195291291264],
          [-123.78378378378379, 56.48665413213209],
          [-123.42342342342343, 56.48665413213209],
          [-123.42342342342343, 55.76593258658656],
          [-123.06306306306307, 55.405571813813765],
          [-122.34234234234235, 55.22539142742738],
          [-121.62162162162161, 54.86503065465462],
          [-121.62162162162161, 54.684850268268235],
          [-120.54054054054055, 54.14430910910906],
          [-119.81981981981983, 53.42358756356353],
          [-119.45945945945945, 53.24340717717715],
          [-118.73873873873873, 53.24340717717715],
          [-118.37837837837839, 52.883046404404354],
          [-118.37837837837839, 52.342505245245206],
          [-118.01801801801801, 51.98214447247244],
          [-118.01801801801801, 51.441603313313266],
          [-117.29729729729729, 51.441603313313266],
          [-117.29729729729729, 51.0812425405405],
          [-116.57657657657657, 50.720881767767736],
          [-116.57657657657657, 49.819979835835795],
          [-116.93693693693695, 49.819979835835795],
          [-116.93693693693695, 48.919077903903855],
          [-116.21621621621622, 48.919077903903855],
          [-116.21621621621622, 48.01817597197194],
          [-115.85585585585586, 48.01817597197194],
          [-115.85585585585586, 47.47763481281277],
          [-115.13513513513514, 47.297454426426384],
          [-115.13513513513514, 46.93709365365362],
          [-114.77477477477478, 46.93709365365362],
          [-114.77477477477478, 46.576732880880854],
          [-114.41441441441442, 46.576732880880854],
          [-114.41441441441442, 45.49565056256253],
          [-116.21621621621622, 45.49565056256253],
          [-116.21621621621622, 45.856011335335296],
          [-116.57657657657657, 46.03619172172168],
          [-116.57657657657657, 45.135289789789766],
          [-116.93693693693695, 44.955109403403355],
          [-116.93693693693695, 44.59474863063059],
          [-118.37837837837839, 44.234387857857826],
          [-118.37837837837839, 42.432583993993944],
          [-116.93693693693695, 42.432583993993944],
          [-116.93693693693695, 42.07222322122118],
          [-114.05405405405406, 42.07222322122118],
          [-114.05405405405406, 35.94609008408405],
          [-114.77477477477478, 36.12627047047043],
          [-114.77477477477478, 34.865007765765725],
          [-114.41441441441442, 34.865007765765725],
          [-114.41441441441442, 33.42356467467464],
          [-114.77477477477478, 33.42356467467464],
          [-114.77477477477478, 33.06320390190187],
          [-114.41441441441442, 33.06320390190187],
          [-114.41441441441442, 32.70284312912909],
          [-114.77477477477478, 32.70284312912909],
          [-115.13513513513514, 32.52266274274271],
          [-115.13513513513514, 31.98212158358355],
          [-114.77477477477478, 31.98212158358355],
          [-114.77477477477478, 31.621760810810784],
          [-114.41441441441442, 31.081219651651622],
          [-113.6936936936937, 30.36049810610608],
          [-113.6936936936937, 30.0001373333333],
          [-113.33333333333334, 29.639776560560534],
          [-112.97297297297298, 29.099235401401373],
          [-112.61261261261262, 28.738874628628594],
          [-112.61261261261262, 28.37851385585583],
          [-112.25225225225226, 28.01815308308305],
          [-114.05405405405406, 28.01815308308305],
          [-115.13513513513514, 28.55869424224221],
          [-116.93693693693695, 28.55869424224221],
          [-116.93693693693695, 24.05418458258255],
          [-112.61261261261262, 24.05418458258255],
          [-112.61261261261262, 11.441557535535509],
          [-106.84684684684684, 11.441557535535509],
          [-106.84684684684684, 8.558671353353333],
          [-112.61261261261262, 8.558671353353333],
          [-112.61261261261262, -74.144125997998],
          [-112.97297297297298, -73.78376522522524],
          [-113.6936936936937, -73.60358483883884],
          [-114.77477477477478, -73.78376522522524],
          [-118.37837837837839, -73.78376522522524],
          [-118.37837837837839, -73.60358483883884],
          [-121.98198198198199, -73.60358483883884],
          [-123.42342342342343, -73.42340445245246],
          [-124.50450450450451, -73.60358483883884],
          [-124.86486486486487, -73.24322406606606],
          [-125.58558558558559, -73.06304367967968],
          [-127.38738738738739, -73.06304367967968],
          [-127.38738738738739, -26.03596283283285],
          [-133.15315315315314, -26.03596283283285],
          [-133.15315315315314, -22.071994332332352],
          [-127.38738738738739, -22.071994332332352],
          [-127.38738738738739, 49.819979835835795],
          [-128.82882882882882, 50.54070138138135],
          [-128.82882882882882, 50.90106215415412],
          [-128.46846846846847, 51.26142292692688],
          [-128.46846846846847, 51.98214447247244],
          [-129.54954954954957, 52.52268563163159],
          [-129.54954954954957, 52.70286601801797],
          [-130.990990990991, 53.42358756356353],
          [-130.990990990991, 54.14430910910906],
          [-131.7117117117117, 53.42358756356353],
          [-131.35135135135135, 53.24340717717715],
          [-131.35135135135135, 52.883046404404354],
          [-130.63063063063063, 52.342505245245206],
          [-130.63063063063063, 51.80196408608606],
          [-131.35135135135135, 51.98214447247244],
          [-132.43243243243245, 52.52268563163159],
          [-133.51351351351352, 53.60376794994991],
          [-133.51351351351352, 54.32448949549547],
          [-132.07207207207207, 54.32448949549547],
          [-131.35135135135135, 54.684850268268235],
          [-130.63063063063063, 54.684850268268235],
          [-130.27027027027026, 54.86503065465462],
          [-130.27027027027026, 55.22539142742738],
          [-129.9099099099099, 55.405571813813765],
          [-129.9099099099099, 56.12629335935932],
          [-130.63063063063063, 56.12629335935932],
          [-132.43243243243245, 57.027195291291264],
          [-132.43243243243245, 57.56773645045041],
          [-133.15315315315314, 58.28845799599597],
          [-134.95495495495496, 59.18935992792788],
          [-134.95495495495496, 59.54972070070065],
          [-135.31531531531533, 59.72990108708706],
          [-136.03603603603602, 59.72990108708706],
          [-136.3963963963964, 59.54972070070065],
          [-136.3963963963964, 59.18935992792788],
          [-137.47747747747746, 59.18935992792788],
          [-139.27927927927928, 60.09026185985982],
          [-139.27927927927928, 60.270442246246205],
          [-141.0810810810811, 60.270442246246205],
          [-141.0810810810811, 69.82000272472467],
          [-138.55855855855856, 69.82000272472467],
          [-137.83783783783784, 69.27946156556553],
          [-136.3963963963964, 69.27946156556553],
        ],
      ],
    },
    properties: {
      objectid: 6,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-8',
      map_color6: 2,
      map_color8: 7,
      note: null,
      zone: -8,
      utc_format: 'UTC-08:00',
      time_zone: 'UTC-08:00',
      iso_8601: '2012-05-30T20:33:50-08:00',
      places:
        'Canada (most of British Columbia), Mexico (Baja California), United States (California, most of Nevada, most of Oregon, Washington (state))',
      dst_places:
        'Canada (most of British Columbia), Mexico (Baja California), United States (California, most of Nevada, most of Oregon, Washington (state))',
      tz_name1st: 'America/Los_Angeles',
      tz_namesum: 8,
      cartodb_id: 21,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-97.47747747747748, -24.954880514514528],
          [-99.63963963963964, -24.954880514514528],
          [-111.17117117117118, -24.954880514514528],
          [-111.17117117117118, -28.918849015015034],
          [-101.08108108108108, -28.918849015015034],
          [-97.47747747747748, -28.918849015015034],
          [-97.47747747747748, -71.62160058858859],
          [-100.72072072072072, -71.62160058858859],
          [-101.44144144144144, -71.80178097497497],
          [-102.88288288288288, -71.80178097497497],
          [-102.88288288288288, -72.34232213413414],
          [-105.76576576576576, -72.8828632932933],
          [-105.4054054054054, -73.42340445245246],
          [-103.6036036036036, -73.42340445245246],
          [-103.6036036036036, -73.96394561161162],
          [-102.16216216216216, -74.144125997998],
          [-102.16216216216216, -74.50448677077077],
          [-101.44144144144144, -74.86484754354355],
          [-105.4054054054054, -74.86484754354355],
          [-105.76576576576576, -75.04502792992993],
          [-109.009009009009, -75.04502792992993],
          [-109.36936936936937, -74.32430638438439],
          [-110.45045045045045, -73.96394561161162],
          [-112.25225225225226, -73.96394561161162],
          [-112.61261261261262, -74.144125997998],
          [-112.61261261261262, 8.558671353353333],
          [-106.84684684684684, 8.558671353353333],
          [-106.84684684684684, 11.441557535535509],
          [-112.61261261261262, 11.441557535535509],
          [-112.61261261261262, 24.05418458258255],
          [-116.93693693693695, 24.05418458258255],
          [-116.93693693693695, 28.55869424224221],
          [-115.13513513513514, 28.55869424224221],
          [-114.05405405405406, 28.01815308308305],
          [-112.25225225225226, 28.01815308308305],
          [-112.61261261261262, 28.37851385585583],
          [-112.61261261261262, 28.738874628628594],
          [-112.97297297297298, 29.099235401401373],
          [-113.33333333333334, 29.639776560560534],
          [-113.6936936936937, 30.0001373333333],
          [-113.6936936936937, 30.36049810610608],
          [-114.41441441441442, 31.081219651651622],
          [-114.77477477477478, 31.621760810810784],
          [-114.77477477477478, 31.98212158358355],
          [-115.13513513513514, 31.98212158358355],
          [-115.13513513513514, 32.52266274274271],
          [-114.77477477477478, 32.70284312912909],
          [-114.41441441441442, 32.70284312912909],
          [-114.41441441441442, 33.06320390190187],
          [-114.77477477477478, 33.06320390190187],
          [-114.77477477477478, 33.42356467467464],
          [-114.41441441441442, 33.42356467467464],
          [-114.41441441441442, 34.865007765765725],
          [-114.77477477477478, 34.865007765765725],
          [-114.77477477477478, 36.12627047047043],
          [-114.05405405405406, 35.94609008408405],
          [-114.05405405405406, 42.07222322122118],
          [-116.93693693693695, 42.07222322122118],
          [-116.93693693693695, 42.432583993993944],
          [-118.37837837837839, 42.432583993993944],
          [-118.37837837837839, 44.234387857857826],
          [-116.93693693693695, 44.59474863063059],
          [-116.93693693693695, 44.955109403403355],
          [-116.57657657657657, 45.135289789789766],
          [-116.57657657657657, 46.03619172172168],
          [-116.21621621621622, 45.856011335335296],
          [-116.21621621621622, 45.49565056256253],
          [-114.41441441441442, 45.49565056256253],
          [-114.41441441441442, 46.576732880880854],
          [-114.77477477477478, 46.576732880880854],
          [-114.77477477477478, 46.93709365365362],
          [-115.13513513513514, 46.93709365365362],
          [-115.13513513513514, 47.297454426426384],
          [-115.85585585585586, 47.47763481281277],
          [-115.85585585585586, 48.01817597197194],
          [-116.21621621621622, 48.01817597197194],
          [-116.21621621621622, 48.919077903903855],
          [-116.93693693693695, 48.919077903903855],
          [-116.93693693693695, 49.819979835835795],
          [-116.57657657657657, 49.819979835835795],
          [-116.57657657657657, 50.720881767767736],
          [-117.29729729729729, 51.0812425405405],
          [-117.29729729729729, 51.441603313313266],
          [-118.01801801801801, 51.441603313313266],
          [-118.01801801801801, 51.98214447247244],
          [-118.37837837837839, 52.342505245245206],
          [-118.37837837837839, 52.883046404404354],
          [-118.73873873873873, 53.24340717717715],
          [-119.45945945945945, 53.24340717717715],
          [-119.81981981981983, 53.42358756356353],
          [-120.54054054054055, 54.14430910910906],
          [-121.62162162162161, 54.684850268268235],
          [-121.62162162162161, 54.86503065465462],
          [-122.34234234234235, 55.22539142742738],
          [-123.06306306306307, 55.405571813813765],
          [-123.42342342342343, 55.76593258658656],
          [-123.42342342342343, 56.48665413213209],
          [-123.78378378378379, 56.48665413213209],
          [-123.78378378378379, 57.027195291291264],
          [-123.42342342342343, 57.207375677677646],
          [-121.26126126126127, 57.207375677677646],
          [-120.54054054054055, 57.38755606406403],
          [-119.81981981981983, 57.207375677677646],
          [-119.81981981981983, 59.91008147347344],
          [-123.78378378378379, 59.91008147347344],
          [-124.14414414414415, 60.09026185985982],
          [-124.86486486486487, 60.81098340540535],
          [-127.02702702702703, 60.81098340540535],
          [-127.02702702702703, 61.53170495095091],
          [-127.74774774774775, 61.71188533733729],
          [-128.46846846846847, 62.07224611011006],
          [-129.1891891891892, 62.07224611011006],
          [-129.1891891891892, 62.61278726926923],
          [-129.9099099099099, 62.792967655655616],
          [-129.9099099099099, 63.69386958758756],
          [-130.27027027027026, 63.69386958758756],
          [-130.990990990991, 64.05423036036032],
          [-130.990990990991, 64.41459113313309],
          [-131.7117117117117, 64.41459113313309],
          [-132.43243243243245, 64.77495190590585],
          [-132.43243243243245, 66.03621461061056],
          [-133.51351351351352, 66.03621461061056],
          [-133.8738738738739, 66.21639499699697],
          [-133.8738738738739, 66.9371165425425],
          [-136.03603603603602, 66.9371165425425],
          [-136.03603603603602, 67.65783808808806],
          [-136.3963963963964, 67.65783808808806],
          [-136.3963963963964, 68.91910079279276],
          [-136.3963963963964, 69.27946156556553],
          [-136.03603603603602, 69.82000272472467],
          [-132.7927927927928, 69.82000272472467],
          [-131.35135135135135, 70.36054388388385],
          [-129.9099099099099, 70.36054388388385],
          [-128.46846846846847, 70.901085043043],
          [-127.74774774774775, 70.72090465665661],
          [-127.38738738738739, 70.72090465665661],
          [-126.30630630630631, 70.18036349749747],
          [-125.58558558558559, 70.36054388388385],
          [-124.14414414414415, 70.36054388388385],
          [-123.78378378378379, 71.08126542942938],
          [-124.50450450450451, 71.62180658858856],
          [-125.58558558558559, 71.80198697497494],
          [-126.66666666666667, 71.80198697497494],
          [-126.66666666666667, 72.1623477477477],
          [-125.58558558558559, 72.70288890690685],
          [-125.58558558558559, 73.24343006606603],
          [-124.86486486486487, 73.60379083883879],
          [-125.58558558558559, 74.14433199799797],
          [-125.58558558558559, 74.50469277077073],
          [-124.14414414414415, 74.68487315715711],
          [-121.62162162162161, 74.68487315715711],
          [-121.26126126126127, 75.58577508908905],
          [-123.78378378378379, 75.94613586186182],
          [-122.70270270270271, 76.66685740740735],
          [-121.26126126126127, 76.84703779379376],
          [-120.9009009009009, 77.20739856656652],
          [-119.81981981981983, 77.56775933933929],
          [-118.01801801801801, 77.56775933933929],
          [-117.65765765765767, 77.74793972572567],
          [-115.85585585585586, 77.74793972572567],
          [-115.85585585585586, 78.10830049849847],
          [-114.41441441441442, 78.28848088488485],
          [-112.61261261261262, 78.829022044044],
          [-112.61261261261262, 90.00020599999996],
          [-97.47747747747748, 90.00020599999996],
          [-97.47747747747748, 84.95515518118114],
          [-97.47747747747748, 80.63082590790785],
          [-97.83783783783784, 80.27046513513508],
          [-101.08108108108108, 80.27046513513508],
          [-101.44144144144144, 79.36956320320317],
          [-102.16216216216216, 79.36956320320317],
          [-102.16216216216216, 73.42361045245241],
          [-101.44144144144144, 73.24343006606603],
          [-100.36036036036036, 73.24343006606603],
          [-98.91891891891892, 72.88306929329326],
          [-97.47747747747748, 72.88306929329326],
          [-96.3963963963964, 72.52270852052047],
          [-95.31531531531532, 72.52270852052047],
          [-94.23423423423424, 72.34252813413408],
          [-92.07207207207207, 71.26144581581576],
          [-92.07207207207207, 70.901085043043],
          [-90.990990990991, 70.36054388388385],
          [-90.990990990991, 70.00018311111106],
          [-90.27027027027027, 69.63982233833829],
          [-89.1891891891892, 69.45964195195191],
          [-89.1891891891892, 68.73892040640635],
          [-88.82882882882883, 68.37855963363359],
          [-88.82882882882883, 66.9371165425425],
          [-102.16216216216216, 66.9371165425425],
          [-102.16216216216216, 59.91008147347344],
          [-110.09009009009009, 59.91008147347344],
          [-110.09009009009009, 53.60376794994991],
          [-109.72972972972973, 53.42358756356353],
          [-109.009009009009, 53.42358756356353],
          [-109.009009009009, 52.883046404404354],
          [-109.36936936936937, 52.70286601801797],
          [-110.09009009009009, 52.70286601801797],
          [-110.09009009009009, 48.919077903903855],
          [-103.96396396396396, 48.919077903903855],
          [-103.96396396396396, 47.83799558558556],
          [-103.6036036036036, 47.65781519919915],
          [-102.16216216216216, 47.65781519919915],
          [-101.08108108108108, 47.11727404004],
          [-100.72072072072072, 47.11727404004],
          [-100.72072072072072, 46.39655249449444],
          [-101.44144144144144, 46.21637210810806],
          [-101.44144144144144, 45.856011335335296],
          [-100.36036036036036, 45.856011335335296],
          [-100.36036036036036, 44.234387857857826],
          [-101.08108108108108, 44.234387857857826],
          [-101.08108108108108, 42.97312515315312],
          [-100.72072072072072, 42.97312515315312],
          [-100.72072072072072, 41.711862448448414],
          [-101.44144144144144, 41.711862448448414],
          [-101.44144144144144, 40.991140902902856],
          [-101.08108108108108, 40.991140902902856],
          [-101.08108108108108, 40.63078013013009],
          [-101.44144144144144, 40.63078013013009],
          [-101.44144144144144, 40.090238970970944],
          [-102.16216216216216, 40.090238970970944],
          [-102.16216216216216, 39.54969781181177],
          [-101.44144144144144, 39.54969781181177],
          [-101.44144144144144, 37.747893947947915],
          [-102.16216216216216, 37.747893947947915],
          [-102.16216216216216, 37.02717240240237],
          [-102.88288288288288, 37.02717240240237],
          [-102.88288288288288, 32.52266274274271],
          [-103.24324324324324, 32.34248235635633],
          [-103.24324324324324, 31.98212158358355],
          [-105.04504504504504, 31.98212158358355],
          [-105.04504504504504, 30.54067849249246],
          [-104.68468468468468, 30.54067849249246],
          [-104.68468468468468, 29.639776560560534],
          [-104.32432432432432, 29.639776560560534],
          [-103.24324324324324, 29.099235401401373],
          [-103.6036036036036, 28.738874628628594],
          [-103.6036036036036, 28.198333469469432],
          [-103.96396396396396, 28.198333469469432],
          [-103.96396396396396, 27.297431537537506],
          [-103.6036036036036, 27.117251151151123],
          [-103.6036036036036, 26.756890378378344],
          [-104.32432432432432, 26.756890378378344],
          [-104.68468468468468, 26.57670999199196],
          [-105.76576576576576, 26.57670999199196],
          [-106.12612612612612, 26.39652960560558],
          [-106.48648648648648, 26.39652960560558],
          [-106.48648648648648, 25.675808060060035],
          [-106.84684684684684, 25.675808060060035],
          [-107.2072072072072, 25.49562767367364],
          [-107.2072072072072, 24.955086514514477],
          [-106.84684684684684, 24.955086514514477],
          [-106.84684684684684, 24.594725741741712],
          [-106.48648648648648, 24.594725741741712],
          [-106.12612612612612, 24.41454535535533],
          [-106.12612612612612, 24.05418458258255],
          [-105.76576576576576, 24.05418458258255],
          [-105.76576576576576, 23.153282650650624],
          [-105.4054054054054, 23.153282650650624],
          [-105.04504504504504, 22.973102264264227],
          [-105.04504504504504, 22.612741491491462],
          [-104.68468468468468, 22.612741491491462],
          [-104.32432432432432, 22.43256110510508],
          [-104.32432432432432, 21.53165917317314],
          [-103.96396396396396, 21.53165917317314],
          [-103.96396396396396, 21.171298400400374],
          [-104.32432432432432, 21.171298400400374],
          [-105.4054054054054, 20.630757241241213],
          [-105.76576576576576, 20.630757241241213],
          [-105.76576576576576, 19.91003569569567],
          [-105.4054054054054, 19.729855309309286],
          [-105.4054054054054, 19.369494536536507],
          [-103.96396396396396, 18.648772990990963],
          [-103.96396396396396, 18.46859260460458],
          [-103.24324324324324, 18.1082318318318],
          [-103.24324324324324, 17.92805144544542],
          [-102.52252252252252, 17.92805144544542],
          [-101.08108108108108, 17.207329899899875],
          [-99.63963963963964, 16.48660835435433],
          [-99.27927927927928, 16.48660835435433],
          [-97.83783783783784, 15.765886808808787],
          [-97.47747747747748, 15.765886808808787],
          [-97.47747747747748, -24.954880514514528],
        ],
      ],
    },
    properties: {
      objectid: 7,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-7',
      map_color6: 1,
      map_color8: 1,
      note: null,
      zone: -7,
      utc_format: 'UTC-07:00',
      time_zone: 'UTC-07:00',
      iso_8601: '2012-05-30T21:33:50-07:00',
      places:
        'Canada (northeastern British Columbia), Mexico (Sonora), United States (Arizona)',
      dst_places:
        'Canada (Alberta), Mexico (Chihuahua), United States (Colorado)',
      tz_name1st: 'America/Denver',
      tz_namesum: 14,
      cartodb_id: 10,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-56.03603603603604, 46.576732880880854],
          [-56.03603603603604, 46.75691326726724],
          [-54.95495495495496, 46.75691326726724],
          [-53.513513513513516, 46.39655249449444],
          [-52.792792792792795, 46.39655249449444],
          [-52.792792792792795, 46.75691326726724],
          [-52.432432432432435, 47.11727404004],
          [-52.432432432432435, 5.49560478478476],
          [-52.792792792792795, 5.6757851711711425],
          [-53.153153153153156, 5.6757851711711425],
          [-53.873873873873876, 6.036145943943922],
          [-54.234234234234236, 6.036145943943922],
          [-54.5945945945946, 6.216326330330304],
          [-57.11711711711712, 6.216326330330304],
          [-57.11711711711712, 6.036145943943922],
          [-57.11711711711712, 5.3154243983983775],
          [-57.47747747747748, 5.3154243983983775],
          [-57.11711711711712, 5.3154243983983775],
          [-57.11711711711712, 5.135244012011981],
          [-57.11711711711712, 5.3154243983983775],
          [-57.11711711711712, 5.135244012011981],
          [-57.11711711711712, 4.955063625625598],
          [-57.47747747747748, 4.955063625625598],
          [-57.83783783783784, 4.955063625625598],
          [-57.83783783783784, 3.333440148148128],
          [-57.47747747747748, 3.333440148148128],
          [-57.11711711711712, 3.1532597617617313],
          [-57.11711711711712, 2.973079375375349],
          [-57.11711711711712, 2.7928989889889664],
          [-57.11711711711712, 2.612718602602584],
          [-57.11711711711712, 2.4325382162161873],
          [-56.75675675675676, 2.4325382162161873],
          [-56.75675675675676, 2.0721774434434224],
          [-56.3963963963964, 1.8919970570570257],
          [-56.75675675675676, 1.8919970570570257],
          [-57.11711711711712, 1.8919970570570257],
          [-57.11711711711712, 2.0721774434434224],
          [-57.11711711711712, 1.8919970570570257],
          [-57.47747747747748, 1.8919970570570257],
          [-57.47747747747748, 1.7118166706706432],
          [-57.83783783783784, 1.7118166706706432],
          [-58.1981981981982, 1.5316362842842608],
          [-58.55855855855856, 1.3514558978978783],
          [-58.91891891891892, 1.1712755115114817],
          [-58.91891891891892, 1.3514558978978783],
          [-58.91891891891892, -0.6305283523523713],
          [-58.55855855855856, -0.8107087387387679],
          [-58.55855855855856, -0.9908891251251504],
          [-58.1981981981982, -1.1710695115115328],
          [-58.1981981981982, -1.3512498978979153],
          [-57.47747747747748, -1.7116106706706944],
          [-57.11711711711712, -1.7116106706706944],
          [-57.11711711711712, -1.8917910570570768],
          [-56.75675675675676, -2.0719714434434735],
          [-56.75675675675676, -2.252151829829856],
          [-56.3963963963964, -2.0719714434434735],
          [-56.3963963963964, -2.252151829829856],
          [-56.3963963963964, -2.4323322162162384],
          [-56.75675675675676, -2.7926929889890175],
          [-56.75675675675676, -3.1530537617617824],
          [-57.11711711711712, -3.5134145345345615],
          [-57.11711711711712, -4.053955693693723],
          [-57.47747747747748, -4.414316466466488],
          [-57.47747747747748, -4.774677239239267],
          [-57.83783783783784, -5.3152183983984145],
          [-57.83783783783784, -5.675579171171194],
          [-58.1981981981982, -6.035939943943973],
          [-58.1981981981982, -6.57648110310312],
          [-58.55855855855856, -6.57648110310312],
          [-58.55855855855856, -6.936841875875899],
          [-58.1981981981982, -6.936841875875899],
          [-58.1981981981982, -7.477383035035061],
          [-57.83783783783784, -7.477383035035061],
          [-57.83783783783784, -8.55846535335337],
          [-57.47747747747748, -8.55846535335337],
          [-57.47747747747748, -8.918826126126149],
          [-57.11711711711712, -8.918826126126149],
          [-57.11711711711712, -9.279186898898928],
          [-56.75675675675676, -9.45936728528531],
          [-56.3963963963964, -9.45936728528531],
          [-55.67567567567568, -9.45936728528531],
          [-54.95495495495496, -9.639547671671693],
          [-52.792792792792795, -9.639547671671693],
          [-52.072072072072075, -9.819728058058075],
          [-50.27027027027029, -9.819728058058075],
          [-50.27027027027029, -10.360269217217237],
          [-50.630630630630634, -10.360269217217237],
          [-50.630630630630634, -12.522433853853869],
          [-50.630630630630634, -12.882794626626648],
          [-50.630630630630634, -13.603516172172192],
          [-50.99099099099101, -13.603516172172192],
          [-50.99099099099101, -14.144057331331354],
          [-50.99099099099101, -15.04495926326328],
          [-51.351351351351354, -15.04495926326328],
          [-51.71171171171173, -15.04495926326328],
          [-51.71171171171173, -15.585500422422442],
          [-52.072072072072075, -15.765680808808824],
          [-52.432432432432435, -15.94586119519522],
          [-52.432432432432435, -16.306221967967986],
          [-52.792792792792795, -16.306221967967986],
          [-52.792792792792795, -16.846763127127147],
          [-53.153153153153156, -16.846763127127147],
          [-53.153153153153156, -18.468386604604618],
          [-52.792792792792795, -18.288206218218235],
          [-52.792792792792795, -18.648566990991014],
          [-52.432432432432435, -18.648566990991014],
          [-52.432432432432435, -18.828747377377397],
          [-51.71171171171173, -19.189108150150176],
          [-51.351351351351354, -19.36928853653656],
          [-50.99099099099101, -19.36928853653656],
          [-50.99099099099101, -20.270190468468485],
          [-51.351351351351354, -20.270190468468485],
          [-51.351351351351354, -20.630551241241264],
          [-51.71171171171173, -20.630551241241264],
          [-51.71171171171173, -21.351272786786808],
          [-52.072072072072075, -21.53145317317319],
          [-52.072072072072075, -21.89181394594597],
          [-52.432432432432435, -21.89181394594597],
          [-52.432432432432435, -22.252174718718734],
          [-52.792792792792795, -22.432355105105117],
          [-53.513513513513516, -22.792715877877896],
          [-53.513513513513516, -23.153076650650675],
          [-53.873873873873876, -23.333257037037058],
          [-53.873873873873876, -23.693617809809822],
          [-54.234234234234236, -23.693617809809822],
          [-54.234234234234236, -24.774700128128146],
          [-54.5945945945946, -24.954880514514528],
          [-54.5945945945946, -25.675602060060072],
          [-54.5945945945946, -26.576503991992013],
          [-54.95495495495496, -26.576503991992013],
          [-54.95495495495496, -26.936864764764785],
          [-55.31531531531532, -26.936864764764785],
          [-55.31531531531532, -27.117045151151167],
          [-55.67567567567568, -27.117045151151167],
          [-55.67567567567568, -27.47740592392394],
          [-56.03603603603604, -27.297225537537557],
          [-56.3963963963964, -27.297225537537557],
          [-56.3963963963964, -27.65758631031033],
          [-56.75675675675676, -27.47740592392394],
          [-57.11711711711712, -27.47740592392394],
          [-57.47747747747748, -27.47740592392394],
          [-57.83783783783784, -27.297225537537557],
          [-58.1981981981982, -27.297225537537557],
          [-58.55855855855856, -27.297225537537557],
          [-58.55855855855856, -27.117045151151167],
          [-58.1981981981982, -26.756684378378395],
          [-58.1981981981982, -26.576503991992013],
          [-58.1981981981982, -26.216143219219234],
          [-57.83783783783784, -26.03596283283285],
          [-57.83783783783784, -25.675602060060072],
          [-57.47747747747748, -25.675602060060072],
          [-57.47747747747748, -25.315241287287307],
          [-57.83783783783784, -25.315241287287307],
          [-57.83783783783784, -24.954880514514528],
          [-58.1981981981982, -24.954880514514528],
          [-58.55855855855856, -24.954880514514528],
          [-59.63963963963964, -24.414339355355366],
          [-60, -24.0539785825826],
          [-60.36036036036036, -24.0539785825826],
          [-60.72072072072072, -23.87379819619622],
          [-61.08108108108108, -23.87379819619622],
          [-61.08108108108108, -23.51343742342344],
          [-61.44144144144144, -23.51343742342344],
          [-61.8018018018018, -23.333257037037058],
          [-61.8018018018018, -22.97289626426428],
          [-62.16216216216216, -22.97289626426428],
          [-62.16216216216216, -22.612535491491514],
          [-62.16216216216216, -22.432355105105117],
          [-62.52252252252252, -22.252174718718734],
          [-62.88288288288288, -22.071994332332352],
          [-63.6036036036036, -22.071994332332352],
          [-63.96396396396396, -22.071994332332352],
          [-64.32432432432432, -22.432355105105117],
          [-64.32432432432432, -22.792715877877896],
          [-64.32432432432432, -22.432355105105117],
          [-64.6846846846847, -22.252174718718734],
          [-65.04504504504506, -22.071994332332352],
          [-65.40540540540542, -22.071994332332352],
          [-65.76576576576578, -22.071994332332352],
          [-66.12612612612614, -21.711633559559573],
          [-66.12612612612614, -22.071994332332352],
          [-66.4864864864865, -22.071994332332352],
          [-66.4864864864865, -22.252174718718734],
          [-66.84684684684686, -22.252174718718734],
          [-66.84684684684686, -22.612535491491514],
          [-67.20720720720722, -22.792715877877896],
          [-67.20720720720722, -24.0539785825826],
          [-67.56756756756758, -24.0539785825826],
          [-68.2882882882883, -24.414339355355366],
          [-68.2882882882883, -24.594519741741763],
          [-68.64864864864866, -24.594519741741763],
          [-68.64864864864866, -24.954880514514528],
          [-68.2882882882883, -25.135060900900925],
          [-68.64864864864866, -25.135060900900925],
          [-68.64864864864866, -26.576503991992013],
          [-68.2882882882883, -26.936864764764785],
          [-68.2882882882883, -27.117045151151167],
          [-68.64864864864866, -27.117045151151167],
          [-69.00900900900902, -27.117045151151167],
          [-69.00900900900902, -27.83776669669671],
          [-69.36936936936938, -28.198127469469483],
          [-69.72972972972974, -28.378307855855873],
          [-69.72972972972974, -29.099029401401417],
          [-70.0900900900901, -29.099029401401417],
          [-70.0900900900901, -30.180111719719733],
          [-70.0900900900901, -29.99993133333335],
          [-70.0900900900901, -30.360292106106122],
          [-70.45045045045046, -30.720652878878894],
          [-70.45045045045046, -31.081013651651666],
          [-70.45045045045046, -31.80173519719721],
          [-70.45045045045046, -31.9819155835836],
          [-70.45045045045046, -32.34227635635637],
          [-70.0900900900901, -32.34227635635637],
          [-70.0900900900901, -33.243178288288306],
          [-69.72972972972974, -33.243178288288306],
          [-69.72972972972974, -33.96389983383385],
          [-69.72972972972974, -34.32426060660662],
          [-70.0900900900901, -34.32426060660662],
          [-70.0900900900901, -34.684621379379394],
          [-70.45045045045046, -34.684621379379394],
          [-70.45045045045046, -35.9458840840841],
          [-70.45045045045046, -36.12606447047048],
          [-70.81081081081082, -36.48642524324326],
          [-71.17117117117118, -36.48642524324326],
          [-71.17117117117118, -36.66660562962964],
          [-71.17117117117118, -37.026966402402415],
          [-71.17117117117118, -38.28822910710712],
          [-70.81081081081082, -38.46840949349351],
          [-70.81081081081082, -38.82877026626628],
          [-71.17117117117118, -38.82877026626628],
          [-71.53153153153154, -38.82877026626628],
          [-71.53153153153154, -39.549491811811826],
          [-71.53153153153154, -40.09003297097099],
          [-71.8918918918919, -40.09003297097099],
          [-71.8918918918919, -40.27021335735737],
          [-71.53153153153154, -40.27021335735737],
          [-71.8918918918919, -40.45039374374376],
          [-71.8918918918919, -42.25219760760762],
          [-71.8918918918919, -42.07201722122124],
          [-72.25225225225226, -42.25219760760762],
          [-72.25225225225226, -43.153099539539554],
          [-71.8918918918919, -43.333279925925936],
          [-71.8918918918919, -43.513460312312326],
          [-71.8918918918919, -43.69364069869871],
          [-71.8918918918919, -44.41436224424426],
          [-71.17117117117118, -44.41436224424426],
          [-71.17117117117118, -44.77472301701703],
          [-71.53153153153154, -44.77472301701703],
          [-71.8918918918919, -44.77472301701703],
          [-71.8918918918919, -44.954903403403414],
          [-71.53153153153154, -44.954903403403414],
          [-71.53153153153154, -45.495444562562575],
          [-71.8918918918919, -45.495444562562575],
          [-71.8918918918919, -47.297248426426435],
          [-71.8918918918919, -47.11706804004005],
          [-72.25225225225226, -47.477428812812825],
          [-72.61261261261262, -47.8377895855856],
          [-72.25225225225226, -48.017969971971986],
          [-72.25225225225226, -48.37833074474476],
          [-72.61261261261262, -48.37833074474476],
          [-72.61261261261262, -48.91887190390391],
          [-73.6936936936937, -49.459413063063074],
          [-73.6936936936937, -50.18013460860862],
          [-73.33333333333334, -50.18013460860862],
          [-73.33333333333334, -50.72067576776778],
          [-72.97297297297298, -50.72067576776778],
          [-72.61261261261262, -50.54049538138139],
          [-72.61261261261262, -50.72067576776778],
          [-72.61261261261262, -50.54049538138139],
          [-72.25225225225226, -50.54049538138139],
          [-72.25225225225226, -51.62157769969971],
          [-71.8918918918919, -51.981938472472486],
          [-69.72972972972974, -51.981938472472486],
          [-69.72972972972974, -52.16211885885887],
          [-68.64864864864866, -52.16211885885887],
          [-68.2882882882883, -52.34229924524526],
          [-68.64864864864866, -52.70266001801803],
          [-68.64864864864866, -54.86482465465466],
          [-68.2882882882883, -54.86482465465466],
          [-67.20720720720722, -54.86482465465466],
          [-66.12612612612614, -55.225185427427434],
          [-65.40540540540542, -55.04500504104105],
          [-63.6036036036036, -55.04500504104105],
          [-63.6036036036036, -54.50446388188189],
          [-65.76576576576578, -54.50446388188189],
          [-67.56756756756758, -53.60356194994996],
          [-67.92792792792794, -53.243201177177184],
          [-67.92792792792794, -52.88284040440441],
          [-68.2882882882883, -52.52247963163164],
          [-68.2882882882883, -51.801758086086096],
          [-68.64864864864866, -51.62157769969971],
          [-68.64864864864866, -50.36031499499501],
          [-68.2882882882883, -50.36031499499501],
          [-67.56756756756758, -49.999954222222236],
          [-67.20720720720722, -49.459413063063074],
          [-67.20720720720722, -48.91887190390391],
          [-65.76576576576578, -48.19815035835837],
          [-65.40540540540542, -48.19815035835837],
          [-65.40540540540542, -47.11706804004005],
          [-66.12612612612614, -46.93688765365366],
          [-67.20720720720722, -46.39634649449451],
          [-67.20720720720722, -45.67562494894896],
          [-66.84684684684686, -45.67562494894896],
          [-66.84684684684686, -45.315264176176186],
          [-65.76576576576578, -45.315264176176186],
          [-65.40540540540542, -45.1350837897898],
          [-65.40540540540542, -44.77472301701703],
          [-65.04504504504506, -44.77472301701703],
          [-65.04504504504506, -43.69364069869871],
          [-63.6036036036036, -42.972919153153164],
          [-63.24324324324324, -42.972919153153164],
          [-63.24324324324324, -42.25219760760762],
          [-63.96396396396396, -41.89183683483485],
          [-64.6846846846847, -42.07201722122124],
          [-64.6846846846847, -40.990934902902914],
          [-63.96396396396396, -41.351295675675686],
          [-62.88288288288288, -41.351295675675686],
          [-61.8018018018018, -40.81075451651653],
          [-61.8018018018018, -40.45039374374376],
          [-62.16216216216216, -40.45039374374376],
          [-62.16216216216216, -40.09003297097099],
          [-61.8018018018018, -39.9098525845846],
          [-61.8018018018018, -39.36931142542544],
          [-61.44144144144144, -39.189131039039054],
          [-60.36036036036036, -39.189131039039054],
          [-60, -39.008950652652665],
          [-59.27927927927928, -39.008950652652665],
          [-58.55855855855856, -38.82877026626628],
          [-57.11711711711712, -38.10804872072073],
          [-56.75675675675676, -37.56750756156158],
          [-56.75675675675676, -37.207146788788805],
          [-56.3963963963964, -37.026966402402415],
          [-56.3963963963964, -36.12606447047048],
          [-57.11711711711712, -36.12606447047048],
          [-57.11711711711712, -35.76570369769771],
          [-56.75675675675676, -35.58552331131133],
          [-56.75675675675676, -34.86480176576578],
          [-56.03603603603604, -35.044982152152166],
          [-55.31531531531532, -35.044982152152166],
          [-54.95495495495496, -35.225162538538555],
          [-53.513513513513516, -34.50444099299301],
          [-53.153153153153156, -34.14408022022023],
          [-53.153153153153156, -33.78371944744746],
          [-52.432432432432435, -33.42335867467469],
          [-52.432432432432435, -77.02701218018018],
          [-56.75675675675676, -75.94592986186187],
          [-57.47747747747748, -75.94592986186187],
          [-61.08108108108108, -75.04502792992993],
          [-61.08108108108108, -74.68466715715716],
          [-60, -74.50448677077077],
          [-60, -73.60358483883884],
          [-59.27927927927928, -73.42340445245246],
          [-59.63963963963964, -72.70268290690692],
          [-59.63963963963964, -71.98196136136137],
          [-60, -71.26123981581583],
          [-60, -70.36033788388389],
          [-61.44144144144144, -70.36033788388389],
          [-60.36036036036036, -69.81979672472474],
          [-61.08108108108108, -69.63961633833834],
          [-61.08108108108108, -69.27925556556556],
          [-61.8018018018018, -68.9188947927928],
          [-62.52252252252252, -68.9188947927928],
          [-62.52252252252252, -68.19817324724725],
          [-63.96396396396396, -68.19817324724725],
          [-64.32432432432432, -67.83781247447448],
          [-64.32432432432432, -67.11709092892893],
          [-63.24324324324324, -67.11709092892893],
          [-62.16216216216216, -66.93691054254255],
          [-61.44144144144144, -66.57654976976977],
          [-60.72072072072072, -66.57654976976977],
          [-60, -66.03600861061062],
          [-60.36036036036036, -65.67564783783784],
          [-61.08108108108108, -65.67564783783784],
          [-61.08108108108108, -65.31528706506506],
          [-60.36036036036036, -65.31528706506506],
          [-59.27927927927928, -65.49546745145146],
          [-59.27927927927928, -64.77474590590592],
          [-56.75675675675676, -64.77474590590592],
          [-56.03603603603604, -64.41438513313314],
          [-56.3963963963964, -64.05402436036036],
          [-56.3963963963964, -63.873843973973976],
          [-55.67567567567568, -63.873843973973976],
          [-55.31531531531532, -63.51348320120121],
          [-54.5945945945946, -63.51348320120121],
          [-54.5945945945946, -63.15312242842843],
          [-55.67567567567568, -62.79276165565567],
          [-56.75675675675676, -62.79276165565567],
          [-58.55855855855856, -63.33330281481482],
          [-60, -63.33330281481482],
          [-60.36036036036036, -63.51348320120121],
          [-61.44144144144144, -63.51348320120121],
          [-61.08108108108108, -63.15312242842843],
          [-60, -63.15312242842843],
          [-60, -62.97294204204205],
          [-59.27927927927928, -62.61258126926928],
          [-58.55855855855856, -62.43240088288289],
          [-57.83783783783784, -62.43240088288289],
          [-57.11711711711712, -62.252220496496506],
          [-57.11711711711712, -61.89185972372373],
          [-57.47747747747748, -61.711679337337344],
          [-58.55855855855856, -61.711679337337344],
          [-59.27927927927928, -61.89185972372373],
          [-60, -62.252220496496506],
          [-61.08108108108108, -62.252220496496506],
          [-61.8018018018018, -62.61258126926928],
          [-62.52252252252252, -62.61258126926928],
          [-63.24324324324324, -62.97294204204205],
          [-63.24324324324324, -63.15312242842843],
          [-62.16216216216216, -63.693663587587594],
          [-62.88288288288288, -64.05402436036036],
          [-63.96396396396396, -64.05402436036036],
          [-64.6846846846847, -64.41438513313314],
          [-64.6846846846847, -64.9549262922923],
          [-65.04504504504506, -65.31528706506506],
          [-66.4864864864865, -65.31528706506506],
          [-66.4864864864865, -65.49546745145146],
          [-67.56756756756758, -66.03600861061062],
          [-67.56756756756758, -56.12608735935937],
          [-67.92792792792794, -56.12608735935937],
          [-68.64864864864866, -55.765726586586595],
          [-69.36936936936938, -55.765726586586595],
          [-70.0900900900901, -55.58554620020021],
          [-70.81081081081082, -55.225185427427434],
          [-71.17117117117118, -55.225185427427434],
          [-72.97297297297298, -54.32428349549551],
          [-73.6936936936937, -54.32428349549551],
          [-73.6936936936937, -53.963922722722735],
          [-74.41441441441442, -53.60356194994996],
          [-74.41441441441442, -53.243201177177184],
          [-75.13513513513514, -52.88284040440441],
          [-74.77477477477478, -52.52247963163164],
          [-75.4954954954955, -52.16211885885887],
          [-75.4954954954955, -51.08103654054055],
          [-75.85585585585586, -50.72067576776778],
          [-75.85585585585586, -45.67562494894896],
          [-75.4954954954955, -45.315264176176186],
          [-75.4954954954955, -44.41436224424426],
          [-75.13513513513514, -44.05400147147149],
          [-75.13513513513514, -43.333279925925936],
          [-74.41441441441442, -42.972919153153164],
          [-74.41441441441442, -41.71165644844846],
          [-74.05405405405406, -41.351295675675686],
          [-74.41441441441442, -40.990934902902914],
          [-74.05405405405406, -40.81075451651653],
          [-74.05405405405406, -39.72967219819821],
          [-73.6936936936937, -39.72967219819821],
          [-73.6936936936937, -38.64858987987989],
          [-74.05405405405406, -38.64858987987989],
          [-74.05405405405406, -37.38732717517519],
          [-81.62162162162163, -37.38732717517519],
          [-81.62162162162163, -24.774700128128146],
          [-70.81081081081082, -24.774700128128146],
          [-70.81081081081082, -22.792715877877896],
          [-70.45045045045046, -22.792715877877896],
          [-70.45045045045046, -18.288206218218235],
          [-70.0900900900901, -18.288206218218235],
          [-69.72972972972974, -18.108025831831853],
          [-69.72972972972974, -17.207123899899926],
          [-69.36936936936938, -17.207123899899926],
          [-69.36936936936938, -16.666582740740765],
          [-69.00900900900902, -16.666582740740765],
          [-69.00900900900902, -16.126041581581603],
          [-69.36936936936938, -16.126041581581603],
          [-69.36936936936938, -14.504418104104118],
          [-69.00900900900902, -14.504418104104118],
          [-69.00900900900902, -12.702614240240266],
          [-68.64864864864866, -12.702614240240266],
          [-68.64864864864866, -12.342253467467486],
          [-69.00900900900902, -12.162073081081104],
          [-69.00900900900902, -11.801712308308325],
          [-69.36936936936938, -11.621531921921942],
          [-69.36936936936938, -11.08099076276278],
          [-70.81081081081082, -11.08099076276278],
          [-70.81081081081082, -9.819728058058075],
          [-70.45045045045046, -9.819728058058075],
          [-70.45045045045046, -9.45936728528531],
          [-70.81081081081082, -9.45936728528531],
          [-70.81081081081082, -9.819728058058075],
          [-71.17117117117118, -9.999908444444472],
          [-72.25225225225226, -9.999908444444472],
          [-72.25225225225226, -9.45936728528531],
          [-72.97297297297298, -9.279186898898928],
          [-72.97297297297298, -8.738645739739766],
          [-73.33333333333334, -8.738645739739766],
          [-73.33333333333334, -8.378284966966987],
          [-73.6936936936937, -8.378284966966987],
          [-73.6936936936937, -7.657563421421443],
          [-74.05405405405406, -7.657563421421443],
          [-74.05405405405406, -7.297202648648664],
          [-73.6936936936937, -7.297202648648664],
          [-73.6936936936937, -6.756661489489517],
          [-73.33333333333334, -6.756661489489517],
          [-73.33333333333334, -6.035939943943973],
          [-72.97297297297298, -5.855759557557576],
          [-72.97297297297298, -5.135038012012032],
          [-72.61261261261262, -5.135038012012032],
          [-72.25225225225226, -4.95485762562565],
          [-72.25225225225226, -4.5944968528528705],
          [-71.8918918918919, -4.414316466466488],
          [-70.81081081081082, -4.414316466466488],
          [-70.81081081081082, -4.234136080080106],
          [-70.0900900900901, -4.234136080080106],
          [-70.0900900900901, -4.053955693693723],
          [-69.72972972972974, -3.8737753073073264],
          [-69.72972972972974, -2.0719714434434735],
          [-69.36936936936938, -1.8917910570570768],
          [-69.36936936936938, -0.9908891251251504],
          [-69.72972972972974, -0.8107087387387679],
          [-69.72972972972974, -0.27016757957960635],
          [-70.0900900900901, -0.27016757957960635],
          [-70.0900900900901, 0.6307343523523343],
          [-69.72972972972974, 0.6307343523523343],
          [-69.72972972972974, 1.7118166706706432],
          [-68.2882882882883, 1.7118166706706432],
          [-68.2882882882883, 1.8919970570570257],
          [-67.56756756756758, 1.8919970570570257],
          [-67.20720720720722, 2.0721774434434224],
          [-67.20720720720722, 1.1712755115114817],
          [-66.84684684684686, 1.1712755115114817],
          [-66.4864864864865, 0.9910951251250992],
          [-66.4864864864865, 0.8109147387387168],
          [-65.76576576576578, 0.8109147387387168],
          [-65.76576576576578, 0.9910951251250992],
          [-65.04504504504506, 0.9910951251250992],
          [-65.04504504504506, 1.1712755115114817],
          [-64.32432432432432, 1.5316362842842608],
          [-63.96396396396396, 1.5316362842842608],
          [-63.96396396396396, 1.8919970570570257],
          [-63.6036036036036, 2.0721774434434224],
          [-63.24324324324324, 2.0721774434434224],
          [-63.24324324324324, 2.4325382162161873],
          [-63.96396396396396, 2.4325382162161873],
          [-63.96396396396396, 2.973079375375349],
          [-64.32432432432432, 2.973079375375349],
          [-64.32432432432432, 3.693800920920893],
          [-64.6846846846847, 3.8739813073072753],
          [-64.6846846846847, 4.054161693693672],
          [-63.24324324324324, 4.054161693693672],
          [-63.24324324324324, 3.693800920920893],
          [-62.88288288288288, 3.693800920920893],
          [-62.88288288288288, 4.054161693693672],
          [-62.52252252252252, 4.234342080080054],
          [-61.44144144144144, 4.234342080080054],
          [-61.44144144144144, 4.5947028528528335],
          [-61.08108108108108, 4.774883239239216],
          [-60.72072072072072, 4.774883239239216],
          [-60.72072072072072, 5.3154243983983775],
          [-61.08108108108108, 5.49560478478476],
          [-61.08108108108108, 6.756867489489466],
          [-60.72072072072072, 6.756867489489466],
          [-60.72072072072072, 7.8379498078077745],
          [-60.36036036036036, 8.018130194194171],
          [-60, 8.018130194194171],
          [-60, 8.738851739739715],
          [-60.72072072072072, 8.738851739739715],
          [-60.72072072072072, 9.639753671671642],
          [-61.44144144144144, 10.00011444444442],
          [-62.16216216216216, 10.00011444444442],
          [-61.8018018018018, 10.360475217217186],
          [-61.8018018018018, 11.261377149149126],
          [-62.16216216216216, 11.621737921921891],
          [-62.88288288288288, 11.801918308308274],
          [-63.24324324324324, 11.801918308308274],
          [-63.6036036036036, 11.98209869469467],
          [-63.96396396396396, 11.98209869469467],
          [-64.6846846846847, 12.162279081081053],
          [-67.20720720720722, 12.162279081081053],
          [-67.56756756756758, 12.342459467467435],
          [-67.92792792792794, 12.162279081081053],
          [-67.92792792792794, 11.621737921921891],
          [-68.64864864864866, 11.621737921921891],
          [-69.36936936936938, 11.98209869469467],
          [-69.72972972972974, 12.342459467467435],
          [-70.81081081081082, 12.342459467467435],
          [-71.53153153153154, 12.702820240240214],
          [-71.8918918918919, 12.702820240240214],
          [-71.8918918918919, 18.288412218218184],
          [-71.8918918918919, 19.009133763763728],
          [-71.53153153153154, 19.189314150150125],
          [-71.53153153153154, 19.54967492292289],
          [-71.8918918918919, 19.729855309309286],
          [-71.8918918918919, 20.270396468468434],
          [-67.56756756756758, 20.270396468468434],
          [-67.56756756756758, 43.87402708508506],
          [-67.20720720720722, 44.234387857857826],
          [-67.20720720720722, 44.59474863063059],
          [-66.84684684684686, 44.59474863063059],
          [-66.84684684684686, 44.955109403403355],
          [-67.56756756756758, 45.135289789789766],
          [-67.56756756756758, 45.675830948948914],
          [-67.92792792792794, 45.675830948948914],
          [-67.92792792792794, 47.297454426426384],
          [-68.2882882882883, 47.47763481281277],
          [-68.2882882882883, 48.01817597197194],
          [-65.76576576576578, 48.01817597197194],
          [-65.40540540540542, 47.83799558558556],
          [-64.32432432432432, 48.37853674474471],
          [-63.6036036036036, 48.37853674474471],
          [-62.88288288288288, 48.55871713113109],
          [-62.88288288288288, 48.198356358358325],
          [-62.52252252252252, 47.65781519919915],
          [-62.52252252252252, 47.297454426426384],
          [-62.16216216216216, 46.93709365365362],
          [-61.44144144144144, 46.93709365365362],
          [-61.08108108108108, 47.297454426426384],
          [-61.08108108108108, 48.919077903903855],
          [-61.44144144144144, 49.27943867667665],
          [-61.44144144144144, 50.18034060860856],
          [-61.8018018018018, 50.18034060860856],
          [-61.8018018018018, 51.80196408608606],
          [-62.16216216216216, 51.98214447247244],
          [-63.6036036036036, 51.98214447247244],
          [-63.6036036036036, 52.342505245245206],
          [-64.32432432432432, 52.342505245245206],
          [-64.32432432432432, 51.62178369969965],
          [-64.6846846846847, 51.80196408608606],
          [-65.40540540540542, 51.80196408608606],
          [-65.76576576576578, 52.162324858858824],
          [-66.4864864864865, 52.162324858858824],
          [-66.4864864864865, 52.52268563163159],
          [-67.20720720720722, 52.70286601801797],
          [-67.20720720720722, 53.063226790790765],
          [-66.84684684684686, 53.42358756356353],
          [-67.56756756756758, 53.60376794994991],
          [-67.56756756756758, 53.96412872272268],
          [-67.92792792792794, 54.14430910910906],
          [-67.20720720720722, 54.50466988188185],
          [-67.20720720720722, 54.86503065465462],
          [-66.84684684684686, 55.22539142742738],
          [-65.76576576576578, 54.684850268268235],
          [-65.40540540540542, 54.86503065465462],
          [-64.6846846846847, 54.86503065465462],
          [-63.96396396396396, 54.684850268268235],
          [-63.6036036036036, 54.86503065465462],
          [-63.6036036036036, 56.12629335935932],
          [-63.96396396396396, 56.12629335935932],
          [-63.96396396396396, 57.38755606406403],
          [-63.6036036036036, 57.747916836836794],
          [-64.32432432432432, 57.928097223223176],
          [-64.32432432432432, 58.28845799599597],
          [-63.6036036036036, 58.82899915515512],
          [-64.32432432432432, 59.0091795415415],
          [-64.6846846846847, 59.369540314314264],
          [-64.6846846846847, 60.270442246246205],
          [-64.32432432432432, 60.45062263263259],
          [-64.32432432432432, 61.71188533733729],
          [-64.6846846846847, 61.892065723723675],
          [-64.6846846846847, 62.25242649649647],
          [-63.96396396396396, 62.25242649649647],
          [-63.96396396396396, 62.792967655655616],
          [-63.6036036036036, 63.15332842842838],
          [-63.6036036036036, 63.513689201201146],
          [-63.96396396396396, 63.87404997397394],
          [-64.6846846846847, 64.2344107467467],
          [-64.6846846846847, 64.59477151951947],
          [-64.32432432432432, 64.77495190590585],
          [-62.88288288288288, 64.77495190590585],
          [-62.88288288288288, 65.31549306506503],
          [-61.8018018018018, 65.49567345145141],
          [-61.8018018018018, 65.85603422422417],
          [-60.72072072072072, 66.75693615615612],
          [-62.16216216216216, 67.47765770170165],
          [-63.24324324324324, 67.65783808808806],
          [-64.32432432432432, 68.1983792472472],
          [-65.40540540540542, 68.1983792472472],
          [-66.4864864864865, 68.73892040640635],
          [-66.12612612612614, 69.09928117917914],
          [-66.4864864864865, 69.45964195195191],
          [-66.4864864864865, 70.00018311111106],
          [-67.56756756756758, 70.36054388388385],
          [-67.56756756756758, 75.76595547547544],
          [-69.36936936936938, 75.94613586186182],
          [-71.53153153153154, 76.66685740740735],
          [-72.61261261261262, 77.20739856656652],
          [-72.61261261261262, 77.56775933933929],
          [-74.05405405405406, 78.28848088488485],
          [-72.97297297297298, 78.829022044044],
          [-70.81081081081082, 79.36956320320317],
          [-70.0900900900901, 79.36956320320317],
          [-68.64864864864866, 80.0902847487487],
          [-66.4864864864865, 79.91010436236232],
          [-66.4864864864865, 79.18938281681676],
          [-64.6846846846847, 77.38757895295291],
          [-63.6036036036036, 75.94613586186182],
          [-61.44144144144144, 75.94613586186182],
          [-58.91891891891892, 74.8650535435435],
          [-58.1981981981982, 74.68487315715711],
          [-58.1981981981982, 73.96415161161156],
          [-56.3963963963964, 73.42361045245241],
          [-56.3963963963964, 71.44162620220214],
          [-55.31531531531532, 71.26144581581576],
          [-54.95495495495496, 70.901085043043],
          [-55.67567567567568, 70.54072427027023],
          [-55.31531531531532, 70.00018311111106],
          [-55.67567567567568, 69.82000272472467],
          [-54.5945945945946, 69.27946156556553],
          [-53.513513513513516, 69.09928117917914],
          [-54.234234234234236, 68.01819886086082],
          [-54.234234234234236, 67.47765770170165],
          [-54.5945945945946, 66.9371165425425],
          [-54.234234234234236, 66.57675576976973],
          [-54.234234234234236, 66.03621461061056],
          [-53.873873873873876, 65.67585383783779],
          [-52.792792792792795, 65.13531267867864],
          [-52.432432432432435, 64.59477151951947],
          [-52.432432432432435, 47.83799558558556],
          [-52.792792792792795, 48.198356358358325],
          [-52.792792792792795, 48.919077903903855],
          [-53.153153153153156, 48.73889751751747],
          [-53.153153153153156, 49.45961906306303],
          [-53.873873873873876, 49.63979944944941],
          [-53.873873873873876, 50.00016022222218],
          [-54.5945945945946, 49.819979835835795],
          [-55.31531531531532, 50.00016022222218],
          [-56.03603603603604, 50.36052099499497],
          [-55.31531531531532, 50.54070138138135],
          [-55.31531531531532, 52.162324858858824],
          [-55.31531531531532, 53.42358756356353],
          [-56.03603603603604, 53.96412872272268],
          [-56.75675675675676, 53.783948336336294],
          [-57.47747747747748, 53.42358756356353],
          [-57.47747747747748, 53.063226790790765],
          [-57.11711711711712, 52.883046404404354],
          [-57.11711711711712, 51.26142292692688],
          [-57.83783783783784, 50.720881767767736],
          [-57.83783783783784, 50.18034060860856],
          [-58.55855855855856, 49.63979944944941],
          [-58.55855855855856, 49.27943867667665],
          [-58.91891891891892, 48.919077903903855],
          [-59.63963963963964, 48.55871713113109],
          [-59.63963963963964, 47.47763481281277],
          [-57.47747747747748, 47.47763481281277],
          [-57.11711711711712, 47.297454426426384],
          [-56.3963963963964, 47.297454426426384],
          [-57.11711711711712, 46.93709365365362],
          [-56.75675675675676, 46.576732880880854],
          [-56.03603603603604, 46.21637210810806],
          [-56.03603603603604, 46.576732880880854],
        ],
      ],
    },
    properties: {
      objectid: 10,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-4',
      map_color6: 4,
      map_color8: 4,
      note: null,
      zone: -4,
      utc_format: 'UTC-04:00',
      time_zone: 'UTC-04:00',
      iso_8601: '2012-05-31T00:33:50-04:00',
      places:
        'Bolivia, Brazil (Amazonas), Chile (continental), Dominican Republic, Canada (Nova Scotia), Puerto Rico, Trinidad and Tobago',
      dst_places: 'Falkland Islands',
      tz_name1st: 'America/La_Paz',
      tz_namesum: 39,
      cartodb_id: 17,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [105.40540540540542, 23.333463037037006],
          [105.40540540540542, 22.973102264264227],
          [105.76576576576576, 22.973102264264227],
          [106.12612612612611, 22.973102264264227],
          [106.12612612612611, 22.792921877877845],
          [106.48648648648646, 22.973102264264227],
          [106.48648648648646, 22.792921877877845],
          [106.84684684684686, 22.792921877877845],
          [106.48648648648646, 22.612741491491462],
          [106.48648648648646, 21.89201994594592],
          [106.84684684684686, 21.89201994594592],
          [106.84684684684686, 22.0722003323323],
          [106.84684684684686, 21.89201994594592],
          [107.2072072072072, 21.711839559559536],
          [107.2072072072072, 21.53165917317314],
          [107.56756756756755, 21.711839559559536],
          [107.56756756756755, 21.53165917317314],
          [107.9279279279279, 21.711839559559536],
          [107.9279279279279, 21.53165917317314],
          [108.2882882882883, 21.351478786786757],
          [109.00900900900899, 21.351478786786757],
          [109.00900900900899, 20.810937627627595],
          [109.72972972972974, 20.45057685485483],
          [109.00900900900899, 20.09021608208205],
          [109.00900900900899, 19.729855309309286],
          [108.2882882882883, 19.369494536536507],
          [108.2882882882883, 18.828953377377346],
          [108.64864864864865, 18.648772990990963],
          [108.64864864864865, 18.288412218218184],
          [109.00900900900899, 18.288412218218184],
          [109.36936936936934, 17.92805144544542],
          [110.45045045045043, 18.46859260460458],
          [110.81081081081078, 18.828953377377346],
          [110.81081081081078, 19.189314150150125],
          [111.17117117117118, 19.369494536536507],
          [111.17117117117118, 20.09021608208205],
          [110.81081081081078, 20.270396468468434],
          [110.81081081081078, 21.171298400400374],
          [111.17117117117118, 21.171298400400374],
          [111.53153153153153, 21.351478786786757],
          [112.61261261261262, 21.351478786786757],
          [112.61261261261262, 14.684804490490464],
          [112.61261261261262, 6.216326330330304],
          [102.16216216216213, 6.216326330330304],
          [101.80180180180179, 6.036145943943922],
          [101.80180180180179, 5.6757851711711425],
          [101.80180180180179, 5.855965557557525],
          [101.80180180180179, 5.6757851711711425],
          [101.44144144144144, 5.855965557557525],
          [101.0810810810811, 5.6757851711711425],
          [101.0810810810811, 6.216326330330304],
          [100.72072072072069, 6.216326330330304],
          [100.72072072072069, 6.576687103103083],
          [100.72072072072069, 6.3965067167166865],
          [100.36036036036035, 6.576687103103083],
          [100.36036036036035, 6.756867489489466],
          [100, 6.756867489489466],
          [100, 6.3965067167166865],
          [99.63963963963965, 6.576687103103083],
          [99.27927927927925, 6.3965067167166865],
          [99.63963963963965, 6.216326330330304],
          [99.63963963963965, 6.036145943943922],
          [100, 6.036145943943922],
          [100, 4.955063625625598],
          [100.36036036036035, 4.774883239239216],
          [100.36036036036035, 3.8739813073072753],
          [100.72072072072069, 3.693800920920893],
          [100.72072072072069, 3.5136205345345104],
          [101.0810810810811, 3.333440148148128],
          [101.0810810810811, 2.612718602602584],
          [101.44144144144144, 2.612718602602584],
          [101.80180180180179, 2.4325382162161873],
          [101.80180180180179, 2.252357829829805],
          [102.88288288288288, 1.7118166706706432],
          [102.88288288288288, 1.5316362842842608],
          [103.24324324324323, 1.3514558978978783],
          [103.24324324324323, 1.1712755115114817],
          [103.96396396396398, 1.1712755115114817],
          [104.68468468468467, 1.5316362842842608],
          [105.04504504504501, 1.8919970570570257],
          [105.04504504504501, 2.612718602602584],
          [104.68468468468467, 2.973079375375349],
          [104.68468468468467, 4.955063625625598],
          [109.72972972972974, 4.955063625625598],
          [109.72972972972974, 2.973079375375349],
          [109.72972972972974, 1.5316362842842608],
          [109.72972972972974, 1.3514558978978783],
          [110.09009009009009, 1.3514558978978783],
          [110.09009009009009, 0.9910951251250992],
          [110.45045045045043, 0.9910951251250992],
          [110.45045045045043, 0.8109147387387168],
          [110.81081081081078, 0.8109147387387168],
          [110.81081081081078, 0.9910951251250992],
          [110.81081081081078, 0.8109147387387168],
          [110.81081081081078, 0.9910951251250992],
          [111.17117117117118, 0.9910951251250992],
          [111.53153153153153, 0.9910951251250992],
          [111.89189189189187, 0.9910951251250992],
          [112.25225225225222, 1.1712755115114817],
          [112.25225225225222, 1.5316362842842608],
          [112.61261261261262, 1.5316362842842608],
          [112.97297297297297, 1.5316362842842608],
          [112.97297297297297, 1.3514558978978783],
          [113.33333333333331, 1.3514558978978783],
          [113.69369369369366, 1.1712755115114817],
          [113.69369369369366, 1.3514558978978783],
          [114.05405405405406, 1.5316362842842608],
          [114.05405405405406, 1.3514558978978783],
          [114.05405405405406, 0.8109147387387168],
          [114.05405405405406, 0.9910951251250992],
          [114.05405405405406, 0.6307343523523343],
          [113.69369369369366, 0.6307343523523343],
          [114.05405405405406, 0.6307343523523343],
          [114.41441441441441, 0.6307343523523343],
          [114.77477477477476, 0.8109147387387168],
          [115.1351351351351, 0.8109147387387168],
          [115.1351351351351, -0.0899871931932239],
          [115.1351351351351, 0.09019319319317276],
          [115.1351351351351, -0.4503479659659888],
          [115.4954954954955, -0.4503479659659888],
          [115.4954954954955, -0.9908891251251504],
          [115.85585585585585, -1.1710695115115328],
          [115.85585585585585, -1.3512498978979153],
          [115.4954954954955, -1.3512498978979153],
          [115.4954954954955, -1.8917910570570768],
          [115.1351351351351, -1.8917910570570768],
          [115.1351351351351, -2.252151829829856],
          [114.77477477477476, -2.252151829829856],
          [114.77477477477476, -2.7926929889890175],
          [114.41441441441441, -2.7926929889890175],
          [114.41441441441441, -3.5134145345345615],
          [114.05405405405406, -3.8737753073073264],
          [114.05405405405406, -4.234136080080106],
          [113.69369369369366, -4.774677239239267],
          [113.69369369369366, -5.135038012012032],
          [116.2162162162162, -5.135038012012032],
          [116.2162162162162, -7.477383035035061],
          [115.85585585585585, -7.477383035035061],
          [114.77477477477476, -7.477383035035061],
          [114.77477477477476, -7.837743807807826],
          [114.41441441441441, -8.017924194194222],
          [114.41441441441441, -8.378284966966987],
          [114.77477477477476, -8.55846535335337],
          [114.77477477477476, -9.639547671671693],
          [112.61261261261262, -9.639547671671693],
          [112.61261261261262, -65.67564783783784],
          [111.89189189189187, -65.85582822422423],
          [110.81081081081078, -65.85582822422423],
          [110.09009009009009, -66.216188996997],
          [110.09009009009009, -66.57654976976977],
          [109.00900900900899, -66.75673015615617],
          [108.2882882882883, -66.39636938338339],
          [107.2072072072072, -66.39636938338339],
          [105.76576576576576, -66.03600861061062],
          [104.68468468468467, -65.85582822422423],
          [103.24324324324323, -65.85582822422423],
          [103.96396396396398, -65.49546745145146],
          [103.24324324324323, -64.9549262922923],
          [102.52252252252254, -64.9549262922923],
          [102.52252252252254, -65.31528706506506],
          [101.80180180180179, -65.49546745145146],
          [101.0810810810811, -65.13510667867868],
          [100, -65.31528706506506],
          [100, -65.85582822422423],
          [99.27927927927925, -66.216188996997],
          [97.47747747747746, -66.216188996997],
          [97.47747747747746, -12.882794626626648],
          [97.47747747747746, -11.261171149149177],
          [97.47747747747746, 0.6307343523523343],
          [97.11711711711712, 0.6307343523523343],
          [97.11711711711712, 1.1712755115114817],
          [96.75675675675677, 1.3514558978978783],
          [96.75675675675677, 1.8919970570570257],
          [96.03603603603602, 2.252357829829805],
          [96.03603603603602, 2.4325382162161873],
          [95.31531531531527, 2.7928989889889664],
          [96.03603603603602, 3.1532597617617313],
          [96.39639639639637, 2.973079375375349],
          [96.39639639639637, 2.612718602602584],
          [96.75675675675677, 2.4325382162161873],
          [97.47747747747746, 2.4325382162161873],
          [97.47747747747746, 2.612718602602584],
          [97.11711711711712, 2.7928989889889664],
          [97.11711711711712, 3.1532597617617313],
          [96.75675675675677, 3.333440148148128],
          [96.75675675675677, 3.5136205345345104],
          [96.03603603603602, 3.8739813073072753],
          [96.03603603603602, 4.054161693693672],
          [95.67567567567568, 4.414522466466437],
          [95.31531531531527, 4.5947028528528335],
          [94.95495495495493, 4.955063625625598],
          [94.95495495495493, 6.036145943943922],
          [95.31531531531527, 6.036145943943922],
          [96.03603603603602, 5.6757851711711425],
          [96.03603603603602, 5.49560478478476],
          [97.47747747747746, 5.49560478478476],
          [97.47747747747746, 9.639753671671642],
          [97.83783783783781, 9.639753671671642],
          [98.19819819819821, 9.45957328528526],
          [98.19819819819821, 9.819934058058024],
          [98.55855855855856, 10.00011444444442],
          [98.55855855855856, 10.360475217217186],
          [98.9189189189189, 10.360475217217186],
          [98.9189189189189, 11.08119676276273],
          [99.27927927927925, 11.08119676276273],
          [99.27927927927925, 11.621737921921891],
          [99.63963963963965, 11.621737921921891],
          [99.63963963963965, 12.162279081081053],
          [99.27927927927925, 12.162279081081053],
          [99.27927927927925, 13.783902558558538],
          [98.9189189189189, 13.783902558558538],
          [98.9189189189189, 14.144263331331302],
          [98.55855855855856, 14.144263331331302],
          [98.55855855855856, 14.684804490490464],
          [98.19819819819821, 14.684804490490464],
          [98.19819819819821, 15.225345649649626],
          [98.55855855855856, 15.225345649649626],
          [98.55855855855856, 17.02714951351348],
          [98.19819819819821, 17.02714951351348],
          [98.19819819819821, 17.387510286286258],
          [97.83783783783781, 17.56769067267264],
          [97.83783783783781, 19.729855309309286],
          [98.9189189189189, 19.729855309309286],
          [98.9189189189189, 20.09021608208205],
          [99.63963963963965, 20.09021608208205],
          [99.63963963963965, 20.270396468468434],
          [100.36036036036035, 20.630757241241213],
          [100.36036036036035, 20.991118014013978],
          [100.72072072072069, 20.991118014013978],
          [100.72072072072069, 21.351478786786757],
          [101.0810810810811, 21.53165917317314],
          [101.0810810810811, 21.351478786786757],
          [101.44144144144144, 21.171298400400374],
          [101.80180180180179, 21.171298400400374],
          [101.80180180180179, 21.89201994594592],
          [101.44144144144144, 21.89201994594592],
          [101.44144144144144, 22.252380718718683],
          [101.80180180180179, 22.43256110510508],
          [102.16216216216213, 22.43256110510508],
          [102.52252252252254, 22.612741491491462],
          [102.52252252252254, 22.792921877877845],
          [102.52252252252254, 22.612741491491462],
          [102.52252252252254, 22.792921877877845],
          [102.88288288288288, 22.43256110510508],
          [103.24324324324323, 22.43256110510508],
          [103.24324324324323, 22.792921877877845],
          [103.60360360360357, 22.612741491491462],
          [103.60360360360357, 22.792921877877845],
          [103.96396396396398, 22.43256110510508],
          [103.96396396396398, 22.792921877877845],
          [104.32432432432432, 22.792921877877845],
          [104.32432432432432, 22.612741491491462],
          [104.68468468468467, 22.792921877877845],
          [104.68468468468467, 23.153282650650624],
          [105.04504504504501, 23.153282650650624],
          [105.04504504504501, 23.333463037037006],
          [105.40540540540542, 23.333463037037006],
        ],
      ],
    },
    properties: {
      objectid: 27,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+7',
      map_color6: 5,
      map_color8: 1,
      note: null,
      zone: 7,
      utc_format: 'UTC+07:00',
      time_zone: 'UTC+07:00',
      iso_8601: '2012-05-31T11:33:50+07:00',
      places: 'Jakarta, Thailand, Vietnam',
      dst_places: null,
      tz_name1st: 'Asia/Jakarta',
      tz_namesum: 9,
      cartodb_id: 55,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [78.018018018018, 35.40554892],
          [78.018018018018, 34.86500777],
          [78.37837837837839, 34.86500777],
          [78.37837837837839, 34.50464699],
          [78.73873873873875, 34.50464699],
          [78.73873873873875, 33.42356467],
          [79.09909909909909, 33.24338429],
          [79.45945945945941, 33.24338429],
          [79.45945945945941, 32.52266274],
          [79.09909909909909, 32.52266274],
          [78.73873873873875, 32.34248236],
          [78.73873873873875, 32.70284313],
          [78.37837837837839, 32.52266274],
          [78.37837837837839, 32.16230197],
          [78.73873873873875, 31.98212158],
          [78.73873873873875, 31.62176081],
          [78.73873873873875, 31.26140004],
          [79.09909909909909, 31.26140004],
          [79.09909909909909, 31.44158042],
          [79.09909909909909, 31.08121965],
          [79.45945945945941, 30.90103927],
          [79.81981981981984, 30.90103927],
          [80.18018018018019, 30.72085888],
          [80.18018018018019, 30.54067849],
          [80.54054054054051, 30.54067849],
          [80.90090090090085, 30.18031772],
          [80.18018018018019, 29.81995695],
          [80.18018018018019, 28.55869424],
          [80.90090090090085, 28.55869424],
          [81.6216216216216, 28.19833347],
          [82.34234234234231, 27.8379727],
          [83.06306306306306, 27.47761192],
          [84.14414414414415, 27.47761192],
          [84.5045045045045, 27.11725115],
          [84.86486486486486, 26.93707076],
          [85.2252252252252, 26.93707076],
          [85.58558558558559, 26.57670999],
          [86.66666666666662, 26.57670999],
          [86.66666666666662, 26.39652961000001],
          [88.10810810810806, 26.39652961000001],
          [88.10810810810806, 28.01815308],
          [88.46846846846846, 28.01815308],
          [88.8288288288288, 28.01815308],
          [88.8288288288288, 27.29743154],
          [88.8288288288288, 26.93707076],
          [89.18918918918917, 26.93707076],
          [89.54954954954951, 26.75689038000001],
          [91.7117117117117, 26.75689038000001],
          [92.12067150847685, 26.89251854],
          [93.08907336751319, 26.88581446],
          [93.8432143904637, 27.04704264],
          [94.31459045959522, 27.59342372],
          [95.28645306658275, 27.93761512],
          [95.88731447863961, 28.2782037],
          [97.06757612960728, 27.73678712383361],
          [96.03603603603601, 27.29743154],
          [96.03603603603601, 26.93707076],
          [95.67567567567566, 26.93707076],
          [94.95495495495491, 26.57670999],
          [94.95495495495491, 25.49562767],
          [94.5945945945946, 25.49562767],
          [94.5945945945946, 24.59472574],
          [94.23423423423425, 24.59472574],
          [94.23423423423425, 23.8740042],
          [93.5135135135135, 23.8740042],
          [93.5135135135135, 22.97310226],
          [93.15315315315316, 22.97310226],
          [93.15315315315316, 22.07220033],
          [92.43243243243241, 22.07220033],
          [92.43243243243241, 21.89201995],
          [92.43243243243241, 23.69382381000001],
          [92.07207207207206, 23.69382381000001],
          [91.7117117117117, 23.51364342],
          [91.7117117117117, 22.97310226],
          [91.35135135135135, 24.05418458000001],
          [91.7117117117117, 24.23436497],
          [92.07207207207206, 24.23436497],
          [92.07207207207206, 24.95508651],
          [92.43243243243241, 25.1352669],
          [90.27027027027026, 25.1352669],
          [89.9099099099099, 25.31544729],
          [89.9099099099099, 26.03616883],
          [89.18918918918917, 26.03616883],
          [89.18918918918917, 26.39652961000001],
          [88.10810810810806, 26.21634922],
          [88.10810810810806, 25.85598845],
          [88.8288288288288, 25.49562767],
          [88.8288288288288, 25.1352669],
          [88.46846846846846, 25.1352669],
          [88.10810810810806, 24.95508651],
          [88.10810810810806, 24.41454536],
          [88.46846846846846, 24.41454536],
          [88.8288288288288, 24.23436497],
          [88.8288288288288, 23.8740042],
          [88.46846846846846, 23.51364342],
          [88.8288288288288, 23.51364342],
          [88.8288288288288, 22.25238072],
          [89.18918918918917, 22.25238072],
          [89.18918918918917, 21.35147879],
          [88.10810810810806, 21.35147879],
          [87.74774774774771, 21.53165917],
          [87.02702702702705, 21.1712984],
          [87.02702702702705, 20.27039647],
          [86.66666666666662, 19.9100357],
          [84.86486486486486, 18.82895338],
          [84.5045045045045, 18.4685926],
          [84.5045045045045, 18.28841222],
          [83.78378378378375, 17.92805145],
          [83.78378378378375, 17.74787106],
          [83.4234234234234, 17.38751029],
          [83.06306306306306, 17.2073299],
          [82.7027027027027, 17.2073299],
          [82.7027027027027, 16.48660835],
          [82.34234234234231, 16.48660835],
          [81.26126126126125, 16.12624758],
          [81.26126126126125, 15.58570642],
          [80.54054054054051, 15.58570642],
          [80.18018018018019, 15.22534565],
          [80.18018018018019, 14.86498488],
          [80.54054054054051, 14.68480449],
          [80.54054054054051, 12.52263985],
          [80.18018018018019, 12.34245947],
          [80.18018018018019, 10.00011444],
          [80.54054054054051, 9.819934057999999],
          [81.26126126126125, 8.738851739999999],
          [81.6216216216216, 8.558671352999999],
          [81.6216216216216, 8.198310580999999],
          [81.98198198198196, 8.018130193999999],
          [81.98198198198196, 6.396506717000001],
          [80.54054054054051, 5.675785171],
          [79.81981981981984, 6.036145943999999],
          [79.81981981981984, 6.756867489],
          [79.45945945945941, 7.117228262],
          [79.45945945945941, 8.378490966999999],
          [79.81981981981984, 8.919032125999999],
          [79.45945945945941, 8.919032125999999],
          [79.09909909909909, 9.099212512999999],
          [78.73873873873875, 8.919032125999999],
          [78.37837837837839, 8.919032125999999],
          [78.37837837837839, 8.198310580999999],
          [77.65765765765765, 7.837949808],
          [76.93693693693695, 8.198310580999999],
          [76.93693693693695, 8.378490966999999],
          [76.2162162162162, 8.738851739999999],
          [75.85585585585585, 10.18029483],
          [75.85585585585585, 10.72083599],
          [75.49549549549549, 10.90101638],
          [75.49549549549549, 11.62173792],
          [75.13513513513514, 11.98209869],
          [74.77477477477476, 12.16227908],
          [74.77477477477476, 12.70282024],
          [74.4144144144144, 13.06318101],
          [74.4144144144144, 13.96408294],
          [74.05405405405405, 14.14426333],
          [73.69369369369369, 14.86498488],
          [73.69369369369369, 15.58570642],
          [73.3333333333333, 15.58570642],
          [73.3333333333333, 16.12624758],
          [72.97297297297298, 16.48660835],
          [72.97297297297298, 17.92805145],
          [72.61261261261259, 18.10823183],
          [72.61261261261259, 19.54967492],
          [72.61261261261259, 20.99111801],
          [71.89189189189189, 20.99111801],
          [70.09009009009009, 20.81093763],
          [69.36936936936938, 21.53165917],
          [69.36936936936938, 21.71183956],
          [68.64864864864865, 22.07220033],
          [68.64864864864865, 22.61274149],
          [69.00900900900899, 22.79292188],
          [68.28828828828829, 23.15328265],
          [68.28828828828829, 24.05418458000001],
          [68.64864864864865, 24.23436497],
          [70.09009009009009, 24.23436497],
          [70.81081081081079, 24.23436497],
          [70.81081081081079, 25.67580806],
          [70.09009009009009, 25.67580806],
          [70.09009009009009, 26.57670999],
          [69.7297297297297, 26.75689038000001],
          [69.36936936936938, 26.75689038000001],
          [69.36936936936938, 27.11725115],
          [69.7297297297297, 27.11725115],
          [69.7297297297297, 27.47761192],
          [70.09009009009009, 27.65779231],
          [70.81081081081079, 28.01815308],
          [71.17117117117115, 27.8379727],
          [71.53153153153154, 27.8379727],
          [71.89189189189189, 28.01815308],
          [72.25225225225225, 28.37851386],
          [72.25225225225225, 28.73887463],
          [72.97297297297298, 29.09923540000001],
          [73.3333333333333, 29.45959617000001],
          [73.3333333333333, 30.00013733],
          [73.69369369369369, 30.00013733],
          [74.05405405405405, 30.72085888],
          [74.4144144144144, 30.72085888],
          [74.4144144144144, 31.80194120000001],
          [75.49549549549549, 32.34248236],
          [74.77477477477476, 32.70284313],
          [74.4144144144144, 32.70284313],
          [74.4144144144144, 33.0632039],
          [74.05405405405405, 33.0632039],
          [74.05405405405405, 34.68482738],
          [75.13513513513514, 34.68482738],
          [75.85585585585585, 34.50464699],
          [75.85585585585585, 34.68482738],
          [76.57657657657654, 34.68482738],
          [76.57657657657654, 34.86500777],
          [77.65765765765765, 35.40554892],
        ],
      ],
    },
    properties: {
      objectid: 23,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+5.5',
      map_color6: 3,
      map_color8: 3,
      note: null,
      zone: 5.5,
      utc_format: 'UTC+05:30',
      time_zone: 'UTC+05:30',
      iso_8601: '2012-05-31T10:03:50+05:30',
      places: 'India, Sri Lanka',
      dst_places: null,
      tz_name1st: 'Asia/Kolkata',
      tz_namesum: 1,
      cartodb_id: 57,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [157.65765765765764, -69.09907517917918],
          [157.2972972972973, -68.9188947927928],
          [156.2162162162162, -68.9188947927928],
          [155.4954954954955, -68.73871440640642],
          [154.4144144144144, -68.19817324724725],
          [153.33333333333331, -68.19817324724725],
          [153.33333333333331, -68.55853402002003],
          [151.53153153153153, -68.55853402002003],
          [151.53153153153153, -68.19817324724725],
          [147.56756756756755, -68.19817324724725],
          [147.56756756756755, -68.01799286086087],
          [146.48648648648646, -67.47745170170171],
          [145.04504504504501, -67.29727131531533],
          [145.04504504504501, -66.93691054254255],
          [143.96396396396398, -66.75673015615617],
          [142.52252252252248, -66.75673015615617],
          [142.52252252252248, -38.46840949349351],
          [141.8018018018018, -38.46840949349351],
          [141.44144144144144, -38.64858987987989],
          [141.08108108108104, -38.28822910710712],
          [141.08108108108104, -31.9819155835836],
          [141.8018018018018, -31.9819155835836],
          [141.8018018018018, -31.44137442442444],
          [141.08108108108104, -31.44137442442444],
          [141.08108108108104, -26.03596283283285],
          [137.8378378378378, -26.03596283283285],
          [137.8378378378378, -16.486402354354368],
          [137.8378378378378, -16.306221967967986],
          [138.55855855855856, -16.666582740740765],
          [139.6396396396396, -16.126041581581603],
          [140, -16.306221967967986],
          [140, -16.666582740740765],
          [139.6396396396396, -16.666582740740765],
          [139.6396396396396, -17.38730428628631],
          [140, -17.56748467267269],
          [140.36036036036035, -17.56748467267269],
          [140.7207207207207, -17.38730428628631],
          [140.7207207207207, -16.846763127127147],
          [141.08108108108104, -16.666582740740765],
          [141.08108108108104, -15.585500422422442],
          [141.44144144144144, -15.40532003603606],
          [141.44144144144144, -13.783696558558574],
          [141.44144144144144, -11.981892694694722],
          [141.8018018018018, -11.801712308308325],
          [141.8018018018018, -9.819728058058075],
          [142.16216216216213, -9.819728058058075],
          [142.16216216216213, -9.45936728528531],
          [141.08108108108104, -9.45936728528531],
          [141.08108108108104, -6.57648110310312],
          [141.08108108108104, -1.8917910570570768],
          [141.44144144144144, -1.3512498978979153],
          [142.16216216216213, -0.6305283523523713],
          [142.16216216216213, -0.0899871931932239],
          [142.52252252252248, 0.2703735795795552],
          [142.52252252252248, 4.054161693693672],
          [136.03603603603602, 4.054161693693672],
          [136.03603603603602, 17.02714951351348],
          [142.52252252252248, 17.02714951351348],
          [142.52252252252248, 40.45059974374371],
          [142.52252252252248, 42.07222322122118],
          [143.24324324324323, 41.711862448448414],
          [143.60360360360357, 41.8920428348348],
          [143.60360360360357, 42.25240360760756],
          [143.96396396396398, 42.79294476676674],
          [145.04504504504501, 42.79294476676674],
          [145.76576576576576, 43.1533055395395],
          [146.48648648648646, 43.333485925925885],
          [147.56756756756755, 43.87402708508506],
          [148.64864864864865, 44.234387857857826],
          [149.72972972972974, 45.135289789789766],
          [151.53153153153153, 46.03619172172168],
          [152.61261261261262, 46.93709365365362],
          [153.33333333333331, 47.11727404004],
          [154.05405405405406, 47.65781519919915],
          [154.4144144144144, 48.01817597197194],
          [155.1351351351351, 48.37853674474471],
          [156.2162162162162, 49.27943867667665],
          [157.2972972972973, 49.63979944944941],
          [157.65765765765764, 50.00016022222218],
          [157.65765765765764, 11.98209869469467],
          [154.05405405405406, 11.98209869469467],
          [154.05405405405406, -0.0899871931932239],
          [157.65765765765764, -0.0899871931932239],
          [157.65765765765764, -3.5134145345345615],
          [160.18018018018017, -3.5134145345345615],
          [160.18018018018017, -4.774677239239267],
          [158.73873873873873, -4.774677239239267],
          [158.01801801801798, -5.135038012012032],
          [157.65765765765764, -5.495398784784811],
          [157.2972972972973, -5.675579171171194],
          [156.93693693693695, -6.035939943943973],
          [155.85585585585585, -6.57648110310312],
          [155.85585585585585, -6.936841875875899],
          [155.4954954954955, -6.936841875875899],
          [154.77477477477476, -7.657563421421443],
          [154.4144144144144, -8.198104580580605],
          [154.77477477477476, -8.378284966966987],
          [155.1351351351351, -8.738645739739766],
          [155.1351351351351, -9.099006512512531],
          [155.4954954954955, -9.279186898898928],
          [156.2162162162162, -9.999908444444472],
          [156.2162162162162, -10.360269217217237],
          [157.2972972972973, -11.44135153553556],
          [157.2972972972973, -11.801712308308325],
          [157.65765765765764, -12.162073081081104],
          [157.65765765765764, -69.09907517917918],
        ],
      ],
    },
    properties: {
      objectid: 31,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+10',
      map_color6: 2,
      map_color8: 5,
      note: null,
      zone: 10,
      utc_format: 'UTC+10:00',
      time_zone: 'UTC+10:00',
      iso_8601: '2012-05-31T14:33:50+10:00',
      places:
        'Papua New Guinea, Australia (Queensland, New South Wales, Tasmania, Victoria)',
      dst_places: 'Australia (New South Wales, Tasmania, Victoria)',
      tz_name1st: 'Australia/Sydney',
      tz_namesum: 10,
      cartodb_id: 25,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-82.34234234234235, 18.46859260460458],
          [-82.34234234234235, 17.747871059059037],
          [-82.34234234234235, 9.639753671671642],
          [-82.70270270270271, 9.639753671671642],
          [-83.06306306306307, 9.45957328528526],
          [-83.06306306306307, 9.09921251251248],
          [-82.70270270270271, 9.09921251251248],
          [-82.70270270270271, 8.378490966966936],
          [-83.06306306306307, 8.378490966966936],
          [-83.06306306306307, 7.8379498078077745],
          [-82.70270270270271, 8.018130194194171],
          [-82.34234234234235, 8.018130194194171],
          [-82.34234234234235, -73.60358483883884],
          [-82.70270270270271, -73.42340445245246],
          [-84.50450450450451, -73.42340445245246],
          [-85.58558558558559, -72.8828632932933],
          [-87.02702702702703, -73.06304367967968],
          [-87.74774774774775, -72.52250252052053],
          [-90.27027027027027, -72.52250252052053],
          [-90.63063063063063, -72.34232213413414],
          [-94.5945945945946, -72.34232213413414],
          [-95.67567567567568, -71.80178097497497],
          [-95.67567567567568, -71.62160058858859],
          [-97.47747747747748, -71.62160058858859],
          [-97.47747747747748, -28.918849015015034],
          [-101.08108108108108, -28.918849015015034],
          [-111.17117117117118, -28.918849015015034],
          [-111.17117117117118, -24.954880514514528],
          [-99.63963963963964, -24.954880514514528],
          [-97.47747747747748, -24.954880514514528],
          [-97.47747747747748, 15.765886808808787],
          [-97.83783783783784, 15.765886808808787],
          [-99.27927927927928, 16.48660835435433],
          [-99.63963963963964, 16.48660835435433],
          [-101.08108108108108, 17.207329899899875],
          [-102.52252252252252, 17.92805144544542],
          [-103.24324324324324, 17.92805144544542],
          [-103.24324324324324, 18.1082318318318],
          [-103.96396396396396, 18.46859260460458],
          [-103.96396396396396, 18.648772990990963],
          [-105.4054054054054, 19.369494536536507],
          [-105.4054054054054, 19.729855309309286],
          [-105.76576576576576, 19.91003569569567],
          [-105.76576576576576, 20.630757241241213],
          [-105.4054054054054, 20.630757241241213],
          [-104.32432432432432, 21.171298400400374],
          [-103.96396396396396, 21.171298400400374],
          [-103.96396396396396, 21.53165917317314],
          [-104.32432432432432, 21.53165917317314],
          [-104.32432432432432, 22.43256110510508],
          [-104.68468468468468, 22.612741491491462],
          [-105.04504504504504, 22.612741491491462],
          [-105.04504504504504, 22.973102264264227],
          [-105.4054054054054, 23.153282650650624],
          [-105.76576576576576, 23.153282650650624],
          [-105.76576576576576, 24.05418458258255],
          [-106.12612612612612, 24.05418458258255],
          [-106.12612612612612, 24.41454535535533],
          [-106.48648648648648, 24.594725741741712],
          [-106.84684684684684, 24.594725741741712],
          [-106.84684684684684, 24.955086514514477],
          [-107.2072072072072, 24.955086514514477],
          [-107.2072072072072, 25.49562767367364],
          [-106.84684684684684, 25.675808060060035],
          [-106.48648648648648, 25.675808060060035],
          [-106.48648648648648, 26.39652960560558],
          [-106.12612612612612, 26.39652960560558],
          [-105.76576576576576, 26.57670999199196],
          [-104.68468468468468, 26.57670999199196],
          [-104.32432432432432, 26.756890378378344],
          [-103.6036036036036, 26.756890378378344],
          [-103.6036036036036, 27.117251151151123],
          [-103.96396396396396, 27.297431537537506],
          [-103.96396396396396, 28.198333469469432],
          [-103.6036036036036, 28.198333469469432],
          [-103.6036036036036, 28.738874628628594],
          [-103.24324324324324, 29.099235401401373],
          [-104.32432432432432, 29.639776560560534],
          [-104.68468468468468, 29.639776560560534],
          [-104.68468468468468, 30.54067849249246],
          [-105.04504504504504, 30.54067849249246],
          [-105.04504504504504, 31.98212158358355],
          [-103.24324324324324, 31.98212158358355],
          [-103.24324324324324, 32.34248235635633],
          [-102.88288288288288, 32.52266274274271],
          [-102.88288288288288, 37.02717240240237],
          [-102.16216216216216, 37.02717240240237],
          [-102.16216216216216, 37.747893947947915],
          [-101.44144144144144, 37.747893947947915],
          [-101.44144144144144, 39.54969781181177],
          [-102.16216216216216, 39.54969781181177],
          [-102.16216216216216, 40.090238970970944],
          [-101.44144144144144, 40.090238970970944],
          [-101.44144144144144, 40.63078013013009],
          [-101.08108108108108, 40.63078013013009],
          [-101.08108108108108, 40.991140902902856],
          [-101.44144144144144, 40.991140902902856],
          [-101.44144144144144, 41.711862448448414],
          [-100.72072072072072, 41.711862448448414],
          [-100.72072072072072, 42.97312515315312],
          [-101.08108108108108, 42.97312515315312],
          [-101.08108108108108, 44.234387857857826],
          [-100.36036036036036, 44.234387857857826],
          [-100.36036036036036, 45.856011335335296],
          [-101.44144144144144, 45.856011335335296],
          [-101.44144144144144, 46.21637210810806],
          [-100.72072072072072, 46.39655249449444],
          [-100.72072072072072, 47.11727404004],
          [-101.08108108108108, 47.11727404004],
          [-102.16216216216216, 47.65781519919915],
          [-103.6036036036036, 47.65781519919915],
          [-103.96396396396396, 47.83799558558556],
          [-103.96396396396396, 48.919077903903855],
          [-110.09009009009009, 48.919077903903855],
          [-110.09009009009009, 52.70286601801797],
          [-109.36936936936937, 52.70286601801797],
          [-109.009009009009, 52.883046404404354],
          [-109.009009009009, 53.42358756356353],
          [-109.72972972972973, 53.42358756356353],
          [-110.09009009009009, 53.60376794994991],
          [-110.09009009009009, 59.91008147347344],
          [-102.16216216216216, 59.91008147347344],
          [-102.16216216216216, 66.9371165425425],
          [-88.82882882882883, 66.9371165425425],
          [-88.82882882882883, 68.37855963363359],
          [-89.1891891891892, 68.73892040640635],
          [-89.1891891891892, 69.45964195195191],
          [-90.27027027027027, 69.63982233833829],
          [-90.990990990991, 70.00018311111106],
          [-90.990990990991, 70.36054388388385],
          [-92.07207207207207, 70.901085043043],
          [-92.07207207207207, 71.26144581581576],
          [-94.23423423423424, 72.34252813413408],
          [-95.31531531531532, 72.52270852052047],
          [-96.3963963963964, 72.52270852052047],
          [-97.47747747747748, 72.88306929329326],
          [-98.91891891891892, 72.88306929329326],
          [-100.36036036036036, 73.24343006606603],
          [-101.44144144144144, 73.24343006606603],
          [-102.16216216216216, 73.42361045245241],
          [-102.16216216216216, 79.36956320320317],
          [-101.44144144144144, 79.36956320320317],
          [-101.08108108108108, 80.27046513513508],
          [-97.83783783783784, 80.27046513513508],
          [-97.47747747747748, 80.63082590790785],
          [-97.47747747747748, 84.95515518118114],
          [-97.47747747747748, 90.00020599999996],
          [-82.34234234234235, 90.00020599999996],
          [-82.34234234234235, 82.97317093093088],
          [-84.86486486486487, 82.61281015815811],
          [-84.86486486486487, 66.21639499699697],
          [-85.94594594594595, 65.85603422422417],
          [-88.82882882882883, 62.973148042042],
          [-88.82882882882883, 56.84701490490485],
          [-89.54954954954955, 56.48665413213209],
          [-89.90990990990991, 56.12629335935932],
          [-89.90990990990991, 53.96412872272268],
          [-89.1891891891892, 53.96412872272268],
          [-88.46846846846847, 53.60376794994991],
          [-88.46846846846847, 53.42358756356353],
          [-89.1891891891892, 53.063226790790765],
          [-89.1891891891892, 52.70286601801797],
          [-89.90990990990991, 52.70286601801797],
          [-89.90990990990991, 51.98214447247244],
          [-90.63063063063063, 51.80196408608606],
          [-90.63063063063063, 51.0812425405405],
          [-89.90990990990991, 50.720881767767736],
          [-89.90990990990991, 49.45961906306303],
          [-90.990990990991, 49.27943867667665],
          [-90.990990990991, 48.55871713113109],
          [-90.27027027027027, 48.37853674474471],
          [-89.54954954954955, 48.01817597197194],
          [-89.54954954954955, 47.65781519919915],
          [-89.90990990990991, 47.65781519919915],
          [-89.90990990990991, 46.576732880880854],
          [-89.1891891891892, 46.576732880880854],
          [-89.1891891891892, 46.39655249449444],
          [-88.10810810810811, 46.39655249449444],
          [-87.38738738738739, 46.03619172172168],
          [-87.38738738738739, 45.49565056256253],
          [-86.66666666666667, 45.49565056256253],
          [-86.66666666666667, 44.59474863063059],
          [-87.02702702702703, 44.41456824424421],
          [-87.02702702702703, 41.8920428348348],
          [-86.66666666666667, 41.711862448448414],
          [-86.66666666666667, 41.35150167567565],
          [-87.02702702702703, 41.17132128928927],
          [-87.02702702702703, 40.810960516516474],
          [-87.38738738738739, 40.810960516516474],
          [-87.38738738738739, 39.369517425425386],
          [-87.74774774774775, 39.369517425425386],
          [-87.74774774774775, 39.00915665265262],
          [-87.38738738738739, 39.00915665265262],
          [-87.38738738738739, 38.648795879879856],
          [-86.66666666666667, 38.28843510710706],
          [-86.30630630630631, 37.9280743343343],
          [-86.30630630630631, 37.56771356156153],
          [-85.94594594594595, 37.56771356156153],
          [-85.22522522522523, 37.207352788788754],
          [-84.86486486486487, 37.207352788788754],
          [-84.50450450450451, 36.846992016015975],
          [-84.86486486486487, 36.66681162962959],
          [-84.86486486486487, 35.765909697697666],
          [-85.22522522522523, 35.58572931131128],
          [-85.22522522522523, 35.04518815215212],
          [-85.58558558558559, 35.04518815215212],
          [-85.58558558558559, 34.14428622022018],
          [-85.22522522522523, 33.9641058338338],
          [-85.22522522522523, 32.70284312912909],
          [-84.86486486486487, 32.52266274274271],
          [-84.86486486486487, 32.16230196996993],
          [-85.22522522522523, 32.16230196996993],
          [-85.22522522522523, 31.081219651651622],
          [-84.86486486486487, 31.081219651651622],
          [-84.86486486486487, 30.36049810610608],
          [-85.22522522522523, 30.18031771971968],
          [-85.22522522522523, 29.459596174174138],
          [-84.86486486486487, 29.459596174174138],
          [-84.14414414414415, 29.819956946946917],
          [-83.78378378378379, 29.819956946946917],
          [-83.78378378378379, 29.459596174174138],
          [-83.42342342342343, 29.459596174174138],
          [-83.42342342342343, 29.099235401401373],
          [-83.06306306306307, 28.919055015014976],
          [-83.06306306306307, 27.477611923923888],
          [-82.34234234234235, 26.756890378378344],
          [-82.34234234234235, 23.333463037037006],
          [-82.70270270270271, 23.333463037037006],
          [-83.06306306306307, 23.153282650650624],
          [-83.42342342342343, 23.153282650650624],
          [-83.78378378378379, 22.973102264264227],
          [-84.14414414414415, 22.973102264264227],
          [-84.50450450450451, 22.792921877877845],
          [-84.50450450450451, 22.252380718718683],
          [-84.86486486486487, 22.252380718718683],
          [-85.22522522522523, 22.0722003323323],
          [-85.22522522522523, 21.711839559559536],
          [-84.86486486486487, 21.711839559559536],
          [-84.50450450450451, 21.53165917317314],
          [-84.14414414414415, 21.711839559559536],
          [-83.42342342342343, 21.711839559559536],
          [-83.42342342342343, 21.351478786786757],
          [-82.34234234234235, 21.351478786786757],
          [-82.34234234234235, 18.46859260460458],
        ],
      ],
    },
    properties: {
      objectid: 8,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-6',
      map_color6: 6,
      map_color8: 2,
      note: null,
      zone: -6,
      utc_format: 'UTC-06:00',
      time_zone: 'UTC-06:00',
      iso_8601: '2012-05-30T22:33:50-06:00',
      places:
        'Canada (almost all of Saskatchewan), Costa Rica, El Salvador, Ecuador (Galapagos Islands), Guatemala, Honduras, Mexico (most), Nicaragua,',
      dst_places: 'Canada (Manitoba), United States (Illinois, most of Texas)',
      tz_name1st: 'America/Chicago',
      tz_namesum: 25,
      cartodb_id: 12,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-59.63963963963964, 82.25244938538535],
          [-61.44144144144144, 82.07226899899896],
          [-66.12612612612614, 80.81100629429426],
          [-68.2882882882883, 80.45064552152147],
          [-68.64864864864866, 80.27046513513508],
          [-68.64864864864866, 80.0902847487487],
          [-70.0900900900901, 79.36956320320317],
          [-70.81081081081082, 79.36956320320317],
          [-72.97297297297298, 78.829022044044],
          [-74.05405405405406, 78.28848088488485],
          [-72.61261261261262, 77.56775933933929],
          [-72.61261261261262, 77.20739856656652],
          [-71.53153153153154, 76.66685740740735],
          [-69.36936936936938, 75.94613586186182],
          [-67.56756756756758, 75.76595547547544],
          [-67.56756756756758, 70.36054388388385],
          [-66.4864864864865, 70.00018311111106],
          [-66.4864864864865, 69.45964195195191],
          [-66.12612612612614, 69.09928117917914],
          [-66.4864864864865, 68.73892040640635],
          [-65.40540540540542, 68.1983792472472],
          [-64.32432432432432, 68.1983792472472],
          [-63.24324324324324, 67.65783808808806],
          [-62.16216216216216, 67.47765770170165],
          [-60.72072072072072, 66.75693615615612],
          [-61.8018018018018, 65.85603422422417],
          [-61.8018018018018, 65.49567345145141],
          [-62.88288288288288, 65.31549306506503],
          [-62.88288288288288, 64.77495190590585],
          [-64.32432432432432, 64.77495190590585],
          [-64.6846846846847, 64.59477151951947],
          [-64.6846846846847, 64.2344107467467],
          [-63.96396396396396, 63.87404997397394],
          [-63.6036036036036, 63.513689201201146],
          [-63.6036036036036, 63.15332842842838],
          [-63.96396396396396, 62.792967655655616],
          [-63.96396396396396, 62.25242649649647],
          [-64.6846846846847, 62.25242649649647],
          [-64.6846846846847, 61.892065723723675],
          [-64.32432432432432, 61.71188533733729],
          [-64.32432432432432, 60.45062263263259],
          [-64.6846846846847, 60.270442246246205],
          [-64.6846846846847, 59.369540314314264],
          [-64.32432432432432, 59.0091795415415],
          [-63.6036036036036, 58.82899915515512],
          [-64.32432432432432, 58.28845799599597],
          [-64.32432432432432, 57.928097223223176],
          [-63.6036036036036, 57.747916836836794],
          [-63.96396396396396, 57.38755606406403],
          [-63.96396396396396, 56.12629335935932],
          [-63.6036036036036, 56.12629335935932],
          [-63.6036036036036, 54.86503065465462],
          [-63.96396396396396, 54.684850268268235],
          [-64.6846846846847, 54.86503065465462],
          [-65.40540540540542, 54.86503065465462],
          [-65.76576576576578, 54.684850268268235],
          [-66.84684684684686, 55.22539142742738],
          [-67.20720720720722, 54.86503065465462],
          [-67.20720720720722, 54.50466988188185],
          [-67.92792792792794, 54.14430910910906],
          [-67.56756756756758, 53.96412872272268],
          [-67.56756756756758, 53.60376794994991],
          [-66.84684684684686, 53.42358756356353],
          [-67.20720720720722, 53.063226790790765],
          [-67.20720720720722, 52.70286601801797],
          [-66.4864864864865, 52.52268563163159],
          [-66.4864864864865, 52.162324858858824],
          [-65.76576576576578, 52.162324858858824],
          [-65.40540540540542, 51.80196408608606],
          [-64.6846846846847, 51.80196408608606],
          [-64.32432432432432, 51.62178369969965],
          [-64.32432432432432, 52.342505245245206],
          [-63.6036036036036, 52.342505245245206],
          [-63.6036036036036, 51.98214447247244],
          [-62.16216216216216, 51.98214447247244],
          [-61.8018018018018, 51.80196408608606],
          [-61.8018018018018, 50.18034060860856],
          [-61.44144144144144, 50.18034060860856],
          [-61.44144144144144, 49.27943867667665],
          [-61.08108108108108, 48.919077903903855],
          [-61.08108108108108, 47.297454426426384],
          [-61.44144144144144, 46.93709365365362],
          [-62.16216216216216, 46.93709365365362],
          [-62.52252252252252, 47.297454426426384],
          [-62.52252252252252, 47.65781519919915],
          [-62.88288288288288, 48.198356358358325],
          [-62.88288288288288, 48.55871713113109],
          [-63.6036036036036, 48.37853674474471],
          [-64.32432432432432, 48.37853674474471],
          [-65.40540540540542, 47.83799558558556],
          [-65.76576576576578, 48.01817597197194],
          [-68.2882882882883, 48.01817597197194],
          [-68.2882882882883, 47.47763481281277],
          [-67.92792792792794, 47.297454426426384],
          [-67.92792792792794, 45.675830948948914],
          [-67.56756756756758, 45.675830948948914],
          [-67.56756756756758, 45.135289789789766],
          [-66.84684684684686, 44.955109403403355],
          [-66.84684684684686, 44.59474863063059],
          [-67.20720720720722, 44.59474863063059],
          [-67.20720720720722, 44.234387857857826],
          [-67.56756756756758, 43.87402708508506],
          [-67.56756756756758, 20.270396468468434],
          [-71.8918918918919, 20.270396468468434],
          [-71.8918918918919, 19.729855309309286],
          [-71.53153153153154, 19.54967492292289],
          [-71.53153153153154, 19.189314150150125],
          [-71.8918918918919, 19.009133763763728],
          [-71.8918918918919, 18.288412218218184],
          [-71.8918918918919, 12.702820240240214],
          [-71.53153153153154, 12.702820240240214],
          [-70.81081081081082, 12.342459467467435],
          [-70.81081081081082, 11.98209869469467],
          [-71.17117117117118, 11.801918308308274],
          [-71.8918918918919, 11.801918308308274],
          [-72.25225225225226, 11.441557535535509],
          [-72.25225225225226, 11.08119676276273],
          [-72.61261261261262, 11.08119676276273],
          [-72.61261261261262, 10.901016376376347],
          [-72.97297297297298, 10.540655603603582],
          [-72.97297297297298, 9.639753671671642],
          [-73.33333333333334, 9.45957328528526],
          [-72.61261261261262, 9.09921251251248],
          [-72.61261261261262, 8.378490966966936],
          [-72.25225225225226, 8.378490966966936],
          [-72.25225225225226, 8.018130194194171],
          [-72.61261261261262, 8.018130194194171],
          [-72.61261261261262, 7.47758903503501],
          [-72.25225225225226, 7.47758903503501],
          [-72.25225225225226, 7.1172282622622305],
          [-71.53153153153154, 7.1172282622622305],
          [-71.53153153153154, 6.937047875875848],
          [-70.81081081081082, 6.937047875875848],
          [-70.45045045045046, 7.1172282622622305],
          [-70.0900900900901, 6.937047875875848],
          [-70.0900900900901, 6.756867489489466],
          [-69.72972972972974, 6.576687103103083],
          [-69.72972972972974, 6.3965067167166865],
          [-69.36936936936938, 6.216326330330304],
          [-67.56756756756758, 6.216326330330304],
          [-67.56756756756758, 5.49560478478476],
          [-67.92792792792794, 5.49560478478476],
          [-67.92792792792794, 4.054161693693672],
          [-67.56756756756758, 4.054161693693672],
          [-67.56756756756758, 2.612718602602584],
          [-67.20720720720722, 2.612718602602584],
          [-67.20720720720722, 1.8919970570570257],
          [-66.84684684684686, 1.7118166706706432],
          [-66.84684684684686, 1.1712755115114817],
          [-67.20720720720722, 1.1712755115114817],
          [-67.20720720720722, 2.0721774434434224],
          [-67.56756756756758, 1.8919970570570257],
          [-68.2882882882883, 1.8919970570570257],
          [-68.2882882882883, 1.7118166706706432],
          [-69.72972972972974, 1.7118166706706432],
          [-69.72972972972974, 0.6307343523523343],
          [-70.0900900900901, 0.6307343523523343],
          [-70.0900900900901, -0.27016757957960635],
          [-69.72972972972974, -0.27016757957960635],
          [-69.72972972972974, -0.8107087387387679],
          [-69.36936936936938, -0.9908891251251504],
          [-69.36936936936938, -1.8917910570570768],
          [-69.72972972972974, -2.0719714434434735],
          [-69.72972972972974, -3.8737753073073264],
          [-70.0900900900901, -4.053955693693723],
          [-70.0900900900901, -4.234136080080106],
          [-70.81081081081082, -4.234136080080106],
          [-70.81081081081082, -4.414316466466488],
          [-71.8918918918919, -4.414316466466488],
          [-72.25225225225226, -4.5944968528528705],
          [-72.25225225225226, -4.95485762562565],
          [-72.61261261261262, -5.135038012012032],
          [-72.97297297297298, -5.135038012012032],
          [-72.97297297297298, -5.855759557557576],
          [-73.33333333333334, -6.035939943943973],
          [-73.33333333333334, -6.756661489489517],
          [-73.6936936936937, -6.756661489489517],
          [-73.6936936936937, -7.297202648648664],
          [-74.05405405405406, -7.297202648648664],
          [-74.05405405405406, -7.657563421421443],
          [-73.6936936936937, -7.657563421421443],
          [-73.6936936936937, -8.378284966966987],
          [-73.33333333333334, -8.378284966966987],
          [-73.33333333333334, -8.738645739739766],
          [-72.97297297297298, -8.738645739739766],
          [-72.97297297297298, -9.279186898898928],
          [-72.25225225225226, -9.45936728528531],
          [-72.25225225225226, -9.999908444444472],
          [-71.17117117117118, -9.999908444444472],
          [-70.81081081081082, -9.819728058058075],
          [-70.81081081081082, -9.45936728528531],
          [-70.45045045045046, -9.45936728528531],
          [-70.45045045045046, -9.819728058058075],
          [-70.81081081081082, -9.819728058058075],
          [-70.81081081081082, -11.08099076276278],
          [-69.36936936936938, -11.08099076276278],
          [-69.36936936936938, -11.621531921921942],
          [-69.00900900900902, -11.801712308308325],
          [-69.00900900900902, -12.162073081081104],
          [-68.64864864864866, -12.342253467467486],
          [-68.64864864864866, -12.702614240240266],
          [-69.00900900900902, -12.702614240240266],
          [-69.00900900900902, -14.504418104104118],
          [-69.36936936936938, -14.504418104104118],
          [-69.36936936936938, -16.126041581581603],
          [-69.00900900900902, -16.126041581581603],
          [-69.00900900900902, -16.666582740740765],
          [-69.36936936936938, -16.666582740740765],
          [-69.36936936936938, -17.207123899899926],
          [-69.72972972972974, -17.207123899899926],
          [-69.72972972972974, -18.108025831831853],
          [-70.0900900900901, -18.288206218218235],
          [-70.45045045045046, -18.288206218218235],
          [-70.45045045045046, -22.792715877877896],
          [-70.81081081081082, -22.792715877877896],
          [-70.81081081081082, -24.774700128128146],
          [-81.62162162162163, -24.774700128128146],
          [-81.62162162162163, -37.38732717517519],
          [-74.05405405405406, -37.38732717517519],
          [-74.05405405405406, -38.64858987987989],
          [-73.6936936936937, -38.64858987987989],
          [-73.6936936936937, -39.72967219819821],
          [-74.05405405405406, -39.72967219819821],
          [-74.05405405405406, -40.81075451651653],
          [-74.41441441441442, -40.990934902902914],
          [-74.05405405405406, -41.351295675675686],
          [-74.41441441441442, -41.71165644844846],
          [-74.41441441441442, -42.972919153153164],
          [-75.13513513513514, -43.333279925925936],
          [-75.13513513513514, -44.05400147147149],
          [-75.4954954954955, -44.41436224424426],
          [-75.4954954954955, -45.315264176176186],
          [-75.85585585585586, -45.67562494894896],
          [-75.85585585585586, -50.72067576776778],
          [-75.4954954954955, -51.08103654054055],
          [-75.4954954954955, -52.16211885885887],
          [-74.77477477477478, -52.52247963163164],
          [-75.13513513513514, -52.88284040440441],
          [-74.41441441441442, -53.243201177177184],
          [-74.41441441441442, -53.60356194994996],
          [-73.6936936936937, -53.963922722722735],
          [-73.6936936936937, -54.32428349549551],
          [-72.97297297297298, -54.32428349549551],
          [-71.17117117117118, -55.225185427427434],
          [-70.81081081081082, -55.225185427427434],
          [-70.0900900900901, -55.58554620020021],
          [-69.36936936936938, -55.765726586586595],
          [-68.64864864864866, -55.765726586586595],
          [-67.92792792792794, -56.12608735935937],
          [-67.56756756756758, -56.12608735935937],
          [-67.56756756756758, -66.03600861061062],
          [-67.56756756756758, -66.39636938338339],
          [-68.2882882882883, -66.57654976976977],
          [-69.72972972972974, -67.29727131531533],
          [-69.72972972972974, -67.65763208808809],
          [-69.00900900900902, -68.01799286086087],
          [-67.56756756756758, -68.19817324724725],
          [-67.56756756756758, -68.55853402002003],
          [-67.92792792792794, -69.09907517917918],
          [-69.00900900900902, -69.09907517917918],
          [-70.0900900900901, -68.55853402002003],
          [-71.17117117117118, -68.55853402002003],
          [-71.53153153153154, -68.73871440640642],
          [-72.61261261261262, -68.73871440640642],
          [-72.61261261261262, -69.27925556556556],
          [-73.33333333333334, -69.27925556556556],
          [-73.6936936936937, -69.63961633833834],
          [-75.13513513513514, -69.45943595195196],
          [-76.57657657657658, -69.99997711111112],
          [-76.21621621621622, -70.54051827027027],
          [-77.2972972972973, -70.90087904304305],
          [-76.93693693693695, -71.26123981581583],
          [-75.85585585585586, -71.26123981581583],
          [-75.85585585585586, -72.70268290690692],
          [-76.57657657657658, -72.8828632932933],
          [-76.93693693693695, -73.24322406606606],
          [-78.37837837837839, -73.24322406606606],
          [-79.81981981981983, -72.70268290690692],
          [-80.90090090090091, -72.70268290690692],
          [-81.26126126126127, -73.06304367967968],
          [-81.98198198198199, -73.06304367967968],
          [-82.34234234234235, -73.60358483883884],
          [-82.34234234234235, 8.018130194194171],
          [-82.70270270270271, 8.018130194194171],
          [-83.06306306306307, 7.8379498078077745],
          [-83.06306306306307, 8.378490966966936],
          [-82.70270270270271, 8.378490966966936],
          [-82.70270270270271, 9.09921251251248],
          [-83.06306306306307, 9.09921251251248],
          [-83.06306306306307, 9.45957328528526],
          [-82.70270270270271, 9.639753671671642],
          [-82.34234234234235, 9.639753671671642],
          [-82.34234234234235, 17.747871059059037],
          [-82.34234234234235, 18.46859260460458],
          [-82.34234234234235, 21.351478786786757],
          [-83.42342342342343, 21.351478786786757],
          [-83.42342342342343, 21.711839559559536],
          [-84.14414414414415, 21.711839559559536],
          [-84.50450450450451, 21.53165917317314],
          [-84.86486486486487, 21.711839559559536],
          [-85.22522522522523, 21.711839559559536],
          [-85.22522522522523, 22.0722003323323],
          [-84.86486486486487, 22.252380718718683],
          [-84.50450450450451, 22.252380718718683],
          [-84.50450450450451, 22.792921877877845],
          [-84.14414414414415, 22.973102264264227],
          [-83.78378378378379, 22.973102264264227],
          [-83.42342342342343, 23.153282650650624],
          [-83.06306306306307, 23.153282650650624],
          [-82.70270270270271, 23.333463037037006],
          [-82.34234234234235, 23.333463037037006],
          [-82.34234234234235, 26.756890378378344],
          [-83.06306306306307, 27.477611923923888],
          [-83.06306306306307, 28.919055015014976],
          [-83.42342342342343, 29.099235401401373],
          [-83.42342342342343, 29.459596174174138],
          [-83.78378378378379, 29.459596174174138],
          [-83.78378378378379, 29.819956946946917],
          [-84.14414414414415, 29.819956946946917],
          [-84.86486486486487, 29.459596174174138],
          [-85.22522522522523, 29.459596174174138],
          [-85.22522522522523, 30.18031771971968],
          [-84.86486486486487, 30.36049810610608],
          [-84.86486486486487, 31.081219651651622],
          [-85.22522522522523, 31.081219651651622],
          [-85.22522522522523, 32.16230196996993],
          [-84.86486486486487, 32.16230196996993],
          [-84.86486486486487, 32.52266274274271],
          [-85.22522522522523, 32.70284312912909],
          [-85.22522522522523, 33.9641058338338],
          [-85.58558558558559, 34.14428622022018],
          [-85.58558558558559, 35.04518815215212],
          [-85.22522522522523, 35.04518815215212],
          [-85.22522522522523, 35.58572931131128],
          [-84.86486486486487, 35.765909697697666],
          [-84.86486486486487, 36.66681162962959],
          [-84.50450450450451, 36.846992016015975],
          [-84.86486486486487, 37.207352788788754],
          [-85.22522522522523, 37.207352788788754],
          [-85.94594594594595, 37.56771356156153],
          [-86.30630630630631, 37.56771356156153],
          [-86.30630630630631, 37.9280743343343],
          [-86.66666666666667, 38.28843510710706],
          [-87.38738738738739, 38.648795879879856],
          [-87.38738738738739, 39.00915665265262],
          [-87.74774774774775, 39.00915665265262],
          [-87.74774774774775, 39.369517425425386],
          [-87.38738738738739, 39.369517425425386],
          [-87.38738738738739, 40.810960516516474],
          [-87.02702702702703, 40.810960516516474],
          [-87.02702702702703, 41.17132128928927],
          [-86.66666666666667, 41.35150167567565],
          [-86.66666666666667, 41.711862448448414],
          [-87.02702702702703, 41.8920428348348],
          [-87.02702702702703, 44.41456824424421],
          [-86.66666666666667, 44.59474863063059],
          [-86.66666666666667, 45.49565056256253],
          [-87.38738738738739, 45.49565056256253],
          [-87.38738738738739, 46.03619172172168],
          [-88.10810810810811, 46.39655249449444],
          [-89.1891891891892, 46.39655249449444],
          [-89.1891891891892, 46.576732880880854],
          [-89.90990990990991, 46.576732880880854],
          [-89.90990990990991, 47.65781519919915],
          [-89.54954954954955, 47.65781519919915],
          [-89.54954954954955, 48.01817597197194],
          [-90.27027027027027, 48.37853674474471],
          [-90.990990990991, 48.55871713113109],
          [-90.990990990991, 49.27943867667665],
          [-89.90990990990991, 49.45961906306303],
          [-89.90990990990991, 50.720881767767736],
          [-90.63063063063063, 51.0812425405405],
          [-90.63063063063063, 51.80196408608606],
          [-89.90990990990991, 51.98214447247244],
          [-89.90990990990991, 52.70286601801797],
          [-89.1891891891892, 52.70286601801797],
          [-89.1891891891892, 53.063226790790765],
          [-88.46846846846847, 53.42358756356353],
          [-88.46846846846847, 53.60376794994991],
          [-89.1891891891892, 53.96412872272268],
          [-89.90990990990991, 53.96412872272268],
          [-89.90990990990991, 56.12629335935932],
          [-89.54954954954955, 56.48665413213209],
          [-88.82882882882883, 56.84701490490485],
          [-88.82882882882883, 62.973148042042],
          [-85.94594594594595, 65.85603422422417],
          [-84.86486486486487, 66.21639499699697],
          [-84.86486486486487, 82.61281015815811],
          [-82.34234234234235, 82.97317093093088],
          [-82.34234234234235, 90.00020599999996],
          [-67.56756756756758, 90.00020599999996],
          [-67.56756756756758, 83.15335131731726],
          [-63.6036036036036, 83.15335131731726],
          [-61.8018018018018, 82.97317093093088],
          [-59.63963963963964, 82.25244938538535],
        ],
      ],
    },
    properties: {
      objectid: 9,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-5',
      map_color6: 5,
      map_color8: 3,
      note: null,
      zone: -5,
      utc_format: 'UTC-05:00',
      time_zone: 'UTC-05:00',
      iso_8601: '2012-05-30T23:33:50-05:00',
      places: 'Colombia, Cuba, Ecuador (continental), Jamaica, Panama, Peru',
      dst_places:
        'Canada (most of Ontario, most of Quebec), Haiti, United States (most of Florida, Georgia, Massachusetts, most of Michigan, New York, North Carolina, Ohio, Washington D.C.)',
      tz_name1st: 'America/New_York',
      tz_namesum: 26,
      cartodb_id: 13,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [74.05405405405403, 10.00011444444442],
          [74.05405405405403, 7.657769421421392],
          [72.6126126126126, 7.657769421421392],
          [72.25225225225225, 7.8379498078077745],
          [71.53153153153153, 7.8379498078077745],
          [71.53153153153153, 12.522639853853832],
          [74.05405405405403, 12.522639853853832],
          [74.05405405405403, 10.00011444444442],
        ],
      ],
    },
    properties: {
      objectid: 23,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+5.5',
      map_color6: 3,
      map_color8: 3,
      note: null,
      zone: 5.5,
      utc_format: 'UTC+05:30',
      time_zone: 'UTC+05:30',
      iso_8601: '2012-05-31T10:03:50+05:30',
      places: 'India (Laccadive Is.)',
      dst_places: null,
      tz_name1st: null,
      tz_namesum: 0,
      cartodb_id: 54,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: null,
    properties: {
      objectid: 22,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+5',
      map_color6: 1,
      map_color8: 7,
      note: null,
      zone: 5,
      utc_format: 'UTC+05:00',
      time_zone: 'UTC+05:00',
      iso_8601: '2012-05-31T09:33:50+05:00',
      places: 'Tajikistan',
      dst_places: null,
      tz_name1st: null,
      tz_namesum: 0,
      cartodb_id: 58,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [140, 65.85603422422417],
          [139.6396396396396, 65.67585383783779],
          [139.27927927927925, 65.85603422422417],
          [139.27927927927925, 65.67585383783779],
          [138.9189189189189, 65.85603422422417],
          [138.19819819819816, 65.49567345145141],
          [137.47747747747746, 65.31549306506503],
          [137.11711711711712, 65.31549306506503],
          [136.03603603603602, 65.49567345145141],
          [135.31531531531527, 65.13531267867864],
          [134.59459459459458, 64.95513229229226],
          [134.23423423423424, 65.13531267867864],
          [133.87387387387383, 65.13531267867864],
          [133.87387387387383, 64.41459113313309],
          [133.5135135135135, 64.2344107467467],
          [133.15315315315314, 64.2344107467467],
          [132.7927927927928, 64.2344107467467],
          [131.7117117117117, 65.31549306506503],
          [131.7117117117117, 65.49567345145141],
          [130.27027027027026, 66.21639499699697],
          [129.9099099099099, 66.57675576976973],
          [129.9099099099099, 66.9371165425425],
          [130.6306306306306, 67.11729692892888],
          [130.6306306306306, 67.47765770170165],
          [131.35135135135135, 67.65783808808806],
          [131.7117117117117, 67.65783808808806],
          [133.15315315315314, 68.37855963363359],
          [133.15315315315314, 68.73892040640635],
          [132.4324324324324, 68.91910079279276],
          [132.4324324324324, 69.09928117917914],
          [132.7927927927928, 69.09928117917914],
          [133.15315315315314, 69.63982233833829],
          [133.5135135135135, 69.63982233833829],
          [133.5135135135135, 69.82000272472467],
          [133.15315315315314, 69.82000272472467],
          [132.7927927927928, 70.36054388388385],
          [132.4324324324324, 70.36054388388385],
          [132.07207207207205, 70.36054388388385],
          [132.07207207207205, 71.08126542942938],
          [131.7117117117117, 71.44162620220214],
          [131.7117117117117, 73.06324967967964],
          [146.84684684684686, 73.06324967967964],
          [146.84684684684686, 73.24343006606603],
          [151.53153153153153, 73.24343006606603],
          [151.89189189189187, 73.60379083883879],
          [154.05405405405406, 74.68487315715711],
          [154.4144144144144, 75.04523392992988],
          [155.4954954954955, 75.40559470270267],
          [156.93693693693695, 76.48667702102097],
          [157.65765765765764, 76.66685740740735],
          [157.65765765765764, 84.95515518118114],
          [172.4324324324324, 90.00020599999996],
          [172.4324324324324, 70.18036349749747],
          [171.35135135135135, 70.36054388388385],
          [169.9099099099099, 70.36054388388385],
          [169.5495495495495, 70.18036349749747],
          [167.74774774774772, 70.18036349749747],
          [167.02702702702703, 69.82000272472467],
          [164.5045045045045, 69.82000272472467],
          [164.5045045045045, 70.00018311111106],
          [163.06306306306305, 70.00018311111106],
          [162.7027027027027, 69.82000272472467],
          [160.54054054054052, 69.82000272472467],
          [160.90090090090087, 70.36054388388385],
          [163.06306306306305, 70.72090465665661],
          [161.98198198198196, 71.08126542942938],
          [158.73873873873873, 71.08126542942938],
          [158.3783783783784, 71.26144581581576],
          [154.4144144144144, 71.26144581581576],
          [154.05405405405406, 71.08126542942938],
          [152.61261261261262, 71.26144581581576],
          [151.53153153153153, 71.62180658858856],
          [149.36936936936934, 72.52270852052047],
          [146.84684684684686, 72.52270852052047],
          [146.84684684684686, 72.34252813413408],
          [143.96396396396398, 72.34252813413408],
          [142.52252252252248, 71.62180658858856],
          [142.52252252252248, 71.08126542942938],
          [141.8018018018018, 70.901085043043],
          [140.7207207207207, 70.18036349749747],
          [141.44144144144144, 69.82000272472467],
          [142.16216216216213, 69.82000272472467],
          [142.16216216216213, 69.45964195195191],
          [141.44144144144144, 69.27946156556553],
          [141.8018018018018, 68.73892040640635],
          [141.08108108108104, 68.37855963363359],
          [141.08108108108104, 67.83801847447444],
          [140.36036036036035, 67.83801847447444],
          [139.6396396396396, 67.47765770170165],
          [138.9189189189189, 67.47765770170165],
          [138.9189189189189, 67.11729692892888],
          [140.36036036036035, 66.39657538338335],
          [139.6396396396396, 66.39657538338335],
          [140, 65.85603422422417],
        ],
      ],
    },
    properties: {
      objectid: 33,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+11',
      map_color6: 1,
      map_color8: 6,
      note: 'Reflects 2012 shift in daylight savings time in Russia.',
      zone: 11,
      utc_format: 'UTC+11:00',
      time_zone: 'UTC+11:00',
      iso_8601: '2012-05-31T15:33:50+11:00',
      places: 'Russia (Primorsky Krai)',
      dst_places: null,
      tz_name1st: null,
      tz_namesum: 0,
      cartodb_id: 29,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'MultiPolygon',
      coordinates: [
        [
          [
            [157.65765765765764, 76.66685740740735],
            [156.93693693693695, 76.48667702102097],
            [155.4954954954955, 75.40559470270267],
            [154.4144144144144, 75.04523392992988],
            [154.05405405405406, 74.68487315715711],
            [151.89189189189187, 73.60379083883879],
            [151.53153153153153, 73.24343006606603],
            [146.84684684684686, 73.24343006606603],
            [146.84684684684686, 73.06324967967964],
            [146.84684684684686, 73.24343006606603],
            [151.53153153153153, 73.24343006606603],
            [151.89189189189187, 73.60379083883879],
            [154.05405405405406, 74.68487315715711],
            [154.4144144144144, 75.04523392992988],
            [155.4954954954955, 75.40559470270267],
            [156.93693693693695, 76.48667702102097],
            [157.65765765765764, 76.66685740740735],
          ],
        ],
        [
          [
            [180, 59.54972070070065],
            [179.27927927927925, 59.18935992792788],
            [178.9189189189189, 58.82899915515512],
            [178.19819819819816, 58.46863838238235],
            [178.19819819819816, 58.28845799599597],
            [176.39639639639637, 57.38755606406403],
            [176.39639639639637, 57.207375677677646],
            [175.67567567567568, 56.84701490490485],
            [175.31531531531527, 56.48665413213209],
            [173.87387387387383, 55.76593258658656],
            [173.87387387387383, 55.58575220020015],
            [173.15315315315314, 55.22539142742738],
            [172.7927927927928, 54.86503065465462],
            [172.07207207207205, 54.50466988188185],
            [172.07207207207205, 54.32448949549547],
            [170.99099099099095, 53.783948336336294],
            [170.99099099099095, 53.60376794994991],
            [169.9099099099099, 53.063226790790765],
            [169.5495495495495, 52.883046404404354],
            [169.5495495495495, 52.52268563163159],
            [168.82882882882882, 52.162324858858824],
            [168.10810810810807, 51.62178369969965],
            [167.38738738738738, 51.26142292692688],
            [167.02702702702703, 50.90106215415412],
            [166.30630630630628, 50.54070138138135],
            [165.5855855855856, 50.00016022222218],
            [157.65765765765764, 50.00016022222218],
            [157.2972972972973, 49.63979944944941],
            [156.2162162162162, 49.27943867667665],
            [155.1351351351351, 48.37853674474471],
            [154.4144144144144, 48.01817597197194],
            [154.05405405405406, 47.65781519919915],
            [152.25225225225222, 49.45961906306303],
            [151.89189189189187, 49.63979944944941],
            [149.36936936936934, 52.162324858858824],
            [149.009009009009, 52.342505245245206],
            [146.84684684684686, 54.50466988188185],
            [146.84684684684686, 59.369540314314264],
            [147.2072072072072, 59.369540314314264],
            [147.2072072072072, 59.91008147347344],
            [146.48648648648646, 59.91008147347344],
            [146.48648648648646, 60.270442246246205],
            [145.76576576576576, 60.270442246246205],
            [145.76576576576576, 60.63080301901897],
            [146.48648648648646, 60.63080301901897],
            [146.48648648648646, 61.892065723723675],
            [146.1261261261261, 62.07224611011006],
            [145.40540540540542, 62.07224611011006],
            [145.40540540540542, 63.69386958758756],
            [146.1261261261261, 63.87404997397394],
            [145.76576576576576, 64.2344107467467],
            [144.32432432432432, 64.95513229229226],
            [141.8018018018018, 65.49567345145141],
            [140.36036036036035, 65.49567345145141],
            [140, 65.85603422422417],
            [139.6396396396396, 66.39657538338335],
            [140.36036036036035, 66.39657538338335],
            [138.9189189189189, 67.11729692892888],
            [138.9189189189189, 67.47765770170165],
            [139.6396396396396, 67.47765770170165],
            [140.36036036036035, 67.83801847447444],
            [141.08108108108104, 67.83801847447444],
            [141.08108108108104, 68.37855963363359],
            [141.8018018018018, 68.73892040640635],
            [141.44144144144144, 69.27946156556553],
            [142.16216216216213, 69.45964195195191],
            [142.16216216216213, 69.82000272472467],
            [141.44144144144144, 69.82000272472467],
            [140.7207207207207, 70.18036349749747],
            [141.8018018018018, 70.901085043043],
            [142.52252252252248, 71.08126542942938],
            [142.52252252252248, 71.62180658858856],
            [143.96396396396398, 72.34252813413408],
            [146.84684684684686, 72.34252813413408],
            [146.84684684684686, 72.52270852052047],
            [149.36936936936934, 72.52270852052047],
            [151.53153153153153, 71.62180658858856],
            [152.61261261261262, 71.26144581581576],
            [154.05405405405406, 71.08126542942938],
            [154.4144144144144, 71.26144581581576],
            [158.3783783783784, 71.26144581581576],
            [158.73873873873873, 71.08126542942938],
            [161.98198198198196, 71.08126542942938],
            [163.06306306306305, 70.72090465665661],
            [160.90090090090087, 70.36054388388385],
            [160.54054054054052, 69.82000272472467],
            [162.7027027027027, 69.82000272472467],
            [163.06306306306305, 70.00018311111106],
            [164.5045045045045, 70.00018311111106],
            [164.5045045045045, 69.82000272472467],
            [167.02702702702703, 69.82000272472467],
            [167.74774774774772, 70.18036349749747],
            [169.5495495495495, 70.18036349749747],
            [169.9099099099099, 70.36054388388385],
            [171.35135135135135, 70.36054388388385],
            [172.4324324324324, 70.18036349749747],
            [172.4324324324324, 90.00020599999996],
            [180, 59.54972070070065],
          ],
        ],
      ],
    },
    properties: {
      objectid: 0,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+12',
      map_color6: 6,
      map_color8: 2,
      note: 'Reflects 2012 shift in daylight savings time in Russia.',
      zone: 12,
      utc_format: 'UTC+12:00',
      time_zone: 'UTC+12:00',
      iso_8601: '2012-05-31T16:33:50+12:00',
      places: 'Russia (Kamchatka Krai)',
      dst_places: null,
      tz_name1st: 'Asia/Kamchatka',
      tz_namesum: 3,
      cartodb_id: 30,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [61.44144144144144, 24.955086514514477],
          [61.80180180180179, 24.774906128128094],
          [62.52252252252251, 25.135266900900874],
          [62.88288288288288, 24.955086514514477],
          [63.6036036036036, 24.955086514514477],
          [63.6036036036036, 25.135266900900874],
          [64.32432432432432, 25.135266900900874],
          [64.68468468468467, 24.955086514514477],
          [65.04504504504504, 25.135266900900874],
          [65.76576576576576, 25.135266900900874],
          [66.12612612612611, 25.315447287287256],
          [66.48648648648648, 25.135266900900874],
          [66.48648648648648, 24.594725741741712],
          [66.84684684684683, 24.594725741741712],
          [67.2072072072072, 24.41454535535533],
          [67.2072072072072, 23.693823809809786],
          [67.56756756756755, 23.693823809809786],
          [67.56756756756755, 18.828953377377346],
          [67.56756756756755, -67.65763208808809],
          [66.48648648648648, -67.65763208808809],
          [66.12612612612611, -67.47745170170171],
          [64.68468468468467, -67.47745170170171],
          [64.32432432432432, -67.29727131531533],
          [62.16216216216216, -67.29727131531533],
          [61.08108108108107, -67.29727131531533],
          [60.72072072072072, -67.11709092892893],
          [59.639639639639626, -67.11709092892893],
          [59.27927927927928, -66.93691054254255],
          [58.198198198198185, -66.93691054254255],
          [57.83783783783784, -66.39636938338339],
          [57.11711711711712, -66.216188996997],
          [56.3963963963964, -66.216188996997],
          [56.03603603603602, -65.85582822422423],
          [55.3153153153153, -65.67564783783784],
          [52.792792792792795, -65.67564783783784],
          [52.43243243243242, -65.85582822422423],
          [52.43243243243242, -46.93688765365366],
          [52.43243243243242, -44.954903403403414],
          [52.43243243243242, -11.08099076276278],
          [50.27027027027026, -11.08099076276278],
          [49.909909909909885, -10.900810376376398],
          [49.54954954954954, -10.54044960360362],
          [49.189189189189165, -10.54044960360362],
          [48.82882882882882, -10.900810376376398],
          [48.1081081081081, -10.900810376376398],
          [47.747747747747724, -10.720629989990016],
          [46.66666666666666, -10.720629989990016],
          [46.30630630630628, -10.900810376376398],
          [45.58558558558556, -10.900810376376398],
          [45.225225225225216, -10.720629989990016],
          [44.86486486486484, -10.360269217217237],
          [44.86486486486484, -8.017924194194222],
          [52.43243243243242, -8.017924194194222],
          [52.43243243243242, 10.540655603603582],
          [56.03603603603602, 10.540655603603582],
          [56.03603603603602, 13.60372217217214],
          [52.43243243243242, 13.60372217217214],
          [52.43243243243242, 16.126247581581552],
          [53.15315315315314, 16.48660835435433],
          [53.15315315315314, 16.846969127127096],
          [52.792792792792795, 16.846969127127096],
          [52.792792792792795, 17.56769067267264],
          [52.43243243243242, 17.747871059059037],
          [52.43243243243242, 18.288412218218184],
          [52.072072072072075, 18.46859260460458],
          [52.072072072072075, 19.009133763763728],
          [52.792792792792795, 19.369494536536507],
          [53.15315315315314, 19.369494536536507],
          [53.87387387387386, 19.729855309309286],
          [54.234234234234236, 19.729855309309286],
          [54.59459459459458, 19.91003569569567],
          [54.95495495495496, 19.91003569569567],
          [54.95495495495496, 20.45057685485483],
          [55.3153153153153, 20.45057685485483],
          [55.3153153153153, 21.53165917317314],
          [55.67567567567568, 21.53165917317314],
          [55.67567567567568, 22.0722003323323],
          [55.3153153153153, 22.252380718718683],
          [55.3153153153153, 22.792921877877845],
          [54.95495495495496, 22.612741491491462],
          [54.59459459459458, 22.612741491491462],
          [54.234234234234236, 22.792921877877845],
          [53.15315315315314, 22.792921877877845],
          [52.792792792792795, 22.973102264264227],
          [52.43243243243242, 22.973102264264227],
          [52.43243243243242, 23.333463037037006],
          [52.072072072072075, 23.333463037037006],
          [52.072072072072075, 23.693823809809786],
          [51.7117117117117, 23.693823809809786],
          [51.7117117117117, 24.594725741741712],
          [52.072072072072075, 24.774906128128094],
          [52.43243243243242, 24.774906128128094],
          [52.43243243243242, 27.117251151151123],
          [52.792792792792795, 27.117251151151123],
          [52.792792792792795, 26.756890378378344],
          [53.15315315315314, 26.756890378378344],
          [54.234234234234236, 26.216349219219182],
          [54.234234234234236, 25.855988446446418],
          [54.59459459459458, 25.675808060060035],
          [54.59459459459458, 26.216349219219182],
          [54.95495495495496, 26.39652960560558],
          [56.03603603603602, 26.39652960560558],
          [56.3963963963964, 26.57670999199196],
          [56.756756756756744, 26.937070764764727],
          [56.756756756756744, 26.216349219219182],
          [57.11711711711712, 26.0361688328328],
          [57.11711711711712, 25.49562767367364],
          [57.83783783783784, 25.49562767367364],
          [57.83783783783784, 25.315447287287256],
          [58.918918918918905, 25.315447287287256],
          [58.918918918918905, 25.135266900900874],
          [60.72072072072072, 25.135266900900874],
          [61.08108108108107, 24.955086514514477],
          [61.44144144144144, 24.955086514514477],
        ],
      ],
    },
    properties: {
      objectid: 20,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+4',
      map_color6: 2,
      map_color8: 5,
      note: null,
      zone: 4,
      utc_format: 'UTC+04:00',
      time_zone: 'UTC+04:00',
      iso_8601: '2012-05-31T08:33:50+04:00',
      places: 'Mauritius, Oman, Seychelles, United Arab Emirates',
      dst_places: null,
      tz_name1st: 'Asia/Dubai',
      tz_namesum: 6,
      cartodb_id: 31,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [72.97297297297297, -8.017924194194222],
          [70.8108108108108, -8.017924194194222],
          [70.8108108108108, -2.7926929889890175],
          [72.25225225225225, -2.7926929889890175],
          [72.6126126126126, -2.9728733753754],
          [72.97297297297297, -2.9728733753754],
          [72.97297297297297, -3.8737753073073264],
          [72.97297297297297, -8.017924194194222],
        ],
      ],
    },
    properties: {
      objectid: 25,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+6',
      map_color6: 6,
      map_color8: 8,
      note: null,
      zone: 6,
      utc_format: 'UTC+06:00',
      time_zone: 'UTC+06:00',
      iso_8601: '2012-05-31T10:33:50+06:00',
      places: 'British Indian Ocean Territory',
      dst_places: null,
      tz_name1st: 'Indian/Chagos',
      tz_namesum: 1,
      cartodb_id: 32,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [78.37837837837839, 80.45064552152147],
          [79.45945945945942, 80.45064552152147],
          [80.54054054054052, 80.45064552152147],
          [81.62162162162161, 80.45064552152147],
          [88.82882882882882, 80.45064552152147],
          [88.82882882882882, 77.92812011211205],
          [87.74774774774772, 77.38757895295291],
          [86.66666666666663, 77.02721818018014],
          [86.30630630630628, 76.66685740740735],
          [83.78378378378375, 75.58577508908905],
          [81.98198198198196, 75.04523392992988],
          [80.18018018018017, 74.14433199799797],
          [78.37837837837839, 73.96415161161156],
          [78.37837837837839, 72.34252813413408],
          [78.73873873873873, 72.1623477477477],
          [79.09909909909908, 72.1623477477477],
          [79.45945945945942, 71.98216736136132],
          [79.81981981981983, 71.98216736136132],
          [80.18018018018017, 71.98216736136132],
          [80.18018018018017, 71.80198697497494],
          [79.45945945945942, 71.62180658858856],
          [79.09909909909908, 71.44162620220214],
          [79.81981981981983, 71.08126542942938],
          [80.54054054054052, 71.08126542942938],
          [80.54054054054052, 70.36054388388385],
          [80.90090090090087, 70.36054388388385],
          [80.54054054054052, 70.36054388388385],
          [80.54054054054052, 70.54072427027023],
          [80.18018018018017, 70.36054388388385],
          [79.81981981981983, 70.18036349749747],
          [79.81981981981983, 70.36054388388385],
          [79.45945945945942, 70.18036349749747],
          [79.45945945945942, 70.00018311111106],
          [79.09909909909908, 70.00018311111106],
          [78.73873873873873, 69.82000272472467],
          [79.45945945945942, 69.63982233833829],
          [79.81981981981983, 69.27946156556553],
          [80.18018018018017, 69.27946156556553],
          [80.90090090090087, 69.27946156556553],
          [81.26126126126127, 69.27946156556553],
          [81.62162162162161, 69.27946156556553],
          [81.62162162162161, 69.45964195195191],
          [82.3423423423423, 69.09928117917914],
          [82.70270270270271, 68.73892040640635],
          [82.70270270270271, 68.55874002001997],
          [82.3423423423423, 68.1983792472472],
          [81.98198198198196, 68.01819886086082],
          [81.62162162162161, 68.01819886086082],
          [81.98198198198196, 67.65783808808806],
          [81.98198198198196, 67.83801847447444],
          [82.3423423423423, 67.47765770170165],
          [82.3423423423423, 67.29747731531526],
          [83.06306306306305, 66.75693615615612],
          [83.4234234234234, 66.39657538338335],
          [83.4234234234234, 65.85603422422417],
          [83.78378378378375, 65.85603422422417],
          [84.5045045045045, 65.49567345145141],
          [84.5045045045045, 64.95513229229226],
          [84.86486486486484, 64.95513229229226],
          [84.86486486486484, 64.77495190590585],
          [85.22522522522519, 64.77495190590585],
          [85.58558558558559, 64.77495190590585],
          [85.94594594594594, 64.77495190590585],
          [85.94594594594594, 64.05423036036032],
          [85.22522522522519, 63.87404997397394],
          [85.22522522522519, 63.513689201201146],
          [85.22522522522519, 63.69386958758756],
          [84.86486486486484, 63.513689201201146],
          [85.22522522522519, 63.513689201201146],
          [85.58558558558559, 63.33350881481476],
          [85.58558558558559, 62.973148042042],
          [84.86486486486484, 62.61278726926923],
          [84.5045045045045, 62.25242649649647],
          [84.5045045045045, 61.892065723723675],
          [84.86486486486484, 61.71188533733729],
          [85.22522522522519, 61.71188533733729],
          [85.58558558558559, 61.53170495095091],
          [85.94594594594594, 61.53170495095091],
          [85.22522522522519, 61.171344178178146],
          [84.86486486486484, 61.171344178178146],
          [84.14414414414415, 60.81098340540535],
          [83.78378378378375, 60.99116379179176],
          [83.06306306306305, 60.99116379179176],
          [81.98198198198196, 60.63080301901897],
          [79.45945945945942, 60.63080301901897],
          [79.45945945945942, 60.81098340540535],
          [76.93693693693695, 60.81098340540535],
          [76.93693693693695, 60.09026185985982],
          [76.57657657657654, 59.91008147347344],
          [76.57657657657654, 59.54972070070065],
          [75.85585585585585, 59.369540314314264],
          [75.85585585585585, 59.0091795415415],
          [74.05405405405403, 58.10827760960956],
          [71.17117117117115, 58.10827760960956],
          [70.45045045045043, 57.928097223223176],
          [70.8108108108108, 57.38755606406403],
          [71.53153153153153, 57.027195291291264],
          [71.53153153153153, 56.66683451851847],
          [70.8108108108108, 56.48665413213209],
          [70.8108108108108, 55.94611297297294],
          [70.45045045045043, 55.94611297297294],
          [70.45045045045043, 55.22539142742738],
          [70.8108108108108, 54.86503065465462],
          [71.17117117117115, 54.86503065465462],
          [71.17117117117115, 54.14430910910906],
          [71.89189189189187, 54.14430910910906],
          [72.25225225225225, 53.96412872272268],
          [73.33333333333331, 53.96412872272268],
          [73.69369369369369, 53.60376794994991],
          [74.77477477477476, 53.60376794994991],
          [74.77477477477476, 53.783948336336294],
          [75.49549549549548, 54.14430910910906],
          [76.57657657657654, 53.96412872272268],
          [78.01801801801798, 53.24340717717715],
          [78.37837837837839, 52.70286601801797],
          [78.73873873873873, 52.52268563163159],
          [78.73873873873873, 52.162324858858824],
          [79.45945945945942, 51.441603313313266],
          [79.81981981981983, 51.26142292692688],
          [79.81981981981983, 50.720881767767736],
          [80.90090090090087, 50.90106215415412],
          [81.26126126126127, 50.720881767767736],
          [82.70270270270271, 50.720881767767736],
          [82.70270270270271, 50.90106215415412],
          [83.78378378378375, 50.90106215415412],
          [84.14414414414415, 50.720881767767736],
          [84.14414414414415, 50.18034060860856],
          [84.86486486486484, 50.18034060860856],
          [84.86486486486484, 49.819979835835795],
          [85.94594594594594, 49.45961906306303],
          [87.02702702702703, 49.45961906306303],
          [87.38738738738738, 49.099258290290265],
          [87.02702702702703, 49.099258290290265],
          [86.66666666666663, 49.099258290290265],
          [86.66666666666663, 48.55871713113109],
          [86.30630630630628, 48.55871713113109],
          [85.94594594594594, 48.37853674474471],
          [85.58558558558559, 48.37853674474471],
          [85.58558558558559, 47.11727404004],
          [85.22522522522519, 47.11727404004],
          [84.86486486486484, 46.75691326726724],
          [84.5045045045045, 46.93709365365362],
          [84.14414414414415, 46.93709365365362],
          [83.78378378378375, 46.93709365365362],
          [83.06306306306305, 47.297454426426384],
          [83.06306306306305, 46.93709365365362],
          [82.70270270270271, 46.75691326726724],
          [82.70270270270271, 46.21637210810806],
          [82.3423423423423, 46.03619172172168],
          [82.3423423423423, 45.49565056256253],
          [82.70270270270271, 45.49565056256253],
          [82.70270270270271, 45.135289789789766],
          [82.3423423423423, 45.135289789789766],
          [82.3423423423423, 45.31547017617615],
          [81.98198198198196, 45.135289789789766],
          [81.62162162162161, 45.31547017617615],
          [80.90090090090087, 45.135289789789766],
          [80.54054054054052, 45.135289789789766],
          [80.18018018018017, 45.135289789789766],
          [80.18018018018017, 44.955109403403355],
          [80.18018018018017, 44.77492901701697],
          [80.18018018018017, 44.05420747147144],
          [80.54054054054052, 44.05420747147144],
          [80.54054054054052, 43.1533055395395],
          [80.54054054054052, 42.79294476676674],
          [80.18018018018017, 42.79294476676674],
          [80.18018018018017, 42.07222322122118],
          [79.81981981981983, 42.07222322122118],
          [79.81981981981983, 41.8920428348348],
          [79.45945945945942, 41.711862448448414],
          [78.73873873873873, 41.711862448448414],
          [78.37837837837839, 41.53168206206203],
          [78.37837837837839, 41.17132128928927],
          [78.01801801801798, 40.991140902902856],
          [77.65765765765764, 40.991140902902856],
          [77.29729729729729, 40.991140902902856],
          [76.93693693693695, 40.991140902902856],
          [76.57657657657654, 40.810960516516474],
          [76.57657657657654, 40.45059974374371],
          [76.2162162162162, 40.270419357357326],
          [76.2162162162162, 40.45059974374371],
          [75.85585585585585, 40.270419357357326],
          [75.49549549549548, 40.270419357357326],
          [75.49549549549548, 40.63078013013009],
          [75.13513513513513, 40.45059974374371],
          [74.77477477477476, 40.45059974374371],
          [74.77477477477476, 40.270419357357326],
          [74.41441441441441, 40.090238970970944],
          [74.05405405405403, 40.090238970970944],
          [74.05405405405403, 39.72987819819815],
          [73.69369369369369, 39.369517425425386],
          [71.53153153153153, 39.369517425425386],
          [71.53153153153153, 39.54969781181177],
          [69.36936936936937, 39.54969781181177],
          [69.36936936936937, 40.090238970970944],
          [70.8108108108108, 40.090238970970944],
          [70.8108108108108, 40.270419357357326],
          [71.53153153153153, 40.270419357357326],
          [72.25225225225225, 40.63078013013009],
          [72.97297297297297, 40.63078013013009],
          [72.97297297297297, 40.810960516516474],
          [71.53153153153153, 41.53168206206203],
          [71.53153153153153, 41.17132128928927],
          [70.8108108108108, 41.17132128928927],
          [70.45045045045043, 41.35150167567565],
          [70.45045045045043, 41.8920428348348],
          [70.8108108108108, 41.8920428348348],
          [70.8108108108108, 42.25240360760756],
          [68.64864864864865, 41.17132128928927],
          [68.64864864864865, 40.63078013013009],
          [67.92792792792793, 40.810960516516474],
          [67.92792792792793, 41.17132128928927],
          [66.84684684684683, 41.17132128928927],
          [66.48648648648648, 41.35150167567565],
          [66.48648648648648, 42.07222322122118],
          [66.12612612612611, 42.07222322122118],
          [66.12612612612611, 42.97312515315312],
          [65.04504504504504, 43.51366631231227],
          [63.6036036036036, 43.51366631231227],
          [63.6036036036036, 43.69384669869865],
          [62.88288288288288, 43.69384669869865],
          [62.88288288288288, 43.51366631231227],
          [61.80180180180179, 43.51366631231227],
          [61.80180180180179, 43.87402708508506],
          [58.918918918918905, 45.31547017617615],
          [58.918918918918905, 45.856011335335296],
          [59.27927927927928, 46.03619172172168],
          [59.27927927927928, 46.39655249449444],
          [61.08108108108107, 47.297454426426384],
          [61.08108108108107, 47.47763481281277],
          [61.80180180180179, 47.83799558558556],
          [62.16216216216216, 47.47763481281277],
          [62.88288288288288, 47.11727404004],
          [63.24324324324323, 47.47763481281277],
          [64.32432432432432, 48.01817597197194],
          [63.6036036036036, 48.55871713113109],
          [63.24324324324323, 48.55871713113109],
          [62.52252252252251, 48.919077903903855],
          [62.52252252252251, 50.720881767767736],
          [62.16216216216216, 51.0812425405405],
          [61.44144144144144, 51.26142292692688],
          [61.44144144144144, 50.720881767767736],
          [60, 50.720881767767736],
          [59.639639639639626, 50.54070138138135],
          [59.27927927927928, 50.720881767767736],
          [58.55855855855856, 50.720881767767736],
          [58.55855855855856, 51.0812425405405],
          [56.3963963963964, 51.0812425405405],
          [55.67567567567568, 50.54070138138135],
          [54.59459459459458, 51.0812425405405],
          [53.513513513513516, 51.441603313313266],
          [52.43243243243242, 51.441603313313266],
          [52.43243243243242, 51.80196408608606],
          [51.7117117117117, 51.441603313313266],
          [51.351351351351354, 51.441603313313266],
          [50.630630630630606, 51.80196408608606],
          [51.351351351351354, 51.98214447247244],
          [51.7117117117117, 52.342505245245206],
          [51.7117117117117, 52.883046404404354],
          [52.072072072072075, 52.883046404404354],
          [52.072072072072075, 53.60376794994991],
          [52.43243243243242, 53.60376794994991],
          [52.43243243243242, 54.32448949549547],
          [53.15315315315314, 54.32448949549547],
          [53.513513513513516, 53.96412872272268],
          [53.513513513513516, 55.045211041041],
          [53.87387387387386, 55.405571813813765],
          [53.87387387387386, 56.12629335935932],
          [54.234234234234236, 56.12629335935932],
          [54.234234234234236, 57.928097223223176],
          [53.87387387387386, 58.10827760960956],
          [53.87387387387386, 59.18935992792788],
          [53.513513513513516, 59.54972070070065],
          [53.513513513513516, 60.09026185985982],
          [52.792792792792795, 60.270442246246205],
          [51.7117117117117, 60.81098340540535],
          [52.43243243243242, 60.81098340540535],
          [52.792792792792795, 61.171344178178146],
          [53.513513513513516, 60.99116379179176],
          [55.3153153153153, 60.99116379179176],
          [55.3153153153153, 61.171344178178146],
          [56.3963963963964, 61.171344178178146],
          [56.756756756756744, 61.53170495095091],
          [59.27927927927928, 61.53170495095091],
          [59.639639639639626, 61.892065723723675],
          [59.639639639639626, 62.61278726926923],
          [59.27927927927928, 62.61278726926923],
          [59.27927927927928, 63.513689201201146],
          [59.639639639639626, 63.69386958758756],
          [59.639639639639626, 64.77495190590585],
          [60.72072072072072, 64.95513229229226],
          [62.52252252252251, 65.85603422422417],
          [63.6036036036036, 66.57675576976973],
          [65.04504504504504, 66.75693615615612],
          [66.12612612612611, 67.47765770170165],
          [66.12612612612611, 68.01819886086082],
          [65.40540540540539, 68.01819886086082],
          [65.40540540540539, 68.73892040640635],
          [65.04504504504504, 68.73892040640635],
          [65.04504504504504, 71.08126542942938],
          [65.40540540540539, 71.26144581581576],
          [67.56756756756755, 73.06324967967964],
          [70.09009009009009, 75.04523392992988],
          [70.09009009009009, 82.07226899899896],
          [75.13513513513513, 82.07226899899896],
          [82.70270270270271, 82.07226899899896],
          [82.70270270270271, 90.00020599999996],
          [97.47747747747746, 90.00020599999996],
          [97.47747747747746, 81.53172783983979],
          [88.82882882882882, 81.53172783983979],
          [88.82882882882882, 81.3515474534534],
          [80.54054054054052, 81.3515474534534],
          [79.81981981981983, 81.3515474534534],
          [79.09909909909908, 81.3515474534534],
          [78.37837837837839, 81.3515474534534],
          [78.37837837837839, 80.45064552152147],
        ],
      ],
    },
    properties: {
      objectid: 25,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+6',
      map_color6: 6,
      map_color8: 8,
      note: 'Reflects 2012 shift in daylight savings time in Russia.',
      zone: 6,
      utc_format: 'UTC+06:00',
      time_zone: 'UTC+06:00',
      iso_8601: '2012-05-31T10:33:50+06:00',
      places:
        'Kazakhstan (most), Russia (Ural: Sverdlovsk Oblast, Chelyabinsk Oblast)',
      dst_places: null,
      tz_name1st: 'Asia/Almaty',
      tz_namesum: 4,
      cartodb_id: 36,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [107.56756756756755, 50.00016022222218],
          [107.2072072072072, 50.00016022222218],
          [106.48648648648646, 50.36052099499497],
          [106.12612612612611, 50.36052099499497],
          [105.76576576576576, 50.36052099499497],
          [105.40540540540542, 50.54070138138135],
          [105.04504504504501, 50.36052099499497],
          [104.68468468468467, 50.36052099499497],
          [104.32432432432432, 50.36052099499497],
          [103.96396396396398, 50.18034060860856],
          [103.60360360360357, 50.18034060860856],
          [103.24324324324323, 50.18034060860856],
          [103.24324324324323, 50.36052099499497],
          [102.88288288288288, 50.36052099499497],
          [102.16216216216213, 50.54070138138135],
          [102.16216216216213, 51.441603313313266],
          [101.80180180180179, 51.441603313313266],
          [101.44144144144144, 51.441603313313266],
          [101.0810810810811, 51.441603313313266],
          [100.36036036036035, 51.80196408608606],
          [100, 51.80196408608606],
          [99.63963963963965, 51.80196408608606],
          [98.9189189189189, 52.162324858858824],
          [98.55855855855856, 52.342505245245206],
          [98.55855855855856, 52.52268563163159],
          [98.9189189189189, 52.52268563163159],
          [98.9189189189189, 52.70286601801797],
          [98.9189189189189, 52.883046404404354],
          [98.9189189189189, 52.70286601801797],
          [98.9189189189189, 52.883046404404354],
          [99.27927927927925, 52.883046404404354],
          [98.9189189189189, 53.063226790790765],
          [98.55855855855856, 53.24340717717715],
          [98.55855855855856, 53.063226790790765],
          [98.19819819819821, 53.063226790790765],
          [98.19819819819821, 53.24340717717715],
          [97.83783783783781, 53.42358756356353],
          [97.47747747747746, 53.42358756356353],
          [97.47747747747746, 53.60376794994991],
          [97.11711711711712, 53.60376794994991],
          [96.75675675675677, 53.783948336336294],
          [96.75675675675677, 53.60376794994991],
          [96.39639639639637, 53.60376794994991],
          [96.39639639639637, 53.96412872272268],
          [96.03603603603602, 54.14430910910906],
          [95.67567567567568, 54.50466988188185],
          [96.03603603603602, 54.32448949549547],
          [96.03603603603602, 54.50466988188185],
          [96.39639639639637, 54.50466988188185],
          [96.75675675675677, 54.684850268268235],
          [96.75675675675677, 55.76593258658656],
          [97.11711711711712, 56.12629335935932],
          [97.47747747747746, 56.12629335935932],
          [97.83783783783781, 56.306473745745706],
          [97.83783783783781, 56.84701490490485],
          [97.47747747747746, 56.84701490490485],
          [97.47747747747746, 57.207375677677646],
          [97.83783783783781, 57.38755606406403],
          [97.83783783783781, 57.747916836836794],
          [98.55855855855856, 57.747916836836794],
          [98.9189189189189, 57.747916836836794],
          [99.27927927927925, 57.747916836836794],
          [99.63963963963965, 58.10827760960956],
          [100, 58.10827760960956],
          [100.36036036036035, 57.56773645045041],
          [100.72072072072069, 57.38755606406403],
          [101.0810810810811, 57.38755606406403],
          [100.72072072072069, 57.56773645045041],
          [100.72072072072069, 57.928097223223176],
          [101.0810810810811, 57.928097223223176],
          [101.44144144144144, 58.28845799599597],
          [101.80180180180179, 58.46863838238235],
          [102.52252252252254, 58.648818768768734],
          [102.52252252252254, 59.18935992792788],
          [102.88288288288288, 59.18935992792788],
          [102.88288288288288, 59.369540314314264],
          [103.24324324324323, 59.18935992792788],
          [103.24324324324323, 59.369540314314264],
          [103.24324324324323, 59.18935992792788],
          [103.60360360360357, 58.82899915515512],
          [103.60360360360357, 59.0091795415415],
          [103.96396396396398, 58.82899915515512],
          [103.96396396396398, 58.648818768768734],
          [103.96396396396398, 58.82899915515512],
          [104.32432432432432, 58.648818768768734],
          [104.68468468468467, 58.648818768768734],
          [105.40540540540542, 59.18935992792788],
          [105.04504504504501, 59.54972070070065],
          [105.04504504504501, 59.369540314314264],
          [105.04504504504501, 59.54972070070065],
          [105.04504504504501, 59.72990108708706],
          [105.04504504504501, 59.91008147347344],
          [105.40540540540542, 59.91008147347344],
          [105.40540540540542, 60.270442246246205],
          [105.04504504504501, 60.270442246246205],
          [104.68468468468467, 60.270442246246205],
          [104.68468468468467, 61.171344178178146],
          [105.04504504504501, 61.171344178178146],
          [105.04504504504501, 61.35152456456453],
          [105.76576576576576, 61.71188533733729],
          [105.76576576576576, 61.53170495095091],
          [105.76576576576576, 61.892065723723675],
          [106.48648648648646, 62.25242649649647],
          [106.48648648648646, 62.43260688288285],
          [106.48648648648646, 62.792967655655616],
          [106.12612612612611, 62.973148042042],
          [106.48648648648646, 63.33350881481476],
          [106.84684684684686, 63.69386958758756],
          [106.84684684684686, 64.05423036036032],
          [107.2072072072072, 63.87404997397394],
          [107.56756756756755, 63.87404997397394],
          [107.9279279279279, 64.05423036036032],
          [108.2882882882883, 64.05423036036032],
          [108.2882882882883, 64.2344107467467],
          [108.2882882882883, 63.513689201201146],
          [109.36936936936934, 63.513689201201146],
          [109.36936936936934, 62.43260688288285],
          [109.72972972972974, 62.07224611011006],
          [109.72972972972974, 61.35152456456453],
          [110.45045045045043, 61.171344178178146],
          [109.72972972972974, 60.45062263263259],
          [109.72972972972974, 59.91008147347344],
          [109.36936936936934, 59.72990108708706],
          [109.36936936936934, 59.18935992792788],
          [109.72972972972974, 59.0091795415415],
          [110.45045045045043, 59.18935992792788],
          [111.89189189189187, 59.18935992792788],
          [112.61261261261262, 59.369540314314264],
          [113.33333333333331, 59.18935992792788],
          [113.69369369369366, 59.369540314314264],
          [113.69369369369366, 59.72990108708706],
          [114.41441441441441, 59.72990108708706],
          [114.41441441441441, 60.09026185985982],
          [115.1351351351351, 60.45062263263259],
          [116.2162162162162, 60.45062263263259],
          [116.93693693693695, 60.09026185985982],
          [117.29729729729729, 60.09026185985982],
          [117.29729729729729, 59.54972070070065],
          [118.01801801801798, 59.369540314314264],
          [118.73873873873873, 59.369540314314264],
          [118.73873873873873, 58.46863838238235],
          [118.37837837837839, 58.28845799599597],
          [117.65765765765764, 58.46863838238235],
          [117.29729729729729, 58.10827760960956],
          [117.29729729729729, 57.207375677677646],
          [117.65765765765764, 56.84701490490485],
          [115.85585585585585, 56.84701490490485],
          [115.85585585585585, 55.405571813813765],
          [116.57657657657654, 55.405571813813765],
          [116.93693693693695, 55.22539142742738],
          [116.93693693693695, 54.684850268268235],
          [116.57657657657654, 54.50466988188185],
          [115.4954954954955, 54.50466988188185],
          [115.1351351351351, 54.32448949549547],
          [115.1351351351351, 53.96412872272268],
          [114.41441441441441, 53.96412872272268],
          [114.05405405405406, 53.783948336336294],
          [114.05405405405406, 52.70286601801797],
          [113.69369369369366, 52.52268563163159],
          [112.97297297297297, 52.52268563163159],
          [111.53153153153153, 51.80196408608606],
          [110.81081081081078, 51.80196408608606],
          [109.72972972972974, 51.441603313313266],
          [108.64864864864865, 51.441603313313266],
          [108.2882882882883, 51.26142292692688],
          [108.2882882882883, 50.36052099499497],
          [107.9279279279279, 50.00016022222218],
          [107.56756756756755, 50.00016022222218],
        ],
      ],
    },
    properties: {
      objectid: 29,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+9',
      map_color6: 3,
      map_color8: 3,
      note: 'Reflects 2012 shift in daylight savings time in Russia.',
      zone: 9,
      utc_format: 'UTC+09:00',
      time_zone: 'UTC+09:00',
      iso_8601: '2012-05-31T13:33:50+09:00',
      places: 'Russia (Irkutsk Oblast)',
      dst_places: null,
      tz_name1st: 'Asia/Irkutsk',
      tz_namesum: 1,
      cartodb_id: 37,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [48.82882882882882, 38.468615493493445],
          [49.54954954954954, 38.468615493493445],
          [50.27027027027026, 38.82897626626624],
          [51.7117117117117, 39.189337039039],
          [52.43243243243242, 38.468615493493445],
          [52.43243243243242, 38.28843510710706],
          [53.15315315315314, 37.56771356156153],
          [53.513513513513516, 37.387533175175136],
          [54.59459459459458, 37.387533175175136],
          [54.95495495495496, 37.56771356156153],
          [54.95495495495496, 37.9280743343343],
          [55.3153153153153, 38.10825472072068],
          [56.3963963963964, 38.10825472072068],
          [56.3963963963964, 38.28843510710706],
          [57.11711711711712, 38.28843510710706],
          [58.198198198198185, 37.747893947947915],
          [58.198198198198185, 37.56771356156153],
          [59.27927927927928, 37.56771356156153],
          [59.27927927927928, 37.207352788788754],
          [59.639639639639626, 37.207352788788754],
          [60.360360360360346, 36.846992016015975],
          [60.360360360360346, 36.66681162962959],
          [61.08108108108107, 36.66681162962959],
          [61.08108108108107, 35.58572931131128],
          [61.44144144144144, 35.58572931131128],
          [61.08108108108107, 35.40554892492489],
          [61.08108108108107, 34.68482737937934],
          [60.72072072072072, 34.68482737937934],
          [60.72072072072072, 34.14428622022018],
          [60.360360360360346, 34.14428622022018],
          [60.360360360360346, 33.60374506106103],
          [60.72072072072072, 33.42356467467464],
          [60.72072072072072, 31.441580424424387],
          [61.80180180180179, 31.441580424424387],
          [61.80180180180179, 30.720858878878843],
          [61.08108108108107, 30.36049810610608],
          [61.08108108108107, 30.0001373333333],
          [60.72072072072072, 29.819956946946917],
          [61.08108108108107, 29.819956946946917],
          [61.08108108108107, 29.459596174174138],
          [61.44144144144144, 29.459596174174138],
          [61.44144144144144, 28.919055015014976],
          [62.88288288288288, 28.198333469469432],
          [62.88288288288288, 27.297431537537506],
          [63.24324324324323, 27.297431537537506],
          [63.24324324324323, 26.57670999199196],
          [62.16216216216216, 26.57670999199196],
          [62.16216216216216, 26.216349219219182],
          [61.80180180180179, 26.216349219219182],
          [61.80180180180179, 25.315447287287256],
          [61.44144144144144, 25.315447287287256],
          [61.44144144144144, 24.955086514514477],
          [61.08108108108107, 24.955086514514477],
          [60.72072072072072, 25.135266900900874],
          [58.918918918918905, 25.135266900900874],
          [58.918918918918905, 25.315447287287256],
          [57.83783783783784, 25.315447287287256],
          [57.83783783783784, 25.49562767367364],
          [57.11711711711712, 25.49562767367364],
          [57.11711711711712, 26.0361688328328],
          [56.756756756756744, 26.216349219219182],
          [56.756756756756744, 26.937070764764727],
          [56.3963963963964, 26.57670999199196],
          [56.03603603603602, 26.39652960560558],
          [54.95495495495496, 26.39652960560558],
          [54.59459459459458, 26.216349219219182],
          [54.59459459459458, 25.675808060060035],
          [54.234234234234236, 25.855988446446418],
          [54.234234234234236, 26.216349219219182],
          [53.15315315315314, 26.756890378378344],
          [52.792792792792795, 26.756890378378344],
          [52.792792792792795, 27.117251151151123],
          [52.43243243243242, 27.117251151151123],
          [52.43243243243242, 27.477611923923888],
          [52.072072072072075, 27.657792310310285],
          [51.351351351351354, 27.657792310310285],
          [50.99099099099098, 28.01815308308305],
          [50.99099099099098, 28.55869424224221],
          [50.630630630630606, 28.919055015014976],
          [49.909909909909885, 29.279415787787755],
          [50.27027027027026, 29.459596174174138],
          [49.909909909909885, 29.819956946946917],
          [49.54954954954954, 29.819956946946917],
          [49.189189189189165, 30.0001373333333],
          [48.82882882882882, 29.819956946946917],
          [48.468468468468444, 29.819956946946917],
          [48.468468468468444, 30.36049810610608],
          [48.1081081081081, 30.36049810610608],
          [48.1081081081081, 31.081219651651622],
          [47.747747747747724, 31.081219651651622],
          [47.747747747747724, 32.16230196996993],
          [47.38738738738738, 32.16230196996993],
          [47.38738738738738, 32.52266274274271],
          [47.027027027027, 32.52266274274271],
          [46.66666666666666, 32.883023515515475],
          [45.94594594594594, 32.883023515515475],
          [45.94594594594594, 33.60374506106103],
          [45.58558558558556, 33.60374506106103],
          [45.58558558558556, 34.865007765765725],
          [46.30630630630628, 35.225368538538504],
          [45.94594594594594, 35.40554892492489],
          [45.94594594594594, 35.765909697697666],
          [45.225225225225216, 35.94609008408405],
          [45.225225225225216, 36.48663124324321],
          [44.86486486486484, 36.48663124324321],
          [44.86486486486484, 37.207352788788754],
          [44.504504504504496, 37.387533175175136],
          [44.504504504504496, 37.9280743343343],
          [44.14414414414412, 37.9280743343343],
          [44.14414414414412, 39.369517425425386],
          [44.504504504504496, 39.369517425425386],
          [44.504504504504496, 39.72987819819815],
          [44.86486486486484, 39.72987819819815],
          [44.86486486486484, 39.54969781181177],
          [45.225225225225216, 39.369517425425386],
          [45.225225225225216, 39.00915665265262],
          [45.94594594594594, 39.00915665265262],
          [45.94594594594594, 38.82897626626624],
          [46.66666666666666, 38.82897626626624],
          [46.66666666666666, 39.189337039039],
          [47.747747747747724, 39.72987819819815],
          [48.1081081081081, 39.72987819819815],
          [48.1081081081081, 38.648795879879856],
          [48.82882882882882, 38.468615493493445],
        ],
      ],
    },
    properties: {
      objectid: 19,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+3.5',
      map_color6: 5,
      map_color8: 6,
      note: null,
      zone: 3.5,
      utc_format: 'UTC+03:30',
      time_zone: 'UTC+03:30',
      iso_8601: '2012-05-31T08:03:50+03:30',
      places: 'Iran',
      dst_places: 'Iran',
      tz_name1st: 'Asia/Tehran',
      tz_namesum: 2,
      cartodb_id: 38,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [74.77477477477476, 37.207352788788754],
          [74.77477477477476, 37.387533175175136],
          [74.77477477477476, 37.207352788788754],
          [74.41441441441441, 37.207352788788754],
          [74.41441441441441, 37.02717240240237],
          [74.41441441441441, 36.846992016015975],
          [73.69369369369369, 36.846992016015975],
          [72.6126126126126, 36.846992016015975],
          [72.6126126126126, 36.66681162962959],
          [71.89189189189187, 36.66681162962959],
          [71.89189189189187, 36.30645085685683],
          [71.53153153153153, 36.30645085685683],
          [71.53153153153153, 35.40554892492489],
          [71.53153153153153, 34.865007765765725],
          [71.17117117117115, 34.865007765765725],
          [71.17117117117115, 33.9641058338338],
          [69.72972972972971, 33.9641058338338],
          [70.09009009009009, 33.783925447447416],
          [70.09009009009009, 33.06320390190187],
          [69.36936936936937, 33.06320390190187],
          [69.36936936936937, 31.98212158358355],
          [68.64864864864865, 31.801941197197166],
          [67.92792792792793, 31.801941197197166],
          [67.92792792792793, 31.261400038038005],
          [66.84684684684683, 31.261400038038005],
          [66.12612612612611, 30.54067849249246],
          [66.12612612612611, 29.819956946946917],
          [65.76576576576576, 29.639776560560534],
          [64.32432432432432, 29.639776560560534],
          [64.32432432432432, 29.459596174174138],
          [63.24324324324323, 29.459596174174138],
          [62.88288288288288, 29.459596174174138],
          [61.80180180180179, 29.459596174174138],
          [61.44144144144144, 29.819956946946917],
          [60.72072072072072, 29.819956946946917],
          [61.08108108108107, 30.0001373333333],
          [61.08108108108107, 30.36049810610608],
          [61.80180180180179, 30.720858878878843],
          [61.80180180180179, 31.441580424424387],
          [60.72072072072072, 31.441580424424387],
          [60.72072072072072, 33.42356467467464],
          [60.360360360360346, 33.60374506106103],
          [60.360360360360346, 34.14428622022018],
          [60.72072072072072, 34.14428622022018],
          [60.72072072072072, 34.68482737937934],
          [61.08108108108107, 34.68482737937934],
          [61.08108108108107, 35.40554892492489],
          [61.44144144144144, 35.58572931131128],
          [61.44144144144144, 35.40554892492489],
          [62.16216216216216, 35.40554892492489],
          [62.16216216216216, 35.225368538538504],
          [62.88288288288288, 35.225368538538504],
          [63.24324324324323, 35.40554892492489],
          [63.24324324324323, 35.94609008408405],
          [63.96396396396395, 35.94609008408405],
          [64.32432432432432, 36.30645085685683],
          [64.68468468468467, 36.30645085685683],
          [64.68468468468467, 37.207352788788754],
          [65.40540540540539, 37.207352788788754],
          [65.40540540540539, 37.387533175175136],
          [67.2072072072072, 37.387533175175136],
          [67.2072072072072, 37.207352788788754],
          [68.28828828828827, 37.207352788788754],
          [68.64864864864865, 37.387533175175136],
          [69.36936936936937, 37.02717240240237],
          [69.36936936936937, 37.56771356156153],
          [70.09009009009009, 37.56771356156153],
          [70.09009009009009, 37.9280743343343],
          [70.45045045045043, 37.9280743343343],
          [70.45045045045043, 38.28843510710706],
          [71.17117117117115, 38.468615493493445],
          [71.17117117117115, 38.10825472072068],
          [71.53153153153153, 37.9280743343343],
          [71.53153153153153, 36.66681162962959],
          [71.89189189189187, 36.66681162962959],
          [72.25225225225225, 37.02717240240237],
          [72.97297297297297, 37.387533175175136],
          [74.77477477477476, 37.387533175175136],
          [74.77477477477476, 37.207352788788754],
        ],
      ],
    },
    properties: {
      objectid: 21,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+4.5',
      map_color6: 3,
      map_color8: 2,
      note: null,
      zone: 4.5,
      utc_format: 'UTC+04:30',
      time_zone: 'UTC+04:30',
      iso_8601: '2012-05-31T09:03:50+04:30',
      places: 'Afghanistan',
      dst_places: null,
      tz_name1st: 'Asia/Kabul',
      tz_namesum: 1,
      cartodb_id: 39,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [81.62162162162161, 30.36049810610608],
          [81.98198198198196, 30.36049810610608],
          [81.98198198198196, 30.0001373333333],
          [82.3423423423423, 30.0001373333333],
          [82.70270270270271, 29.819956946946917],
          [82.70270270270271, 29.639776560560534],
          [83.06306306306305, 29.639776560560534],
          [83.4234234234234, 29.459596174174138],
          [83.4234234234234, 29.099235401401373],
          [83.78378378378375, 29.099235401401373],
          [83.78378378378375, 29.279415787787755],
          [84.14414414414415, 29.279415787787755],
          [84.14414414414415, 28.919055015014976],
          [84.5045045045045, 28.738874628628594],
          [84.86486486486484, 28.55869424224221],
          [85.22522522522519, 28.37851385585583],
          [85.22522522522519, 28.198333469469432],
          [85.58558558558559, 28.37851385585583],
          [85.58558558558559, 28.198333469469432],
          [85.58558558558559, 28.37851385585583],
          [85.94594594594594, 28.198333469469432],
          [85.94594594594594, 27.837972696696667],
          [85.94594594594594, 28.01815308308305],
          [86.30630630630628, 28.01815308308305],
          [86.30630630630628, 27.837972696696667],
          [86.66666666666663, 28.01815308308305],
          [87.02702702702703, 28.01815308308305],
          [87.02702702702703, 27.837972696696667],
          [87.38738738738738, 27.837972696696667],
          [87.74774774774772, 27.837972696696667],
          [88.10810810810807, 27.837972696696667],
          [88.10810810810807, 26.39652960560558],
          [86.66666666666663, 26.39652960560558],
          [86.66666666666663, 26.57670999199196],
          [85.58558558558559, 26.57670999199196],
          [85.22522522522519, 26.937070764764727],
          [84.86486486486484, 26.937070764764727],
          [84.5045045045045, 27.117251151151123],
          [84.14414414414415, 27.477611923923888],
          [83.06306306306305, 27.477611923923888],
          [82.3423423423423, 27.837972696696667],
          [81.62162162162161, 27.837972696696667],
          [81.62162162162161, 28.198333469469432],
          [80.90090090090087, 28.55869424224221],
          [80.18018018018017, 28.55869424224221],
          [80.18018018018017, 29.819956946946917],
          [80.90090090090087, 30.18031771971968],
          [81.26126126126127, 30.0001373333333],
          [81.26126126126127, 30.18031771971968],
          [81.26126126126127, 30.36049810610608],
          [81.62162162162161, 30.36049810610608],
        ],
      ],
    },
    properties: {
      objectid: 24,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+5.75',
      map_color6: 1,
      map_color8: 4,
      note: null,
      zone: 5.75,
      utc_format: 'UTC+05:45',
      time_zone: 'UTC+05:45',
      iso_8601: '2012-05-31T10:18:50+05:45',
      places: 'Nepal',
      dst_places: null,
      tz_name1st: 'Asia/Kathmandu',
      tz_namesum: 1,
      cartodb_id: 40,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [127.3873874, 90.00020599999999],
          [127.3873874, 79.91010436000001],
          [124.8648649, 79.18938282000001],
          [121.2612613, 78.28848087999999],
          [120.5405405, 77.92812011],
          [114.4144144, 77.92812011],
          [114.4144144, 75.04523393],
          [112.972973, 74.86505354000001],
          [111.1711712, 74.32451238],
          [111.5315315, 73.96415161],
          [110.8108108, 73.60379084],
          [110.8108108, 72.52270852],
          [111.5315315, 72.34252813000001],
          [111.8918919, 72.16234775],
          [111.8918919, 71.4416262],
          [112.6126126, 71.26144582000001],
          [112.6126126, 71.08126543],
          [112.2522523, 71.08126543],
          [110.8108108, 70.72090466],
          [110.8108108, 70.90108504],
          [110.8108108, 70.72090466],
          [110.4504505, 70.72090466],
          [110.0900901, 70.54072427],
          [110.0900901, 70.36054387999999],
          [109.7297297, 70.36054387999999],
          [109.009009, 69.82000272000001],
          [108.6486486, 69.82000272000001],
          [108.2882883, 69.82000272000001],
          [107.9279279, 69.63982234],
          [106.4864865, 69.45964195000001],
          [106.4864865, 69.63982234],
          [106.1261261, 69.27946157],
          [106.8468468, 68.91910079],
          [106.8468468, 67.29747732],
          [106.4864865, 67.29747732],
          [105.7657658, 66.93711654000001],
          [106.1261261, 66.75693616],
          [106.4864865, 66.57675577000001],
          [106.1261261, 66.21639500000001],
          [106.4864865, 66.21639500000001],
          [106.4864865, 65.67585384],
          [106.8468468, 65.31549307],
          [106.4864865, 65.31549307],
          [106.4864865, 65.13531268],
          [106.1261261, 64.77495191],
          [106.1261261, 64.95513229],
          [106.1261261, 64.77495191],
          [105.7657658, 64.77495191],
          [105.7657658, 64.59477152],
          [105.7657658, 64.41459113000001],
          [106.1261261, 64.59477152],
          [106.1261261, 64.41459113000001],
          [106.4864865, 64.59477152],
          [106.8468468, 64.41459113000001],
          [107.2072072, 64.23441075],
          [107.5675676, 64.23441075],
          [107.9279279, 64.23441075],
          [108.2882883, 64.23441075],
          [108.2882883, 64.05423036000001],
          [107.9279279, 64.05423036000001],
          [107.5675676, 63.87404997],
          [107.2072072, 63.87404997],
          [106.8468468, 64.05423036000001],
          [106.8468468, 63.69386959],
          [106.4864865, 63.33350881000001],
          [106.1261261, 62.97314804],
          [106.4864865, 62.79296766],
          [106.4864865, 62.43260688000001],
          [106.4864865, 62.2524265],
          [105.7657658, 61.89206571999999],
          [105.7657658, 61.53170495],
          [105.7657658, 61.71188534000001],
          [105.045045, 61.35152456],
          [105.045045, 61.17134417999999],
          [104.6846847, 61.17134417999999],
          [104.6846847, 60.27044225],
          [105.045045, 60.27044225],
          [105.4054054, 60.27044225],
          [105.4054054, 59.91008147],
          [105.045045, 59.91008147],
          [105.045045, 59.72990109],
          [105.045045, 59.5497207],
          [105.045045, 59.36954031],
          [105.045045, 59.5497207],
          [105.4054054, 59.18935993],
          [104.6846847, 58.64881877000001],
          [104.3243243, 58.64881877000001],
          [103.963964, 58.82899916],
          [103.963964, 58.64881877000001],
          [103.963964, 58.82899916],
          [103.6036036, 59.00917954],
          [103.6036036, 58.82899916],
          [103.2432432, 59.18935993],
          [103.2432432, 59.36954031],
          [103.2432432, 59.18935993],
          [102.8828829, 59.36954031],
          [102.8828829, 59.18935993],
          [102.5225225, 59.18935993],
          [102.5225225, 58.64881877000001],
          [101.8018018, 58.46863838],
          [101.4414414, 58.288458],
          [101.0810811, 57.92809722000001],
          [100.7207207, 57.92809722000001],
          [100.7207207, 57.56773645],
          [101.0810811, 57.38755606],
          [100.7207207, 57.38755606],
          [100.3603604, 57.56773645],
          [100, 58.10827761],
          [99.63963964, 58.10827761],
          [99.27927928, 57.74791684],
          [98.91891892000001, 57.74791684],
          [98.55855856000001, 57.74791684],
          [97.83783784000001, 57.74791684],
          [97.83783784000001, 57.38755606],
          [97.47747748000001, 57.20737568000001],
          [97.47747748000001, 56.8470149],
          [97.83783784000001, 56.8470149],
          [97.83783784000001, 56.30647375000001],
          [97.47747748000001, 56.12629336],
          [97.11711712, 56.12629336],
          [96.75675676, 55.76593258999999],
          [96.75675676, 54.68485027],
          [96.3963964, 54.50466988],
          [96.03603604, 54.50466988],
          [96.03603604, 54.3244895],
          [95.67567568, 54.50466988],
          [96.03603604, 54.14430911],
          [96.3963964, 53.96412872],
          [96.3963964, 53.60376795],
          [96.75675676, 53.60376795],
          [96.75675676, 53.78394834],
          [97.11711712, 53.60376795],
          [97.47747748000001, 53.60376795],
          [97.47747748000001, 53.42358756],
          [97.83783784000001, 53.42358756],
          [98.19819820000001, 53.24340718000001],
          [98.19819820000001, 53.06322679],
          [98.55855856000001, 53.06322679],
          [98.55855856000001, 53.24340718000001],
          [98.91891892000001, 53.06322679],
          [99.27927928, 52.8830464],
          [98.91891892000001, 52.8830464],
          [98.91891892000001, 52.70286602],
          [98.91891892000001, 52.8830464],
          [98.91891892000001, 52.70286602],
          [98.91891892000001, 52.52268563000001],
          [98.55855856000001, 52.52268563000001],
          [98.55855856000001, 52.34250525],
          [98.91891892000001, 52.16232486],
          [99.63963964, 51.80196409000001],
          [100, 51.80196409000001],
          [100.3603604, 51.80196409000001],
          [101.0810811, 51.44160331],
          [101.4414414, 51.44160331],
          [101.8018018, 51.44160331],
          [102.1621622, 51.44160331],
          [102.1621622, 50.54070138],
          [102.8828829, 50.36052098999999],
          [103.2432432, 50.36052098999999],
          [103.2432432, 50.18034061],
          [103.6036036, 50.18034061],
          [103.963964, 50.18034061],
          [104.3243243, 50.36052098999999],
          [104.6846847, 50.36052098999999],
          [105.045045, 50.36052098999999],
          [105.4054054, 50.54070138],
          [105.7657658, 50.36052098999999],
          [106.1261261, 50.36052098999999],
          [106.4864865, 50.36052098999999],
          [107.2072072, 50.00016022],
          [107.5675676, 50.00016022],
          [107.9279279, 50.00016022],
          [107.9279279, 49.63979945],
          [108.6486486, 49.27943868],
          [109.009009, 49.27943868],
          [109.3693694, 49.27943868],
          [109.7297297, 49.27943868],
          [110.0900901, 49.09925829],
          [110.4504505, 49.27943868],
          [110.8108108, 49.09925829],
          [110.8108108, 49.27943868],
          [111.5315315, 49.27943868],
          [111.5315315, 49.45961905999999],
          [112.6126126, 49.45961905999999],
          [113.6936937, 50.00016022],
          [114.4144144, 50.36052098999999],
          [114.4144144, 50.18034061],
          [114.7747748, 50.18034061],
          [115.4954955, 49.81997984],
          [115.8558559, 49.81997984],
          [116.2162162, 50.00016022],
          [116.9369369, 49.63979945],
          [117.6576577, 49.45961905999999],
          [118.3783784, 49.63979945],
          [118.7387387, 50.00016022],
          [119.0990991, 50.00016022],
          [119.4594595, 50.36052098999999],
          [119.0990991, 50.36052098999999],
          [119.4594595, 50.54070138],
          [119.4594595, 50.90106215000001],
          [119.8198198, 51.26142293],
          [120.1801802, 51.62178370000001],
          [120.5405405, 51.80196409000001],
          [120.5405405, 51.98214447],
          [120.9009009, 52.34250525],
          [120.5405405, 52.70286602],
          [120.1801802, 52.52268563000001],
          [120.9009009, 53.24340718000001],
          [121.2612613, 53.24340718000001],
          [121.981982, 53.42358756],
          [122.3423423, 53.42358756],
          [123.0630631, 53.42358756],
          [123.4234234, 53.60376795],
          [123.7837838, 53.60376795],
          [124.1441441, 53.42358756],
          [124.8648649, 53.24340718000001],
          [124.8648649, 53.06322679],
          [124.8648649, 53.24340718000001],
          [124.8648649, 53.06322679],
          [125.2252252, 53.24340718000001],
          [125.5855856, 53.06322679],
          [125.5855856, 52.8830464],
          [125.9459459, 52.8830464],
          [125.9459459, 52.70286602],
          [125.9459459, 52.52268563000001],
          [126.3063063, 52.52268563000001],
          [126.6666667, 52.16232486],
          [126.6666667, 51.26142293],
          [127.027027, 51.26142293],
          [127.027027, 50.90106215000001],
          [127.3873874, 50.72088177],
          [127.3873874, 50.00016022],
          [127.7477477, 49.63979945],
          [128.1081081, 49.63979945],
          [128.1081081, 49.45961905999999],
          [128.1081081, 49.63979945],
          [128.4684685, 49.45961905999999],
          [128.4684685, 49.63979945],
          [128.8288288, 49.63979945],
          [128.8288288, 49.45961905999999],
          [129.1891892, 49.27943868],
          [129.1891892, 49.45961905999999],
          [129.1891892, 49.27943868],
          [129.5495495, 49.45961905999999],
          [129.5495495, 49.27943868],
          [129.9099099, 49.27943868],
          [129.9099099, 48.9190779],
          [130.2702703, 48.9190779],
          [130.6306306, 48.9190779],
          [130.6306306, 48.55871713],
          [130.990991, 48.37853674],
          [130.6306306, 48.01817597],
          [130.990991, 47.6578152],
          [131.3513514, 47.6578152],
          [131.7117117, 47.6578152],
          [132.0720721, 47.6578152],
          [132.4324324, 47.6578152],
          [132.7927928, 48.01817597],
          [133.1531532, 48.19835636],
          [133.1531532, 48.01817597],
          [133.5135135, 48.01817597],
          [133.8738739, 48.19835636],
          [134.2342342, 48.37853674],
          [134.5945946, 48.37853674],
          [134.5945946, 48.19835636],
          [134.5945946, 47.47763481],
          [134.2342342, 47.47763481],
          [134.2342342, 46.93709365],
          [133.8738739, 46.75691327],
          [133.8738739, 46.39655249000001],
          [133.8738739, 46.21637211000001],
          [133.5135135, 45.85601134],
          [133.5135135, 45.49565056000001],
          [133.1531532, 45.49565056000001],
          [133.1531532, 45.13528979],
          [132.7927928, 44.9551094],
          [132.0720721, 45.31547018],
          [131.7117117, 45.31547018],
          [131.3513514, 44.9551094],
          [130.990991, 44.9551094],
          [130.990991, 44.41456824],
          [131.3513514, 44.05420747],
          [131.3513514, 43.15330554],
          [130.990991, 42.97312515],
          [130.990991, 42.79294477],
          [130.6306306, 42.79294477],
          [130.2702703, 42.61276438],
          [130.6306306, 42.61276438],
          [130.2702703, 42.61276438],
          [130.2702703, 42.97312515],
          [129.9099099, 42.97312515],
          [129.9099099, 42.43258399],
          [129.5495495, 42.43258399],
          [129.1891892, 42.43258399],
          [129.1891892, 42.07222322],
          [128.8288288, 42.07222322],
          [128.4684685, 42.07222322],
          [128.1081081, 42.07222322],
          [128.1081081, 41.35150168],
          [128.1081081, 41.53168206],
          [127.7477477, 41.35150168],
          [127.7477477, 41.53168206],
          [127.7477477, 41.35150168],
          [127.7477477, 41.53168206],
          [127.7477477, 41.35150168],
          [127.3873874, 41.53168206],
          [127.027027, 41.53168206],
          [127.027027, 41.71186245],
          [126.6666667, 41.71186245],
          [126.6666667, 41.35150168],
          [126.3063063, 41.35150168],
          [125.9459459, 40.9911409],
          [125.9459459, 40.81096052],
          [125.5855856, 40.81096052],
          [125.5855856, 40.63078013],
          [125.2252252, 40.63078013],
          [124.8648649, 40.45059974],
          [124.5045045, 40.09023897],
          [124.1441441, 39.7298782],
          [125.2252252, 39.18933704],
          [124.8648649, 39.00915665],
          [124.8648649, 38.64879588],
          [124.5045045, 38.64879588],
          [124.5045045, 37.56771356],
          [125.5855856, 37.56771356],
          [125.9459459, 37.38753318],
          [125.5855856, 37.0271724],
          [125.9459459, 36.84699202],
          [125.9459459, 35.04518815],
          [125.5855856, 34.86500777],
          [124.8648649, 34.86500777],
          [124.8648649, 33.96410583],
          [125.2252252, 34.14428622],
          [125.9459459, 34.14428622],
          [126.3063063, 33.60374506],
          [125.9459459, 33.42356467],
          [125.9459459, 33.0632039],
          [127.027027, 33.0632039],
          [127.027027, 33.60374506],
          [127.3873874, 33.78392545],
          [127.3873874, 26.75689038000001],
          [127.027027, 26.75689038000001],
          [126.3063063, 26.39652961000001],
          [123.4234234, 26.39652961000001],
          [123.4234234, 25.31544729],
          [123.0630631, 25.31544729],
          [122.7027027, 25.1352669],
          [122.7027027, 24.77490613],
          [122.3423423, 24.59472574],
          [122.3423423, 23.69382381000001],
          [122.7027027, 23.51364342],
          [127.3873874, 23.51364342],
          [127.3873874, 3.153259762],
          [127.027027, 2.973079375],
          [127.027027, 2.432538216],
          [125.9459459, 1.351455898],
          [125.5855856, 0.8109147389999999],
          [125.5855856, 0.450553966],
          [125.2252252, 0.09019319300000002],
          [124.8648649, -0.450347966],
          [124.1441441, -1.171069512],
          [124.1441441, -3.153053762],
          [124.5045045, -3.513414535],
          [124.5045045, -4.954857626],
          [124.8648649, -5.315218398],
          [124.8648649, -6.21612033],
          [125.2252252, -6.756661489],
          [125.2252252, -8.378284967000001],
          [124.8648649, -8.558465353000001],
          [124.8648649, -8.738645740000001],
          [124.5045045, -8.918826126000001],
          [124.1441441, -8.918826126000001],
          [123.7837838, -9.099006513000001],
          [124.5045045, -9.459367285000001],
          [124.5045045, -8.918826126000001],
          [124.8648649, -8.738645740000001],
          [124.8648649, -9.099006513000001],
          [125.2252252, -8.918826126000001],
          [125.2252252, -9.099006513000001],
          [125.2252252, -9.279186899000001],
          [124.8648649, -9.099006513000001],
          [124.8648649, -9.459367285000001],
          [125.5855856, -9.819728058000001],
          [125.9459459, -10.18008883],
          [127.027027, -10.72062999],
          [127.3873874, -11.08099076],
          [127.3873874, -13.78369656],
          [127.7477477, -13.96387694],
          [128.1081081, -14.32423772],
          [128.4684685, -14.5044181],
          [128.8288288, -14.68459849],
          [128.8288288, -26.75668438],
          [128.8288288, -31.26119404],
          [128.1081081, -31.62155481],
          [127.7477477, -31.62155481],
          [127.3873874, -31.8017352],
          [127.3873874, -32.34227636],
          [127.3873874, -66.75673016],
          [127.027027, -66.216189],
          [125.2252252, -66.216189],
          [125.2252252, -66.39636938],
          [123.7837838, -66.39636938],
          [123.4234234, -66.57654977],
          [122.3423423, -66.57654977],
          [121.6216216, -66.75673016],
          [120.9009009, -66.57654977],
          [119.8198198, -66.93691054],
          [117.2972973, -66.93691054],
          [115.8558559, -66.39636938],
          [114.7747748, -66.216189],
          [113.6936937, -65.67564784],
          [112.6126126, -65.67564784],
          [112.6126126, -9.639547672000001],
          [114.7747748, -9.639547672000001],
          [114.7747748, -8.558465353000001],
          [114.4144144, -8.378284967000001],
          [114.4144144, -8.017924194000001],
          [114.7747748, -7.837743808],
          [114.7747748, -7.477383035000001],
          [115.8558559, -7.477383035000001],
          [116.2162162, -7.477383035000001],
          [116.2162162, -5.135038012],
          [113.6936937, -5.135038012],
          [113.6936937, -4.774677239],
          [114.0540541, -4.23413608],
          [114.0540541, -3.873775307],
          [114.4144144, -3.513414535],
          [114.4144144, -2.792692989],
          [114.7747748, -2.792692989],
          [114.7747748, -2.25215183],
          [115.1351351, -2.25215183],
          [115.1351351, -1.891791057],
          [115.4954955, -1.891791057],
          [115.4954955, -1.351249898],
          [115.8558559, -1.351249898],
          [115.8558559, -1.171069512],
          [115.4954955, -0.990889125],
          [115.4954955, -0.450347966],
          [115.1351351, -0.450347966],
          [115.1351351, 0.09019319300000002],
          [115.1351351, -0.08998719299999999],
          [115.1351351, 0.8109147389999999],
          [114.7747748, 0.8109147389999999],
          [114.4144144, 0.6307343520000001],
          [114.0540541, 0.6307343520000001],
          [113.6936937, 0.6307343520000001],
          [114.0540541, 0.6307343520000001],
          [114.0540541, 0.9910951250000001],
          [114.0540541, 0.8109147389999999],
          [114.0540541, 1.351455898],
          [114.0540541, 1.531636284],
          [113.6936937, 1.351455898],
          [113.6936937, 1.171275512],
          [113.3333333, 1.351455898],
          [112.972973, 1.351455898],
          [112.972973, 1.531636284],
          [112.6126126, 1.531636284],
          [112.2522523, 1.531636284],
          [112.2522523, 1.171275512],
          [111.8918919, 0.9910951250000001],
          [111.5315315, 0.9910951250000001],
          [111.1711712, 0.9910951250000001],
          [110.8108108, 0.9910951250000001],
          [110.8108108, 0.8109147389999999],
          [110.8108108, 0.9910951250000001],
          [110.8108108, 0.8109147389999999],
          [110.4504505, 0.8109147389999999],
          [110.4504505, 0.9910951250000001],
          [110.0900901, 0.9910951250000001],
          [110.0900901, 1.351455898],
          [109.7297297, 1.351455898],
          [109.7297297, 1.531636284],
          [109.7297297, 2.973079375],
          [109.7297297, 4.955063626],
          [104.6846847, 4.955063626],
          [104.6846847, 2.973079375],
          [105.045045, 2.612718603],
          [105.045045, 1.891997057],
          [104.6846847, 1.531636284],
          [103.963964, 1.171275512],
          [103.2432432, 1.171275512],
          [103.2432432, 1.351455898],
          [102.8828829, 1.531636284],
          [102.8828829, 1.711816671],
          [101.8018018, 2.25235783],
          [101.8018018, 2.432538216],
          [101.4414414, 2.612718603],
          [101.0810811, 2.612718603],
          [101.0810811, 3.333440148],
          [100.7207207, 3.513620535],
          [100.7207207, 3.693800921],
          [100.3603604, 3.873981307000001],
          [100.3603604, 4.774883239],
          [100, 4.955063626],
          [100, 6.036145943999999],
          [99.63963964, 6.036145943999999],
          [99.63963964, 6.216326329999999],
          [99.27927928, 6.396506717000001],
          [99.63963964, 6.576687103],
          [100, 6.396506717000001],
          [100, 6.756867489],
          [100.3603604, 6.756867489],
          [100.3603604, 6.576687103],
          [100.7207207, 6.396506717000001],
          [100.7207207, 6.576687103],
          [100.7207207, 6.216326329999999],
          [101.0810811, 6.216326329999999],
          [101.0810811, 5.675785171],
          [101.4414414, 5.855965558],
          [101.8018018, 5.675785171],
          [101.8018018, 5.855965558],
          [101.8018018, 5.675785171],
          [101.8018018, 6.036145943999999],
          [102.1621622, 6.216326329999999],
          [112.6126126, 6.216326329999999],
          [112.6126126, 14.68480449],
          [112.6126126, 21.35147879],
          [111.5315315, 21.35147879],
          [111.1711712, 21.1712984],
          [110.8108108, 21.1712984],
          [110.8108108, 20.27039647],
          [111.1711712, 20.09021608],
          [111.1711712, 19.36949454],
          [110.8108108, 19.18931415],
          [110.8108108, 18.82895338],
          [110.4504505, 18.4685926],
          [109.3693694, 17.92805145],
          [109.009009, 18.28841222],
          [108.6486486, 18.28841222],
          [108.6486486, 18.64877299],
          [108.2882883, 18.82895338],
          [108.2882883, 19.36949454],
          [109.009009, 19.72985531],
          [109.009009, 20.09021608],
          [109.7297297, 20.45057685],
          [109.009009, 20.81093763],
          [109.009009, 21.35147879],
          [108.2882883, 21.35147879],
          [107.9279279, 21.53165917],
          [107.9279279, 21.71183956],
          [107.5675676, 21.53165917],
          [107.5675676, 21.71183956],
          [107.2072072, 21.53165917],
          [107.2072072, 21.71183956],
          [106.8468468, 21.89201995],
          [106.8468468, 22.07220033],
          [106.8468468, 21.89201995],
          [106.4864865, 21.89201995],
          [106.4864865, 22.61274149],
          [106.8468468, 22.79292188],
          [106.4864865, 22.79292188],
          [106.4864865, 22.97310226],
          [106.1261261, 22.79292188],
          [106.1261261, 22.97310226],
          [105.7657658, 22.97310226],
          [105.4054054, 22.97310226],
          [105.4054054, 23.33346304],
          [105.045045, 23.33346304],
          [105.045045, 23.15328265],
          [104.6846847, 23.15328265],
          [104.6846847, 22.79292188],
          [104.3243243, 22.61274149],
          [104.3243243, 22.79292188],
          [103.963964, 22.79292188],
          [103.963964, 22.43256111],
          [103.6036036, 22.79292188],
          [103.6036036, 22.61274149],
          [103.2432432, 22.79292188],
          [103.2432432, 22.43256111],
          [102.8828829, 22.43256111],
          [102.5225225, 22.79292188],
          [102.5225225, 22.61274149],
          [102.5225225, 22.79292188],
          [102.5225225, 22.61274149],
          [102.1621622, 22.43256111],
          [101.8018018, 22.43256111],
          [101.4414414, 22.25238072],
          [101.4414414, 21.89201995],
          [101.8018018, 21.89201995],
          [101.8018018, 21.1712984],
          [101.4414414, 21.1712984],
          [101.0810811, 21.35147879],
          [101.0810811, 21.71183956],
          [100.7207207, 21.53165917],
          [100.3603604, 21.53165917],
          [100.3603604, 21.35147879],
          [100, 21.35147879],
          [100, 22.07220033],
          [99.63963964, 22.07220033],
          [99.27927928, 22.07220033],
          [99.27927928, 22.97310226],
          [99.63963964, 22.97310226],
          [99.27927928, 23.15328265],
          [99.27927928, 22.97310226],
          [99.27927928, 23.15328265],
          [98.91891892000001, 23.15328265],
          [98.91891892000001, 23.33346304],
          [98.91891892000001, 23.51364342],
          [98.91891892000001, 24.05418458000001],
          [98.55855856000001, 24.05418458000001],
          [98.19819820000001, 24.05418458000001],
          [97.83783784000001, 24.05418458000001],
          [97.47747748000001, 23.8740042],
          [97.83783784000001, 24.05418458000001],
          [97.47747748000001, 24.41454536],
          [97.47747748000001, 24.77490613],
          [97.83783784000001, 24.77490613],
          [97.83783784000001, 25.31544729],
          [97.83783784000001, 25.1352669],
          [98.19819820000001, 25.31544729],
          [98.19819820000001, 25.67580806],
          [98.19819820000001, 25.49562767],
          [98.55855856000001, 25.85598845],
          [98.55855856000001, 26.03616883],
          [98.55855856000001, 26.21634922],
          [98.55855856000001, 26.03616883],
          [98.55855856000001, 26.21634922],
          [98.55855856000001, 27.65779231],
          [98.19819820000001, 27.47761192],
          [98.19342620321524, 28.19682771000595],
          [97.61615461785961, 28.52809152549701],
          [97.07574560530789, 27.73606922490738],
          [95.8889600351941, 28.27803400816411],
          [95.27278289333657, 27.93107223708416],
          [94.31483109159694, 27.58781675086205],
          [93.85362883476633, 27.05217889025283],
          [93.09895101559835, 26.88693641399579],
          [92.11341039488593, 26.88389028938052],
          [92.1202908153692, 27.27732916060884],
          [92.0122017266638, 27.47154106428225],
          [91.66596376896395, 27.48521270996915],
          [91.56590872651981, 27.8449477047763],
          [91.35135134999999, 28.01815308],
          [90.99099098999999, 28.01815308],
          [90.63063062999999, 28.01815308],
          [90.27027027, 28.01815308],
          [89.90990991, 28.37851386],
          [89.90990991, 28.19833347],
          [89.90990991, 28.37851386],
          [89.54954955, 28.19833347],
          [89.54954955, 27.8379727],
          [89.18918918999999, 27.8379727],
          [89.18918918999999, 27.47761192],
          [88.82882883000001, 27.29743154],
          [88.82882883000001, 28.01815308],
          [88.46846847000001, 28.01815308],
          [88.10810811, 28.01815308],
          [88.10810811, 27.8379727],
          [87.74774775, 27.8379727],
          [87.38738739, 27.8379727],
          [87.02702703, 27.8379727],
          [87.02702703, 28.01815308],
          [86.66666667, 28.01815308],
          [86.30630631, 27.8379727],
          [86.30630631, 28.01815308],
          [85.94594595, 28.01815308],
          [85.94594595, 27.8379727],
          [85.94594595, 28.19833347],
          [85.58558558999999, 28.37851386],
          [85.58558558999999, 28.19833347],
          [85.58558558999999, 28.37851386],
          [85.22522523000001, 28.19833347],
          [85.22522523000001, 28.37851386],
          [84.86486486, 28.55869424],
          [84.5045045, 28.73887463],
          [84.14414414, 28.91905502],
          [84.14414414, 29.27941579],
          [83.78378377999999, 29.27941579],
          [83.78378377999999, 29.09923540000001],
          [83.42342342000001, 29.09923540000001],
          [83.42342342000001, 29.45959617000001],
          [83.06306306000001, 29.63977656],
          [82.7027027, 29.63977656],
          [82.7027027, 29.81995695],
          [82.34234234, 30.00013733],
          [81.98198198, 30.00013733],
          [81.98198198, 30.36049811],
          [81.62162162, 30.36049811],
          [81.26126126, 30.36049811],
          [81.26126126, 30.18031772],
          [81.26126126, 30.00013733],
          [80.9009009, 30.00013733],
          [80.9009009, 30.36049811],
          [80.54054054, 30.54067849],
          [80.18018017999999, 30.54067849],
          [80.18018017999999, 30.72085888],
          [79.81981982000001, 30.90103927],
          [79.45945946000001, 30.90103927],
          [79.45945946000001, 31.08121965],
          [79.0990991, 31.08121965],
          [79.0990991, 31.44158042],
          [79.0990991, 31.26140004],
          [78.73873874, 31.26140004],
          [78.73873874, 31.62176081],
          [78.73873874, 31.98212158],
          [78.37837838, 32.16230197],
          [78.37837838, 32.52266274],
          [78.73873874, 32.70284313],
          [78.73873874, 32.34248236],
          [79.0990991, 32.34248236],
          [79.0990991, 32.52266274],
          [79.45945946000001, 32.52266274],
          [79.45945946000001, 33.24338429],
          [79.0990991, 33.24338429],
          [78.73873874, 33.42356467],
          [78.73873874, 34.50464699],
          [78.37837838, 34.50464699],
          [78.37837838, 34.86500777],
          [78.01801802, 34.86500777],
          [78.01801802, 35.40554892],
          [77.65765766, 35.58572931],
          [77.65765766, 35.40554892],
          [77.2972973, 35.58572931],
          [76.57657657999999, 35.58572931],
          [76.57657657999999, 35.94609008],
          [76.21621622000001, 35.7659097],
          [75.85585586000001, 35.94609008],
          [75.85585586000001, 36.66681163],
          [75.4954955, 36.84699202],
          [75.4954955, 36.66681163],
          [75.13513514, 37.0271724],
          [74.77477476999999, 36.84699202],
          [74.77477476999999, 37.0271724],
          [74.41441441000001, 37.0271724],
          [74.41441441000001, 37.20735279],
          [74.77477476999999, 37.20735279],
          [74.77477476999999, 37.38753318],
          [74.77477476999999, 37.20735279],
          [75.13513514, 37.20735279],
          [75.13513514, 37.56771356],
          [74.77477476999999, 37.56771356],
          [74.77477476999999, 38.46861549],
          [74.41441441000001, 38.64879588],
          [74.05405405000001, 38.64879588],
          [74.05405405000001, 38.46861549],
          [73.69369369, 38.64879588],
          [73.69369369, 39.54969781],
          [74.05405405000001, 39.7298782],
          [74.05405405000001, 40.09023897],
          [74.41441441000001, 40.09023897],
          [74.77477476999999, 40.27041936],
          [74.77477476999999, 40.45059974],
          [75.13513514, 40.45059974],
          [75.4954955, 40.63078013],
          [75.4954955, 40.27041936],
          [75.85585586000001, 40.27041936],
          [76.21621622000001, 40.45059974],
          [76.21621622000001, 40.27041936],
          [76.57657657999999, 40.45059974],
          [76.57657657999999, 40.81096052],
          [76.93693694, 40.9911409],
          [77.2972973, 40.9911409],
          [77.65765766, 40.9911409],
          [78.01801802, 40.9911409],
          [78.37837838, 41.17132129],
          [78.37837838, 41.53168206],
          [78.73873874, 41.71186245],
          [79.45945946000001, 41.71186245],
          [79.81981982000001, 41.89204283],
          [79.81981982000001, 42.07222322],
          [80.18018017999999, 42.07222322],
          [80.18018017999999, 42.79294477],
          [80.54054054, 42.79294477],
          [80.54054054, 43.15330554],
          [80.54054054, 44.05420747],
          [80.18018017999999, 44.05420747],
          [80.18018017999999, 44.77492902],
          [80.18018017999999, 44.9551094],
          [80.18018017999999, 45.13528979],
          [80.54054054, 45.13528979],
          [80.9009009, 45.13528979],
          [81.62162162, 45.31547018],
          [81.98198198, 45.13528979],
          [82.34234234, 45.31547018],
          [82.34234234, 45.13528979],
          [82.7027027, 45.13528979],
          [82.7027027, 45.49565056000001],
          [82.34234234, 45.49565056000001],
          [82.34234234, 46.03619172],
          [82.7027027, 46.21637211000001],
          [82.7027027, 46.75691327],
          [83.06306306000001, 46.93709365],
          [83.06306306000001, 47.29745443],
          [83.78378377999999, 46.93709365],
          [84.14414414, 46.93709365],
          [84.5045045, 46.93709365],
          [84.86486486, 46.75691327],
          [85.22522523000001, 47.11727404000001],
          [85.58558558999999, 47.11727404000001],
          [85.58558558999999, 48.37853674],
          [85.94594595, 48.37853674],
          [86.30630631, 48.55871713],
          [86.66666667, 48.55871713],
          [86.66666667, 49.09925829],
          [87.02702703, 49.09925829],
          [87.38738739, 49.09925829],
          [87.74774775, 49.09925829],
          [87.74774775, 48.73889752],
          [88.10810811, 48.73889752],
          [88.10810811, 48.55871713],
          [88.46846847000001, 48.37853674],
          [88.46846847000001, 48.19835636],
          [88.82882883000001, 48.19835636],
          [88.82882883000001, 48.01817597],
          [88.82882883000001, 48.19835636],
          [89.18918918999999, 48.01817597],
          [89.54954955, 48.01817597],
          [89.90990991, 47.83799559000001],
          [90.63063062999999, 47.47763481],
          [90.63063062999999, 46.93709365],
          [90.99099098999999, 46.93709365],
          [90.99099098999999, 46.03619172],
          [90.63063062999999, 45.67583094999999],
          [90.63063062999999, 45.31547018],
          [90.99099098999999, 45.13528979],
          [91.35135134999999, 45.13528979],
          [91.71171171000002, 45.13528979],
          [92.07207207000002, 45.13528979],
          [92.07207207000002, 44.9551094],
          [92.43243243000002, 44.9551094],
          [92.79279278999999, 44.9551094],
          [93.15315314999999, 44.9551094],
          [93.15315314999999, 45.85601134],
          [93.51351351, 45.85601134],
          [93.51351351, 46.57673288],
          [94.23423423, 46.75691327],
          [94.23423423, 47.11727404000001],
          [93.51351351, 47.47763481],
          [93.15315314999999, 47.83799559000001],
          [93.15315314999999, 48.19835636],
          [93.51351351, 48.19835636],
          [93.51351351, 48.55871713],
          [94.23423423, 48.73889752],
          [94.59459459, 48.73889752],
          [95.31531532, 48.73889752],
          [95.67567568, 48.9190779],
          [95.67567568, 49.45961905999999],
          [94.95495495, 50.00016022],
          [94.59459459, 50.00016022],
          [94.23423423, 50.18034061],
          [94.23423423, 50.54070138],
          [93.15315314999999, 50.54070138],
          [92.79279278999999, 50.72088177],
          [92.43243243000002, 50.90106215000001],
          [92.07207207000002, 50.72088177],
          [91.71171171000002, 50.72088177],
          [91.35135134999999, 50.54070138],
          [90.63063062999999, 50.18034061],
          [90.27027027, 50.18034061],
          [89.54954955, 49.81997984],
          [89.54954955, 50.18034061],
          [89.54954955, 50.54070138],
          [89.54954955, 50.36052098999999],
          [89.54954955, 50.54070138],
          [89.54954955, 50.90106215000001],
          [88.82882883000001, 51.62178370000001],
          [88.46846847000001, 51.26142293],
          [88.10810811, 51.44160331],
          [88.10810811, 51.80196409000001],
          [87.74774775, 51.80196409000001],
          [88.10810811, 52.16232486],
          [88.10810811, 51.98214447],
          [88.46846847000001, 52.16232486],
          [89.18918918999999, 52.8830464],
          [88.82882883000001, 52.8830464],
          [89.18918918999999, 53.24340718000001],
          [88.82882883000001, 53.42358756],
          [88.82882883000001, 53.60376795],
          [89.18918918999999, 53.78394834],
          [89.18918918999999, 53.96412872],
          [89.18918918999999, 54.3244895],
          [88.82882883000001, 54.3244895],
          [88.46846847000001, 54.3244895],
          [88.82882883000001, 54.68485027],
          [88.82882883000001, 54.86503064999999],
          [88.46846847000001, 55.04521104],
          [88.46846847000001, 55.40557181],
          [89.18918918999999, 55.76593258999999],
          [89.18918918999999, 56.12629336],
          [88.46846847000001, 56.48665412999999],
          [88.46846847000001, 56.8470149],
          [88.82882883000001, 57.02719529000001],
          [88.46846847000001, 57.02719529000001],
          [89.18918918999999, 57.56773645],
          [89.54954955, 57.92809722000001],
          [88.82882883000001, 58.10827761],
          [88.10810811, 58.10827761],
          [88.10810811, 58.64881877000001],
          [88.82882883000001, 59.00917954],
          [88.10810811, 59.36954031],
          [88.10810811, 59.18935993],
          [87.02702703, 59.91008147],
          [85.94594595, 59.91008147],
          [85.58558558999999, 59.91008147],
          [84.5045045, 59.91008147],
          [84.5045045, 60.27044225],
          [84.86486486, 60.45062263],
          [84.5045045, 60.81098341],
          [85.94594595, 61.53170495],
          [85.58558558999999, 61.53170495],
          [85.22522523000001, 61.71188534000001],
          [84.86486486, 61.71188534000001],
          [84.5045045, 61.89206571999999],
          [84.5045045, 62.2524265],
          [84.86486486, 62.61278727000001],
          [85.58558558999999, 62.97314804],
          [85.58558558999999, 63.33350881000001],
          [85.22522523000001, 63.5136892],
          [84.86486486, 63.5136892],
          [85.22522523000001, 63.69386959],
          [85.22522523000001, 63.5136892],
          [85.22522523000001, 63.87404997],
          [85.94594595, 64.05423036000001],
          [85.94594595, 64.77495191],
          [85.58558558999999, 64.77495191],
          [85.22522523000001, 64.77495191],
          [84.86486486, 64.77495191],
          [84.86486486, 64.95513229],
          [84.5045045, 64.95513229],
          [84.5045045, 65.49567345],
          [83.78378377999999, 65.85603422],
          [83.42342342000001, 65.85603422],
          [83.42342342000001, 66.39657538],
          [83.06306306000001, 66.75693616],
          [82.34234234, 67.29747732],
          [82.34234234, 67.4776577],
          [81.98198198, 67.83801846999999],
          [81.98198198, 67.65783809],
          [81.62162162, 68.01819886],
          [81.98198198, 68.01819886],
          [82.34234234, 68.19837925],
          [82.7027027, 68.55874002],
          [82.7027027, 68.73892041000001],
          [82.34234234, 69.09928118000001],
          [81.62162162, 69.45964195000001],
          [81.62162162, 69.27946157],
          [81.26126126, 69.27946157],
          [80.9009009, 69.27946157],
          [80.18018017999999, 69.27946157],
          [79.81981982000001, 69.27946157],
          [79.45945946000001, 69.63982234],
          [78.73873874, 69.82000272000001],
          [79.0990991, 70.00018311],
          [79.45945946000001, 70.00018311],
          [79.45945946000001, 70.1803635],
          [79.81981982000001, 70.36054387999999],
          [79.81981982000001, 70.1803635],
          [80.18018017999999, 70.36054387999999],
          [80.54054054, 70.54072427],
          [80.54054054, 70.36054387999999],
          [80.9009009, 70.36054387999999],
          [80.54054054, 70.36054387999999],
          [80.54054054, 71.08126543],
          [79.81981982000001, 71.08126543],
          [79.0990991, 71.4416262],
          [79.45945946000001, 71.62180659000001],
          [80.18018017999999, 71.80198697],
          [80.18018017999999, 71.98216736000001],
          [79.81981982000001, 71.98216736000001],
          [79.45945946000001, 71.98216736000001],
          [79.0990991, 72.16234775],
          [78.73873874, 72.16234775],
          [78.37837838, 72.34252813000001],
          [78.37837838, 73.96415161],
          [80.18018017999999, 74.14433200000001],
          [81.98198198, 75.04523393],
          [83.78378377999999, 75.58577509],
          [86.30630631, 76.66685741000001],
          [86.66666667, 77.02721818000001],
          [87.74774775, 77.38757895000001],
          [88.82882883000001, 77.92812011],
          [88.82882883000001, 80.45064552],
          [81.62162162, 80.45064552],
          [80.54054054, 80.45064552],
          [79.45945946000001, 80.45064552],
          [78.37837838, 80.45064552],
          [78.37837838, 81.35154745],
          [79.0990991, 81.35154745],
          [79.81981982000001, 81.35154745],
          [80.54054054, 81.35154745],
          [88.82882883000001, 81.35154745],
          [88.82882883000001, 81.53172784],
          [97.47747748000001, 81.53172784],
          [100, 81.53172784],
          [112.6126126, 81.53172784],
          [112.6126126, 90.00020599999999],
          [127.3873874, 90.00020599999996],
        ],
      ],
    },
    properties: {
      objectid: 28,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+8',
      map_color6: 4,
      map_color8: 2,
      note: null,
      zone: 8,
      utc_format: 'UTC+08:00',
      time_zone: 'UTC+08:00',
      iso_8601: '2012-05-31T12:33:50+08:00',
      places:
        'China, Hong Kong, Russia (Krasnoyarsk Krai), Malaysia, Philippines, Singapore, Taiwan, most of Mongolia, Western Australia',
      dst_places: null,
      tz_name1st: 'Australia/Perth',
      tz_namesum: 19,
      cartodb_id: 41,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-22.522522522522536, 66.75693615615612],
          [-22.522522522522536, 69.63982233833829],
          [-21.801801801801815, 69.82000272472467],
          [-21.801801801801815, 70.18036349749747],
          [-22.522522522522536, 70.36054388388385],
          [-23.963963963963977, 70.36054388388385],
          [-24.684684684684697, 70.54072427027023],
          [-24.684684684684697, 71.08126542942938],
          [-23.963963963963977, 72.34252813413408],
          [-22.16216216216216, 71.98216736136132],
          [-21.44144144144144, 72.34252813413408],
          [-21.44144144144144, 72.52270852052047],
          [-19.639639639639654, 73.42361045245241],
          [-19.27927927927928, 73.96415161161156],
          [-18.198198198198213, 74.50469277077073],
          [-17.477477477477493, 74.50469277077073],
          [-16.396396396396398, 75.04523392992988],
          [-17.117117117117118, 75.58577508908905],
          [-18.198198198198213, 75.76595547547544],
          [-17.477477477477493, 77.38757895295291],
          [-16.756756756756772, 77.56775933933929],
          [-16.756756756756772, 77.92812011211205],
          [-17.83783783783784, 78.10830049849847],
          [-17.83783783783784, 78.46866127127123],
          [-16.396396396396398, 79.18938281681676],
          [-17.477477477477493, 79.54974358958955],
          [-16.03603603603605, 80.0902847487487],
          [-14.59459459459461, 80.27046513513508],
          [-9.909909909909913, 81.3515474534534],
          [-11.351351351351354, 81.89208861261255],
          [-13.15315315315317, 82.07226899899896],
          [-16.756756756756772, 82.07226899899896],
          [-20, 82.43262977177173],
          [-20, 82.7929905445445],
          [-22.522522522522536, 82.97317093093088],
          [-22.522522522522536, 90.00020599999996],
          [-7.387387387387406, 90.00020599999996],
          [-7.387387387387406, 66.75693615615612],
          [-18.55855855855856, 66.75693615615612],
          [-18.55855855855856, 66.39657538338335],
          [-20, 66.39657538338335],
          [-20.72072072072072, 66.21639499699697],
          [-21.44144144144144, 66.21639499699697],
          [-22.522522522522536, 66.75693615615612],
        ],
      ],
    },
    properties: {
      objectid: 14,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-1',
      map_color6: 1,
      map_color8: 8,
      note: null,
      zone: -1,
      utc_format: 'UTC-01:00',
      time_zone: 'UTC-01:00',
      iso_8601: '2012-05-31T03:33:50-01:00',
      places: 'Greenland (south eastern part)',
      dst_places: null,
      tz_name1st: 'America/Scoresbysund',
      tz_namesum: 1,
      cartodb_id: 16,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: null,
    properties: {
      objectid: 22,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+5',
      map_color6: 1,
      map_color8: 7,
      note: null,
      zone: 5,
      utc_format: 'UTC+05:00',
      time_zone: 'UTC+05:00',
      iso_8601: '2012-05-31T09:33:50+05:00',
      places: 'Uzbekistan',
      dst_places: null,
      tz_name1st: null,
      tz_namesum: 0,
      cartodb_id: 60,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [29.00900900900899, 69.09928117917914],
          [28.28828828828827, 68.55874002001997],
          [30.090090090090087, 67.65783808808806],
          [29.00900900900899, 66.9371165425425],
          [30.090090090090087, 66.03621461061056],
          [29.729729729729712, 65.67585383783779],
          [29.729729729729712, 64.77495190590585],
          [30.450450450450433, 64.2344107467467],
          [30.090090090090087, 63.87404997397394],
          [30.450450450450433, 63.513689201201146],
          [31.531531531531527, 62.973148042042],
          [31.531531531531527, 62.61278726926923],
          [30.450450450450433, 62.07224611011006],
          [30.090090090090087, 61.71188533733729],
          [29.369369369369366, 61.53170495095091],
          [29.369369369369366, 61.171344178178146],
          [28.648648648648646, 60.99116379179176],
          [27.927927927927925, 60.63080301901897],
          [27.927927927927925, 60.45062263263259],
          [27.207207207207205, 60.09026185985982],
          [26.486486486486484, 59.91008147347344],
          [27.927927927927925, 59.54972070070065],
          [27.927927927927925, 59.369540314314264],
          [27.56756756756755, 59.0091795415415],
          [27.56756756756755, 56.84701490490485],
          [28.28828828828827, 56.48665413213209],
          [28.28828828828827, 56.12629335935932],
          [27.56756756756755, 55.76593258658656],
          [26.486486486486484, 55.76593258658656],
          [26.486486486486484, 55.405571813813765],
          [25.765765765765764, 54.86503065465462],
          [25.765765765765764, 54.14430910910906],
          [24.68468468468467, 54.14430910910906],
          [24.68468468468467, 53.96412872272268],
          [23.603603603603602, 53.96412872272268],
          [22.882882882882882, 54.32448949549547],
          [22.882882882882882, 54.86503065465462],
          [21.801801801801787, 55.22539142742738],
          [19.639639639639626, 55.22539142742738],
          [19.639639639639626, 54.684850268268235],
          [19.27927927927928, 54.684850268268235],
          [19.27927927927928, 55.045211041041],
          [18.918918918918905, 55.405571813813765],
          [18.918918918918905, 56.12629335935932],
          [19.639639639639626, 56.66683451851847],
          [19.639639639639626, 57.027195291291264],
          [20, 57.207375677677646],
          [20, 57.56773645045041],
          [20.360360360360346, 57.928097223223176],
          [20.360360360360346, 59.18935992792788],
          [20, 59.369540314314264],
          [19.27927927927928, 60.09026185985982],
          [19.27927927927928, 61.892065723723675],
          [19.639639639639626, 62.25242649649647],
          [19.639639639639626, 62.973148042042],
          [20.72072072072072, 63.513689201201146],
          [21.081081081081066, 63.513689201201146],
          [21.801801801801787, 63.87404997397394],
          [22.16216216216216, 64.2344107467467],
          [22.882882882882882, 64.59477151951947],
          [23.96396396396395, 65.49567345145141],
          [23.96396396396395, 66.21639499699697],
          [23.603603603603602, 66.21639499699697],
          [23.603603603603602, 68.01819886086082],
          [23.243243243243228, 68.37855963363359],
          [21.801801801801787, 68.55874002001997],
          [20.72072072072072, 69.09928117917914],
          [21.801801801801787, 69.27946156556553],
          [22.522522522522507, 68.73892040640635],
          [24.68468468468467, 68.73892040640635],
          [25.765765765765764, 68.91910079279276],
          [25.765765765765764, 69.45964195195191],
          [26.486486486486484, 70.00018311111106],
          [27.927927927927925, 70.00018311111106],
          [29.369369369369366, 69.45964195195191],
          [29.00900900900899, 69.09928117917914],
        ],
      ],
    },
    properties: {
      objectid: 17,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+2',
      map_color6: 4,
      map_color8: 3,
      note: null,
      zone: 2,
      utc_format: 'UTC+02:00',
      time_zone: 'UTC+02:00',
      iso_8601: '2012-05-31T06:33:50+02:00',
      places: 'Estonia, Finland, Latvia, Lithuania',
      dst_places: 'Estonia, Finland, Latvia, Lithuania',
      tz_name1st: 'Europe/Helsinki',
      tz_namesum: 5,
      cartodb_id: 65,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [38.37837837837836, 47.11727404004],
          [37.65765765765764, 46.75691326726724],
          [37.65765765765764, 45.856011335335296],
          [36.57657657657657, 45.675830948948914],
          [36.57657657657657, 44.955109403403355],
          [36.93693693693692, 44.955109403403355],
          [36.93693693693692, 44.59474863063059],
          [37.29729729729729, 44.41456824424421],
          [38.01801801801801, 44.41456824424421],
          [38.73873873873873, 44.05420747147144],
          [38.73873873873873, 43.87402708508506],
          [39.8198198198198, 43.333485925925885],
          [40.18018018018017, 42.97312515315312],
          [40.54054054054052, 42.97312515315312],
          [41.26126126126124, 42.612764380380355],
          [41.26126126126124, 41.711862448448414],
          [41.621621621621614, 41.53168206206203],
          [43.063063063063055, 41.53168206206203],
          [43.063063063063055, 41.17132128928927],
          [43.783783783783775, 40.991140902902856],
          [43.783783783783775, 40.090238970970944],
          [44.504504504504496, 40.090238970970944],
          [44.504504504504496, 39.72987819819815],
          [44.86486486486484, 39.72987819819815],
          [44.504504504504496, 39.72987819819815],
          [44.504504504504496, 39.369517425425386],
          [44.14414414414412, 39.369517425425386],
          [44.14414414414412, 37.9280743343343],
          [44.504504504504496, 37.9280743343343],
          [44.504504504504496, 37.387533175175136],
          [44.86486486486484, 37.207352788788754],
          [44.14414414414412, 37.387533175175136],
          [43.783783783783775, 37.207352788788754],
          [43.4234234234234, 37.387533175175136],
          [42.70270270270268, 37.387533175175136],
          [42.342342342342334, 37.207352788788754],
          [42.342342342342334, 36.846992016015975],
          [41.98198198198196, 36.66681162962959],
          [41.26126126126124, 36.48663124324321],
          [41.26126126126124, 34.68482737937934],
          [38.73873873873873, 33.42356467467464],
          [38.73873873873873, 33.06320390190187],
          [39.09909909909908, 32.70284312912909],
          [39.09909909909908, 31.98212158358355],
          [38.73873873873873, 31.98212158358355],
          [38.37837837837836, 31.801941197197166],
          [38.01801801801801, 31.801941197197166],
          [37.65765765765764, 31.621760810810784],
          [37.29729729729729, 31.621760810810784],
          [36.93693693693692, 31.441580424424387],
          [37.65765765765764, 31.081219651651622],
          [37.65765765765764, 30.0001373333333],
          [36.93693693693692, 30.0001373333333],
          [36.57657657657657, 29.819956946946917],
          [36.57657657657657, 29.459596174174138],
          [36.216216216216196, 29.279415787787755],
          [34.774774774774755, 29.279415787787755],
          [34.774774774774755, 28.738874628628594],
          [34.41441441441441, 28.198333469469432],
          [34.774774774774755, 28.01815308308305],
          [35.13513513513513, 28.01815308308305],
          [35.13513513513513, 27.657792310310285],
          [35.495495495495476, 27.477611923923888],
          [35.85585585585585, 27.117251151151123],
          [35.85585585585585, 26.756890378378344],
          [36.57657657657657, 26.0361688328328],
          [36.57657657657657, 25.315447287287256],
          [36.93693693693692, 25.315447287287256],
          [36.93693693693692, 24.774906128128094],
          [37.29729729729729, 24.594725741741712],
          [37.29729729729729, 24.234364968968933],
          [37.65765765765764, 24.234364968968933],
          [37.65765765765764, 21.89201994594592],
          [36.93693693693692, 21.89201994594592],
          [36.93693693693692, 22.0722003323323],
          [36.57657657657657, 22.0722003323323],
          [31.531531531531527, 22.0722003323323],
          [31.531531531531527, 22.252380718718683],
          [31.171171171171153, 22.0722003323323],
          [25.045045045045043, 22.0722003323323],
          [25.045045045045043, 21.89201994594592],
          [25.045045045045043, 21.711839559559536],
          [25.045045045045043, 21.351478786786757],
          [25.045045045045043, 21.171298400400374],
          [25.045045045045043, 20.810937627627595],
          [25.045045045045043, 20.45057685485483],
          [25.045045045045043, 20.270396468468434],
          [25.045045045045043, 20.09021608208205],
          [25.045045045045043, 19.91003569569567],
          [23.96396396396395, 19.91003569569567],
          [23.96396396396395, 19.54967492292289],
          [22.16216216216216, 20.45057685485483],
          [19.27927927927928, 21.89201994594592],
          [16.396396396396398, 23.333463037037006],
          [15.675675675675677, 23.333463037037006],
          [14.954954954954957, 22.973102264264227],
          [14.234234234234236, 22.612741491491462],
          [13.873873873873862, 22.973102264264227],
          [13.153153153153141, 23.333463037037006],
          [12.432432432432421, 23.333463037037006],
          [12.432432432432421, 23.51364342342339],
          [11.7117117117117, 23.874004196196168],
          [11.7117117117117, 24.234364968968933],
          [11.351351351351354, 24.234364968968933],
          [10.27027027027026, 24.774906128128094],
          [9.909909909909913, 24.774906128128094],
          [9.909909909909913, 25.675808060060035],
          [9.549549549549539, 25.675808060060035],
          [9.549549549549539, 26.39652960560558],
          [9.909909909909913, 26.57670999199196],
          [9.909909909909913, 29.279415787787755],
          [9.549549549549539, 29.639776560560534],
          [9.549549549549539, 30.18031771971968],
          [9.909909909909913, 30.36049810610608],
          [10.27027027027026, 30.720858878878843],
          [10.27027027027026, 31.801941197197166],
          [11.351351351351354, 32.34248235635633],
          [11.351351351351354, 33.243384288288254],
          [11.7117117117117, 33.42356467467464],
          [12.432432432432421, 33.06320390190187],
          [13.873873873873862, 33.06320390190187],
          [14.594594594594582, 32.70284312912909],
          [14.954954954954957, 32.70284312912909],
          [15.675675675675677, 32.34248235635633],
          [15.675675675675677, 31.621760810810784],
          [16.036036036036023, 31.441580424424387],
          [16.756756756756744, 31.441580424424387],
          [17.117117117117118, 31.261400038038005],
          [17.477477477477464, 31.261400038038005],
          [18.918918918918905, 30.54067849249246],
          [19.27927927927928, 30.54067849249246],
          [19.639639639639626, 30.720858878878843],
          [20, 31.081219651651622],
          [19.639639639639626, 31.261400038038005],
          [19.639639639639626, 32.16230196996993],
          [20, 32.52266274274271],
          [20.72072072072072, 32.883023515515475],
          [21.081081081081066, 32.883023515515475],
          [21.801801801801787, 33.243384288288254],
          [22.16216216216216, 33.243384288288254],
          [22.522522522522507, 33.06320390190187],
          [22.522522522522507, 36.30645085685683],
          [22.16216216216216, 36.30645085685683],
          [21.44144144144144, 36.48663124324321],
          [21.44144144144144, 37.387533175175136],
          [21.081081081081066, 37.56771356156153],
          [20.360360360360346, 37.56771356156153],
          [20.360360360360346, 37.9280743343343],
          [20, 38.10825472072068],
          [20.360360360360346, 38.468615493493445],
          [20.360360360360346, 39.00915665265262],
          [19.639639639639626, 39.189337039039],
          [19.639639639639626, 39.54969781181177],
          [19.27927927927928, 39.54969781181177],
          [19.27927927927928, 39.91005858458456],
          [20, 39.91005858458456],
          [20.72072072072072, 40.090238970970944],
          [20.72072072072072, 40.45059974374371],
          [21.081081081081066, 40.45059974374371],
          [21.081081081081066, 40.810960516516474],
          [21.801801801801787, 40.810960516516474],
          [21.801801801801787, 41.17132128928927],
          [22.882882882882882, 41.17132128928927],
          [22.882882882882882, 42.07222322122118],
          [22.522522522522507, 42.07222322122118],
          [22.522522522522507, 42.79294476676674],
          [22.882882882882882, 42.97312515315312],
          [22.882882882882882, 43.333485925925885],
          [22.522522522522507, 43.333485925925885],
          [22.522522522522507, 44.77492901701697],
          [22.16216216216216, 44.59474863063059],
          [21.44144144144144, 44.77492901701697],
          [21.44144144144144, 45.135289789789766],
          [20.72072072072072, 45.49565056256253],
          [20.72072072072072, 45.856011335335296],
          [20.360360360360346, 45.856011335335296],
          [20.360360360360346, 46.21637210810806],
          [21.081081081081066, 46.21637210810806],
          [21.081081081081066, 46.576732880880854],
          [21.44144144144144, 46.576732880880854],
          [21.44144144144144, 46.93709365365362],
          [21.801801801801787, 46.93709365365362],
          [21.801801801801787, 47.297454426426384],
          [22.16216216216216, 47.65781519919915],
          [22.882882882882882, 48.01817597197194],
          [22.16216216216216, 48.37853674474471],
          [22.16216216216216, 48.73889751751747],
          [22.522522522522507, 48.73889751751747],
          [22.522522522522507, 49.099258290290265],
          [22.882882882882882, 49.27943867667665],
          [22.522522522522507, 49.63979944944941],
          [23.96396396396395, 50.36052099499497],
          [23.96396396396395, 51.26142292692688],
          [23.603603603603602, 51.441603313313266],
          [24.68468468468467, 51.98214447247244],
          [26.12612612612611, 51.98214447247244],
          [26.12612612612611, 51.80196408608606],
          [27.207207207207205, 51.80196408608606],
          [27.927927927927925, 51.62178369969965],
          [29.369369369369366, 51.62178369969965],
          [29.369369369369366, 51.441603313313266],
          [30.810810810810807, 51.441603313313266],
          [30.810810810810807, 52.162324858858824],
          [31.891891891891873, 52.162324858858824],
          [32.25225225225225, 52.342505245245206],
          [34.054054054054035, 52.342505245245206],
          [34.054054054054035, 51.62178369969965],
          [34.41441441441441, 51.26142292692688],
          [35.13513513513513, 51.26142292692688],
          [35.495495495495476, 50.90106215415412],
          [35.495495495495476, 50.36052099499497],
          [37.65765765765764, 50.36052099499497],
          [37.65765765765764, 50.00016022222218],
          [38.73873873873873, 50.00016022222218],
          [40.18018018018017, 49.63979944944941],
          [40.18018018018017, 48.73889751751747],
          [39.8198198198198, 48.73889751751747],
          [39.8198198198198, 47.83799558558556],
          [38.73873873873873, 47.83799558558556],
          [38.37837837837836, 47.65781519919915],
          [38.37837837837836, 47.11727404004],
        ],
      ],
    },
    properties: {
      objectid: 17,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+2',
      map_color6: 4,
      map_color8: 3,
      note: null,
      zone: 2,
      utc_format: 'UTC+02:00',
      time_zone: 'UTC+02:00',
      iso_8601: '2012-05-31T06:33:50+02:00',
      places:
        'Libya, Egypt, Bulgaria, Cyprus, Greece, Israel, Jordan, Lebanon, Moldova, Palestine, Romania, Syria, Turkey, Ukraine',
      dst_places:
        'Bulgaria, Cyprus, Greece, Israel, Jordan, Lebanon, Moldova, Palestine, Romania, Syria, Turkey, Ukraine',
      tz_name1st: 'Europe/Mariehamn',
      tz_namesum: 16,
      cartodb_id: 66,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [97.47747747747746, -11.261171149149177],
          [97.47747747747746, -12.882794626626648],
          [96.03603603603602, -12.882794626626648],
          [96.03603603603602, -11.261171149149177],
          [97.47747747747746, -11.261171149149177],
        ],
      ],
    },
    properties: {
      objectid: 26,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+6.5',
      map_color6: 2,
      map_color8: 6,
      note: null,
      zone: 6.5,
      utc_format: 'UTC+06:30',
      time_zone: 'UTC+06:30',
      iso_8601: '2012-05-31T11:03:50+06:30',
      places: 'Cocos Islands',
      dst_places: null,
      tz_name1st: 'Indian/Cocos',
      tz_namesum: 1,
      cartodb_id: 74,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-56.3963963963964, -63.873843973973976],
          [-56.3963963963964, -64.05402436036036],
          [-56.3963963963964, -64.41438513313314],
          [-57.47747747747748, -64.41438513313314],
          [-57.47747747747748, -63.15312242842843],
          [-56.3963963963964, -63.15312242842843],
          [-56.3963963963964, -63.873843973973976],
        ],
      ],
    },
    properties: {
      objectid: 0,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-3',
      map_color6: 3,
      map_color8: 6,
      note: null,
      zone: -3,
      utc_format: 'UTC-03:00',
      time_zone: 'UTC-03:00',
      iso_8601: '2012-05-30T16:33:50-03:00',
      places: 'Esperanza, Vicecomodoro Marambio Stations',
      dst_places: null,
      tz_name1st: null,
      tz_namesum: 0,
      cartodb_id: 119,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [52.43243243243242, -46.93688765365366],
          [48.82882882882882, -46.93688765365366],
          [48.82882882882882, -44.954903403403414],
          [52.43243243243242, -44.954903403403414],
          [52.43243243243242, -46.93688765365366],
        ],
      ],
    },
    properties: {
      objectid: 0,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+5',
      map_color6: 1,
      map_color8: 7,
      note: null,
      zone: 5,
      utc_format: 'UTC+05:00',
      time_zone: 'UTC+05:00',
      iso_8601: '2012-05-31T09:33:50+05:00',
      places: 'French Southern and Antarctic Lands',
      dst_places: null,
      tz_name1st: null,
      tz_namesum: 0,
      cartodb_id: 34,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [70.09009009009009, 82.07226899899896],
          [70.09009009009009, 75.04523392992988],
          [67.56756756756755, 73.06324967967964],
          [65.40540540540539, 71.26144581581576],
          [65.04504504504504, 71.08126542942938],
          [65.04504504504504, 68.73892040640635],
          [65.40540540540539, 68.73892040640635],
          [65.40540540540539, 68.01819886086082],
          [66.12612612612611, 68.01819886086082],
          [66.12612612612611, 67.47765770170165],
          [65.04504504504504, 66.75693615615612],
          [63.6036036036036, 66.57675576976973],
          [62.52252252252251, 65.85603422422417],
          [60.72072072072072, 64.95513229229226],
          [59.639639639639626, 64.77495190590585],
          [59.639639639639626, 63.69386958758756],
          [59.27927927927928, 63.513689201201146],
          [59.27927927927928, 62.61278726926923],
          [59.639639639639626, 62.61278726926923],
          [59.639639639639626, 61.892065723723675],
          [59.27927927927928, 61.53170495095091],
          [56.756756756756744, 61.53170495095091],
          [56.3963963963964, 61.171344178178146],
          [55.3153153153153, 61.171344178178146],
          [55.3153153153153, 60.99116379179176],
          [53.513513513513516, 60.99116379179176],
          [52.792792792792795, 61.171344178178146],
          [52.43243243243242, 60.81098340540535],
          [51.7117117117117, 60.81098340540535],
          [52.792792792792795, 60.270442246246205],
          [53.513513513513516, 60.09026185985982],
          [53.513513513513516, 59.54972070070065],
          [53.87387387387386, 59.18935992792788],
          [53.87387387387386, 58.10827760960956],
          [54.234234234234236, 57.928097223223176],
          [54.234234234234236, 56.12629335935932],
          [53.87387387387386, 56.12629335935932],
          [53.87387387387386, 55.405571813813765],
          [53.513513513513516, 55.045211041041],
          [53.513513513513516, 53.96412872272268],
          [53.15315315315314, 54.32448949549547],
          [52.43243243243242, 54.32448949549547],
          [52.43243243243242, 53.60376794994991],
          [52.072072072072075, 53.60376794994991],
          [52.072072072072075, 52.883046404404354],
          [51.7117117117117, 52.883046404404354],
          [51.7117117117117, 52.342505245245206],
          [51.351351351351354, 51.98214447247244],
          [50.630630630630606, 51.80196408608606],
          [50.630630630630606, 51.441603313313266],
          [49.909909909909885, 51.0812425405405],
          [49.189189189189165, 51.0812425405405],
          [48.82882882882882, 50.54070138138135],
          [48.82882882882882, 49.819979835835795],
          [48.1081081081081, 49.819979835835795],
          [47.747747747747724, 50.18034060860856],
          [46.66666666666666, 49.63979944944941],
          [46.66666666666666, 49.27943867667665],
          [47.027027027027, 49.27943867667665],
          [47.027027027027, 48.919077903903855],
          [46.30630630630628, 48.37853674474471],
          [47.027027027027, 48.37853674474471],
          [47.027027027027, 47.83799558558556],
          [48.1081081081081, 47.83799558558556],
          [48.468468468468444, 47.297454426426384],
          [48.82882882882882, 47.11727404004],
          [48.82882882882882, 46.39655249449444],
          [49.189189189189165, 46.21637210810806],
          [49.909909909909885, 46.21637210810806],
          [49.909909909909885, 45.675830948948914],
          [49.189189189189165, 45.31547017617615],
          [49.189189189189165, 44.41456824424421],
          [49.54954954954954, 44.41456824424421],
          [49.54954954954954, 44.05420747147144],
          [48.82882882882882, 44.05420747147144],
          [48.82882882882882, 43.333485925925885],
          [49.189189189189165, 43.333485925925885],
          [49.909909909909885, 42.97312515315312],
          [49.909909909909885, 42.432583993993944],
          [50.27027027027026, 42.432583993993944],
          [50.27027027027026, 42.07222322122118],
          [50.99099099099098, 41.711862448448414],
          [50.99099099099098, 40.810960516516474],
          [51.351351351351354, 40.270419357357326],
          [51.351351351351354, 39.54969781181177],
          [51.7117117117117, 39.189337039039],
          [50.27027027027026, 38.82897626626624],
          [49.54954954954954, 38.468615493493445],
          [48.82882882882882, 38.468615493493445],
          [48.1081081081081, 38.648795879879856],
          [48.1081081081081, 39.72987819819815],
          [47.747747747747724, 39.72987819819815],
          [46.66666666666666, 39.189337039039],
          [46.66666666666666, 38.82897626626624],
          [45.94594594594594, 38.82897626626624],
          [45.94594594594594, 39.00915665265262],
          [45.225225225225216, 39.00915665265262],
          [45.225225225225216, 39.369517425425386],
          [44.86486486486484, 39.54969781181177],
          [44.86486486486484, 39.72987819819815],
          [44.504504504504496, 39.72987819819815],
          [44.504504504504496, 40.090238970970944],
          [43.783783783783775, 40.090238970970944],
          [43.783783783783775, 40.991140902902856],
          [43.063063063063055, 41.17132128928927],
          [43.063063063063055, 41.53168206206203],
          [41.621621621621614, 41.53168206206203],
          [41.26126126126124, 41.711862448448414],
          [41.26126126126124, 42.612764380380355],
          [40.54054054054052, 42.97312515315312],
          [40.18018018018017, 42.97312515315312],
          [39.8198198198198, 43.333485925925885],
          [38.73873873873873, 43.87402708508506],
          [38.73873873873873, 44.05420747147144],
          [38.01801801801801, 44.41456824424421],
          [37.29729729729729, 44.41456824424421],
          [36.93693693693692, 44.59474863063059],
          [36.93693693693692, 44.955109403403355],
          [36.57657657657657, 44.955109403403355],
          [36.57657657657657, 45.675830948948914],
          [37.65765765765764, 45.856011335335296],
          [37.65765765765764, 46.75691326726724],
          [38.37837837837836, 47.11727404004],
          [38.37837837837836, 47.65781519919915],
          [38.73873873873873, 47.83799558558556],
          [39.8198198198198, 47.83799558558556],
          [39.8198198198198, 48.73889751751747],
          [40.18018018018017, 48.73889751751747],
          [40.18018018018017, 49.63979944944941],
          [38.73873873873873, 50.00016022222218],
          [37.65765765765764, 50.00016022222218],
          [37.65765765765764, 50.36052099499497],
          [35.495495495495476, 50.36052099499497],
          [35.495495495495476, 50.90106215415412],
          [35.13513513513513, 51.26142292692688],
          [34.41441441441441, 51.26142292692688],
          [34.054054054054035, 51.62178369969965],
          [34.054054054054035, 52.342505245245206],
          [32.25225225225225, 52.342505245245206],
          [31.891891891891873, 52.162324858858824],
          [31.531531531531527, 52.162324858858824],
          [31.531531531531527, 52.883046404404354],
          [32.612612612612594, 53.24340717717715],
          [32.612612612612594, 53.783948336336294],
          [31.891891891891873, 53.783948336336294],
          [31.891891891891873, 54.14430910910906],
          [31.171171171171153, 54.14430910910906],
          [31.171171171171153, 54.684850268268235],
          [30.810810810810807, 54.684850268268235],
          [30.810810810810807, 55.58575220020015],
          [30.450450450450433, 55.76593258658656],
          [29.369369369369366, 55.76593258658656],
          [28.28828828828827, 56.12629335935932],
          [28.28828828828827, 56.48665413213209],
          [27.56756756756755, 56.84701490490485],
          [27.56756756756755, 59.0091795415415],
          [27.927927927927925, 59.369540314314264],
          [27.927927927927925, 59.54972070070065],
          [26.486486486486484, 59.91008147347344],
          [27.207207207207205, 60.09026185985982],
          [27.927927927927925, 60.45062263263259],
          [27.927927927927925, 60.63080301901897],
          [28.648648648648646, 60.99116379179176],
          [29.369369369369366, 61.171344178178146],
          [29.369369369369366, 61.53170495095091],
          [30.090090090090087, 61.71188533733729],
          [30.450450450450433, 62.07224611011006],
          [31.531531531531527, 62.61278726926923],
          [31.531531531531527, 62.973148042042],
          [30.450450450450433, 63.513689201201146],
          [30.090090090090087, 63.87404997397394],
          [30.450450450450433, 64.2344107467467],
          [29.729729729729712, 64.77495190590585],
          [29.729729729729712, 65.67585383783779],
          [30.090090090090087, 66.03621461061056],
          [29.00900900900899, 66.9371165425425],
          [30.090090090090087, 67.65783808808806],
          [28.28828828828827, 68.55874002001997],
          [29.00900900900899, 69.09928117917914],
          [30.810810810810807, 69.45964195195191],
          [30.810810810810807, 70.00018311111106],
          [31.891891891891873, 70.18036349749747],
          [33.333333333333314, 70.00018311111106],
          [33.69369369369369, 69.63982233833829],
          [34.774774774774755, 69.45964195195191],
          [36.216216216216196, 69.45964195195191],
          [36.93693693693692, 69.09928117917914],
          [37.65765765765764, 69.09928117917914],
          [37.65765765765764, 79.00920243043038],
          [35.495495495495476, 79.00920243043038],
          [35.495495495495476, 80.99118668068064],
          [37.65765765765764, 80.99118668068064],
          [37.65765765765764, 82.97317093093088],
          [52.43243243243242, 82.97317093093088],
          [52.43243243243242, 90.00020599999996],
          [67.56756756756755, 90.00020599999996],
          [67.56756756756755, 82.07226899899896],
          [70.09009009009009, 82.07226899899896],
        ],
      ],
    },
    properties: {
      objectid: 20,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+4',
      map_color6: 2,
      map_color8: 5,
      note: 'Reflects 2012 shift in daylight savings time in Russia.',
      zone: 4,
      utc_format: 'UTC+04:00',
      time_zone: 'UTC+04:00',
      iso_8601: '2012-05-31T08:33:50+04:00',
      places: 'Armenia, Azerbaijan, Georgia, Russia (European)',
      dst_places: null,
      tz_name1st: 'Europe/Moscow',
      tz_namesum: 6,
      cartodb_id: 35,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [145.76576576576576, 43.1533055395395],
          [145.04504504504501, 42.79294476676674],
          [143.96396396396398, 42.79294476676674],
          [143.60360360360357, 42.25240360760756],
          [143.60360360360357, 41.8920428348348],
          [143.24324324324323, 41.711862448448414],
          [142.52252252252248, 42.07222322122118],
          [142.52252252252248, 40.45059974374371],
          [142.52252252252248, 17.02714951351348],
          [136.03603603603602, 17.02714951351348],
          [136.03603603603602, 4.054161693693672],
          [142.52252252252248, 4.054161693693672],
          [142.52252252252248, 0.2703735795795552],
          [142.16216216216213, -0.0899871931932239],
          [142.16216216216213, -0.6305283523523713],
          [141.44144144144144, -1.3512498978979153],
          [141.08108108108104, -1.8917910570570768],
          [141.08108108108104, -6.57648110310312],
          [141.08108108108104, -9.45936728528531],
          [142.16216216216213, -9.45936728528531],
          [142.16216216216213, -9.819728058058075],
          [141.8018018018018, -9.819728058058075],
          [141.8018018018018, -11.801712308308325],
          [141.44144144144144, -11.981892694694722],
          [141.44144144144144, -13.783696558558574],
          [141.44144144144144, -15.40532003603606],
          [141.08108108108104, -15.585500422422442],
          [141.08108108108104, -16.666582740740765],
          [140.7207207207207, -16.846763127127147],
          [140.7207207207207, -17.38730428628631],
          [140.36036036036035, -17.56748467267269],
          [140, -17.56748467267269],
          [139.6396396396396, -17.38730428628631],
          [139.6396396396396, -16.666582740740765],
          [140, -16.666582740740765],
          [140, -16.306221967967986],
          [139.6396396396396, -16.126041581581603],
          [138.55855855855856, -16.666582740740765],
          [137.8378378378378, -16.306221967967986],
          [137.8378378378378, -15.94586119519522],
          [137.11711711711712, -15.585500422422442],
          [137.11711711711712, -15.225139649649677],
          [136.75675675675672, -15.40532003603606],
          [136.03603603603602, -15.04495926326328],
          [136.03603603603602, -14.324237717717736],
          [136.39639639639637, -14.504418104104118],
          [137.11711711711712, -14.504418104104118],
          [137.11711711711712, -13.42333578578581],
          [136.75675675675672, -13.42333578578581],
          [136.75675675675672, -12.702614240240266],
          [137.11711711711712, -12.522433853853869],
          [137.11711711711712, -10.900810376376398],
          [136.39639639639637, -10.900810376376398],
          [136.39639639639637, -11.44135153553556],
          [136.03603603603602, -11.44135153553556],
          [135.31531531531527, -11.801712308308325],
          [135.31531531531527, -11.44135153553556],
          [134.95495495495493, -11.44135153553556],
          [134.95495495495493, -11.801712308308325],
          [134.59459459459458, -11.801712308308325],
          [134.23423423423424, -11.621531921921942],
          [133.87387387387383, -11.621531921921942],
          [133.15315315315314, -11.261171149149177],
          [133.15315315315314, -10.900810376376398],
          [132.7927927927928, -10.720629989990016],
          [132.4324324324324, -10.900810376376398],
          [132.07207207207205, -10.900810376376398],
          [131.7117117117117, -11.08099076276278],
          [130.27027027027026, -11.08099076276278],
          [129.9099099099099, -11.261171149149177],
          [129.9099099099099, -11.981892694694722],
          [130.6306306306306, -11.981892694694722],
          [130.27027027027026, -12.342253467467486],
          [130.27027027027026, -12.702614240240266],
          [129.9099099099099, -12.702614240240266],
          [129.9099099099099, -13.243155399399427],
          [129.5495495495495, -13.42333578578581],
          [129.5495495495495, -13.783696558558574],
          [129.18918918918916, -13.963876944944971],
          [129.18918918918916, -14.684598490490515],
          [128.82882882882882, -14.684598490490515],
          [128.46846846846847, -14.504418104104118],
          [128.10810810810807, -14.324237717717736],
          [127.74774774774772, -13.963876944944971],
          [127.38738738738738, -13.783696558558574],
          [127.38738738738738, -11.08099076276278],
          [127.02702702702703, -10.720629989990016],
          [125.94594594594594, -10.180088830830854],
          [125.58558558558559, -9.819728058058075],
          [124.86486486486484, -9.45936728528531],
          [124.86486486486484, -9.099006512512531],
          [125.22522522522519, -9.279186898898928],
          [125.22522522522519, -9.099006512512531],
          [125.22522522522519, -8.918826126126149],
          [124.86486486486484, -9.099006512512531],
          [124.86486486486484, -8.738645739739766],
          [124.5045045045045, -8.918826126126149],
          [124.5045045045045, -9.45936728528531],
          [123.78378378378375, -9.099006512512531],
          [124.14414414414415, -8.918826126126149],
          [124.5045045045045, -8.918826126126149],
          [124.86486486486484, -8.738645739739766],
          [124.86486486486484, -8.55846535335337],
          [125.22522522522519, -8.378284966966987],
          [125.22522522522519, -6.756661489489517],
          [124.86486486486484, -6.216120330330355],
          [124.86486486486484, -5.3152183983984145],
          [124.5045045045045, -4.95485762562565],
          [124.5045045045045, -3.5134145345345615],
          [124.14414414414415, -3.1530537617617824],
          [124.14414414414415, -1.1710695115115328],
          [124.86486486486484, -0.4503479659659888],
          [125.22522522522519, 0.09019319319317276],
          [125.58558558558559, 0.45055396596593766],
          [125.58558558558559, 0.8109147387387168],
          [125.94594594594594, 1.3514558978978783],
          [127.02702702702703, 2.4325382162161873],
          [127.02702702702703, 2.973079375375349],
          [127.38738738738738, 3.1532597617617313],
          [127.38738738738738, 23.51364342342339],
          [122.70270270270271, 23.51364342342339],
          [122.3423423423423, 23.693823809809786],
          [122.3423423423423, 24.594725741741712],
          [122.70270270270271, 24.774906128128094],
          [122.70270270270271, 25.135266900900874],
          [123.06306306306305, 25.315447287287256],
          [123.4234234234234, 25.315447287287256],
          [123.4234234234234, 26.39652960560558],
          [126.30630630630628, 26.39652960560558],
          [127.02702702702703, 26.756890378378344],
          [127.38738738738738, 26.756890378378344],
          [127.38738738738738, 33.783925447447416],
          [127.02702702702703, 33.60374506106103],
          [127.02702702702703, 33.06320390190187],
          [125.94594594594594, 33.06320390190187],
          [125.94594594594594, 33.42356467467464],
          [126.30630630630628, 33.60374506106103],
          [125.94594594594594, 34.14428622022018],
          [125.22522522522519, 34.14428622022018],
          [124.86486486486484, 33.9641058338338],
          [124.86486486486484, 34.865007765765725],
          [125.58558558558559, 34.865007765765725],
          [125.94594594594594, 35.04518815215212],
          [125.94594594594594, 36.846992016015975],
          [125.58558558558559, 37.02717240240237],
          [125.94594594594594, 37.387533175175136],
          [125.58558558558559, 37.56771356156153],
          [124.5045045045045, 37.56771356156153],
          [124.5045045045045, 38.648795879879856],
          [124.86486486486484, 38.648795879879856],
          [124.86486486486484, 39.00915665265262],
          [125.22522522522519, 39.189337039039],
          [124.14414414414415, 39.72987819819815],
          [124.5045045045045, 40.090238970970944],
          [124.86486486486484, 40.45059974374371],
          [125.22522522522519, 40.63078013013009],
          [125.58558558558559, 40.63078013013009],
          [125.58558558558559, 40.810960516516474],
          [125.94594594594594, 40.810960516516474],
          [125.94594594594594, 40.991140902902856],
          [126.30630630630628, 41.35150167567565],
          [126.66666666666663, 41.35150167567565],
          [126.66666666666663, 41.711862448448414],
          [127.02702702702703, 41.711862448448414],
          [127.02702702702703, 41.53168206206203],
          [127.38738738738738, 41.53168206206203],
          [127.74774774774772, 41.35150167567565],
          [127.74774774774772, 41.53168206206203],
          [127.74774774774772, 41.35150167567565],
          [127.74774774774772, 41.53168206206203],
          [127.74774774774772, 41.35150167567565],
          [128.10810810810807, 41.53168206206203],
          [128.10810810810807, 41.35150167567565],
          [128.10810810810807, 42.07222322122118],
          [128.46846846846847, 42.07222322122118],
          [128.82882882882882, 42.07222322122118],
          [129.18918918918916, 42.07222322122118],
          [129.18918918918916, 42.432583993993944],
          [129.5495495495495, 42.432583993993944],
          [129.9099099099099, 42.432583993993944],
          [129.9099099099099, 42.97312515315312],
          [130.27027027027026, 42.97312515315312],
          [130.27027027027026, 42.612764380380355],
          [130.6306306306306, 42.612764380380355],
          [130.99099099099095, 42.432583993993944],
          [131.7117117117117, 42.432583993993944],
          [132.07207207207205, 42.612764380380355],
          [133.87387387387383, 42.612764380380355],
          [134.95495495495493, 43.1533055395395],
          [134.95495495495493, 43.333485925925885],
          [135.67567567567568, 43.69384669869865],
          [136.03603603603602, 44.234387857857826],
          [136.75675675675672, 44.59474863063059],
          [136.75675675675672, 44.955109403403355],
          [137.47747747747746, 45.31547017617615],
          [137.47747747747746, 45.49565056256253],
          [138.19819819819816, 45.856011335335296],
          [138.19819819819816, 46.21637210810806],
          [138.55855855855856, 46.39655249449444],
          [138.55855855855856, 46.75691326726724],
          [139.27927927927925, 47.11727404004],
          [139.27927927927925, 47.65781519919915],
          [139.6396396396396, 47.65781519919915],
          [140.36036036036035, 48.198356358358325],
          [140.36036036036035, 48.73889751751747],
          [140.7207207207207, 48.919077903903855],
          [140.7207207207207, 49.819979835835795],
          [141.08108108108104, 50.00016022222218],
          [140.7207207207207, 50.36052099499497],
          [140.7207207207207, 50.720881767767736],
          [141.08108108108104, 50.90106215415412],
          [141.08108108108104, 51.441603313313266],
          [141.44144144144144, 51.62178369969965],
          [141.8018018018018, 51.26142292692688],
          [141.8018018018018, 48.919077903903855],
          [141.8018018018018, 46.75691326726724],
          [141.08108108108104, 46.39655249449444],
          [141.08108108108104, 45.856011335335296],
          [141.8018018018018, 45.675830948948914],
          [142.52252252252248, 45.675830948948914],
          [142.52252252252248, 45.135289789789766],
          [142.88288288288288, 44.77492901701697],
          [143.60360360360357, 44.41456824424421],
          [144.68468468468467, 44.234387857857826],
          [145.40540540540542, 44.41456824424421],
          [145.40540540540542, 43.51366631231227],
          [145.76576576576576, 43.51366631231227],
          [145.76576576576576, 43.1533055395395],
        ],
      ],
    },
    properties: {
      objectid: 29,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+9',
      map_color6: 3,
      map_color8: 3,
      note: null,
      zone: 9,
      utc_format: 'UTC+09:00',
      time_zone: 'UTC+09:00',
      iso_8601: '2012-05-31T13:33:50+09:00',
      places: 'East Timor, Japan, North Korea, South Korea',
      dst_places: null,
      tz_name1st: 'Asia/Tokyo',
      tz_namesum: 6,
      cartodb_id: 47,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [73.69369369369369, 39.369517425425386],
          [73.69369369369369, 38.648795879879856],
          [74.05405405405403, 38.468615493493445],
          [74.05405405405403, 38.648795879879856],
          [74.41441441441441, 38.648795879879856],
          [74.77477477477476, 38.468615493493445],
          [74.77477477477476, 37.56771356156153],
          [75.13513513513513, 37.56771356156153],
          [75.13513513513513, 37.207352788788754],
          [74.77477477477476, 37.207352788788754],
          [74.77477477477476, 37.387533175175136],
          [72.97297297297297, 37.387533175175136],
          [72.25225225225225, 37.02717240240237],
          [71.89189189189187, 36.66681162962959],
          [71.53153153153153, 36.66681162962959],
          [71.53153153153153, 37.9280743343343],
          [71.17117117117115, 38.10825472072068],
          [71.17117117117115, 38.468615493493445],
          [70.45045045045043, 38.28843510710706],
          [70.45045045045043, 37.9280743343343],
          [70.09009009009009, 37.9280743343343],
          [70.09009009009009, 37.56771356156153],
          [69.36936936936937, 37.56771356156153],
          [69.36936936936937, 37.02717240240237],
          [68.64864864864865, 37.387533175175136],
          [68.28828828828827, 37.207352788788754],
          [67.2072072072072, 37.207352788788754],
          [67.2072072072072, 37.387533175175136],
          [65.40540540540539, 37.387533175175136],
          [65.40540540540539, 37.207352788788754],
          [64.68468468468467, 37.207352788788754],
          [64.68468468468467, 36.30645085685683],
          [64.32432432432432, 36.30645085685683],
          [63.96396396396395, 35.94609008408405],
          [63.24324324324323, 35.94609008408405],
          [63.24324324324323, 35.40554892492489],
          [62.88288288288288, 35.225368538538504],
          [62.16216216216216, 35.225368538538504],
          [62.16216216216216, 35.40554892492489],
          [61.44144144144144, 35.40554892492489],
          [61.44144144144144, 35.58572931131128],
          [61.08108108108107, 35.58572931131128],
          [61.08108108108107, 36.66681162962959],
          [60.360360360360346, 36.66681162962959],
          [60.360360360360346, 36.846992016015975],
          [59.639639639639626, 37.207352788788754],
          [59.27927927927928, 37.207352788788754],
          [59.27927927927928, 37.56771356156153],
          [58.198198198198185, 37.56771356156153],
          [58.198198198198185, 37.747893947947915],
          [57.11711711711712, 38.28843510710706],
          [56.3963963963964, 38.28843510710706],
          [56.3963963963964, 38.10825472072068],
          [55.3153153153153, 38.10825472072068],
          [54.95495495495496, 37.9280743343343],
          [54.95495495495496, 37.56771356156153],
          [54.59459459459458, 37.387533175175136],
          [53.513513513513516, 37.387533175175136],
          [53.15315315315314, 37.56771356156153],
          [52.43243243243242, 38.28843510710706],
          [52.43243243243242, 38.468615493493445],
          [51.7117117117117, 39.189337039039],
          [51.351351351351354, 39.54969781181177],
          [51.351351351351354, 40.270419357357326],
          [50.99099099099098, 40.810960516516474],
          [50.99099099099098, 41.711862448448414],
          [50.27027027027026, 42.07222322122118],
          [50.27027027027026, 42.432583993993944],
          [49.909909909909885, 42.432583993993944],
          [49.909909909909885, 42.97312515315312],
          [49.189189189189165, 43.333485925925885],
          [48.82882882882882, 43.333485925925885],
          [48.82882882882882, 44.05420747147144],
          [49.54954954954954, 44.05420747147144],
          [49.54954954954954, 44.41456824424421],
          [49.189189189189165, 44.41456824424421],
          [49.189189189189165, 45.31547017617615],
          [49.909909909909885, 45.675830948948914],
          [49.909909909909885, 46.21637210810806],
          [49.189189189189165, 46.21637210810806],
          [48.82882882882882, 46.39655249449444],
          [48.82882882882882, 47.11727404004],
          [48.468468468468444, 47.297454426426384],
          [48.1081081081081, 47.83799558558556],
          [47.027027027027, 47.83799558558556],
          [47.027027027027, 48.37853674474471],
          [46.30630630630628, 48.37853674474471],
          [47.027027027027, 48.919077903903855],
          [47.027027027027, 49.27943867667665],
          [46.66666666666666, 49.27943867667665],
          [46.66666666666666, 49.63979944944941],
          [47.747747747747724, 50.18034060860856],
          [48.1081081081081, 49.819979835835795],
          [48.82882882882882, 49.819979835835795],
          [48.82882882882882, 50.54070138138135],
          [49.189189189189165, 51.0812425405405],
          [49.909909909909885, 51.0812425405405],
          [50.630630630630606, 51.441603313313266],
          [50.630630630630606, 51.80196408608606],
          [51.351351351351354, 51.441603313313266],
          [51.7117117117117, 51.441603313313266],
          [52.43243243243242, 51.80196408608606],
          [52.43243243243242, 51.441603313313266],
          [53.513513513513516, 51.441603313313266],
          [54.59459459459458, 51.0812425405405],
          [55.67567567567568, 50.54070138138135],
          [56.3963963963964, 51.0812425405405],
          [58.55855855855856, 51.0812425405405],
          [58.55855855855856, 50.720881767767736],
          [59.27927927927928, 50.720881767767736],
          [59.639639639639626, 50.54070138138135],
          [60, 50.720881767767736],
          [61.44144144144144, 50.720881767767736],
          [61.44144144144144, 51.26142292692688],
          [62.16216216216216, 51.0812425405405],
          [62.52252252252251, 50.720881767767736],
          [62.52252252252251, 48.919077903903855],
          [63.24324324324323, 48.55871713113109],
          [63.6036036036036, 48.55871713113109],
          [64.32432432432432, 48.01817597197194],
          [63.24324324324323, 47.47763481281277],
          [62.88288288288288, 47.11727404004],
          [62.16216216216216, 47.47763481281277],
          [61.80180180180179, 47.83799558558556],
          [61.08108108108107, 47.47763481281277],
          [61.08108108108107, 47.297454426426384],
          [59.27927927927928, 46.39655249449444],
          [59.27927927927928, 46.03619172172168],
          [58.918918918918905, 45.856011335335296],
          [58.918918918918905, 45.31547017617615],
          [61.80180180180179, 43.87402708508506],
          [61.80180180180179, 43.51366631231227],
          [62.88288288288288, 43.51366631231227],
          [62.88288288288288, 43.69384669869865],
          [63.6036036036036, 43.69384669869865],
          [63.6036036036036, 43.51366631231227],
          [65.04504504504504, 43.51366631231227],
          [66.12612612612611, 42.97312515315312],
          [66.12612612612611, 42.07222322122118],
          [66.48648648648648, 42.07222322122118],
          [66.48648648648648, 41.35150167567565],
          [66.84684684684683, 41.17132128928927],
          [67.92792792792793, 41.17132128928927],
          [67.92792792792793, 40.810960516516474],
          [68.64864864864865, 40.63078013013009],
          [68.64864864864865, 41.17132128928927],
          [70.8108108108108, 42.25240360760756],
          [70.8108108108108, 41.8920428348348],
          [70.45045045045043, 41.8920428348348],
          [70.45045045045043, 41.35150167567565],
          [70.8108108108108, 41.17132128928927],
          [71.53153153153153, 41.17132128928927],
          [71.53153153153153, 41.53168206206203],
          [72.97297297297297, 40.810960516516474],
          [72.97297297297297, 40.63078013013009],
          [72.25225225225225, 40.63078013013009],
          [71.53153153153153, 40.270419357357326],
          [70.8108108108108, 40.270419357357326],
          [70.8108108108108, 40.090238970970944],
          [69.36936936936937, 40.090238970970944],
          [69.36936936936937, 39.54969781181177],
          [71.53153153153153, 39.54969781181177],
          [71.53153153153153, 39.369517425425386],
          [73.69369369369369, 39.369517425425386],
        ],
      ],
    },
    properties: {
      objectid: 22,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+5',
      map_color6: 1,
      map_color8: 7,
      note: null,
      zone: 5,
      utc_format: 'UTC+05:00',
      time_zone: 'UTC+05:00',
      iso_8601: '2012-05-31T09:33:50+05:00',
      places: 'Kazakhstan (West), Uzbekistan',
      dst_places: null,
      tz_name1st: 'Asia/Tashkent',
      tz_namesum: 6,
      cartodb_id: 61,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [28.28828828828827, 56.12629335935932],
          [29.369369369369366, 55.76593258658656],
          [30.450450450450433, 55.76593258658656],
          [30.810810810810807, 55.58575220020015],
          [30.810810810810807, 54.684850268268235],
          [31.171171171171153, 54.684850268268235],
          [31.171171171171153, 54.14430910910906],
          [31.891891891891873, 54.14430910910906],
          [31.891891891891873, 53.783948336336294],
          [32.612612612612594, 53.783948336336294],
          [32.612612612612594, 53.24340717717715],
          [31.531531531531527, 52.883046404404354],
          [31.531531531531527, 52.162324858858824],
          [31.891891891891873, 52.162324858858824],
          [30.810810810810807, 52.162324858858824],
          [30.810810810810807, 51.441603313313266],
          [29.369369369369366, 51.441603313313266],
          [29.369369369369366, 51.62178369969965],
          [27.927927927927925, 51.62178369969965],
          [27.207207207207205, 51.80196408608606],
          [26.12612612612611, 51.80196408608606],
          [26.12612612612611, 51.98214447247244],
          [24.68468468468467, 51.98214447247244],
          [23.603603603603602, 51.441603313313266],
          [23.603603603603602, 52.162324858858824],
          [23.243243243243228, 52.52268563163159],
          [23.96396396396395, 52.70286601801797],
          [23.96396396396395, 53.24340717717715],
          [23.603603603603602, 53.24340717717715],
          [23.603603603603602, 53.96412872272268],
          [24.68468468468467, 53.96412872272268],
          [24.68468468468467, 54.14430910910906],
          [25.765765765765764, 54.14430910910906],
          [25.765765765765764, 54.86503065465462],
          [26.486486486486484, 55.405571813813765],
          [26.486486486486484, 55.76593258658656],
          [27.56756756756755, 55.76593258658656],
          [28.28828828828827, 56.12629335935932],
        ],
      ],
    },
    properties: {
      objectid: 0,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+3',
      map_color6: 3,
      map_color8: 4,
      note: null,
      zone: 3,
      utc_format: 'UTC+03:00',
      time_zone: 'UTC+03:00',
      iso_8601: '2012-05-31T07:33:50+03:00',
      places: 'Belarus',
      dst_places: null,
      tz_name1st: 'Europe/Minsk',
      tz_namesum: 1,
      cartodb_id: 63,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [7.387387387387378, 90.00020599999996],
          [22.522522522522507, 90.00020599999996],
          [22.522522522522507, 80.99118668068064],
          [34.774774774774755, 80.99118668068064],
          [34.774774774774755, 75.40559470270267],
          [22.522522522522507, 75.40559470270267],
          [22.522522522522507, 70.901085043043],
          [23.603603603603602, 71.26144581581576],
          [28.648648648648646, 71.26144581581576],
          [29.729729729729712, 70.901085043043],
          [30.810810810810807, 70.901085043043],
          [31.891891891891873, 70.18036349749747],
          [30.810810810810807, 70.00018311111106],
          [30.810810810810807, 69.45964195195191],
          [29.00900900900899, 69.09928117917914],
          [29.369369369369366, 69.45964195195191],
          [27.927927927927925, 70.00018311111106],
          [26.486486486486484, 70.00018311111106],
          [25.765765765765764, 69.45964195195191],
          [25.765765765765764, 68.91910079279276],
          [24.68468468468467, 68.73892040640635],
          [22.522522522522507, 68.73892040640635],
          [21.801801801801787, 69.27946156556553],
          [20.72072072072072, 69.09928117917914],
          [21.801801801801787, 68.55874002001997],
          [23.243243243243228, 68.37855963363359],
          [23.603603603603602, 68.01819886086082],
          [23.603603603603602, 66.21639499699697],
          [23.96396396396395, 66.21639499699697],
          [23.96396396396395, 65.49567345145141],
          [22.882882882882882, 64.59477151951947],
          [22.16216216216216, 64.2344107467467],
          [21.801801801801787, 63.87404997397394],
          [21.081081081081066, 63.513689201201146],
          [20.72072072072072, 63.513689201201146],
          [19.639639639639626, 62.973148042042],
          [19.639639639639626, 62.25242649649647],
          [19.27927927927928, 61.892065723723675],
          [19.27927927927928, 60.09026185985982],
          [20, 59.369540314314264],
          [20.360360360360346, 59.18935992792788],
          [20.360360360360346, 57.928097223223176],
          [20, 57.56773645045041],
          [20, 57.207375677677646],
          [19.639639639639626, 57.027195291291264],
          [19.639639639639626, 56.66683451851847],
          [18.918918918918905, 56.12629335935932],
          [18.918918918918905, 55.405571813813765],
          [19.27927927927928, 55.045211041041],
          [19.27927927927928, 54.684850268268235],
          [19.639639639639626, 54.50466988188185],
          [20.360360360360346, 54.50466988188185],
          [20.72072072072072, 54.32448949549547],
          [22.882882882882882, 54.32448949549547],
          [23.603603603603602, 53.96412872272268],
          [23.603603603603602, 53.24340717717715],
          [23.96396396396395, 53.24340717717715],
          [23.96396396396395, 52.70286601801797],
          [23.243243243243228, 52.52268563163159],
          [23.603603603603602, 52.162324858858824],
          [23.603603603603602, 51.441603313313266],
          [23.96396396396395, 51.26142292692688],
          [23.96396396396395, 50.36052099499497],
          [22.522522522522507, 49.63979944944941],
          [22.882882882882882, 49.27943867667665],
          [22.522522522522507, 49.099258290290265],
          [22.522522522522507, 48.73889751751747],
          [22.16216216216216, 48.73889751751747],
          [22.16216216216216, 48.37853674474471],
          [22.882882882882882, 48.01817597197194],
          [22.16216216216216, 47.65781519919915],
          [21.801801801801787, 47.297454426426384],
          [21.801801801801787, 46.93709365365362],
          [21.44144144144144, 46.93709365365362],
          [21.44144144144144, 46.576732880880854],
          [21.081081081081066, 46.576732880880854],
          [21.081081081081066, 46.21637210810806],
          [20.360360360360346, 46.21637210810806],
          [20.360360360360346, 45.856011335335296],
          [20.72072072072072, 45.856011335335296],
          [20.72072072072072, 45.49565056256253],
          [21.44144144144144, 45.135289789789766],
          [21.44144144144144, 44.77492901701697],
          [22.16216216216216, 44.59474863063059],
          [22.522522522522507, 44.77492901701697],
          [22.522522522522507, 43.333485925925885],
          [22.882882882882882, 43.333485925925885],
          [22.882882882882882, 42.97312515315312],
          [22.522522522522507, 42.79294476676674],
          [22.522522522522507, 42.07222322122118],
          [22.882882882882882, 42.07222322122118],
          [22.882882882882882, 41.17132128928927],
          [21.801801801801787, 41.17132128928927],
          [21.801801801801787, 40.810960516516474],
          [21.081081081081066, 40.810960516516474],
          [21.081081081081066, 40.45059974374371],
          [20.72072072072072, 40.45059974374371],
          [20.72072072072072, 40.090238970970944],
          [20, 39.91005858458456],
          [19.27927927927928, 39.91005858458456],
          [19.27927927927928, 39.54969781181177],
          [19.639639639639626, 39.54969781181177],
          [19.639639639639626, 39.189337039039],
          [20.360360360360346, 39.00915665265262],
          [20.360360360360346, 38.468615493493445],
          [20, 38.10825472072068],
          [20.360360360360346, 37.9280743343343],
          [20.360360360360346, 37.56771356156153],
          [21.081081081081066, 37.56771356156153],
          [21.44144144144144, 37.387533175175136],
          [21.44144144144144, 36.48663124324321],
          [22.16216216216216, 36.30645085685683],
          [22.522522522522507, 36.30645085685683],
          [22.522522522522507, 33.06320390190187],
          [22.16216216216216, 33.243384288288254],
          [21.801801801801787, 33.243384288288254],
          [21.081081081081066, 32.883023515515475],
          [20.72072072072072, 32.883023515515475],
          [20, 32.52266274274271],
          [19.639639639639626, 32.16230196996993],
          [19.639639639639626, 31.261400038038005],
          [20, 31.081219651651622],
          [19.639639639639626, 30.720858878878843],
          [19.27927927927928, 30.54067849249246],
          [18.918918918918905, 30.54067849249246],
          [17.477477477477464, 31.261400038038005],
          [17.117117117117118, 31.261400038038005],
          [16.756756756756744, 31.441580424424387],
          [16.036036036036023, 31.441580424424387],
          [15.675675675675677, 31.621760810810784],
          [15.675675675675677, 32.34248235635633],
          [14.954954954954957, 32.70284312912909],
          [14.594594594594582, 32.70284312912909],
          [13.873873873873862, 33.06320390190187],
          [12.432432432432421, 33.06320390190187],
          [11.7117117117117, 33.42356467467464],
          [11.351351351351354, 33.243384288288254],
          [11.351351351351354, 32.34248235635633],
          [10.27027027027026, 31.801941197197166],
          [10.27027027027026, 30.720858878878843],
          [9.909909909909913, 30.36049810610608],
          [9.549549549549539, 30.18031771971968],
          [9.549549549549539, 29.639776560560534],
          [9.909909909909913, 29.279415787787755],
          [9.909909909909913, 26.57670999199196],
          [9.549549549549539, 26.39652960560558],
          [9.549549549549539, 25.675808060060035],
          [9.909909909909913, 25.675808060060035],
          [9.909909909909913, 24.774906128128094],
          [10.27027027027026, 24.774906128128094],
          [11.351351351351354, 24.234364968968933],
          [11.7117117117117, 24.234364968968933],
          [11.7117117117117, 23.874004196196168],
          [12.432432432432421, 23.51364342342339],
          [12.432432432432421, 23.333463037037006],
          [13.153153153153141, 23.333463037037006],
          [13.873873873873862, 22.973102264264227],
          [14.234234234234236, 22.612741491491462],
          [14.954954954954957, 22.973102264264227],
          [15.675675675675677, 23.333463037037006],
          [16.396396396396398, 23.333463037037006],
          [19.27927927927928, 21.89201994594592],
          [22.16216216216216, 20.45057685485483],
          [23.96396396396395, 19.54967492292289],
          [23.96396396396395, 15.765886808808787],
          [23.243243243243228, 15.765886808808787],
          [22.882882882882882, 15.58570642242239],
          [22.882882882882882, 14.864984876876846],
          [22.522522522522507, 14.864984876876846],
          [22.522522522522507, 13.96408294494492],
          [22.16216216216216, 13.96408294494492],
          [22.16216216216216, 13.06318101301298],
          [21.801801801801787, 13.06318101301298],
          [21.801801801801787, 12.702820240240214],
          [22.522522522522507, 12.702820240240214],
          [22.522522522522507, 11.441557535535509],
          [22.882882882882882, 11.441557535535509],
          [22.882882882882882, 10.720835989989965],
          [23.243243243243228, 10.360475217217186],
          [23.603603603603602, 10.180294830830803],
          [23.603603603603602, 8.738851739739715],
          [24.324324324324323, 8.738851739739715],
          [24.324324324324323, 8.198310580580554],
          [24.68468468468467, 8.198310580580554],
          [25.40540540540539, 7.8379498078077745],
          [25.045045045045043, 7.657769421421392],
          [26.12612612612611, 7.1172282622622305],
          [26.12612612612611, 6.3965067167166865],
          [26.486486486486484, 6.3965067167166865],
          [26.486486486486484, 6.036145943943922],
          [26.84684684684683, 6.036145943943922],
          [27.207207207207205, 5.855965557557525],
          [27.207207207207205, 5.135244012011981],
          [27.56756756756755, 5.135244012011981],
          [25.765765765765764, 5.135244012011981],
          [25.40540540540539, 5.3154243983983775],
          [25.40540540540539, 4.955063625625598],
          [24.68468468468467, 4.955063625625598],
          [24.324324324324323, 5.135244012011981],
          [23.243243243243228, 4.5947028528528335],
          [22.882882882882882, 4.774883239239216],
          [22.522522522522507, 4.5947028528528335],
          [22.522522522522507, 4.054161693693672],
          [22.882882882882882, 3.8739813073072753],
          [23.603603603603602, 3.8739813073072753],
          [22.882882882882882, 3.5136205345345104],
          [22.882882882882882, 2.612718602602584],
          [23.243243243243228, 2.612718602602584],
          [23.243243243243228, 2.0721774434434224],
          [22.522522522522507, 2.0721774434434224],
          [22.522522522522507, 1.1712755115114817],
          [22.882882882882882, 1.1712755115114817],
          [22.882882882882882, 0.45055396596593766],
          [23.243243243243228, 0.2703735795795552],
          [23.243243243243228, -0.27016757957960635],
          [23.603603603603602, -0.4503479659659888],
          [23.603603603603602, -1.1710695115115328],
          [23.96396396396395, -1.3512498978979153],
          [24.324324324324323, -1.3512498978979153],
          [24.324324324324323, -1.7116106706706944],
          [23.603603603603602, -2.0719714434434735],
          [23.243243243243228, -1.8917910570570768],
          [22.16216216216216, -1.8917910570570768],
          [22.16216216216216, -2.4323322162162384],
          [21.081081081081066, -2.4323322162162384],
          [21.081081081081066, -2.7926929889890175],
          [20.72072072072072, -2.7926929889890175],
          [20.72072072072072, -4.234136080080106],
          [20, -4.234136080080106],
          [20, -6.035939943943973],
          [19.639639639639626, -6.035939943943973],
          [19.639639639639626, -6.756661489489517],
          [20, -6.936841875875899],
          [20.72072072072072, -6.936841875875899],
          [20.72072072072072, -7.117022262262282],
          [20.360360360360346, -7.297202648648664],
          [21.801801801801787, -7.297202648648664],
          [21.801801801801787, -9.819728058058075],
          [22.16216216216216, -9.819728058058075],
          [22.16216216216216, -11.261171149149177],
          [22.522522522522507, -11.08099076276278],
          [23.96396396396395, -11.08099076276278],
          [23.96396396396395, -13.06297501301303],
          [21.801801801801787, -13.06297501301303],
          [21.801801801801787, -16.126041581581603],
          [22.16216216216216, -16.126041581581603],
          [22.16216216216216, -16.666582740740765],
          [22.522522522522507, -16.666582740740765],
          [22.522522522522507, -17.02694351351353],
          [22.882882882882882, -17.02694351351353],
          [22.882882882882882, -17.38730428628631],
          [23.243243243243228, -17.56748467267269],
          [25.045045045045043, -17.56748467267269],
          [24.68468468468467, -17.747665059059074],
          [24.68468468468467, -18.108025831831853],
          [23.603603603603602, -18.108025831831853],
          [23.243243243243228, -18.288206218218235],
          [22.882882882882882, -18.108025831831853],
          [22.16216216216216, -18.108025831831853],
          [21.801801801801787, -18.288206218218235],
          [21.081081081081066, -18.288206218218235],
          [21.081081081081066, -22.071994332332352],
          [20, -22.071994332332352],
          [20, -28.558488242242262],
          [19.27927927927928, -28.918849015015034],
          [18.198198198198185, -28.918849015015034],
          [17.83783783783784, -28.738668628628645],
          [17.477477477477464, -28.738668628628645],
          [17.477477477477464, -28.198127469469483],
          [17.117117117117118, -28.198127469469483],
          [16.756756756756744, -28.0179470830831],
          [16.756756756756744, -28.558488242242262],
          [16.396396396396398, -28.558488242242262],
          [16.396396396396398, -28.918849015015034],
          [16.756756756756744, -29.099029401401417],
          [16.756756756756744, -29.63957056056058],
          [17.117117117117118, -29.99993133333335],
          [17.117117117117118, -30.540472492492512],
          [17.477477477477464, -30.720652878878894],
          [17.477477477477464, -31.081013651651666],
          [18.198198198198185, -31.80173519719721],
          [18.198198198198185, -32.52245674274276],
          [17.83783783783784, -32.52245674274276],
          [17.83783783783784, -33.243178288288306],
          [18.198198198198185, -33.42335867467469],
          [18.198198198198185, -34.32426060660662],
          [18.55855855855856, -34.50444099299301],
          [19.27927927927928, -34.50444099299301],
          [19.639639639639626, -34.86480176576578],
          [20.360360360360346, -34.86480176576578],
          [20.72072072072072, -34.50444099299301],
          [21.801801801801787, -34.50444099299301],
          [22.522522522522507, -34.14408022022023],
          [22.522522522522507, -70.1801574974975],
          [21.44144144144144, -69.99997711111112],
          [20.360360360360346, -70.72069865665667],
          [19.639639639639626, -69.99997711111112],
          [18.198198198198185, -69.99997711111112],
          [17.117117117117118, -70.1801574974975],
          [17.117117117117118, -69.63961633833834],
          [16.756756756756744, -69.45943595195196],
          [15.675675675675677, -69.45943595195196],
          [14.954954954954957, -69.63961633833834],
          [14.594594594594582, -69.99997711111112],
          [13.513513513513516, -69.99997711111112],
          [12.792792792792795, -69.81979672472474],
          [8.828828828828819, -69.81979672472474],
          [8.828828828828819, -69.99997711111112],
          [7.387387387387378, -69.99997711111112],
          [7.387387387387378, -55.225185427427434],
          [2.3423423423423344, -55.225185427427434],
          [2.3423423423423344, -53.783742336336346],
          [7.387387387387378, -53.783742336336346],
          [7.387387387387378, -3.8737753073073264],
          [2.7027027027026804, -3.8737753073073264],
          [2.7027027027026804, -0.6305283523523713],
          [7.387387387387378, -0.6305283523523713],
          [7.387387387387378, 1.3514558978978783],
          [7.747747747747752, 1.3514558978978783],
          [7.747747747747752, 1.8919970570570257],
          [7.387387387387378, 1.8919970570570257],
          [7.387387387387378, 4.234342080080054],
          [7.027027027027032, 4.234342080080054],
          [6.666666666666657, 4.054161693693672],
          [5.945945945945937, 4.054161693693672],
          [5.945945945945937, 4.234342080080054],
          [5.225225225225216, 4.5947028528528335],
          [5.225225225225216, 5.3154243983983775],
          [4.86486486486487, 5.3154243983983775],
          [4.86486486486487, 5.855965557557525],
          [4.144144144144121, 6.216326330330304],
          [2.7027027027026804, 6.216326330330304],
          [2.3423423423423344, 6.036145943943922],
          [1.98198198198196, 6.216326330330304],
          [1.621621621621614, 6.216326330330304],
          [1.621621621621614, 9.279392898898877],
          [1.2612612612612395, 9.279392898898877],
          [1.2612612612612395, 10.180294830830803],
          [0.9009009009008935, 10.180294830830803],
          [0.9009009009008935, 11.08119676276273],
          [1.2612612612612395, 11.08119676276273],
          [1.2612612612612395, 11.441557535535509],
          [1.98198198198196, 11.441557535535509],
          [2.3423423423423344, 11.621737921921891],
          [2.3423423423423344, 12.702820240240214],
          [1.2612612612612395, 12.702820240240214],
          [1.2612612612612395, 13.06318101301298],
          [0.9009009009008935, 13.06318101301298],
          [0.9009009009008935, 13.60372217217214],
          [0.540540540540519, 13.60372217217214],
          [0.540540540540519, 14.324443717717685],
          [0.180180180180173, 14.324443717717685],
          [0.180180180180173, 15.045165263263229],
          [1.2612612612612395, 15.045165263263229],
          [1.2612612612612395, 15.225345649649626],
          [2.3423423423423344, 15.225345649649626],
          [2.3423423423423344, 15.405526036036008],
          [3.423423423423401, 15.405526036036008],
          [3.7837837837837753, 15.58570642242239],
          [3.7837837837837753, 15.94606719519517],
          [4.144144144144121, 15.94606719519517],
          [4.144144144144121, 19.189314150150125],
          [3.7837837837837753, 19.009133763763728],
          [3.063063063063055, 19.009133763763728],
          [3.063063063063055, 19.91003569569567],
          [2.3423423423423344, 20.270396468468434],
          [1.621621621621614, 20.270396468468434],
          [1.621621621621614, 20.630757241241213],
          [1.2612612612612395, 20.630757241241213],
          [1.2612612612612395, 21.171298400400374],
          [0.180180180180173, 21.711839559559536],
          [0.180180180180173, 21.89201994594592],
          [-0.9009009009009219, 22.43256110510508],
          [-0.9009009009009219, 22.612741491491462],
          [-2.342342342342363, 23.333463037037006],
          [-2.342342342342363, 23.51364342342339],
          [-3.4234234234234293, 24.05418458258255],
          [-3.4234234234234293, 24.234364968968933],
          [-4.14414414414415, 24.594725741741712],
          [-4.504504504504524, 24.594725741741712],
          [-4.504504504504524, 24.955086514514477],
          [-7.027027027027032, 26.216349219219182],
          [-7.027027027027032, 26.39652960560558],
          [-8.828828828828847, 27.297431537537506],
          [-8.828828828828847, 28.738874628628594],
          [-6.666666666666686, 29.819956946946917],
          [-5.585585585585591, 29.819956946946917],
          [-5.585585585585591, 30.0001373333333],
          [-4.86486486486487, 30.36049810610608],
          [-4.86486486486487, 30.54067849249246],
          [-4.14414414414415, 30.901039265265226],
          [-3.7837837837838038, 30.901039265265226],
          [-3.7837837837838038, 31.621760810810784],
          [-2.702702702702709, 32.16230196996993],
          [-1.261261261261268, 32.16230196996993],
          [-1.261261261261268, 32.52266274274271],
          [-1.6216216216216424, 32.883023515515475],
          [-1.6216216216216424, 34.68482737937934],
          [-2.342342342342363, 35.04518815215212],
          [-2.342342342342363, 35.40554892492489],
          [-2.702702702702709, 35.58572931131128],
          [-3.4234234234234293, 35.40554892492489],
          [-4.504504504504524, 35.40554892492489],
          [-4.86486486486487, 35.58572931131128],
          [-4.86486486486487, 35.94609008408405],
          [-6.306306306306311, 35.94609008408405],
          [-6.306306306306311, 36.30645085685683],
          [-6.666666666666686, 36.48663124324321],
          [-6.666666666666686, 36.846992016015975],
          [-7.387387387387406, 37.02717240240237],
          [-7.387387387387406, 37.9280743343343],
          [-7.027027027027032, 37.9280743343343],
          [-7.027027027027032, 38.28843510710706],
          [-7.387387387387406, 38.28843510710706],
          [-7.387387387387406, 38.82897626626624],
          [-7.027027027027032, 38.82897626626624],
          [-7.027027027027032, 39.189337039039],
          [-7.387387387387406, 39.189337039039],
          [-7.387387387387406, 39.72987819819815],
          [-7.027027027027032, 39.72987819819815],
          [-7.027027027027032, 40.270419357357326],
          [-6.666666666666686, 40.270419357357326],
          [-6.666666666666686, 41.35150167567565],
          [-6.306306306306311, 41.35150167567565],
          [-6.306306306306311, 41.711862448448414],
          [-6.666666666666686, 41.8920428348348],
          [-8.108108108108127, 41.8920428348348],
          [-8.108108108108127, 42.07222322122118],
          [-8.828828828828847, 42.07222322122118],
          [-9.189189189189193, 41.8920428348348],
          [-9.189189189189193, 42.612764380380355],
          [-9.549549549549567, 42.612764380380355],
          [-9.549549549549567, 43.333485925925885],
          [-9.189189189189193, 43.51366631231227],
          [-8.468468468468473, 43.51366631231227],
          [-8.468468468468473, 43.87402708508506],
          [-7.747747747747752, 44.05420747147144],
          [-7.387387387387406, 43.87402708508506],
          [-5.225225225225245, 43.87402708508506],
          [-5.225225225225245, 43.69384669869865],
          [-2.702702702702709, 43.69384669869865],
          [-2.342342342342363, 43.51366631231227],
          [-1.6216216216216424, 43.69384669869865],
          [-1.6216216216216424, 45.135289789789766],
          [-1.261261261261268, 45.49565056256253],
          [-1.6216216216216424, 45.675830948948914],
          [-1.6216216216216424, 46.03619172172168],
          [-1.9819819819819884, 46.21637210810806],
          [-1.9819819819819884, 46.576732880880854],
          [-2.702702702702709, 46.576732880880854],
          [-3.0630630630630833, 47.11727404004],
          [-3.4234234234234293, 47.11727404004],
          [-3.4234234234234293, 47.47763481281277],
          [-3.7837837837838038, 47.65781519919915],
          [-4.504504504504524, 47.65781519919915],
          [-4.86486486486487, 47.83799558558556],
          [-4.86486486486487, 48.198356358358325],
          [-5.585585585585591, 48.37853674474471],
          [-5.585585585585591, 49.27943867667665],
          [-4.86486486486487, 49.27943867667665],
          [-4.504504504504524, 49.45961906306303],
          [-3.7837837837838038, 49.45961906306303],
          [-2.702702702702709, 50.00016022222218],
          [-1.9819819819819884, 50.18034060860856],
          [0.180180180180173, 50.18034060860856],
          [0.9009009009008935, 50.36052099499497],
          [1.2612612612612395, 50.90106215415412],
          [1.98198198198196, 51.26142292692688],
          [2.3423423423423344, 51.26142292692688],
          [4.144144144144121, 52.162324858858824],
          [4.144144144144121, 52.883046404404354],
          [4.504504504504496, 52.883046404404354],
          [4.504504504504496, 53.42358756356353],
          [4.86486486486487, 53.60376794994991],
          [5.945945945945937, 53.60376794994991],
          [6.666666666666657, 53.96412872272268],
          [7.387387387387378, 53.96412872272268],
          [7.387387387387378, 57.747916836836794],
          [6.306306306306311, 57.928097223223176],
          [5.225225225225216, 58.46863838238235],
          [5.225225225225216, 59.0091795415415],
          [4.86486486486487, 59.0091795415415],
          [4.86486486486487, 59.54972070070065],
          [4.504504504504496, 59.72990108708706],
          [4.504504504504496, 60.81098340540535],
          [4.144144144144121, 60.99116379179176],
          [4.504504504504496, 61.35152456456453],
          [4.504504504504496, 62.25242649649647],
          [5.225225225225216, 62.61278726926923],
          [5.945945945945937, 62.792967655655616],
          [6.666666666666657, 63.15332842842838],
          [7.387387387387378, 63.33350881481476],
          [7.387387387387378, 84.95515518118114],
          [7.387387387387378, 90.00020599999996],
        ],
      ],
    },
    properties: {
      objectid: 16,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+1',
      map_color6: 5,
      map_color8: 2,
      note: null,
      zone: 1,
      utc_format: 'UTC+01:00',
      time_zone: 'UTC+01:00',
      iso_8601: '2012-05-31T05:33:50+01:00',
      places: 'Angola, Cameroon, Nigeria, Tunisia',
      dst_places:
        'Albania, Algeria, Austria, Belgium, Bosnia & Herz., Spain (continental), Croatia, Czech Republic, Denmark, Germany, Hungary, Italy, Kinshasa, Kosovo, Macedonia, France (metropolitan), Netherlands,Norway,Poland,Serbia,Slovakia,Slovenia,Sweden,Switzerland',
      tz_name1st: 'Europe/Paris',
      tz_namesum: 48,
      cartodb_id: 73,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: null,
    properties: {
      objectid: 4,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-9',
      map_color6: 3,
      map_color8: 5,
      note: null,
      zone: -9,
      utc_format: 'UTC-09:00',
      time_zone: 'UTC-09:00',
      iso_8601: '2012-05-30T19:33:50-09:00',
      places: 'Gambier Islands',
      dst_places: 'United States (most of Alaska)',
      tz_name1st: null,
      tz_namesum: 0,
      cartodb_id: 78,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [180, -84.7747687947948],
          [180, -77.92791411211212],
          [178.9189189189189, -77.74773372572572],
          [174.59459459459458, -77.74773372572572],
          [172.4324324324324, -77.56755333933934],
          [172.4324324324324, -54.50446388188189],
          [169.9099099099099, -54.50446388188189],
          [165.2252252252252, -54.50446388188189],
          [165.2252252252252, -43.513460312312326],
          [165.94594594594594, -42.61255838038039],
          [165.94594594594594, -42.25219760760762],
          [167.02702702702703, -41.171115289289304],
          [167.02702702702703, -40.63057413013014],
          [167.74774774774772, -39.9098525845846],
          [168.10810810810807, -39.36931142542544],
          [168.10810810810807, -39.008950652652665],
          [168.82882882882882, -38.10804872072073],
          [168.82882882882882, -37.74768794794796],
          [169.5495495495495, -36.84678601601603],
          [169.9099099099099, -36.48642524324326],
          [169.9099099099099, -36.12606447047048],
          [170.6306306306306, -35.40534292492494],
          [170.6306306306306, -34.86480176576578],
          [171.35135135135135, -34.14408022022023],
          [171.35135135135135, -33.78371944744746],
          [172.4324324324324, -32.702637129129144],
          [172.4324324324324, -2.4323322162162384],
          [164.14414414414415, -2.4323322162162384],
          [164.14414414414415, 8.018130194194171],
          [160.54054054054052, 8.018130194194171],
          [160.54054054054052, 20.810937627627595],
          [172.4324324324324, 20.810937627627595],
          [172.4324324324324, 50.720881767767736],
          [172.4324324324324, 51.80196408608606],
          [173.5135135135135, 51.441603313313266],
          [173.87387387387383, 51.0812425405405],
          [174.59459459459458, 50.720881767767736],
          [175.31531531531527, 50.54070138138135],
          [175.67567567567568, 50.18034060860856],
          [176.75675675675672, 49.63979944944941],
          [177.47747747747746, 49.45961906306303],
          [177.8378378378378, 49.099258290290265],
          [180, 48.01817597197194],
          [180, -84.7747687947948],
        ],
      ],
    },
    properties: {
      objectid: 35,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+12',
      map_color6: 6,
      map_color8: 2,
      note: null,
      zone: 12,
      utc_format: 'UTC+12:00',
      time_zone: 'UTC+12:00',
      iso_8601: '2012-05-31T16:33:50+12:00',
      places: 'New Zealand',
      dst_places: 'New Zealand',
      tz_name1st: 'Pacific/Auckland',
      tz_namesum: 9,
      cartodb_id: 86,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-56.3963963963964, -63.873843973973976],
          [-56.3963963963964, -63.15312242842843],
          [-57.47747747747748, -63.15312242842843],
          [-57.47747747747748, -64.41438513313314],
          [-56.3963963963964, -64.41438513313314],
          [-56.3963963963964, -64.05402436036036],
          [-56.03603603603604, -64.41438513313314],
          [-56.75675675675676, -64.77474590590592],
          [-59.27927927927928, -64.77474590590592],
          [-59.27927927927928, -65.49546745145146],
          [-60.36036036036036, -65.31528706506506],
          [-61.08108108108108, -65.31528706506506],
          [-61.08108108108108, -65.67564783783784],
          [-60.36036036036036, -65.67564783783784],
          [-60, -66.03600861061062],
          [-60.72072072072072, -66.57654976976977],
          [-61.44144144144144, -66.57654976976977],
          [-62.16216216216216, -66.93691054254255],
          [-63.24324324324324, -67.11709092892893],
          [-64.32432432432432, -67.11709092892893],
          [-64.32432432432432, -67.83781247447448],
          [-63.96396396396396, -68.19817324724725],
          [-62.52252252252252, -68.19817324724725],
          [-62.52252252252252, -68.9188947927928],
          [-61.8018018018018, -68.9188947927928],
          [-61.08108108108108, -69.27925556556556],
          [-61.08108108108108, -69.63961633833834],
          [-60.36036036036036, -69.81979672472474],
          [-61.44144144144144, -70.36033788388389],
          [-60, -70.36033788388389],
          [-60, -71.26123981581583],
          [-59.63963963963964, -71.98196136136137],
          [-59.63963963963964, -72.70268290690692],
          [-59.27927927927928, -73.42340445245246],
          [-60, -73.60358483883884],
          [-60, -74.50448677077077],
          [-61.08108108108108, -74.68466715715716],
          [-61.08108108108108, -75.04502792992993],
          [-57.47747747747748, -75.94592986186187],
          [-56.75675675675676, -75.94592986186187],
          [-52.432432432432435, -77.02701218018018],
          [-67.56756756756758, -90],
          [-67.56756756756758, -68.55853402002003],
          [-66.12612612612614, -68.55853402002003],
          [-66.12612612612614, -66.57654976976977],
          [-67.56756756756758, -66.57654976976977],
          [-67.56756756756758, -66.03600861061062],
          [-66.4864864864865, -65.49546745145146],
          [-66.4864864864865, -65.31528706506506],
          [-65.04504504504506, -65.31528706506506],
          [-64.6846846846847, -64.9549262922923],
          [-64.6846846846847, -64.41438513313314],
          [-63.96396396396396, -64.05402436036036],
          [-62.88288288288288, -64.05402436036036],
          [-62.16216216216216, -63.693663587587594],
          [-63.24324324324324, -63.15312242842843],
          [-63.24324324324324, -62.97294204204205],
          [-62.52252252252252, -62.61258126926928],
          [-61.8018018018018, -62.61258126926928],
          [-61.08108108108108, -62.252220496496506],
          [-60, -62.252220496496506],
          [-59.27927927927928, -61.89185972372373],
          [-58.55855855855856, -61.711679337337344],
          [-57.47747747747748, -61.711679337337344],
          [-57.11711711711712, -61.89185972372373],
          [-57.11711711711712, -62.252220496496506],
          [-57.83783783783784, -62.43240088288289],
          [-58.55855855855856, -62.43240088288289],
          [-59.27927927927928, -62.61258126926928],
          [-60, -62.97294204204205],
          [-60, -63.15312242842843],
          [-61.08108108108108, -63.15312242842843],
          [-61.44144144144144, -63.51348320120121],
          [-60.36036036036036, -63.51348320120121],
          [-60, -63.33330281481482],
          [-58.55855855855856, -63.33330281481482],
          [-56.75675675675676, -62.79276165565567],
          [-55.67567567567568, -62.79276165565567],
          [-54.5945945945946, -63.15312242842843],
          [-54.5945945945946, -63.51348320120121],
          [-55.31531531531532, -63.51348320120121],
          [-55.67567567567568, -63.873843973973976],
          [-56.3963963963964, -63.873843973973976],
        ],
        [
          [-58.55855855855856, -62.43240088288289],
          [-58.1981981981982, -62.43240088288289],
          [-58.1981981981982, -61.89185972372373],
          [-58.55855855855856, -61.89185972372373],
          [-58.55855855855856, -62.43240088288289],
        ],
      ],
    },
    properties: {
      objectid: 10,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-4',
      map_color6: 4,
      map_color8: 4,
      note: null,
      zone: -4,
      utc_format: 'UTC-04:00',
      time_zone: 'UTC-04:00',
      iso_8601: '2012-05-31T00:33:50-04:00',
      places: "Palmer, Escudero, Great Wall, Gen. Bernado O'Higgins Stations",
      dst_places:
        "Falkland Islands, Palmer Station, Capitan Arturo Prat Station, Escudero Base, Gen. Bernado O'Higgons Station,",
      tz_name1st: 'Antarctica/Palmer',
      tz_namesum: 1,
      cartodb_id: 93,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-68.2882882882883, -66.57654976976977],
          [-66.12612612612614, -66.57654976976977],
          [-66.12612612612614, -68.55853402002003],
          [-67.56756756756758, -68.55853402002003],
          [-67.56756756756758, -68.19817324724725],
          [-69.00900900900902, -68.01799286086087],
          [-69.72972972972974, -67.65763208808809],
          [-69.72972972972974, -67.29727131531533],
          [-68.2882882882883, -66.57654976976977],
        ],
      ],
    },
    properties: {
      objectid: 0,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-3',
      map_color6: 3,
      map_color8: 6,
      note: null,
      zone: -3,
      utc_format: 'UTC-03:00',
      time_zone: 'UTC-03:00',
      iso_8601: '2012-05-30T16:33:50-03:00',
      places: 'Rothera, San Mart�n Stations',
      dst_places: null,
      tz_name1st: null,
      tz_namesum: 0,
      cartodb_id: 117,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [125.58558558558559, -75.94592986186187],
          [121.62162162162161, -75.94592986186187],
          [121.62162162162161, -73.78376522522524],
          [125.58558558558559, -73.78376522522524],
          [125.58558558558559, -75.94592986186187],
        ],
      ],
    },
    properties: {
      objectid: 0,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+10',
      map_color6: 2,
      map_color8: 5,
      note: null,
      zone: 10,
      utc_format: 'UTC+10:00',
      time_zone: 'UTC+10:00',
      iso_8601: '2012-05-30T18:33:50+10:00',
      places: 'Concordia Research Station',
      dst_places: null,
      tz_name1st: 'Antarctica/DumontDUrville',
      tz_namesum: 1,
      cartodb_id: 112,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [180, 59.54972070070065],
          [180, 48.01817597197194],
          [177.8378378378378, 49.099258290290265],
          [177.47747747747746, 49.45961906306303],
          [176.75675675675672, 49.63979944944941],
          [175.67567567567568, 50.18034060860856],
          [175.31531531531527, 50.54070138138135],
          [174.59459459459458, 50.720881767767736],
          [173.87387387387383, 51.0812425405405],
          [173.5135135135135, 51.441603313313266],
          [172.4324324324324, 51.80196408608606],
          [169.9099099099099, 53.063226790790765],
          [170.99099099099095, 53.60376794994991],
          [170.99099099099095, 53.783948336336294],
          [172.07207207207205, 54.32448949549547],
          [172.07207207207205, 54.50466988188185],
          [172.7927927927928, 54.86503065465462],
          [173.15315315315314, 55.22539142742738],
          [173.87387387387383, 55.58575220020015],
          [173.87387387387383, 55.76593258658656],
          [175.31531531531527, 56.48665413213209],
          [175.67567567567568, 56.84701490490485],
          [176.39639639639637, 57.207375677677646],
          [176.39639639639637, 57.38755606406403],
          [178.19819819819816, 58.28845799599597],
          [178.19819819819816, 58.46863838238235],
          [178.9189189189189, 58.82899915515512],
          [179.27927927927925, 59.18935992792788],
          [180, 59.54972070070065],
        ],
      ],
    },
    properties: {
      objectid: 2,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-10',
      map_color6: 4,
      map_color8: 4,
      note: null,
      zone: -10,
      utc_format: 'UTC-10:00',
      time_zone: 'UTC-10:00',
      iso_8601: '2012-05-30T18:33:50-10:00',
      places: 'United States (Aleutian Islands)',
      dst_places: 'United States (Aleutian Islands)',
      tz_name1st: null,
      tz_namesum: 0,
      cartodb_id: 2,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-157.65765765765767, 71.26144581581576],
          [-157.65765765765767, 74.8650535435435],
          [-157.65765765765767, 90.00020599999996],
          [-142.52252252252254, 90.00020599999996],
          [-142.52252252252254, 70.36054388388385],
          [-147.2072072072072, 70.36054388388385],
          [-148.64864864864865, 70.72090465665661],
          [-151.53153153153153, 70.72090465665661],
          [-151.8918918918919, 71.08126542942938],
          [-154.05405405405406, 71.08126542942938],
          [-155.85585585585585, 71.62180658858856],
          [-156.93693693693695, 71.62180658858856],
          [-157.65765765765767, 71.26144581581576],
        ],
      ],
    },
    properties: {
      objectid: 2,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-10',
      map_color6: 4,
      map_color8: 4,
      note: null,
      zone: -10,
      utc_format: 'UTC-10:00',
      time_zone: 'UTC-10:00',
      iso_8601: '2012-05-30T18:33:50-10:00',
      places: 'Arctic Ocean',
      dst_places: null,
      tz_name1st: null,
      tz_namesum: 0,
      cartodb_id: 1,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-22.522522522522536, 90.00020599999996],
          [-22.522522522522536, 82.97317093093088],
          [-24.324324324324323, 83.51371209009005],
          [-30.090090090090087, 83.87407286286282],
          [-35.495495495495504, 83.87407286286282],
          [-37.657657657657666, 83.69389247647644],
          [-22.522522522522536, 90.00020599999996],
        ],
      ],
    },
    properties: {
      objectid: 13,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-2',
      map_color6: 2,
      map_color8: 7,
      note: null,
      zone: -2,
      utc_format: 'UTC-02:00',
      time_zone: 'UTC-02:00',
      iso_8601: '2012-05-31T02:33:50-02:00',
      places: 'Arctic Ocean',
      dst_places: null,
      tz_name1st: null,
      tz_namesum: 0,
      cartodb_id: 18,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [22.882882882882882, 54.32448949549547],
          [20.72072072072072, 54.32448949549547],
          [20.360360360360346, 54.50466988188185],
          [19.639639639639626, 54.50466988188185],
          [19.27927927927928, 54.684850268268235],
          [19.639639639639626, 54.684850268268235],
          [19.639639639639626, 55.22539142742738],
          [21.801801801801787, 55.22539142742738],
          [22.882882882882882, 54.86503065465462],
          [22.882882882882882, 54.32448949549547],
        ],
      ],
    },
    properties: {
      objectid: 0,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+3',
      map_color6: 3,
      map_color8: 4,
      note: null,
      zone: 3,
      utc_format: 'UTC+03:00',
      time_zone: 'UTC+03:00',
      iso_8601: '2012-05-31T07:33:50+03:00',
      places: 'Russia (Kaliningrad Oblast)',
      dst_places: null,
      tz_name1st: 'Europe/Kaliningrad',
      tz_namesum: 1,
      cartodb_id: 64,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-168.82882882882882, 68.01819886086082],
          [-169.54954954954954, 68.1983792472472],
          [-169.54954954954954, 68.55874002001997],
          [-170.63063063063063, 69.09928117917914],
          [-170.99099099099098, 69.45964195195191],
          [-171.7117117117117, 70.00018311111106],
          [-172.43243243243242, 70.54072427027023],
          [-172.43243243243242, 74.8650535435435],
          [-172.43243243243242, 90.00020599999996],
          [-157.65765765765767, 90.00020599999996],
          [-157.65765765765767, 74.8650535435435],
          [-157.65765765765767, 71.26144581581576],
          [-158.018018018018, 71.08126542942938],
          [-159.81981981981983, 71.08126542942938],
          [-161.26126126126127, 70.54072427027023],
          [-162.34234234234233, 70.54072427027023],
          [-163.06306306306305, 70.18036349749747],
          [-163.78378378378378, 69.45964195195191],
          [-164.5045045045045, 69.09928117917914],
          [-166.66666666666666, 69.09928117917914],
          [-168.82882882882882, 68.01819886086082],
        ],
      ],
    },
    properties: {
      objectid: 1,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-11',
      map_color6: 5,
      map_color8: 3,
      note: null,
      zone: -11,
      utc_format: 'UTC-11:00',
      time_zone: 'UTC-11:00',
      iso_8601: '2012-05-30T17:33:50-11:00',
      places: 'Arctic Ocean',
      dst_places: null,
      tz_name1st: null,
      tz_namesum: 0,
      cartodb_id: 3,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [70.09009009009009, 82.07226899899896],
          [67.56756756756755, 82.07226899899896],
          [67.56756756756755, 90.00020599999996],
          [82.70270270270271, 90.00020599999996],
          [82.70270270270271, 82.07226899899896],
          [75.13513513513513, 82.07226899899896],
          [70.09009009009009, 82.07226899899896],
        ],
      ],
    },
    properties: {
      objectid: 22,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+5',
      map_color6: 1,
      map_color8: 7,
      note: null,
      zone: 5,
      utc_format: 'UTC+05:00',
      time_zone: 'UTC+05:00',
      iso_8601: '2012-05-31T09:33:50+05:00',
      places: 'Arctic Ocean',
      dst_places: null,
      tz_name1st: null,
      tz_namesum: 0,
      cartodb_id: 62,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-56.3963963963964, 47.297454426426384],
          [-56.03603603603604, 47.11727404004],
          [-56.03603603603604, 46.75691326726724],
          [-56.03603603603604, 46.576732880880854],
          [-56.03603603603604, 46.21637210810806],
          [-56.75675675675676, 46.576732880880854],
          [-57.11711711711712, 46.93709365365362],
          [-56.3963963963964, 47.297454426426384],
        ],
      ],
    },
    properties: {
      objectid: 12,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-3',
      map_color6: 3,
      map_color8: 6,
      note: null,
      zone: -3,
      utc_format: 'UTC-03:00',
      time_zone: 'UTC-03:00',
      iso_8601: '2012-05-31T01:33:50-03:00',
      places: 'St. Pierre et Miquelon',
      dst_places: null,
      tz_name1st: 'America/Miquelon',
      tz_namesum: 1,
      cartodb_id: 83,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-172.43243243243242, 15.045165263263229],
          [-157.65765765765767, 15.045165263263229],
          [-157.65765765765767, 5.49560478478476],
          [-157.65765765765767, 4.955063625625598],
          [-160.54054054054055, 4.955063625625598],
          [-160.54054054054055, 4.054161693693672],
          [-160.54054054054055, 1.5316362842842608],
          [-160.18018018018017, 1.1712755115114817],
          [-159.81981981981983, 0.9910951251250992],
          [-159.45945945945945, 0.6307343523523343],
          [-159.0990990990991, 0.45055396596593766],
          [-159.0990990990991, 0.09019319319317276],
          [-158.3783783783784, -0.27016757957960635],
          [-158.3783783783784, -2.4323322162162384],
          [-172.43243243243242, -2.4323322162162384],
          [-172.43243243243242, -0.9908891251251504],
          [-172.43243243243242, 15.045165263263229],
        ],
      ],
    },
    properties: {
      objectid: 1,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-11',
      map_color6: 5,
      map_color8: 3,
      note: null,
      zone: -11,
      utc_format: 'UTC-11:00',
      time_zone: 'UTC-11:00',
      iso_8601: '2012-05-30T17:33:50-11:00',
      places: 'American Samoa, Niue',
      dst_places: null,
      tz_name1st: null,
      tz_namesum: 0,
      cartodb_id: 4,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [128.82882882882882, -31.261194038038056],
          [128.82882882882882, -31.621554810810828],
          [128.82882882882882, -31.80173519719721],
          [128.82882882882882, -31.9819155835836],
          [128.46846846846847, -32.16209596996998],
          [128.10810810810807, -32.16209596996998],
          [127.74774774774772, -32.34227635635637],
          [127.38738738738738, -32.34227635635637],
          [127.38738738738738, -31.80173519719721],
          [127.74774774774772, -31.621554810810828],
          [128.10810810810807, -31.621554810810828],
          [128.82882882882882, -31.261194038038056],
        ],
      ],
    },
    properties: {
      objectid: 0,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+8.75',
      map_color6: 2,
      map_color8: 2,
      note: null,
      zone: 8.75,
      utc_format: 'UTC+08:45',
      time_zone: 'UTC+08:45',
      iso_8601: '2012-05-31T09:33:50+08:45',
      places: 'Australia (Eucla)',
      dst_places: null,
      tz_name1st: 'Australia/Eucla',
      tz_namesum: 0,
      cartodb_id: 70,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [127.38738738738738, 90.00020599999996],
          [142.52252252252248, 90.00020599999996],
          [142.52252252252248, 79.91010436236232],
          [127.38738738738738, 79.91010436236232],
          [127.38738738738738, 84.95515518118114],
          [127.38738738738738, 90.00020599999996],
        ],
      ],
    },
    properties: {
      objectid: 29,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+9',
      map_color6: 3,
      map_color8: 3,
      note: null,
      zone: 9,
      utc_format: 'UTC+09:00',
      time_zone: 'UTC+09:00',
      iso_8601: '2012-05-31T13:33:50+09:00',
      places: 'Arctic Ocean',
      dst_places: null,
      tz_name1st: null,
      tz_namesum: 0,
      cartodb_id: 53,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-172.43243243243242, 48.01817597197194],
          [-157.65765765765767, 48.01817597197194],
          [-157.65765765765767, 30.0001373333333],
          [-176.3963963963964, 30.0001373333333],
          [-176.3963963963964, 27.657792310310285],
          [-178.19819819819818, 27.657792310310285],
          [-178.19819819819818, 30.0001373333333],
          [-180, 30.0001373333333],
          [-180, 35.04518815215212],
          [-173.87387387387386, 35.04518815215212],
          [-172.43243243243242, 35.04518815215212],
          [-172.43243243243242, 40.270419357357326],
          [-172.43243243243242, 41.711862448448414],
          [-172.43243243243242, 42.79294476676674],
          [-172.43243243243242, 43.1533055395395],
          [-172.43243243243242, 44.234387857857826],
          [-172.43243243243242, 45.675830948948914],
          [-172.43243243243242, 46.576732880880854],
          [-172.43243243243242, 48.01817597197194],
        ],
      ],
    },
    properties: {
      objectid: 1,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-11',
      map_color6: 5,
      map_color8: 3,
      note: null,
      zone: -11,
      utc_format: 'UTC-11:00',
      time_zone: 'UTC-11:00',
      iso_8601: '2012-05-30T17:33:50-11:00',
      places: 'American Samoa, Niue',
      dst_places: null,
      tz_name1st: 'Pacific/Midway',
      tz_namesum: 1,
      cartodb_id: 5,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-177.47747747747746, -44.954903403403414],
          [-177.47747747747746, -42.972919153153164],
          [-174.95495495495496, -42.972919153153164],
          [-174.95495495495496, -44.954903403403414],
          [-177.47747747747746, -44.954903403403414],
        ],
      ],
    },
    properties: {
      objectid: 36,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+12.75',
      map_color6: 2,
      map_color8: 1,
      note: null,
      zone: 12.75,
      utc_format: 'UTC+12:45',
      time_zone: 'UTC+12:45',
      iso_8601: '2012-05-31T17:18:50+12:45',
      places: 'Chatham Islands',
      dst_places: 'Chatham Islands',
      tz_name1st: 'Pacific/Chatham',
      tz_namesum: 1,
      cartodb_id: 51,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [92.43243243243239, 21.89201994594592],
          [92.43243243243239, 20.09021608208205],
          [92.7927927927928, 19.91003569569567],
          [92.7927927927928, 19.54967492292289],
          [93.15315315315314, 19.54967492292289],
          [93.15315315315314, 18.648772990990963],
          [93.51351351351349, 18.648772990990963],
          [94.23423423423424, 18.288412218218184],
          [94.23423423423424, 16.666788740740714],
          [93.87387387387383, 16.48660835435433],
          [93.87387387387383, 15.94606719519517],
          [94.23423423423424, 15.58570642242239],
          [95.67567567567568, 15.58570642242239],
          [96.03603603603602, 15.94606719519517],
          [96.03603603603602, 16.126247581581552],
          [97.11711711711712, 16.666788740740714],
          [97.11711711711712, 16.126247581581552],
          [97.47747747747746, 16.126247581581552],
          [97.47747747747746, 11.98209869469467],
          [97.47747747747746, 9.639753671671642],
          [97.47747747747746, 5.49560478478476],
          [96.03603603603602, 5.49560478478476],
          [96.03603603603602, 5.6757851711711425],
          [95.31531531531527, 6.036145943943922],
          [94.95495495495493, 6.036145943943922],
          [94.95495495495493, 4.955063625625598],
          [95.31531531531527, 4.5947028528528335],
          [95.67567567567568, 4.414522466466437],
          [96.03603603603602, 4.054161693693672],
          [96.03603603603602, 3.8739813073072753],
          [96.75675675675677, 3.5136205345345104],
          [96.75675675675677, 3.333440148148128],
          [97.11711711711712, 3.1532597617617313],
          [97.11711711711712, 2.7928989889889664],
          [97.47747747747746, 2.612718602602584],
          [97.47747747747746, 2.4325382162161873],
          [96.75675675675677, 2.4325382162161873],
          [96.39639639639637, 2.612718602602584],
          [96.39639639639637, 2.973079375375349],
          [96.03603603603602, 3.1532597617617313],
          [95.31531531531527, 2.7928989889889664],
          [96.03603603603602, 2.4325382162161873],
          [96.03603603603602, 2.252357829829805],
          [96.75675675675677, 1.8919970570570257],
          [96.75675675675677, 1.3514558978978783],
          [97.11711711711712, 1.1712755115114817],
          [97.11711711711712, 0.6307343523523343],
          [97.47747747747746, 0.6307343523523343],
          [97.47747747747746, -11.261171149149177],
          [96.03603603603602, -11.261171149149177],
          [96.03603603603602, -12.882794626626648],
          [97.47747747747746, -12.882794626626648],
          [97.47747747747746, -66.216188996997],
          [97.11711711711712, -65.85582822422423],
          [96.03603603603602, -65.85582822422423],
          [96.03603603603602, -66.39636938338339],
          [90.99099099099095, -66.39636938338339],
          [90.6306306306306, -66.57654976976977],
          [85.58558558558559, -66.57654976976977],
          [84.86486486486484, -66.39636938338339],
          [84.5045045045045, -66.75673015615617],
          [82.3423423423423, -67.47745170170171],
          [82.3423423423423, 16.48660835435433],
          [82.70270270270271, 16.48660835435433],
          [82.70270270270271, 17.207329899899875],
          [83.06306306306305, 17.207329899899875],
          [83.4234234234234, 17.387510286286258],
          [83.78378378378375, 17.747871059059037],
          [83.78378378378375, 17.92805144544542],
          [84.5045045045045, 18.288412218218184],
          [84.5045045045045, 18.46859260460458],
          [84.86486486486484, 18.828953377377346],
          [84.86486486486484, 19.009133763763728],
          [86.66666666666663, 19.91003569569567],
          [87.02702702702703, 20.270396468468434],
          [87.02702702702703, 21.171298400400374],
          [87.74774774774772, 21.53165917317314],
          [88.10810810810807, 21.351478786786757],
          [89.18918918918916, 21.351478786786757],
          [89.18918918918916, 22.252380718718683],
          [88.82882882882882, 22.252380718718683],
          [88.82882882882882, 23.51364342342339],
          [88.46846846846847, 23.51364342342339],
          [88.46846846846847, 23.874004196196168],
          [88.82882882882882, 23.874004196196168],
          [88.82882882882882, 24.234364968968933],
          [88.46846846846847, 24.41454535535533],
          [88.10810810810807, 24.41454535535533],
          [88.10810810810807, 24.955086514514477],
          [88.46846846846847, 25.135266900900874],
          [88.82882882882882, 25.135266900900874],
          [88.82882882882882, 25.49562767367364],
          [88.10810810810807, 25.855988446446418],
          [88.10810810810807, 26.216349219219182],
          [88.46846846846847, 26.39652960560558],
          [89.18918918918916, 26.39652960560558],
          [89.18918918918916, 26.0361688328328],
          [89.90990990990991, 26.0361688328328],
          [89.90990990990991, 25.315447287287256],
          [90.27027027027026, 25.135266900900874],
          [92.43243243243239, 25.135266900900874],
          [92.07207207207205, 24.955086514514477],
          [92.07207207207205, 24.234364968968933],
          [91.7117117117117, 24.234364968968933],
          [91.35135135135135, 24.05418458258255],
          [91.35135135135135, 22.973102264264227],
          [91.7117117117117, 22.973102264264227],
          [91.7117117117117, 23.51364342342339],
          [92.07207207207205, 23.693823809809786],
          [92.43243243243239, 23.693823809809786],
          [92.43243243243239, 21.89201994594592],
        ],
        [
          [92.7927927927928, 4.234342080080054],
          [93.15315315315314, 4.5947028528528335],
          [93.15315315315314, 4.955063625625598],
          [94.23423423423424, 6.036145943943922],
          [94.23423423423424, 6.216326330330304],
          [94.59459459459458, 6.3965067167166865],
          [94.59459459459458, 13.783902558558538],
          [93.87387387387383, 13.783902558558538],
          [93.15315315315314, 13.783902558558538],
          [92.7927927927928, 14.144263331331302],
          [92.07207207207205, 14.504624104104082],
          [92.07207207207205, 4.054161693693672],
          [92.43243243243239, 4.054161693693672],
          [92.7927927927928, 4.234342080080054],
        ],
      ],
    },
    properties: {
      objectid: 25,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+6',
      map_color6: 6,
      map_color8: 8,
      note: null,
      zone: 6,
      utc_format: 'UTC+06:00',
      time_zone: 'UTC+06:00',
      iso_8601: '2012-05-31T10:33:50+06:00',
      places: 'Bangladesh',
      dst_places: null,
      tz_name1st: 'Asia/Dhaka',
      tz_namesum: 1,
      cartodb_id: 52,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-127.38738738738739, 70.72090465665661],
          [-127.74774774774775, 70.72090465665661],
          [-128.46846846846847, 70.901085043043],
          [-129.9099099099099, 70.36054388388385],
          [-131.35135135135135, 70.36054388388385],
          [-132.7927927927928, 69.82000272472467],
          [-136.03603603603602, 69.82000272472467],
          [-136.3963963963964, 69.27946156556553],
          [-137.83783783783784, 69.27946156556553],
          [-138.55855855855856, 69.82000272472467],
          [-141.0810810810811, 69.82000272472467],
          [-141.0810810810811, 60.270442246246205],
          [-139.27927927927928, 60.270442246246205],
          [-139.27927927927928, 60.09026185985982],
          [-137.47747747747746, 59.18935992792788],
          [-136.3963963963964, 59.18935992792788],
          [-136.3963963963964, 59.54972070070065],
          [-136.03603603603602, 59.72990108708706],
          [-135.31531531531533, 59.72990108708706],
          [-134.95495495495496, 59.54972070070065],
          [-134.95495495495496, 59.18935992792788],
          [-133.15315315315314, 58.28845799599597],
          [-132.43243243243245, 57.56773645045041],
          [-132.43243243243245, 57.027195291291264],
          [-130.63063063063063, 56.12629335935932],
          [-129.9099099099099, 56.12629335935932],
          [-129.9099099099099, 55.405571813813765],
          [-130.27027027027026, 55.22539142742738],
          [-130.27027027027026, 54.86503065465462],
          [-130.63063063063063, 54.684850268268235],
          [-131.35135135135135, 54.684850268268235],
          [-132.07207207207207, 54.32448949549547],
          [-133.51351351351352, 54.32448949549547],
          [-133.51351351351352, 53.60376794994991],
          [-132.43243243243245, 52.52268563163159],
          [-131.35135135135135, 51.98214447247244],
          [-130.63063063063063, 51.80196408608606],
          [-130.63063063063063, 52.342505245245206],
          [-131.35135135135135, 52.883046404404354],
          [-131.35135135135135, 53.24340717717715],
          [-131.7117117117117, 53.42358756356353],
          [-130.990990990991, 54.14430910910906],
          [-130.990990990991, 53.42358756356353],
          [-129.54954954954957, 52.70286601801797],
          [-129.54954954954957, 52.52268563163159],
          [-128.46846846846847, 51.98214447247244],
          [-128.46846846846847, 51.26142292692688],
          [-128.82882882882882, 50.90106215415412],
          [-128.82882882882882, 50.54070138138135],
          [-127.38738738738739, 49.819979835835795],
          [-127.38738738738739, -22.071994332332352],
          [-133.15315315315314, -22.071994332332352],
          [-133.15315315315314, -21.53145317317319],
          [-133.51351351351352, -21.171092400400426],
          [-133.51351351351352, -20.630551241241264],
          [-133.8738738738739, -20.270190468468485],
          [-133.8738738738739, -19.729649309309323],
          [-134.23423423423424, -19.36928853653656],
          [-134.23423423423424, -18.828747377377397],
          [-134.59459459459458, -18.468386604604618],
          [-134.95495495495496, -17.92784544544547],
          [-134.95495495495496, -17.56748467267269],
          [-135.31531531531533, -17.02694351351353],
          [-135.31531531531533, -16.666582740740765],
          [-135.67567567567568, -16.126041581581603],
          [-135.67567567567568, -15.765680808808824],
          [-136.03603603603602, -15.225139649649677],
          [-136.03603603603602, -14.864778876876898],
          [-136.3963963963964, -14.324237717717736],
          [-136.75675675675677, -13.963876944944971],
          [-136.75675675675677, -13.42333578578581],
          [-137.11711711711712, -13.06297501301303],
          [-137.11711711711712, -9.999908444444472],
          [-137.11711711711712, -6.035939943943973],
          [-142.52252252252254, -6.035939943943973],
          [-142.52252252252254, 59.91008147347344],
          [-142.88288288288288, 59.72990108708706],
          [-143.6036036036036, 59.72990108708706],
          [-143.96396396396398, 59.54972070070065],
          [-144.68468468468467, 59.54972070070065],
          [-145.76576576576576, 59.369540314314264],
          [-146.48648648648648, 59.0091795415415],
          [-147.2072072072072, 58.82899915515512],
          [-147.92792792792793, 58.46863838238235],
          [-148.64864864864865, 58.28845799599597],
          [-149.72972972972974, 57.747916836836794],
          [-150.45045045045046, 57.56773645045041],
          [-151.17117117117118, 57.207375677677646],
          [-151.8918918918919, 57.027195291291264],
          [-152.61261261261262, 56.66683451851847],
          [-153.33333333333334, 56.48665413213209],
          [-154.4144144144144, 55.94611297297294],
          [-155.13513513513513, 55.76593258658656],
          [-155.85585585585585, 55.405571813813765],
          [-156.93693693693695, 55.22539142742738],
          [-158.018018018018, 54.86503065465462],
          [-158.73873873873873, 54.86503065465462],
          [-159.45945945945945, 54.50466988188185],
          [-159.81981981981983, 54.50466988188185],
          [-161.26126126126127, 54.14430910910906],
          [-161.981981981982, 54.14430910910906],
          [-165.5855855855856, 53.24340717717715],
          [-166.3063063063063, 53.24340717717715],
          [-168.46846846846847, 52.70286601801797],
          [-169.1891891891892, 52.70286601801797],
          [-169.1891891891892, 53.96412872272268],
          [-170.27027027027026, 55.045211041041],
          [-170.63063063063063, 55.58575220020015],
          [-170.63063063063063, 55.94611297297294],
          [-172.43243243243242, 57.747916836836794],
          [-172.43243243243242, 58.10827760960956],
          [-173.87387387387386, 59.54972070070065],
          [-173.87387387387386, 62.25242649649647],
          [-173.87387387387386, 62.973148042042],
          [-173.51351351351352, 63.15332842842838],
          [-173.15315315315314, 63.513689201201146],
          [-172.43243243243242, 63.69386958758756],
          [-171.7117117117117, 64.05423036036032],
          [-170.99099099099098, 64.41459113313309],
          [-170.63063063063063, 64.77495190590585],
          [-169.54954954954954, 65.31549306506503],
          [-168.82882882882882, 65.49567345145141],
          [-168.82882882882882, 68.01819886086082],
          [-166.66666666666666, 69.09928117917914],
          [-164.5045045045045, 69.09928117917914],
          [-163.78378378378378, 69.45964195195191],
          [-163.06306306306305, 70.18036349749747],
          [-162.34234234234233, 70.54072427027023],
          [-161.26126126126127, 70.54072427027023],
          [-159.81981981981983, 71.08126542942938],
          [-158.018018018018, 71.08126542942938],
          [-157.65765765765767, 71.26144581581576],
          [-156.93693693693695, 71.62180658858856],
          [-155.85585585585585, 71.62180658858856],
          [-154.05405405405406, 71.08126542942938],
          [-151.8918918918919, 71.08126542942938],
          [-151.53153153153153, 70.72090465665661],
          [-148.64864864864865, 70.72090465665661],
          [-147.2072072072072, 70.36054388388385],
          [-142.52252252252254, 70.36054388388385],
          [-142.52252252252254, 90.00020599999996],
          [-127.38738738738739, 90.00020599999996],
          [-127.38738738738739, 70.72090465665661],
        ],
      ],
    },
    properties: {
      objectid: 4,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-9',
      map_color6: 3,
      map_color8: 5,
      note: null,
      zone: -9,
      utc_format: 'UTC-09:00',
      time_zone: 'UTC-09:00',
      iso_8601: '2012-05-30T19:33:50-09:00',
      places: 'United States (most of Alaska)',
      dst_places: 'United States (most of Alaska)',
      tz_name1st: 'America/Anchorage',
      tz_namesum: 4,
      cartodb_id: 79,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-168.1081081081081, -8.017924194194222],
          [-168.1081081081081, -10.720629989990016],
          [-168.1081081081081, -13.06297501301303],
          [-167.02702702702703, -13.06297501301303],
          [-167.02702702702703, -22.071994332332352],
          [-163.06306306306305, -22.071994332332352],
          [-163.06306306306305, -24.954880514514528],
          [-157.65765765765767, -24.954880514514528],
          [-157.65765765765767, -76.8468317937938],
          [-159.0990990990991, -77.02701218018018],
          [-159.0990990990991, -77.56755333933934],
          [-159.81981981981983, -78.1080944984985],
          [-163.78378378378378, -78.64863565765766],
          [-166.3063063063063, -78.64863565765766],
          [-166.66666666666666, -78.46845527127127],
          [-172.07207207207207, -78.46845527127127],
          [-172.43243243243242, -78.28827488488488],
          [-172.43243243243242, -49.999954222222236],
          [-172.43243243243242, -44.954903403403414],
          [-172.43243243243242, -34.14408022022023],
          [-172.43243243243242, -33.243178288288306],
          [-172.43243243243242, -32.34227635635637],
          [-172.43243243243242, -30.900833265265284],
          [-172.43243243243242, -28.738668628628645],
          [-172.43243243243242, -28.0179470830831],
          [-172.43243243243242, -26.03596283283285],
          [-172.43243243243242, -22.432355105105117],
          [-172.43243243243242, -21.53145317317319],
          [-172.43243243243242, -20.270190468468485],
          [-172.43243243243242, -15.04495926326328],
          [-172.07207207207207, -14.864778876876898],
          [-171.7117117117117, -14.504418104104118],
          [-171.35135135135135, -14.504418104104118],
          [-170.99099099099098, -13.963876944944971],
          [-170.99099099099098, -12.522433853853869],
          [-171.35135135135135, -11.981892694694722],
          [-171.35135135135135, -11.44135153553556],
          [-171.35135135135135, -11.08099076276278],
          [-171.35135135135135, -10.360269217217237],
          [-170.99099099099098, -9.999908444444472],
          [-170.99099099099098, -9.45936728528531],
          [-170.99099099099098, -9.099006512512531],
          [-170.63063063063063, -8.918826126126149],
          [-170.63063063063063, -8.378284966966987],
          [-170.27027027027026, -8.017924194194222],
          [-170.27027027027026, -7.477383035035061],
          [-169.9099099099099, -6.936841875875899],
          [-169.54954954954954, -6.57648110310312],
          [-169.54954954954954, -5.855759557557576],
          [-168.1081081081081, -5.855759557557576],
          [-168.1081081081081, -8.017924194194222],
        ],
      ],
    },
    properties: {
      objectid: 1,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-11',
      map_color6: 5,
      map_color8: 3,
      note: null,
      zone: -11,
      utc_format: 'UTC-11:00',
      time_zone: 'UTC-11:00',
      iso_8601: '2012-05-30T17:33:50-11:00',
      places: 'American Samoa, Niue',
      dst_places: null,
      tz_name1st: 'Pacific/Pago_Pago',
      tz_namesum: 2,
      cartodb_id: 6,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-172.43243243243242, -78.28827488488488],
          [-176.75675675675674, -78.28827488488488],
          [-177.11711711711712, -78.1080944984985],
          [-178.9189189189189, -78.1080944984985],
          [-180, -77.92791411211212],
          [-180, -50.90085615415416],
          [-178.55855855855856, -49.819773835835846],
          [-178.19819819819818, -49.639593449449464],
          [-177.47747747747746, -48.91887190390391],
          [-177.11711711711712, -48.73869151751753],
          [-176.03603603603602, -47.65760919919921],
          [-175.3153153153153, -47.11706804004005],
          [-174.23423423423424, -46.57652688088089],
          [-173.51351351351352, -45.85580533533535],
          [-172.7927927927928, -45.315264176176186],
          [-172.43243243243242, -44.954903403403414],
          [-172.43243243243242, -49.999954222222236],
          [-172.43243243243242, -78.28827488488488],
        ],
      ],
    },
    properties: {
      objectid: 0,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-12',
      map_color6: 1,
      map_color8: 8,
      note: null,
      zone: -12,
      utc_format: 'UTC-12:00',
      time_zone: 'UTC-12:00',
      iso_8601: '2012-05-30T16:33:50-12:00',
      places: 'Southern Ocean',
      dst_places: null,
      tz_name1st: null,
      tz_namesum: 0,
      cartodb_id: 8,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-172.43243243243242, 70.54072427027023],
          [-173.51351351351352, 71.08126542942938],
          [-173.51351351351352, 71.26144581581576],
          [-174.95495495495496, 71.98216736136132],
          [-174.95495495495496, 72.1623477477477],
          [-176.3963963963964, 72.88306929329326],
          [-176.3963963963964, 73.06324967967964],
          [-178.19819819819818, 73.96415161161156],
          [-178.19819819819818, 74.14433199799797],
          [-180, 75.04523392992988],
          [-172.43243243243242, 90.00020599999996],
          [-172.43243243243242, 74.8650535435435],
          [-172.43243243243242, 70.54072427027023],
        ],
      ],
    },
    properties: {
      objectid: 0,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-12',
      map_color6: 1,
      map_color8: 8,
      note: null,
      zone: -12,
      utc_format: 'UTC-12:00',
      time_zone: 'UTC-12:00',
      iso_8601: '2012-05-30T16:33:50-12:00',
      places: 'Siberia',
      dst_places: null,
      tz_name1st: null,
      tz_namesum: 0,
      cartodb_id: 9,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-139.63963963963965, -13.06297501301303],
          [-142.52252252252254, -13.06297501301303],
          [-142.52252252252254, -6.936841875875899],
          [-142.52252252252254, -6.035939943943973],
          [-137.11711711711712, -6.035939943943973],
          [-137.11711711711712, -9.999908444444472],
          [-137.11711711711712, -13.06297501301303],
          [-139.63963963963965, -13.06297501301303],
        ],
      ],
    },
    properties: {
      objectid: 3,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-9.5',
      map_color6: 6,
      map_color8: 6,
      note: null,
      zone: -9.5,
      utc_format: 'UTC-09:30',
      time_zone: 'UTC-09:30',
      iso_8601: '2012-05-30T19:03:50-09:30',
      places: 'Marquesas Islands',
      dst_places: null,
      tz_name1st: 'Pacific/Marquesas',
      tz_namesum: 1,
      cartodb_id: 11,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [167.02702702702703, -28.0179470830831],
          [169.5495495495495, -28.0179470830831],
          [169.5495495495495, -29.99993133333335],
          [167.02702702702703, -29.99993133333335],
          [167.02702702702703, -28.0179470830831],
        ],
      ],
    },
    properties: {
      objectid: 34,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+11.5',
      map_color6: 5,
      map_color8: 1,
      note: null,
      zone: 11.5,
      utc_format: 'UTC+11:30',
      time_zone: 'UTC+11:30',
      iso_8601: '2012-05-31T16:03:50+11:30',
      places: 'Norfolk Island',
      dst_places: null,
      tz_name1st: 'Pacific/Norfolk',
      tz_namesum: 1,
      cartodb_id: 44,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-66.84684684684686, 1.1712755115114817],
          [-66.84684684684686, 1.7118166706706432],
          [-67.20720720720722, 1.8919970570570257],
          [-67.20720720720722, 2.612718602602584],
          [-67.56756756756758, 2.612718602602584],
          [-67.56756756756758, 4.054161693693672],
          [-67.92792792792794, 4.054161693693672],
          [-67.92792792792794, 5.49560478478476],
          [-67.56756756756758, 5.49560478478476],
          [-67.56756756756758, 6.216326330330304],
          [-69.36936936936938, 6.216326330330304],
          [-69.72972972972974, 6.3965067167166865],
          [-69.72972972972974, 6.576687103103083],
          [-70.0900900900901, 6.756867489489466],
          [-70.0900900900901, 6.937047875875848],
          [-70.45045045045046, 7.1172282622622305],
          [-70.81081081081082, 6.937047875875848],
          [-71.53153153153154, 6.937047875875848],
          [-71.53153153153154, 7.1172282622622305],
          [-72.25225225225226, 7.1172282622622305],
          [-72.25225225225226, 7.47758903503501],
          [-72.61261261261262, 7.47758903503501],
          [-72.61261261261262, 8.018130194194171],
          [-72.25225225225226, 8.018130194194171],
          [-72.25225225225226, 8.378490966966936],
          [-72.61261261261262, 8.378490966966936],
          [-72.61261261261262, 9.09921251251248],
          [-73.33333333333334, 9.45957328528526],
          [-72.97297297297298, 9.639753671671642],
          [-72.97297297297298, 10.540655603603582],
          [-72.61261261261262, 10.901016376376347],
          [-72.61261261261262, 11.08119676276273],
          [-72.25225225225226, 11.08119676276273],
          [-72.25225225225226, 11.441557535535509],
          [-71.8918918918919, 11.801918308308274],
          [-71.17117117117118, 11.801918308308274],
          [-70.81081081081082, 11.98209869469467],
          [-70.81081081081082, 12.342459467467435],
          [-69.72972972972974, 12.342459467467435],
          [-69.36936936936938, 11.98209869469467],
          [-68.64864864864866, 11.621737921921891],
          [-67.92792792792794, 11.621737921921891],
          [-67.92792792792794, 12.162279081081053],
          [-67.56756756756758, 12.342459467467435],
          [-67.20720720720722, 12.162279081081053],
          [-64.6846846846847, 12.162279081081053],
          [-63.96396396396396, 11.98209869469467],
          [-63.6036036036036, 11.98209869469467],
          [-63.24324324324324, 11.801918308308274],
          [-62.88288288288288, 11.801918308308274],
          [-62.16216216216216, 11.621737921921891],
          [-61.8018018018018, 11.261377149149126],
          [-61.8018018018018, 10.360475217217186],
          [-62.16216216216216, 10.00011444444442],
          [-61.44144144144144, 10.00011444444442],
          [-60.72072072072072, 9.639753671671642],
          [-60.72072072072072, 8.738851739739715],
          [-60, 8.738851739739715],
          [-60, 8.018130194194171],
          [-60.36036036036036, 8.018130194194171],
          [-60.72072072072072, 7.8379498078077745],
          [-60.72072072072072, 6.756867489489466],
          [-61.08108108108108, 6.756867489489466],
          [-61.08108108108108, 5.49560478478476],
          [-60.72072072072072, 5.3154243983983775],
          [-60.72072072072072, 4.774883239239216],
          [-61.08108108108108, 4.774883239239216],
          [-61.44144144144144, 4.5947028528528335],
          [-61.44144144144144, 4.234342080080054],
          [-62.52252252252252, 4.234342080080054],
          [-62.88288288288288, 4.054161693693672],
          [-62.88288288288288, 3.693800920920893],
          [-63.24324324324324, 3.693800920920893],
          [-63.24324324324324, 4.054161693693672],
          [-64.6846846846847, 4.054161693693672],
          [-64.6846846846847, 3.8739813073072753],
          [-64.32432432432432, 3.693800920920893],
          [-64.32432432432432, 2.973079375375349],
          [-63.96396396396396, 2.973079375375349],
          [-63.96396396396396, 2.4325382162161873],
          [-63.24324324324324, 2.4325382162161873],
          [-63.24324324324324, 2.0721774434434224],
          [-63.6036036036036, 2.0721774434434224],
          [-63.96396396396396, 1.8919970570570257],
          [-63.96396396396396, 1.5316362842842608],
          [-64.32432432432432, 1.5316362842842608],
          [-65.04504504504506, 1.1712755115114817],
          [-65.04504504504506, 0.9910951251250992],
          [-65.76576576576578, 0.9910951251250992],
          [-65.76576576576578, 0.8109147387387168],
          [-66.4864864864865, 0.8109147387387168],
          [-66.4864864864865, 0.9910951251250992],
          [-66.84684684684686, 1.1712755115114817],
        ],
      ],
    },
    properties: {
      objectid: 0,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-4.5',
      map_color6: 2,
      map_color8: 8,
      note: null,
      zone: -4.5,
      utc_format: 'UTC-04:30',
      time_zone: 'UTC-04:30',
      iso_8601: '2012-05-31T09:03:50-04:30',
      places: 'Venezuela',
      dst_places: null,
      tz_name1st: 'America/Caracas',
      tz_namesum: 1,
      cartodb_id: 45,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-52.432432432432435, 47.83799558558556],
          [-52.432432432432435, 47.11727404004],
          [-52.792792792792795, 46.75691326726724],
          [-52.792792792792795, 46.39655249449444],
          [-53.513513513513516, 46.39655249449444],
          [-54.95495495495496, 46.75691326726724],
          [-56.03603603603604, 46.75691326726724],
          [-56.03603603603604, 46.576732880880854],
          [-56.03603603603604, 46.75691326726724],
          [-56.03603603603604, 47.11727404004],
          [-56.3963963963964, 47.297454426426384],
          [-57.11711711711712, 47.297454426426384],
          [-57.47747747747748, 47.47763481281277],
          [-59.63963963963964, 47.47763481281277],
          [-59.63963963963964, 48.55871713113109],
          [-58.91891891891892, 48.919077903903855],
          [-58.55855855855856, 49.27943867667665],
          [-58.55855855855856, 49.63979944944941],
          [-57.83783783783784, 50.18034060860856],
          [-57.83783783783784, 50.720881767767736],
          [-57.11711711711712, 51.26142292692688],
          [-57.11711711711712, 52.883046404404354],
          [-57.47747747747748, 53.063226790790765],
          [-57.47747747747748, 53.42358756356353],
          [-56.75675675675676, 53.783948336336294],
          [-56.03603603603604, 53.96412872272268],
          [-55.31531531531532, 53.42358756356353],
          [-55.31531531531532, 52.162324858858824],
          [-55.31531531531532, 50.54070138138135],
          [-56.03603603603604, 50.36052099499497],
          [-55.31531531531532, 50.00016022222218],
          [-54.5945945945946, 49.819979835835795],
          [-53.873873873873876, 50.00016022222218],
          [-53.873873873873876, 49.63979944944941],
          [-53.153153153153156, 49.45961906306303],
          [-53.153153153153156, 48.73889751751747],
          [-52.792792792792795, 48.919077903903855],
          [-52.792792792792795, 48.198356358358325],
          [-52.432432432432435, 47.83799558558556],
        ],
      ],
    },
    properties: {
      objectid: 11,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-3.5',
      map_color6: 6,
      map_color8: 5,
      note: null,
      zone: -3.5,
      utc_format: 'UTC-03:30',
      time_zone: 'UTC-03:30',
      iso_8601: '2012-05-31T01:03:50-03:30',
      places: 'Canada (island of Newfoundland and southern Labrador)',
      dst_places: 'Canada (island of Newfoundland and southern Labrador)',
      tz_name1st: 'America/St_Johns',
      tz_namesum: 2,
      cartodb_id: 14,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-52.432432432432435, 90.00020599999996],
          [-52.432432432432435, 82.61281015815811],
          [-55.67567567567568, 82.43262977177173],
          [-58.55855855855856, 82.43262977177173],
          [-59.63963963963964, 82.25244938538535],
          [-61.8018018018018, 82.97317093093088],
          [-63.6036036036036, 83.15335131731726],
          [-67.56756756756758, 83.15335131731726],
          [-67.56756756756758, 90.00020599999996],
          [-52.432432432432435, 90.00020599999996],
        ],
      ],
    },
    properties: {
      objectid: 10,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-4',
      map_color6: 4,
      map_color8: 4,
      note: null,
      zone: -4,
      utc_format: 'UTC-04:00',
      time_zone: 'UTC-04:00',
      iso_8601: '2012-05-31T00:33:50-04:00',
      places: 'Arctic Ocean',
      dst_places: null,
      tz_name1st: null,
      tz_namesum: 0,
      cartodb_id: 15,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-180, 48.01817597197194],
          [-172.43243243243242, 48.01817597197194],
          [-172.43243243243242, 46.576732880880854],
          [-172.43243243243242, 45.675830948948914],
          [-172.43243243243242, 44.234387857857826],
          [-172.43243243243242, 43.1533055395395],
          [-172.43243243243242, 42.79294476676674],
          [-172.43243243243242, 41.711862448448414],
          [-172.43243243243242, 40.270419357357326],
          [-172.43243243243242, 35.04518815215212],
          [-173.87387387387386, 35.04518815215212],
          [-180, 35.04518815215212],
          [-180, 48.01817597197194],
        ],
      ],
    },
    properties: {
      objectid: 1,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-12',
      map_color6: 1,
      map_color8: 8,
      note: null,
      zone: -12,
      utc_format: 'UTC-12:00',
      time_zone: 'UTC-12:00',
      iso_8601: '2012-05-30T16:33:50-12:00',
      places: 'Baker Island, Howland Island (both uninhabited)',
      dst_places: null,
      tz_name1st: null,
      tz_namesum: 0,
      cartodb_id: 76,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-127.38738738738739, 70.72090465665661],
          [-127.38738738738739, 90.00020599999996],
          [-112.61261261261262, 90.00020599999996],
          [-112.61261261261262, 78.829022044044],
          [-114.41441441441442, 78.28848088488485],
          [-115.85585585585586, 78.10830049849847],
          [-115.85585585585586, 77.74793972572567],
          [-117.65765765765767, 77.74793972572567],
          [-118.01801801801801, 77.56775933933929],
          [-119.81981981981983, 77.56775933933929],
          [-120.9009009009009, 77.20739856656652],
          [-121.26126126126127, 76.84703779379376],
          [-122.70270270270271, 76.66685740740735],
          [-123.78378378378379, 75.94613586186182],
          [-121.26126126126127, 75.58577508908905],
          [-121.62162162162161, 74.68487315715711],
          [-124.14414414414415, 74.68487315715711],
          [-125.58558558558559, 74.50469277077073],
          [-125.58558558558559, 74.14433199799797],
          [-124.86486486486487, 73.60379083883879],
          [-125.58558558558559, 73.24343006606603],
          [-125.58558558558559, 72.70288890690685],
          [-126.66666666666667, 72.1623477477477],
          [-126.66666666666667, 71.80198697497494],
          [-125.58558558558559, 71.80198697497494],
          [-124.50450450450451, 71.62180658858856],
          [-123.78378378378379, 71.08126542942938],
          [-124.14414414414415, 70.36054388388385],
          [-125.58558558558559, 70.36054388388385],
          [-126.30630630630631, 70.18036349749747],
          [-127.38738738738739, 70.72090465665661],
        ],
      ],
    },
    properties: {
      objectid: 6,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-8',
      map_color6: 2,
      map_color8: 7,
      note: null,
      zone: -8,
      utc_format: 'UTC-08:00',
      time_zone: 'UTC-08:00',
      iso_8601: '2012-05-30T20:33:50-08:00',
      places: 'Arctic Ocean',
      dst_places: null,
      tz_name1st: null,
      tz_namesum: 0,
      cartodb_id: 22,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [94.23423423423424, 6.036145943943922],
          [93.15315315315314, 4.955063625625598],
          [93.15315315315314, 4.5947028528528335],
          [92.7927927927928, 4.234342080080054],
          [92.43243243243239, 4.054161693693672],
          [92.07207207207205, 4.054161693693672],
          [92.07207207207205, 14.504624104104082],
          [92.7927927927928, 14.144263331331302],
          [93.15315315315314, 13.783902558558538],
          [93.87387387387383, 13.783902558558538],
          [94.59459459459458, 13.783902558558538],
          [94.59459459459458, 6.3965067167166865],
          [94.23423423423424, 6.216326330330304],
          [94.23423423423424, 6.036145943943922],
        ],
      ],
    },
    properties: {
      objectid: 23,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+5.5',
      map_color6: 3,
      map_color8: 3,
      note: null,
      zone: 5.5,
      utc_format: 'UTC+05:30',
      time_zone: 'UTC+05:30',
      iso_8601: '2012-05-31T10:03:50+05:30',
      places: 'India (Andaman Is.)',
      dst_places: null,
      tz_name1st: null,
      tz_namesum: 0,
      cartodb_id: 56,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: null,
    properties: {
      objectid: 22,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+5',
      map_color6: 1,
      map_color8: 7,
      note: null,
      zone: 5,
      utc_format: 'UTC+05:00',
      time_zone: 'UTC+05:00',
      iso_8601: '2012-05-31T09:33:50+05:00',
      places: 'Uzbekistan',
      dst_places: null,
      tz_name1st: null,
      tz_namesum: 0,
      cartodb_id: 59,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-158.3783783783784, -2.4323322162162384],
          [-158.3783783783784, -5.855759557557576],
          [-159.0990990990991, -5.855759557557576],
          [-169.54954954954954, -5.855759557557576],
          [-169.54954954954954, -6.57648110310312],
          [-169.9099099099099, -6.936841875875899],
          [-170.27027027027026, -7.477383035035061],
          [-170.27027027027026, -8.017924194194222],
          [-170.63063063063063, -8.378284966966987],
          [-170.63063063063063, -8.918826126126149],
          [-170.99099099099098, -9.45936728528531],
          [-170.99099099099098, -9.999908444444472],
          [-171.35135135135135, -10.54044960360362],
          [-171.35135135135135, -11.08099076276278],
          [-171.35135135135135, -11.44135153553556],
          [-171.35135135135135, -11.981892694694722],
          [-170.99099099099098, -12.522433853853869],
          [-170.99099099099098, -13.963876944944971],
          [-171.35135135135135, -14.504418104104118],
          [-171.7117117117117, -14.504418104104118],
          [-172.07207207207207, -14.864778876876898],
          [-172.43243243243242, -15.04495926326328],
          [-172.43243243243242, -20.270190468468485],
          [-172.43243243243242, -21.53145317317319],
          [-172.43243243243242, -22.432355105105117],
          [-172.43243243243242, -26.03596283283285],
          [-180, -26.03596283283285],
          [-179.63963963963963, -25.49542167367369],
          [-179.63963963963963, -25.135060900900925],
          [-179.27927927927928, -24.774700128128146],
          [-179.27927927927928, -24.234158968968984],
          [-178.55855855855856, -23.51343742342344],
          [-178.55855855855856, -22.97289626426428],
          [-178.19819819819818, -22.612535491491514],
          [-178.19819819819818, -22.071994332332352],
          [-177.47747747747746, -21.351272786786808],
          [-177.47747747747746, -20.810731627627646],
          [-177.11711711711712, -20.450370854854867],
          [-177.11711711711712, -15.04495926326328],
          [-174.59459459459458, -15.04495926326328],
          [-174.59459459459458, -14.144057331331354],
          [-174.23423423423424, -13.783696558558574],
          [-174.23423423423424, -12.522433853853869],
          [-174.59459459459458, -12.162073081081104],
          [-174.95495495495496, -11.621531921921942],
          [-176.03603603603602, -10.54044960360362],
          [-176.03603603603602, -10.180088830830854],
          [-176.75675675675674, -9.45936728528531],
          [-177.11711711711712, -8.918826126126149],
          [-177.47747747747746, -8.738645739739766],
          [-177.47747747747746, -8.378284966966987],
          [-178.19819819819818, -7.657563421421443],
          [-178.19819819819818, -2.4323322162162384],
          [-172.43243243243242, -2.4323322162162384],
          [-158.3783783783784, -2.4323322162162384],
        ],
      ],
    },
    properties: {
      objectid: 37,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+13',
      map_color6: 2,
      map_color8: 6,
      note: 'Reflects 2012 International Date Line switch for Western Samoa and Kiribati',
      zone: 13,
      utc_format: 'UTC+13:00',
      time_zone: 'UTC+13:00',
      iso_8601: '2012-05-31T17:33:50+13:00',
      places: 'Kiribati (Phoenix Islands), Tonga, Samoa',
      dst_places: 'Samoa',
      tz_name1st: 'Pacific/Enderbury',
      tz_namesum: 3,
      cartodb_id: 23,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-158.3783783783784, -5.855759557557576],
          [-158.3783783783784, -2.4323322162162384],
          [-158.3783783783784, -0.27016757957960635],
          [-159.0990990990991, 0.2703735795795552],
          [-159.45945945945945, 0.45055396596593766],
          [-159.81981981981983, 0.8109147387387168],
          [-160.18018018018017, 0.9910951251250992],
          [-160.18018018018017, 1.3514558978978783],
          [-160.54054054054055, 1.5316362842842608],
          [-160.54054054054055, 4.054161693693672],
          [-160.54054054054055, 4.955063625625598],
          [-157.65765765765767, 4.955063625625598],
          [-155.85585585585585, 4.955063625625598],
          [-155.4954954954955, 4.955063625625598],
          [-155.13513513513513, 4.234342080080054],
          [-155.13513513513513, 3.693800920920893],
          [-154.77477477477478, 3.333440148148128],
          [-154.77477477477478, 2.7928989889889664],
          [-154.4144144144144, 2.4325382162161873],
          [-154.4144144144144, 1.5316362842842608],
          [-154.05405405405406, 0.9910951251250992],
          [-154.05405405405406, 0.6307343523523343],
          [-153.6936936936937, 0.09019319319317276],
          [-153.6936936936937, -0.27016757957960635],
          [-153.33333333333334, -0.8107087387387679],
          [-153.33333333333334, -1.3512498978979153],
          [-152.97297297297297, -1.7116106706706944],
          [-152.97297297297297, -2.252151829829856],
          [-152.61261261261262, -2.612512602602621],
          [-152.61261261261262, -3.1530537617617824],
          [-152.25225225225225, -3.5134145345345615],
          [-152.25225225225225, -4.053955693693723],
          [-151.8918918918919, -4.5944968528528705],
          [-151.8918918918919, -4.95485762562565],
          [-151.53153153153153, -5.495398784784811],
          [-151.53153153153153, -5.855759557557576],
          [-151.17117117117118, -6.216120330330355],
          [-151.17117117117118, -7.297202648648664],
          [-150.8108108108108, -7.657563421421443],
          [-150.8108108108108, -8.198104580580605],
          [-150.45045045045046, -8.55846535335337],
          [-150.45045045045046, -9.099006512512531],
          [-150.0900900900901, -9.45936728528531],
          [-150.0900900900901, -11.08099076276278],
          [-150.0900900900901, -11.621531921921942],
          [-150.45045045045046, -11.621531921921942],
          [-151.8918918918919, -11.621531921921942],
          [-154.4144144144144, -11.621531921921942],
          [-154.77477477477478, -10.900810376376398],
          [-154.77477477477478, -10.54044960360362],
          [-155.13513513513513, -9.999908444444472],
          [-155.13513513513513, -9.099006512512531],
          [-155.4954954954955, -8.55846535335337],
          [-155.4954954954955, -7.477383035035061],
          [-155.85585585585585, -6.936841875875899],
          [-155.85585585585585, -6.396300716716738],
          [-156.21621621621622, -5.855759557557576],
          [-158.3783783783784, -5.855759557557576],
        ],
      ],
    },
    properties: {
      objectid: 0,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+14',
      map_color6: 1,
      map_color8: 1,
      note: 'Reflects 2012 International Date Line switch for Western Samoa and Kiribati',
      zone: 14,
      utc_format: 'UTC+14:00',
      time_zone: 'UTC+14:00',
      iso_8601: '2012-05-31T18:33:50+14:00',
      places: 'Kiribati (Line Islands), Tokelau',
      dst_places: null,
      tz_name1st: 'Pacific/Kiritimati',
      tz_namesum: 2,
      cartodb_id: 24,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-17.477477477477493, 79.54974358958955],
          [-16.396396396396398, 79.18938281681676],
          [-17.83783783783784, 78.46866127127123],
          [-17.83783783783784, 78.10830049849847],
          [-16.756756756756772, 77.92812011211205],
          [-16.756756756756772, 77.56775933933929],
          [-17.477477477477493, 77.38757895295291],
          [-18.198198198198213, 75.76595547547544],
          [-20.360360360360374, 75.76595547547544],
          [-20.72072072072072, 75.94613586186182],
          [-22.882882882882882, 75.94613586186182],
          [-22.882882882882882, 79.54974358958955],
          [-17.477477477477493, 79.54974358958955],
        ],
      ],
    },
    properties: {
      objectid: 12,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '0',
      map_color6: 6,
      map_color8: 1,
      note: null,
      zone: 0,
      utc_format: 'UTC+00:00',
      time_zone: 'UTC+00:00',
      iso_8601: '2012-05-31T09:03:50+00:00',
      places: 'Greenland (north eastern part)',
      dst_places: null,
      tz_name1st: 'America/Danmarkshavn',
      tz_namesum: 1,
      cartodb_id: 68,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [90.27027027027026, 28.01815308308305],
          [90.6306306306306, 28.01815308308305],
          [90.99099099099095, 28.01815308308305],
          [91.35135135135135, 28.01815308308305],
          [91.7117117117117, 27.837972696696667],
          [91.7117117117117, 27.477611923923888],
          [92.07207207207205, 27.477611923923888],
          [92.07207207207205, 26.937070764764727],
          [91.7117117117117, 26.756890378378344],
          [89.54954954954951, 26.756890378378344],
          [89.18918918918916, 26.937070764764727],
          [88.82882882882882, 26.937070764764727],
          [88.82882882882882, 27.297431537537506],
          [89.18918918918916, 27.477611923923888],
          [89.18918918918916, 27.837972696696667],
          [89.54954954954951, 27.837972696696667],
          [89.54954954954951, 28.198333469469432],
          [89.90990990990991, 28.37851385585583],
          [89.90990990990991, 28.198333469469432],
          [89.90990990990991, 28.37851385585583],
          [90.27027027027026, 28.01815308308305],
        ],
      ],
    },
    properties: {
      objectid: 25,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+6',
      map_color6: 6,
      map_color8: 8,
      note: null,
      zone: 6,
      utc_format: 'UTC+06:00',
      time_zone: 'UTC+06:00',
      iso_8601: '2012-05-31T10:33:50+06:00',
      places: 'Bhutan',
      dst_places: null,
      tz_name1st: 'Asia/Thimphu',
      tz_namesum: 1,
      cartodb_id: 33,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [37.65765765765764, 82.97317093093088],
          [37.65765765765764, 90.00020599999996],
          [52.43243243243242, 90.00020599999996],
          [52.43243243243242, 82.97317093093088],
          [37.65765765765764, 82.97317093093088],
        ],
      ],
    },
    properties: {
      objectid: 18,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+3',
      map_color6: 3,
      map_color8: 4,
      note: null,
      zone: 3,
      utc_format: 'UTC+03:00',
      time_zone: 'UTC+03:00',
      iso_8601: '2012-05-31T07:33:50+03:00',
      places: 'Arctic Ocean',
      dst_places: null,
      tz_name1st: null,
      tz_namesum: 0,
      cartodb_id: 71,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [137.8378378378378, -16.306221967967986],
          [137.8378378378378, -16.486402354354368],
          [137.8378378378378, -26.03596283283285],
          [141.08108108108104, -26.03596283283285],
          [141.08108108108104, -31.44137442442444],
          [141.8018018018018, -31.44137442442444],
          [141.8018018018018, -31.9819155835836],
          [141.08108108108104, -31.9819155835836],
          [141.08108108108104, -38.28822910710712],
          [140.7207207207207, -38.28822910710712],
          [140, -37.56750756156158],
          [139.6396396396396, -37.38732717517519],
          [139.6396396396396, -36.48642524324326],
          [139.27927927927925, -36.30624485685687],
          [139.27927927927925, -35.9458840840841],
          [138.9189189189189, -35.76570369769771],
          [138.19819819819816, -35.76570369769771],
          [138.19819819819816, -36.12606447047048],
          [137.47747747747746, -36.30624485685687],
          [137.11711711711712, -36.12606447047048],
          [136.75675675675672, -36.30624485685687],
          [136.39639639639637, -35.9458840840841],
          [136.03603603603602, -35.76570369769771],
          [135.67567567567568, -35.40534292492494],
          [135.67567567567568, -35.044982152152166],
          [135.31531531531527, -35.044982152152166],
          [135.31531531531527, -34.684621379379394],
          [134.95495495495493, -34.684621379379394],
          [134.59459459459458, -34.50444099299301],
          [134.59459459459458, -34.14408022022023],
          [134.23423423423424, -33.96389983383385],
          [134.23423423423424, -33.243178288288306],
          [133.87387387387383, -33.062997901901916],
          [133.87387387387383, -32.702637129129144],
          [133.5135135135135, -32.34227635635637],
          [132.7927927927928, -32.34227635635637],
          [132.7927927927928, -32.16209596996998],
          [132.07207207207205, -32.16209596996998],
          [131.7117117117117, -31.80173519719721],
          [128.82882882882882, -31.80173519719721],
          [128.82882882882882, -31.621554810810828],
          [128.82882882882882, -26.756684378378395],
          [128.82882882882882, -14.684598490490515],
          [129.18918918918916, -14.684598490490515],
          [129.18918918918916, -13.963876944944971],
          [129.5495495495495, -13.783696558558574],
          [129.5495495495495, -13.42333578578581],
          [129.9099099099099, -13.243155399399427],
          [129.9099099099099, -12.702614240240266],
          [130.27027027027026, -12.702614240240266],
          [130.27027027027026, -12.342253467467486],
          [130.6306306306306, -11.981892694694722],
          [129.9099099099099, -11.981892694694722],
          [129.9099099099099, -11.261171149149177],
          [130.27027027027026, -11.08099076276278],
          [131.7117117117117, -11.08099076276278],
          [132.07207207207205, -10.900810376376398],
          [132.4324324324324, -10.900810376376398],
          [132.7927927927928, -10.720629989990016],
          [133.15315315315314, -10.900810376376398],
          [133.15315315315314, -11.261171149149177],
          [133.87387387387383, -11.621531921921942],
          [134.23423423423424, -11.621531921921942],
          [134.59459459459458, -11.801712308308325],
          [134.95495495495493, -11.801712308308325],
          [134.95495495495493, -11.44135153553556],
          [135.31531531531527, -11.44135153553556],
          [135.31531531531527, -11.801712308308325],
          [136.03603603603602, -11.44135153553556],
          [136.39639639639637, -11.44135153553556],
          [136.39639639639637, -10.900810376376398],
          [137.11711711711712, -10.900810376376398],
          [137.11711711711712, -12.522433853853869],
          [136.75675675675672, -12.702614240240266],
          [136.75675675675672, -13.42333578578581],
          [137.11711711711712, -13.42333578578581],
          [137.11711711711712, -14.504418104104118],
          [136.39639639639637, -14.504418104104118],
          [136.03603603603602, -14.324237717717736],
          [136.03603603603602, -15.04495926326328],
          [136.75675675675672, -15.40532003603606],
          [137.11711711711712, -15.225139649649677],
          [137.11711711711712, -15.585500422422442],
          [137.8378378378378, -15.94586119519522],
          [137.8378378378378, -16.306221967967986],
        ],
      ],
    },
    properties: {
      objectid: 30,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+9.5',
      map_color6: 1,
      map_color8: 4,
      note: null,
      zone: 9.5,
      utc_format: 'UTC+09:30',
      time_zone: 'UTC+09:30',
      iso_8601: '2012-05-31T14:03:50+09:30',
      places: 'Australia (Northern Territory)',
      dst_places: 'Australia (South Australia)',
      tz_name1st: 'Australia/Adelaide',
      tz_namesum: 3,
      cartodb_id: 42,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [141.08108108108104, -38.28822910710712],
          [141.44144144144144, -38.64858987987989],
          [141.8018018018018, -38.46840949349351],
          [142.52252252252248, -38.46840949349351],
          [142.52252252252248, -66.75673015615617],
          [142.16216216216213, -66.57654976976977],
          [140, -66.57654976976977],
          [139.6396396396396, -66.39636938338339],
          [138.19819819819816, -66.39636938338339],
          [137.8378378378378, -66.216188996997],
          [136.39639639639637, -66.216188996997],
          [136.03603603603602, -66.03600861061062],
          [134.23423423423424, -66.03600861061062],
          [133.5135135135135, -65.85582822422423],
          [133.15315315315314, -66.03600861061062],
          [129.9099099099099, -66.03600861061062],
          [129.18918918918916, -66.39636938338339],
          [128.82882882882882, -66.93691054254255],
          [127.74774774774772, -66.93691054254255],
          [127.38738738738738, -66.75673015615617],
          [127.38738738738738, -32.34227635635637],
          [127.74774774774772, -32.34227635635637],
          [128.10810810810807, -32.16209596996998],
          [128.46846846846847, -32.16209596996998],
          [128.82882882882882, -31.9819155835836],
          [128.82882882882882, -31.80173519719721],
          [131.7117117117117, -31.80173519719721],
          [132.07207207207205, -32.16209596996998],
          [132.7927927927928, -32.16209596996998],
          [132.7927927927928, -32.34227635635637],
          [133.5135135135135, -32.34227635635637],
          [133.87387387387383, -32.702637129129144],
          [133.87387387387383, -33.062997901901916],
          [134.23423423423424, -33.243178288288306],
          [134.23423423423424, -33.96389983383385],
          [134.59459459459458, -34.14408022022023],
          [134.59459459459458, -34.50444099299301],
          [134.95495495495493, -34.684621379379394],
          [135.31531531531527, -34.684621379379394],
          [135.31531531531527, -35.044982152152166],
          [135.67567567567568, -35.044982152152166],
          [135.67567567567568, -35.40534292492494],
          [136.03603603603602, -35.76570369769771],
          [136.39639639639637, -35.9458840840841],
          [136.75675675675672, -36.30624485685687],
          [137.11711711711712, -36.12606447047048],
          [137.47747747747746, -36.30624485685687],
          [138.19819819819816, -36.12606447047048],
          [138.19819819819816, -35.76570369769771],
          [138.9189189189189, -35.76570369769771],
          [139.27927927927925, -35.9458840840841],
          [139.27927927927925, -36.30624485685687],
          [139.6396396396396, -36.48642524324326],
          [139.6396396396396, -37.38732717517519],
          [140, -37.56750756156158],
          [140.7207207207207, -38.28822910710712],
          [141.08108108108104, -38.28822910710712],
        ],
      ],
    },
    properties: {
      objectid: 29,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+9',
      map_color6: 3,
      map_color8: 3,
      note: null,
      zone: 9,
      utc_format: 'UTC+09:00',
      time_zone: 'UTC+09:00',
      iso_8601: '2012-05-31T13:33:50+09:00',
      places: 'Southern Ocean',
      dst_places: null,
      tz_name1st: null,
      tz_namesum: 1,
      cartodb_id: 46,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [100, 81.53172783983979],
          [97.47747747747746, 81.53172783983979],
          [97.47747747747746, 90.00020599999996],
          [112.61261261261262, 90.00020599999996],
          [112.61261261261262, 81.53172783983979],
          [100, 81.53172783983979],
        ],
      ],
    },
    properties: {
      objectid: 27,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+7',
      map_color6: 5,
      map_color8: 1,
      note: 'Reflects 2012 shift in daylight savings time in Russia.',
      zone: 7,
      utc_format: 'UTC+07:00',
      time_zone: 'UTC+07:00',
      iso_8601: '2012-05-31T11:33:50+07:00',
      places: 'Arctic Ocean',
      dst_places: null,
      tz_name1st: null,
      tz_namesum: 0,
      cartodb_id: 72,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [97.47747747747746, 28.55869424224221],
          [97.83783783783781, 28.37851385585583],
          [98.19819819819821, 28.198333469469432],
          [98.19819819819821, 27.477611923923888],
          [98.55855855855856, 27.657792310310285],
          [98.55855855855856, 26.216349219219182],
          [98.55855855855856, 26.0361688328328],
          [98.55855855855856, 26.216349219219182],
          [98.55855855855856, 26.0361688328328],
          [98.55855855855856, 25.855988446446418],
          [98.19819819819821, 25.49562767367364],
          [98.19819819819821, 25.675808060060035],
          [98.19819819819821, 25.315447287287256],
          [97.83783783783781, 25.135266900900874],
          [97.83783783783781, 25.315447287287256],
          [97.83783783783781, 24.774906128128094],
          [97.47747747747746, 24.774906128128094],
          [97.47747747747746, 24.41454535535533],
          [97.83783783783781, 24.05418458258255],
          [97.47747747747746, 23.874004196196168],
          [97.83783783783781, 24.05418458258255],
          [98.19819819819821, 24.05418458258255],
          [98.55855855855856, 24.05418458258255],
          [98.9189189189189, 24.05418458258255],
          [98.55855855855856, 24.05418458258255],
          [98.55855855855856, 23.693823809809786],
          [98.9189189189189, 23.51364342342339],
          [98.9189189189189, 23.333463037037006],
          [98.9189189189189, 23.153282650650624],
          [99.27927927927925, 23.153282650650624],
          [99.27927927927925, 22.973102264264227],
          [99.27927927927925, 23.153282650650624],
          [99.63963963963965, 22.973102264264227],
          [99.27927927927925, 22.973102264264227],
          [99.27927927927925, 22.0722003323323],
          [99.63963963963965, 22.0722003323323],
          [100, 22.0722003323323],
          [100, 21.351478786786757],
          [100.36036036036035, 21.351478786786757],
          [100.36036036036035, 21.53165917317314],
          [100.72072072072069, 21.53165917317314],
          [101.0810810810811, 21.711839559559536],
          [101.0810810810811, 21.53165917317314],
          [100.72072072072069, 21.351478786786757],
          [100.72072072072069, 20.991118014013978],
          [100.36036036036035, 20.991118014013978],
          [100.36036036036035, 20.630757241241213],
          [99.63963963963965, 20.270396468468434],
          [99.63963963963965, 20.09021608208205],
          [98.9189189189189, 20.09021608208205],
          [98.9189189189189, 19.729855309309286],
          [97.83783783783781, 19.729855309309286],
          [97.83783783783781, 17.56769067267264],
          [98.19819819819821, 17.387510286286258],
          [98.19819819819821, 17.02714951351348],
          [98.55855855855856, 17.02714951351348],
          [98.55855855855856, 15.225345649649626],
          [98.19819819819821, 15.225345649649626],
          [98.19819819819821, 14.684804490490464],
          [98.55855855855856, 14.684804490490464],
          [98.55855855855856, 14.144263331331302],
          [98.9189189189189, 14.144263331331302],
          [98.9189189189189, 13.783902558558538],
          [99.27927927927925, 13.783902558558538],
          [99.27927927927925, 12.162279081081053],
          [99.63963963963965, 12.162279081081053],
          [99.63963963963965, 11.621737921921891],
          [99.27927927927925, 11.621737921921891],
          [99.27927927927925, 11.08119676276273],
          [98.9189189189189, 11.08119676276273],
          [98.9189189189189, 10.360475217217186],
          [98.55855855855856, 10.360475217217186],
          [98.55855855855856, 10.00011444444442],
          [98.19819819819821, 9.819934058058024],
          [98.19819819819821, 9.45957328528526],
          [97.83783783783781, 9.639753671671642],
          [97.47747747747746, 9.639753671671642],
          [97.47747747747746, 11.98209869469467],
          [97.47747747747746, 16.126247581581552],
          [97.11711711711712, 16.126247581581552],
          [97.11711711711712, 16.666788740740714],
          [96.03603603603602, 16.126247581581552],
          [96.03603603603602, 15.94606719519517],
          [95.67567567567568, 15.58570642242239],
          [94.23423423423424, 15.58570642242239],
          [93.87387387387383, 15.94606719519517],
          [93.87387387387383, 16.48660835435433],
          [94.23423423423424, 16.666788740740714],
          [94.23423423423424, 18.288412218218184],
          [93.51351351351349, 18.648772990990963],
          [93.15315315315314, 18.648772990990963],
          [93.15315315315314, 19.54967492292289],
          [92.7927927927928, 19.54967492292289],
          [92.7927927927928, 19.91003569569567],
          [92.43243243243239, 20.09021608208205],
          [92.43243243243239, 21.89201994594592],
          [92.43243243243239, 22.0722003323323],
          [93.15315315315314, 22.0722003323323],
          [93.15315315315314, 22.973102264264227],
          [93.51351351351349, 22.973102264264227],
          [93.51351351351349, 23.874004196196168],
          [93.87387387387383, 24.05418458258255],
          [94.23423423423424, 23.874004196196168],
          [94.23423423423424, 24.594725741741712],
          [94.59459459459458, 24.594725741741712],
          [94.59459459459458, 25.49562767367364],
          [94.95495495495493, 25.49562767367364],
          [94.95495495495493, 26.57670999199196],
          [95.67567567567568, 26.937070764764727],
          [96.03603603603602, 26.937070764764727],
          [96.03603603603602, 27.297431537537506],
          [96.75675675675677, 27.477611923923888],
          [97.11711711711712, 27.837972696696667],
          [97.47747747747746, 27.837972696696667],
          [97.47747747747746, 28.198333469469432],
          [97.47747747747746, 28.55869424224221],
        ],
      ],
    },
    properties: {
      objectid: 26,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+6.5',
      map_color6: 2,
      map_color8: 6,
      note: null,
      zone: 6.5,
      utc_format: 'UTC+06:30',
      time_zone: 'UTC+06:30',
      iso_8601: '2012-05-31T11:03:50+06:30',
      places: 'Myanmar',
      dst_places: null,
      tz_name1st: 'Asia/Rangoon',
      tz_namesum: 1,
      cartodb_id: 75,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [37.65765765765764, 82.97317093093088],
          [37.65765765765764, 80.99118668068064],
          [35.495495495495476, 80.99118668068064],
          [35.495495495495476, 79.00920243043038],
          [37.65765765765764, 79.00920243043038],
          [37.65765765765764, 69.09928117917914],
          [36.93693693693692, 69.09928117917914],
          [36.216216216216196, 69.45964195195191],
          [34.774774774774755, 69.45964195195191],
          [33.69369369369369, 69.63982233833829],
          [33.333333333333314, 70.00018311111106],
          [31.891891891891873, 70.18036349749747],
          [30.810810810810807, 70.901085043043],
          [29.729729729729712, 70.901085043043],
          [28.648648648648646, 71.26144581581576],
          [23.603603603603602, 71.26144581581576],
          [22.522522522522507, 70.901085043043],
          [22.522522522522507, 75.40559470270267],
          [34.774774774774755, 75.40559470270267],
          [34.774774774774755, 80.99118668068064],
          [22.522522522522507, 80.99118668068064],
          [22.522522522522507, 90.00020599999996],
          [37.65765765765764, 90.00020599999996],
          [37.65765765765764, 82.97317093093088],
        ],
      ],
    },
    properties: {
      objectid: 17,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+2',
      map_color6: 4,
      map_color8: 3,
      note: null,
      zone: 2,
      utc_format: 'UTC+02:00',
      time_zone: 'UTC+02:00',
      iso_8601: '2012-05-31T06:33:50+02:00',
      places: 'Arctic Ocean',
      dst_places: null,
      tz_name1st: null,
      tz_namesum: 0,
      cartodb_id: 48,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [27.56756756756755, 5.135244012011981],
          [27.56756756756755, 4.774883239239216],
          [27.927927927927925, 4.774883239239216],
          [27.927927927927925, 4.414522466466437],
          [29.729729729729712, 4.414522466466437],
          [30.090090090090087, 4.234342080080054],
          [30.090090090090087, 3.8739813073072753],
          [30.450450450450433, 3.8739813073072753],
          [30.810810810810807, 3.693800920920893],
          [30.810810810810807, 2.4325382162161873],
          [31.171171171171153, 2.252357829829805],
          [31.171171171171153, 1.7118166706706432],
          [30.090090090090087, 1.1712755115114817],
          [30.090090090090087, 0.45055396596593766],
          [29.729729729729712, 0.45055396596593766],
          [29.729729729729712, -1.531430284284312],
          [30.090090090090087, -1.531430284284312],
          [30.090090090090087, -1.1710695115115328],
          [30.450450450450433, -1.3512498978979153],
          [30.810810810810807, -1.3512498978979153],
          [30.810810810810807, -2.4323322162162384],
          [30.450450450450433, -2.4323322162162384],
          [30.450450450450433, -2.9728733753754],
          [30.810810810810807, -2.9728733753754],
          [30.810810810810807, -3.333234148148165],
          [30.450450450450433, -3.5134145345345615],
          [30.450450450450433, -3.8737753073073264],
          [30.090090090090087, -3.8737753073073264],
          [30.090090090090087, -4.234136080080106],
          [29.729729729729712, -4.414316466466488],
          [29.369369369369366, -4.414316466466488],
          [29.369369369369366, -5.3152183983984145],
          [29.729729729729712, -5.675579171171194],
          [29.369369369369366, -5.855759557557576],
          [29.369369369369366, -6.396300716716738],
          [29.729729729729712, -6.396300716716738],
          [29.729729729729712, -6.756661489489517],
          [30.090090090090087, -6.756661489489517],
          [30.090090090090087, -7.117022262262282],
          [30.450450450450433, -7.117022262262282],
          [30.450450450450433, -7.657563421421443],
          [30.810810810810807, -7.837743807807826],
          [30.810810810810807, -8.55846535335337],
          [31.531531531531527, -8.55846535335337],
          [31.531531531531527, -8.918826126126149],
          [31.891891891891873, -9.099006512512531],
          [32.612612612612594, -9.099006512512531],
          [32.612612612612594, -9.279186898898928],
          [33.333333333333314, -9.639547671671693],
          [34.41441441441441, -9.639547671671693],
          [34.41441441441441, -10.54044960360362],
          [34.774774774774755, -10.54044960360362],
          [34.774774774774755, -11.44135153553556],
          [35.13513513513513, -11.621531921921942],
          [37.65765765765764, -11.621531921921942],
          [38.01801801801801, -11.261171149149177],
          [38.73873873873873, -11.261171149149177],
          [38.73873873873873, -11.08099076276278],
          [39.45945945945945, -11.08099076276278],
          [39.45945945945945, -10.900810376376398],
          [40.18018018018017, -10.900810376376398],
          [40.18018018018017, -10.54044960360362],
          [40.90090090090089, -10.54044960360362],
          [40.90090090090089, -11.08099076276278],
          [40.54054054054052, -11.261171149149177],
          [40.54054054054052, -11.981892694694722],
          [40.90090090090089, -12.342253467467486],
          [40.90090090090089, -15.585500422422442],
          [40.18018018018017, -15.94586119519522],
          [40.18018018018017, -16.486402354354368],
          [39.8198198198198, -16.666582740740765],
          [39.45945945945945, -17.02694351351353],
          [39.09909909909908, -17.207123899899926],
          [38.73873873873873, -17.207123899899926],
          [37.65765765765764, -17.747665059059074],
          [37.65765765765764, -46.57652688088089],
          [37.29729729729729, -46.75670726726728],
          [37.29729729729729, -47.11706804004005],
          [37.65765765765764, -47.11706804004005],
          [37.65765765765764, -69.45943595195196],
          [35.85585585585585, -69.45943595195196],
          [35.85585585585585, -69.09907517917918],
          [34.774774774774755, -68.9188947927928],
          [34.774774774774755, -68.55853402002003],
          [33.333333333333314, -68.37835363363364],
          [31.891891891891873, -68.73871440640642],
          [32.25225225225225, -69.27925556556556],
          [32.25225225225225, -69.81979672472474],
          [31.891891891891873, -69.99997711111112],
          [30.090090090090087, -69.99997711111112],
          [29.00900900900899, -70.1801574974975],
          [27.56756756756755, -70.54051827027027],
          [27.56756756756755, -70.1801574974975],
          [26.84684684684683, -69.81979672472474],
          [26.12612612612611, -69.81979672472474],
          [24.68468468468467, -70.1801574974975],
          [22.522522522522507, -70.1801574974975],
          [22.522522522522507, -34.14408022022023],
          [21.801801801801787, -34.50444099299301],
          [20.72072072072072, -34.50444099299301],
          [20.360360360360346, -34.86480176576578],
          [19.639639639639626, -34.86480176576578],
          [19.27927927927928, -34.50444099299301],
          [18.55855855855856, -34.50444099299301],
          [18.198198198198185, -34.32426060660662],
          [18.198198198198185, -33.42335867467469],
          [17.83783783783784, -33.243178288288306],
          [17.83783783783784, -32.52245674274276],
          [18.198198198198185, -32.52245674274276],
          [18.198198198198185, -31.80173519719721],
          [17.477477477477464, -31.081013651651666],
          [17.477477477477464, -30.720652878878894],
          [17.117117117117118, -30.540472492492512],
          [17.117117117117118, -29.99993133333335],
          [16.756756756756744, -29.63957056056058],
          [16.756756756756744, -29.099029401401417],
          [16.396396396396398, -28.918849015015034],
          [16.396396396396398, -28.558488242242262],
          [16.756756756756744, -28.558488242242262],
          [16.756756756756744, -28.0179470830831],
          [17.117117117117118, -28.198127469469483],
          [17.477477477477464, -28.198127469469483],
          [17.477477477477464, -28.738668628628645],
          [17.83783783783784, -28.738668628628645],
          [18.198198198198185, -28.918849015015034],
          [19.27927927927928, -28.918849015015034],
          [20, -28.558488242242262],
          [20, -22.071994332332352],
          [21.081081081081066, -22.071994332332352],
          [21.081081081081066, -18.288206218218235],
          [21.801801801801787, -18.288206218218235],
          [22.16216216216216, -18.108025831831853],
          [22.882882882882882, -18.108025831831853],
          [23.243243243243228, -18.288206218218235],
          [23.603603603603602, -18.108025831831853],
          [24.68468468468467, -18.108025831831853],
          [24.68468468468467, -17.747665059059074],
          [25.045045045045043, -17.56748467267269],
          [23.243243243243228, -17.56748467267269],
          [22.882882882882882, -17.38730428628631],
          [22.882882882882882, -17.02694351351353],
          [22.522522522522507, -17.02694351351353],
          [22.522522522522507, -16.666582740740765],
          [22.16216216216216, -16.666582740740765],
          [22.16216216216216, -16.126041581581603],
          [21.801801801801787, -16.126041581581603],
          [21.801801801801787, -13.06297501301303],
          [23.96396396396395, -13.06297501301303],
          [23.96396396396395, -11.08099076276278],
          [22.522522522522507, -11.08099076276278],
          [22.16216216216216, -11.261171149149177],
          [22.16216216216216, -9.819728058058075],
          [21.801801801801787, -9.819728058058075],
          [21.801801801801787, -7.297202648648664],
          [20.360360360360346, -7.297202648648664],
          [20.72072072072072, -7.117022262262282],
          [20.72072072072072, -6.936841875875899],
          [20, -6.936841875875899],
          [19.639639639639626, -6.756661489489517],
          [19.639639639639626, -6.035939943943973],
          [20, -6.035939943943973],
          [20, -4.234136080080106],
          [20.72072072072072, -4.234136080080106],
          [20.72072072072072, -2.7926929889890175],
          [21.081081081081066, -2.7926929889890175],
          [21.081081081081066, -2.4323322162162384],
          [22.16216216216216, -2.4323322162162384],
          [22.16216216216216, -1.8917910570570768],
          [23.243243243243228, -1.8917910570570768],
          [23.603603603603602, -2.0719714434434735],
          [24.324324324324323, -1.7116106706706944],
          [24.324324324324323, -1.3512498978979153],
          [23.96396396396395, -1.3512498978979153],
          [23.603603603603602, -1.1710695115115328],
          [23.603603603603602, -0.4503479659659888],
          [23.243243243243228, -0.27016757957960635],
          [23.243243243243228, 0.2703735795795552],
          [22.882882882882882, 0.45055396596593766],
          [22.882882882882882, 1.1712755115114817],
          [22.522522522522507, 1.1712755115114817],
          [22.522522522522507, 2.0721774434434224],
          [23.243243243243228, 2.0721774434434224],
          [23.243243243243228, 2.612718602602584],
          [22.882882882882882, 2.612718602602584],
          [22.882882882882882, 3.5136205345345104],
          [23.603603603603602, 3.8739813073072753],
          [22.882882882882882, 3.8739813073072753],
          [22.522522522522507, 4.054161693693672],
          [22.522522522522507, 4.5947028528528335],
          [22.882882882882882, 4.774883239239216],
          [23.243243243243228, 4.5947028528528335],
          [24.324324324324323, 5.135244012011981],
          [24.68468468468467, 4.955063625625598],
          [25.40540540540539, 4.955063625625598],
          [25.40540540540539, 5.3154243983983775],
          [25.765765765765764, 5.135244012011981],
          [27.56756756756755, 5.135244012011981],
        ],
      ],
    },
    properties: {
      objectid: 17,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+2',
      map_color6: 4,
      map_color8: 3,
      note: null,
      zone: 2,
      utc_format: 'UTC+02:00',
      time_zone: 'UTC+02:00',
      iso_8601: '2012-05-31T06:33:50+02:00',
      places:
        'Libya, Egypt, Malawi, Mozambique, South Africa, Swaziland, Zambia, Zimbabwe',
      dst_places:
        'Bulgaria, Cyprus, Estonia, Finland, Greece, Israel, Jordan, Latvia, Lebanon, Lithuania, Moldova, Palestine, Romania, Syria, Turkey, Ukraine',
      tz_name1st: 'Africa/Johannesburg',
      tz_namesum: 11,
      cartodb_id: 49,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [74.77477477477476, 36.846992016015975],
          [75.13513513513513, 37.02717240240237],
          [75.49549549549548, 36.66681162962959],
          [75.49549549549548, 36.846992016015975],
          [75.85585585585585, 36.66681162962959],
          [75.85585585585585, 35.94609008408405],
          [76.2162162162162, 35.765909697697666],
          [76.57657657657654, 35.94609008408405],
          [76.57657657657654, 35.58572931131128],
          [77.29729729729729, 35.58572931131128],
          [77.65765765765764, 35.40554892492489],
          [77.65765765765764, 35.58572931131128],
          [77.65765765765764, 35.40554892492489],
          [76.57657657657654, 34.865007765765725],
          [76.57657657657654, 34.68482737937934],
          [75.85585585585585, 34.68482737937934],
          [75.85585585585585, 34.50464699299296],
          [75.13513513513513, 34.50464699299296],
          [75.13513513513513, 34.68482737937934],
          [74.05405405405403, 34.68482737937934],
          [74.05405405405403, 33.06320390190187],
          [74.41441441441441, 33.06320390190187],
          [74.41441441441441, 32.70284312912909],
          [74.77477477477476, 32.70284312912909],
          [75.49549549549548, 32.34248235635633],
          [74.41441441441441, 31.801941197197166],
          [74.41441441441441, 30.720858878878843],
          [74.05405405405403, 30.720858878878843],
          [74.05405405405403, 30.18031771971968],
          [73.69369369369369, 30.0001373333333],
          [73.33333333333331, 30.0001373333333],
          [73.33333333333331, 29.459596174174138],
          [72.97297297297297, 29.099235401401373],
          [72.25225225225225, 28.738874628628594],
          [72.25225225225225, 28.37851385585583],
          [71.89189189189187, 28.01815308308305],
          [71.53153153153153, 27.837972696696667],
          [71.17117117117115, 27.837972696696667],
          [70.8108108108108, 28.01815308308305],
          [70.09009009009009, 28.01815308308305],
          [70.09009009009009, 27.657792310310285],
          [69.72972972972971, 27.477611923923888],
          [69.72972972972971, 27.117251151151123],
          [69.36936936936937, 27.117251151151123],
          [69.36936936936937, 26.756890378378344],
          [69.72972972972971, 26.756890378378344],
          [70.09009009009009, 26.57670999199196],
          [70.09009009009009, 25.675808060060035],
          [70.8108108108108, 25.675808060060035],
          [70.8108108108108, 24.234364968968933],
          [70.45045045045043, 24.41454535535533],
          [70.09009009009009, 24.234364968968933],
          [68.64864864864865, 24.234364968968933],
          [68.28828828828827, 24.05418458258255],
          [68.28828828828827, 23.153282650650624],
          [69.00900900900899, 22.792921877877845],
          [68.64864864864865, 22.612741491491462],
          [68.64864864864865, 22.0722003323323],
          [69.36936936936937, 21.711839559559536],
          [69.36936936936937, 21.53165917317314],
          [70.09009009009009, 20.810937627627595],
          [70.8108108108108, 20.45057685485483],
          [71.89189189189187, 20.991118014013978],
          [72.6126126126126, 20.991118014013978],
          [72.6126126126126, 19.54967492292289],
          [72.6126126126126, 18.1082318318318],
          [72.97297297297297, 17.92805144544542],
          [72.97297297297297, 16.48660835435433],
          [73.33333333333331, 16.126247581581552],
          [73.33333333333331, 15.58570642242239],
          [73.69369369369369, 15.58570642242239],
          [73.69369369369369, 14.864984876876846],
          [74.05405405405403, 14.684804490490464],
          [74.05405405405403, 14.144263331331302],
          [74.41441441441441, 13.96408294494492],
          [74.41441441441441, 13.06318101301298],
          [74.77477477477476, 12.702820240240214],
          [74.77477477477476, 12.162279081081053],
          [75.13513513513513, 11.98209869469467],
          [75.49549549549548, 11.621737921921891],
          [75.49549549549548, 10.901016376376347],
          [75.85585585585585, 10.720835989989965],
          [75.85585585585585, 10.180294830830803],
          [76.2162162162162, 9.819934058058024],
          [76.2162162162162, 8.738851739739715],
          [76.93693693693695, 8.378490966966936],
          [76.93693693693695, 8.198310580580554],
          [77.65765765765764, 7.8379498078077745],
          [78.37837837837839, 8.198310580580554],
          [78.37837837837839, 8.919032126126098],
          [78.73873873873873, 8.919032126126098],
          [79.09909909909908, 9.09921251251248],
          [79.45945945945942, 8.919032126126098],
          [79.81981981981983, 8.919032126126098],
          [79.81981981981983, 8.558671353353333],
          [79.45945945945942, 8.378490966966936],
          [79.45945945945942, 7.1172282622622305],
          [79.81981981981983, 6.756867489489466],
          [79.81981981981983, 6.036145943943922],
          [80.54054054054052, 5.6757851711711425],
          [81.98198198198196, 6.3965067167166865],
          [81.98198198198196, 8.018130194194171],
          [81.62162162162161, 8.198310580580554],
          [81.62162162162161, 8.558671353353333],
          [81.26126126126127, 8.738851739739715],
          [81.26126126126127, 9.09921251251248],
          [80.54054054054052, 9.819934058058024],
          [80.18018018018017, 10.00011444444442],
          [80.18018018018017, 12.342459467467435],
          [80.54054054054052, 12.522639853853832],
          [80.54054054054052, 14.684804490490464],
          [80.18018018018017, 14.864984876876846],
          [80.18018018018017, 15.225345649649626],
          [80.54054054054052, 15.58570642242239],
          [81.26126126126127, 15.58570642242239],
          [81.26126126126127, 16.126247581581552],
          [81.62162162162161, 16.126247581581552],
          [82.3423423423423, 16.48660835435433],
          [82.3423423423423, -67.47745170170171],
          [80.54054054054052, -67.65763208808809],
          [79.09909909909908, -68.01799286086087],
          [78.01801801801798, -68.19817324724725],
          [78.01801801801798, -68.55853402002003],
          [77.29729729729729, -68.9188947927928],
          [75.85585585585585, -69.27925556556556],
          [75.13513513513513, -69.63961633833834],
          [74.41441441441441, -69.45943595195196],
          [72.97297297297297, -68.73871440640642],
          [71.17117117117115, -68.73871440640642],
          [70.8108108108108, -68.37835363363364],
          [70.09009009009009, -68.19817324724725],
          [70.09009009009009, -67.65763208808809],
          [67.56756756756755, -67.65763208808809],
          [67.56756756756755, 18.828953377377346],
          [67.56756756756755, 23.693823809809786],
          [67.2072072072072, 23.693823809809786],
          [67.2072072072072, 24.41454535535533],
          [66.84684684684683, 24.594725741741712],
          [66.48648648648648, 24.594725741741712],
          [66.48648648648648, 25.135266900900874],
          [66.12612612612611, 25.315447287287256],
          [65.76576576576576, 25.135266900900874],
          [65.04504504504504, 25.135266900900874],
          [64.68468468468467, 24.955086514514477],
          [64.32432432432432, 25.135266900900874],
          [63.6036036036036, 25.135266900900874],
          [63.6036036036036, 24.955086514514477],
          [62.88288288288288, 24.955086514514477],
          [62.52252252252251, 25.135266900900874],
          [61.80180180180179, 24.774906128128094],
          [61.44144144144144, 24.955086514514477],
          [61.44144144144144, 25.315447287287256],
          [61.80180180180179, 25.315447287287256],
          [61.80180180180179, 26.216349219219182],
          [62.16216216216216, 26.216349219219182],
          [62.16216216216216, 26.57670999199196],
          [63.24324324324323, 26.57670999199196],
          [63.24324324324323, 27.297431537537506],
          [62.88288288288288, 27.297431537537506],
          [62.88288288288288, 28.198333469469432],
          [61.44144144144144, 28.919055015014976],
          [61.44144144144144, 29.459596174174138],
          [61.08108108108107, 29.459596174174138],
          [61.08108108108107, 29.819956946946917],
          [60.72072072072072, 29.819956946946917],
          [61.44144144144144, 29.819956946946917],
          [61.80180180180179, 29.459596174174138],
          [62.88288288288288, 29.459596174174138],
          [63.24324324324323, 29.459596174174138],
          [64.32432432432432, 29.459596174174138],
          [64.32432432432432, 29.639776560560534],
          [65.76576576576576, 29.639776560560534],
          [66.12612612612611, 29.819956946946917],
          [66.12612612612611, 30.54067849249246],
          [66.84684684684683, 31.261400038038005],
          [67.92792792792793, 31.261400038038005],
          [67.92792792792793, 31.801941197197166],
          [68.64864864864865, 31.801941197197166],
          [69.36936936936937, 31.98212158358355],
          [69.36936936936937, 33.06320390190187],
          [70.09009009009009, 33.06320390190187],
          [70.09009009009009, 33.783925447447416],
          [69.72972972972971, 33.9641058338338],
          [71.17117117117115, 33.9641058338338],
          [71.17117117117115, 34.865007765765725],
          [71.53153153153153, 34.865007765765725],
          [71.53153153153153, 35.40554892492489],
          [71.53153153153153, 36.30645085685683],
          [71.89189189189187, 36.30645085685683],
          [71.89189189189187, 36.66681162962959],
          [72.6126126126126, 36.66681162962959],
          [72.6126126126126, 36.846992016015975],
          [73.69369369369369, 36.846992016015975],
          [74.41441441441441, 36.846992016015975],
          [74.41441441441441, 37.02717240240237],
          [74.77477477477476, 37.02717240240237],
          [74.77477477477476, 36.846992016015975],
        ],
        [
          [74.05405405405403, 10.00011444444442],
          [74.05405405405403, 12.522639853853832],
          [71.53153153153153, 12.522639853853832],
          [71.53153153153153, 7.8379498078077745],
          [72.25225225225225, 7.8379498078077745],
          [72.6126126126126, 7.657769421421392],
          [74.05405405405403, 7.657769421421392],
          [74.05405405405403, 10.00011444444442],
        ],
        [
          [70.8108108108108, -8.017924194194222],
          [72.97297297297297, -8.017924194194222],
          [72.97297297297297, -3.8737753073073264],
          [72.97297297297297, -2.9728733753754],
          [72.6126126126126, -2.9728733753754],
          [72.25225225225225, -2.7926929889890175],
          [70.8108108108108, -2.7926929889890175],
          [70.8108108108108, -8.017924194194222],
        ],
      ],
    },
    properties: {
      objectid: 22,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+5',
      map_color6: 1,
      map_color8: 7,
      note: null,
      zone: 5,
      utc_format: 'UTC+05:00',
      time_zone: 'UTC+05:00',
      iso_8601: '2012-05-31T09:33:50+05:00',
      places: 'Maldives, Pakistan',
      dst_places: null,
      tz_name1st: 'Asia/Karachi',
      tz_namesum: 5,
      cartodb_id: 50,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-178.19819819819818, -2.4323322162162384],
          [-178.55855855855856, -2.4323322162162384],
          [-180, -2.4323322162162384],
          [-180, 24.955086514514477],
          [-172.43243243243242, 24.955086514514477],
          [-172.43243243243242, 17.56769067267264],
          [-172.43243243243242, 15.045165263263229],
          [-172.43243243243242, -0.9908891251251504],
          [-172.43243243243242, -2.4323322162162384],
          [-178.19819819819818, -2.4323322162162384],
        ],
      ],
    },
    properties: {
      objectid: 1,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-12',
      map_color6: 1,
      map_color8: 8,
      note: null,
      zone: -12,
      utc_format: 'UTC-12:00',
      time_zone: 'UTC-12:00',
      iso_8601: '2012-05-30T16:33:50-12:00',
      places: 'Pacific Ocean',
      dst_places: null,
      tz_name1st: null,
      tz_namesum: 0,
      cartodb_id: 77,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-157.65765765765767, -76.8468317937938],
          [-157.65765765765767, -88.55855690890891],
          [-157.65765765765767, -89.45945884084084],
          [-157.65765765765767, -90],
          [-172.43243243243242, -90],
          [-172.43243243243242, -78.28827488488488],
          [-172.07207207207207, -78.46845527127127],
          [-166.66666666666666, -78.46845527127127],
          [-166.3063063063063, -78.64863565765766],
          [-163.78378378378378, -78.64863565765766],
          [-159.81981981981983, -78.1080944984985],
          [-159.0990990990991, -77.56755333933934],
          [-159.0990990990991, -77.02701218018018],
          [-157.65765765765767, -76.8468317937938],
        ],
      ],
    },
    properties: {
      objectid: 1,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-11',
      map_color6: 5,
      map_color8: 3,
      note: null,
      zone: -11,
      utc_format: 'UTC-11:00',
      time_zone: 'UTC-11:00',
      iso_8601: '2012-05-30T17:33:50-11:00',
      places: 'Antarctica',
      dst_places: null,
      tz_name1st: 'Antarctica/',
      tz_namesum: 0,
      cartodb_id: 87,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-142.52252252252254, -75.22520831631633],
          [-142.52252252252254, -28.918849015015034],
          [-140, -28.918849015015034],
          [-140, -26.936864764764785],
          [-133.15315315315314, -26.936864764764785],
          [-133.15315315315314, -26.03596283283285],
          [-127.38738738738739, -26.03596283283285],
          [-127.38738738738739, -73.06304367967968],
          [-128.10810810810813, -73.24322406606606],
          [-128.10810810810813, -73.78376522522524],
          [-127.74774774774775, -74.144125997998],
          [-128.82882882882882, -74.144125997998],
          [-129.1891891891892, -74.68466715715716],
          [-130.27027027027026, -74.68466715715716],
          [-130.27027027027026, -74.32430638438439],
          [-131.35135135135135, -73.96394561161162],
          [-132.7927927927928, -73.96394561161162],
          [-133.8738738738739, -74.50448677077077],
          [-134.95495495495496, -74.32430638438439],
          [-137.11711711711712, -74.50448677077077],
          [-137.47747747747746, -74.86484754354355],
          [-139.63963963963965, -74.86484754354355],
          [-140.72072072072072, -75.22520831631633],
          [-142.52252252252254, -75.22520831631633],
        ],
      ],
    },
    properties: {
      objectid: 4,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-9',
      map_color6: 3,
      map_color8: 5,
      note: null,
      zone: -9,
      utc_format: 'UTC-09:00',
      time_zone: 'UTC-09:00',
      iso_8601: '2012-05-30T19:33:50-09:00',
      places: 'Gambier Islands',
      dst_places: null,
      tz_name1st: null,
      tz_namesum: 0,
      cartodb_id: 80,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-27.927927927927925, -75.94592986186187],
          [-26.84684684684686, -75.94592986186187],
          [-25.765765765765764, -75.58556908908909],
          [-25.045045045045043, -75.58556908908909],
          [-25.045045045045043, -77.20719256656658],
          [-27.927927927927925, -77.20719256656658],
          [-27.927927927927925, -75.94592986186187],
        ],
      ],
    },
    properties: {
      objectid: 0,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '0',
      map_color6: 6,
      map_color8: 1,
      note: 'DST is -3',
      zone: 0,
      utc_format: 'UTC+00:00',
      time_zone: 'UTC+00:00',
      iso_8601: '2012-05-30T16:33:50+00:00',
      places: 'Halley Station',
      dst_places: 'Halley Station',
      tz_name1st: null,
      tz_namesum: 0,
      cartodb_id: 116,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-172.43243243243242, -26.03596283283285],
          [-172.43243243243242, -28.0179470830831],
          [-172.43243243243242, -28.738668628628645],
          [-172.43243243243242, -30.900833265265284],
          [-172.43243243243242, -32.34227635635637],
          [-172.43243243243242, -33.243178288288306],
          [-172.43243243243242, -34.14408022022023],
          [-172.43243243243242, -44.954903403403414],
          [-172.7927927927928, -45.315264176176186],
          [-173.51351351351352, -45.85580533533535],
          [-174.23423423423424, -46.57652688088089],
          [-175.3153153153153, -47.11706804004005],
          [-176.03603603603602, -47.65760919919921],
          [-177.11711711711712, -48.73869151751753],
          [-177.47747747747746, -48.91887190390391],
          [-178.19819819819818, -49.639593449449464],
          [-178.55855855855856, -49.819773835835846],
          [-180, -50.90085615415416],
          [-180, -2.4323322162162384],
          [-178.55855855855856, -2.4323322162162384],
          [-178.19819819819818, -2.4323322162162384],
          [-178.19819819819818, -7.657563421421443],
          [-177.47747747747746, -8.378284966966987],
          [-177.47747747747746, -8.738645739739766],
          [-177.11711711711712, -8.918826126126149],
          [-176.75675675675674, -9.45936728528531],
          [-176.03603603603602, -10.180088830830854],
          [-176.03603603603602, -10.54044960360362],
          [-174.95495495495496, -11.621531921921942],
          [-174.59459459459458, -12.162073081081104],
          [-174.23423423423424, -12.522433853853869],
          [-174.23423423423424, -13.783696558558574],
          [-174.59459459459458, -14.144057331331354],
          [-174.59459459459458, -15.04495926326328],
          [-177.11711711711712, -15.04495926326328],
          [-177.11711711711712, -20.450370854854867],
          [-177.47747747747746, -20.810731627627646],
          [-177.47747747747746, -21.351272786786808],
          [-178.19819819819818, -22.071994332332352],
          [-178.19819819819818, -22.612535491491514],
          [-178.55855855855856, -22.97289626426428],
          [-178.55855855855856, -23.51343742342344],
          [-179.27927927927928, -24.234158968968984],
          [-179.27927927927928, -24.774700128128146],
          [-179.63963963963963, -25.135060900900925],
          [-179.63963963963963, -25.49542167367369],
          [-180, -26.03596283283285],
          [-172.43243243243242, -26.03596283283285],
        ],
        [
          [-177.47747747747746, -44.954903403403414],
          [-174.95495495495496, -44.954903403403414],
          [-174.95495495495496, -42.972919153153164],
          [-177.47747747747746, -42.972919153153164],
          [-177.47747747747746, -44.954903403403414],
        ],
      ],
    },
    properties: {
      objectid: 35,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+12',
      map_color6: 6,
      map_color8: 2,
      note: null,
      zone: 12,
      utc_format: 'UTC+12:00',
      time_zone: 'UTC+12:00',
      iso_8601: '2012-05-31T16:33:50+12:00',
      places: 'New Zealand, Kiribati (Gilbert Islands), Fiji',
      dst_places: 'New Zealand',
      tz_name1st: 'Pacific/Auckland',
      tz_namesum: 9,
      cartodb_id: 85,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-142.52252252252254, -75.22520831631633],
          [-142.52252252252254, -90],
          [-157.65765765765767, -90],
          [-157.65765765765767, -89.45945884084084],
          [-157.65765765765767, -88.55855690890891],
          [-157.65765765765767, -76.8468317937938],
          [-151.8918918918919, -76.8468317937938],
          [-151.17117117117118, -76.48647102102103],
          [-149.36936936936937, -75.94592986186187],
          [-146.84684684684686, -75.94592986186187],
          [-146.84684684684686, -75.40538870270271],
          [-143.24324324324323, -75.40538870270271],
          [-142.52252252252254, -75.22520831631633],
        ],
      ],
    },
    properties: {
      objectid: 2,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-10',
      map_color6: 4,
      map_color8: 4,
      note: null,
      zone: -10,
      utc_format: 'UTC-10:00',
      time_zone: 'UTC-10:00',
      iso_8601: '2012-05-30T18:33:50-10:00',
      places: 'Antarctica',
      dst_places: null,
      tz_name1st: 'Antarctica/',
      tz_namesum: 0,
      cartodb_id: 88,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-180, -77.92791411211212],
          [-178.9189189189189, -78.1080944984985],
          [-177.11711711711712, -78.1080944984985],
          [-176.75675675675674, -78.28827488488488],
          [-172.43243243243242, -78.28827488488488],
          [-172.43243243243242, -90],
          [-180, -77.92791411211212],
        ],
      ],
    },
    properties: {
      objectid: 0,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-12',
      map_color6: 1,
      map_color8: 8,
      note: null,
      zone: -12,
      utc_format: 'UTC-12:00',
      time_zone: 'UTC-12:00',
      iso_8601: '2012-05-30T16:33:50-12:00',
      places: 'Antarctica',
      dst_places: null,
      tz_name1st: 'Antarctica/',
      tz_namesum: 0,
      cartodb_id: 89,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-22.522522522522536, -90],
          [-37.657657657657666, -79.72971797597597],
          [-33.69369369369369, -79.72971797597597],
          [-33.69369369369369, -77.02701218018018],
          [-31.891891891891902, -76.66665140740741],
          [-31.17117117117118, -76.66665140740741],
          [-29.369369369369366, -76.12611024824825],
          [-28.2882882882883, -76.12611024824825],
          [-27.927927927927925, -77.20719256656658],
          [-25.045045045045043, -77.20719256656658],
          [-25.045045045045043, -75.58556908908909],
          [-24.684684684684697, -75.58556908908909],
          [-23.243243243243256, -75.58556908908909],
          [-22.522522522522536, -75.40538870270271],
          [-22.522522522522536, -90],
        ],
      ],
    },
    properties: {
      objectid: 13,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-2',
      map_color6: 2,
      map_color8: 7,
      note: null,
      zone: -2,
      utc_format: 'UTC-02:00',
      time_zone: 'UTC-02:00',
      iso_8601: '2012-05-31T02:33:50-02:00',
      places: 'Antarctica',
      dst_places: null,
      tz_name1st: 'Antarctica/',
      tz_namesum: 0,
      cartodb_id: 94,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-97.47747747747748, -71.62160058858859],
          [-97.47747747747748, -90],
          [-112.61261261261262, -90],
          [-112.61261261261262, -74.144125997998],
          [-112.25225225225226, -73.96394561161162],
          [-110.45045045045045, -73.96394561161162],
          [-109.36936936936937, -74.32430638438439],
          [-109.009009009009, -75.04502792992993],
          [-105.76576576576576, -75.04502792992993],
          [-105.4054054054054, -74.86484754354355],
          [-101.44144144144144, -74.86484754354355],
          [-102.16216216216216, -74.50448677077077],
          [-102.16216216216216, -74.144125997998],
          [-103.6036036036036, -73.96394561161162],
          [-103.6036036036036, -73.42340445245246],
          [-105.4054054054054, -73.42340445245246],
          [-105.76576576576576, -72.8828632932933],
          [-102.88288288288288, -72.34232213413414],
          [-102.88288288288288, -71.80178097497497],
          [-101.44144144144144, -71.80178097497497],
          [-100.72072072072072, -71.62160058858859],
          [-97.47747747747748, -71.62160058858859],
        ],
      ],
    },
    properties: {
      objectid: 7,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-7',
      map_color6: 1,
      map_color8: 1,
      note: null,
      zone: -7,
      utc_format: 'UTC-07:00',
      time_zone: 'UTC-07:00',
      iso_8601: '2012-05-30T21:33:50-07:00',
      places: 'Antarctica',
      dst_places: null,
      tz_name1st: 'Antarctica/',
      tz_namesum: 0,
      cartodb_id: 90,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-82.34234234234235, -73.60358483883884],
          [-82.34234234234235, -90],
          [-97.47747747747748, -90],
          [-97.47747747747748, -71.62160058858859],
          [-95.67567567567568, -71.62160058858859],
          [-95.67567567567568, -71.80178097497497],
          [-94.5945945945946, -72.34232213413414],
          [-90.63063063063063, -72.34232213413414],
          [-90.27027027027027, -72.52250252052053],
          [-87.74774774774775, -72.52250252052053],
          [-87.02702702702703, -73.06304367967968],
          [-85.58558558558559, -72.8828632932933],
          [-84.50450450450451, -73.42340445245246],
          [-82.70270270270271, -73.42340445245246],
          [-82.34234234234235, -73.60358483883884],
        ],
      ],
    },
    properties: {
      objectid: 8,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-6',
      map_color6: 6,
      map_color8: 2,
      note: null,
      zone: -6,
      utc_format: 'UTC-06:00',
      time_zone: 'UTC-06:00',
      iso_8601: '2012-05-30T22:33:50-06:00',
      places: 'Antarctica',
      dst_places: null,
      tz_name1st: 'Antarctica/',
      tz_namesum: 0,
      cartodb_id: 91,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-112.61261261261262, -74.144125997998],
          [-112.61261261261262, -90],
          [-127.38738738738739, -90],
          [-127.38738738738739, -73.06304367967968],
          [-125.58558558558559, -73.06304367967968],
          [-124.86486486486487, -73.24322406606606],
          [-124.50450450450451, -73.60358483883884],
          [-123.42342342342343, -73.42340445245246],
          [-121.98198198198199, -73.60358483883884],
          [-118.37837837837839, -73.60358483883884],
          [-118.37837837837839, -73.78376522522524],
          [-114.77477477477478, -73.78376522522524],
          [-113.6936936936937, -73.60358483883884],
          [-112.97297297297298, -73.78376522522524],
          [-112.61261261261262, -74.144125997998],
        ],
      ],
    },
    properties: {
      objectid: 6,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-8',
      map_color6: 2,
      map_color8: 7,
      note: null,
      zone: -8,
      utc_format: 'UTC-08:00',
      time_zone: 'UTC-08:00',
      iso_8601: '2012-05-30T20:33:50-08:00',
      places: 'Antarctica',
      dst_places: null,
      tz_name1st: 'Antarctica/',
      tz_namesum: 0,
      cartodb_id: 96,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'MultiPolygon',
      coordinates: [
        [
          [
            [-68.2882882882883, -66.57654976976977],
            [-67.56756756756758, -66.39636938338339],
            [-67.56756756756758, -66.03600861061062],
            [-67.56756756756758, -66.57654976976977],
            [-68.2882882882883, -66.57654976976977],
          ],
        ],
        [
          [
            [-67.56756756756758, -68.55853402002003],
            [-67.56756756756758, -90],
            [-82.34234234234235, -90],
            [-82.34234234234235, -73.60358483883884],
            [-81.98198198198199, -73.06304367967968],
            [-81.26126126126127, -73.06304367967968],
            [-80.90090090090091, -72.70268290690692],
            [-79.81981981981983, -72.70268290690692],
            [-78.37837837837839, -73.24322406606606],
            [-76.93693693693695, -73.24322406606606],
            [-76.57657657657658, -72.8828632932933],
            [-75.85585585585586, -72.70268290690692],
            [-75.85585585585586, -71.26123981581583],
            [-76.93693693693695, -71.26123981581583],
            [-77.2972972972973, -70.90087904304305],
            [-76.21621621621622, -70.54051827027027],
            [-76.57657657657658, -69.99997711111112],
            [-75.13513513513514, -69.45943595195196],
            [-73.6936936936937, -69.63961633833834],
            [-73.33333333333334, -69.27925556556556],
            [-72.61261261261262, -69.27925556556556],
            [-72.61261261261262, -68.73871440640642],
            [-71.53153153153154, -68.73871440640642],
            [-71.17117117117118, -68.55853402002003],
            [-70.0900900900901, -68.55853402002003],
            [-69.00900900900902, -69.09907517917918],
            [-67.92792792792794, -69.09907517917918],
            [-67.56756756756758, -68.55853402002003],
          ],
        ],
      ],
    },
    properties: {
      objectid: 9,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-5',
      map_color6: 5,
      map_color8: 3,
      note: null,
      zone: -5,
      utc_format: 'UTC-05:00',
      time_zone: 'UTC-05:00',
      iso_8601: '2012-05-30T23:33:50-05:00',
      places: 'Antarctica',
      dst_places: null,
      tz_name1st: 'Antarctica/',
      tz_namesum: 0,
      cartodb_id: 92,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-9.909909909909913, -70.72069865665667],
          [-9.909909909909913, -71.98196136136137],
          [-7.387387387387406, -71.98196136136137],
          [-7.387387387387406, -90],
          [-22.522522522522536, -90],
          [-22.522522522522536, -75.40538870270271],
          [-21.081081081081095, -75.40538870270271],
          [-20, -75.22520831631633],
          [-18.198198198198213, -74.50448677077077],
          [-18.198198198198213, -74.144125997998],
          [-16.756756756756772, -74.144125997998],
          [-17.477477477477493, -73.60358483883884],
          [-16.03603603603605, -72.8828632932933],
          [-17.117117117117118, -72.8828632932933],
          [-17.117117117117118, -72.34232213413414],
          [-15.675675675675677, -72.34232213413414],
          [-15.315315315315331, -72.52250252052053],
          [-13.513513513513516, -72.52250252052053],
          [-13.513513513513516, -71.80178097497497],
          [-12.792792792792795, -71.08105942942943],
          [-10.990990990991008, -71.08105942942943],
          [-10.630630630630634, -70.72069865665667],
          [-9.909909909909913, -70.72069865665667],
        ],
      ],
    },
    properties: {
      objectid: 14,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-1',
      map_color6: 1,
      map_color8: 8,
      note: null,
      zone: -1,
      utc_format: 'UTC-01:00',
      time_zone: 'UTC-01:00',
      iso_8601: '2012-05-31T03:33:50-01:00',
      places: 'Aboa, Svea, Wasa, Novolazarevskaya Stations',
      dst_places: null,
      tz_name1st: 'Antarctica/Central',
      tz_namesum: 1,
      cartodb_id: 95,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [139.6396396396396, -66.39636938338339],
          [139.6396396396396, -67.65763208808809],
          [142.52252252252248, -67.65763208808809],
          [142.52252252252248, -90],
          [127.38738738738738, -90],
          [127.38738738738738, -66.75673015615617],
          [127.74774774774772, -66.93691054254255],
          [128.82882882882882, -66.93691054254255],
          [129.18918918918916, -66.39636938338339],
          [129.9099099099099, -66.03600861061062],
          [133.15315315315314, -66.03600861061062],
          [133.5135135135135, -65.85582822422423],
          [134.23423423423424, -66.03600861061062],
          [136.03603603603602, -66.03600861061062],
          [136.39639639639637, -66.216188996997],
          [137.8378378378378, -66.216188996997],
          [138.19819819819816, -66.39636938338339],
          [139.6396396396396, -66.39636938338339],
        ],
      ],
    },
    properties: {
      objectid: 29,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+9',
      map_color6: 3,
      map_color8: 3,
      note: null,
      zone: 9,
      utc_format: 'UTC+09:00',
      time_zone: 'UTC+09:00',
      iso_8601: '2012-05-31T13:33:50+09:00',
      places: 'Antarctica',
      dst_places: null,
      tz_name1st: 'Antarctica/',
      tz_namesum: 0,
      cartodb_id: 101,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [157.65765765765764, -69.09907517917918],
          [157.65765765765764, -90],
          [142.52252252252248, -90],
          [142.52252252252248, -67.65763208808809],
          [139.6396396396396, -67.65763208808809],
          [139.6396396396396, -66.39636938338339],
          [140, -66.57654976976977],
          [142.16216216216213, -66.57654976976977],
          [142.52252252252248, -66.75673015615617],
          [143.96396396396398, -66.75673015615617],
          [145.04504504504501, -66.93691054254255],
          [145.04504504504501, -67.29727131531533],
          [146.48648648648646, -67.47745170170171],
          [147.56756756756755, -68.01799286086087],
          [147.56756756756755, -68.19817324724725],
          [151.53153153153153, -68.19817324724725],
          [151.53153153153153, -68.55853402002003],
          [153.33333333333331, -68.55853402002003],
          [153.33333333333331, -68.19817324724725],
          [154.4144144144144, -68.19817324724725],
          [155.4954954954955, -68.73871440640642],
          [156.2162162162162, -68.9188947927928],
          [157.2972972972973, -68.9188947927928],
          [157.65765765765764, -69.09907517917918],
        ],
      ],
    },
    properties: {
      objectid: 31,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+10',
      map_color6: 2,
      map_color8: 5,
      note: null,
      zone: 10,
      utc_format: 'UTC+10:00',
      time_zone: 'UTC+10:00',
      iso_8601: '2012-05-31T14:33:50+10:00',
      places: "Dumont d'Urville Station",
      dst_places: null,
      tz_name1st: 'Antarctica/DumontDUrville',
      tz_namesum: 1,
      cartodb_id: 97,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [166.30630630630628, -73.96394561161162],
          [166.30630630630628, -73.24322406606606],
          [161.98198198198196, -73.24322406606606],
          [161.98198198198196, -73.78376522522524],
          [161.98198198198196, -79.90989836236237],
          [172.4324324324324, -79.90989836236237],
          [172.4324324324324, -84.59458840840841],
          [172.4324324324324, -90],
          [157.65765765765764, -90],
          [157.65765765765764, -69.09907517917918],
          [159.09909909909908, -69.09907517917918],
          [160.90090090090087, -69.63961633833834],
          [160.90090090090087, -69.99997711111112],
          [161.98198198198196, -69.99997711111112],
          [162.3423423423423, -70.1801574974975],
          [164.14414414414415, -70.1801574974975],
          [164.14414414414415, -70.36033788388389],
          [166.66666666666663, -70.36033788388389],
          [169.18918918918916, -71.08105942942943],
          [170.6306306306306, -71.08105942942943],
          [171.35135135135135, -71.98196136136137],
          [170.99099099099095, -72.16214174774775],
          [170.99099099099095, -72.70268290690692],
          [170.27027027027026, -73.06304367967968],
          [170.6306306306306, -73.42340445245246],
          [170.27027027027026, -73.78376522522524],
          [169.18918918918916, -73.78376522522524],
          [168.46846846846847, -73.42340445245246],
          [166.30630630630628, -73.96394561161162],
        ],
      ],
    },
    properties: {
      objectid: 33,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+11',
      map_color6: 1,
      map_color8: 6,
      note: null,
      zone: 11,
      utc_format: 'UTC+11:00',
      time_zone: 'UTC+11:00',
      iso_8601: '2012-05-31T15:33:50+11:00',
      places: 'Antarctica',
      dst_places: null,
      tz_name1st: 'Antarctica/',
      tz_namesum: 0,
      cartodb_id: 98,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [62.16216216216216, -67.29727131531533],
          [62.16216216216216, -69.45943595195196],
          [67.56756756756755, -69.45943595195196],
          [67.56756756756755, -90],
          [52.43243243243242, -90],
          [52.43243243243242, -65.85582822422423],
          [52.792792792792795, -65.67564783783784],
          [55.3153153153153, -65.67564783783784],
          [56.03603603603602, -65.85582822422423],
          [56.3963963963964, -66.216188996997],
          [57.11711711711712, -66.216188996997],
          [57.83783783783784, -66.39636938338339],
          [58.198198198198185, -66.93691054254255],
          [59.27927927927928, -66.93691054254255],
          [59.639639639639626, -67.11709092892893],
          [60.72072072072072, -67.11709092892893],
          [61.08108108108107, -67.29727131531533],
          [62.16216216216216, -67.29727131531533],
        ],
      ],
    },
    properties: {
      objectid: 20,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+4',
      map_color6: 2,
      map_color8: 5,
      note: null,
      zone: 4,
      utc_format: 'UTC+04:00',
      time_zone: 'UTC+04:00',
      iso_8601: '2012-05-31T08:33:50+04:00',
      places: 'Antarctica',
      dst_places: null,
      tz_name1st: 'Antarctica/',
      tz_namesum: 0,
      cartodb_id: 99,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [37.65765765765764, -69.45943595195196],
          [37.65765765765764, -90],
          [22.522522522522507, -90],
          [22.522522522522507, -88.55855690890891],
          [22.522522522522507, -87.65765497697697],
          [22.522522522522507, -87.2972942042042],
          [22.522522522522507, -86.21621188588588],
          [22.522522522522507, -70.1801574974975],
          [24.68468468468467, -70.1801574974975],
          [26.12612612612611, -69.81979672472474],
          [26.84684684684683, -69.81979672472474],
          [27.56756756756755, -70.1801574974975],
          [27.56756756756755, -70.54051827027027],
          [29.00900900900899, -70.1801574974975],
          [30.090090090090087, -69.99997711111112],
          [31.891891891891873, -69.99997711111112],
          [32.25225225225225, -69.81979672472474],
          [32.25225225225225, -69.27925556556556],
          [31.891891891891873, -68.73871440640642],
          [33.333333333333314, -68.37835363363364],
          [34.774774774774755, -68.55853402002003],
          [34.774774774774755, -68.9188947927928],
          [35.85585585585585, -69.09907517917918],
          [35.85585585585585, -69.45943595195196],
          [37.65765765765764, -69.45943595195196],
        ],
      ],
    },
    properties: {
      objectid: 17,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+2',
      map_color6: 4,
      map_color8: 3,
      note: null,
      zone: 2,
      utc_format: 'UTC+02:00',
      time_zone: 'UTC+02:00',
      iso_8601: '2012-05-31T06:33:50+02:00',
      places: 'Antarctica',
      dst_places: null,
      tz_name1st: 'Antarctica/',
      tz_namesum: 0,
      cartodb_id: 102,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [112.61261261261262, -65.67564783783784],
          [113.69369369369366, -65.67564783783784],
          [114.77477477477476, -66.216188996997],
          [115.85585585585585, -66.39636938338339],
          [117.29729729729729, -66.93691054254255],
          [119.81981981981983, -66.93691054254255],
          [120.90090090090087, -66.57654976976977],
          [121.62162162162161, -66.75673015615617],
          [122.3423423423423, -66.57654976976977],
          [123.4234234234234, -66.57654976976977],
          [123.78378378378375, -66.39636938338339],
          [125.22522522522519, -66.39636938338339],
          [125.22522522522519, -66.216188996997],
          [127.02702702702703, -66.216188996997],
          [127.38738738738738, -66.75673015615617],
          [127.38738738738738, -90],
          [112.61261261261262, -90],
          [112.61261261261262, -67.29727131531533],
          [111.53153153153153, -67.29727131531533],
          [110.45045045045043, -67.29727131531533],
          [110.09009009009009, -67.29727131531533],
          [110.09009009009009, -66.57654976976977],
          [110.09009009009009, -66.216188996997],
          [110.81081081081078, -65.85582822422423],
          [111.89189189189187, -65.85582822422423],
          [112.61261261261262, -65.67564783783784],
        ],
        [
          [125.58558558558559, -75.94592986186187],
          [125.58558558558559, -73.78376522522524],
          [121.62162162162161, -73.78376522522524],
          [121.62162162162161, -75.94592986186187],
          [125.58558558558559, -75.94592986186187],
        ],
      ],
    },
    properties: {
      objectid: 28,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+8',
      map_color6: 4,
      map_color8: 2,
      note: null,
      zone: 8,
      utc_format: 'UTC+08:00',
      time_zone: 'UTC+08:00',
      iso_8601: '2012-05-31T12:33:50+08:00',
      places: 'Casety Station',
      dst_places: null,
      tz_name1st: 'Antarctica/Casey',
      tz_namesum: 1,
      cartodb_id: 100,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [77.29729729729729, -68.9188947927928],
          [77.29729729729729, -69.27925556556556],
          [79.09909909909908, -69.27925556556556],
          [79.09909909909908, -68.01799286086087],
          [80.54054054054052, -67.65763208808809],
          [82.3423423423423, -67.47745170170171],
          [82.3423423423423, -90],
          [67.56756756756755, -90],
          [67.56756756756755, -69.45943595195196],
          [62.16216216216216, -69.45943595195196],
          [62.16216216216216, -67.29727131531533],
          [64.32432432432432, -67.29727131531533],
          [64.68468468468467, -67.47745170170171],
          [66.12612612612611, -67.47745170170171],
          [66.48648648648648, -67.65763208808809],
          [67.56756756756755, -67.65763208808809],
          [70.09009009009009, -67.65763208808809],
          [70.09009009009009, -68.19817324724725],
          [70.8108108108108, -68.37835363363364],
          [71.17117117117115, -68.73871440640642],
          [72.97297297297297, -68.73871440640642],
          [74.41441441441441, -69.45943595195196],
          [75.13513513513513, -69.63961633833834],
          [75.85585585585585, -69.27925556556556],
          [77.29729729729729, -68.9188947927928],
        ],
      ],
    },
    properties: {
      objectid: 22,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+5',
      map_color6: 1,
      map_color8: 7,
      note: null,
      zone: 5,
      utc_format: 'UTC+05:00',
      time_zone: 'UTC+05:00',
      iso_8601: '2012-05-31T09:33:50+05:00',
      places: 'Mawson Station, Zhongshan Station',
      dst_places: null,
      tz_name1st: 'Antarctica/Mawson',
      tz_namesum: 1,
      cartodb_id: 103,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [97.47747747747746, -66.216188996997],
          [97.47747747747746, -90],
          [82.3423423423423, -90],
          [82.3423423423423, -67.47745170170171],
          [84.5045045045045, -66.75673015615617],
          [84.86486486486484, -66.39636938338339],
          [85.58558558558559, -66.57654976976977],
          [90.6306306306306, -66.57654976976977],
          [90.99099099099095, -66.39636938338339],
          [96.03603603603602, -66.39636938338339],
          [96.03603603603602, -65.85582822422423],
          [97.11711711711712, -65.85582822422423],
          [97.47747747747746, -66.216188996997],
        ],
      ],
    },
    properties: {
      objectid: 25,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+6',
      map_color6: 6,
      map_color8: 8,
      note: null,
      zone: 6,
      utc_format: 'UTC+06:00',
      time_zone: 'UTC+06:00',
      iso_8601: '2012-05-31T10:33:50+06:00',
      places: 'Mirny Station',
      dst_places: null,
      tz_name1st: 'Antarctica/Mirny',
      tz_namesum: 1,
      cartodb_id: 104,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [110.09009009009009, -66.57654976976977],
          [110.09009009009009, -67.29727131531533],
          [110.45045045045043, -67.29727131531533],
          [111.53153153153153, -67.29727131531533],
          [112.61261261261262, -67.29727131531533],
          [112.61261261261262, -90],
          [97.47747747747746, -90],
          [97.47747747747746, -66.216188996997],
          [99.27927927927925, -66.216188996997],
          [100, -65.85582822422423],
          [100, -65.31528706506506],
          [101.0810810810811, -65.13510667867868],
          [101.80180180180179, -65.49546745145146],
          [102.52252252252254, -65.31528706506506],
          [102.52252252252254, -64.9549262922923],
          [103.24324324324323, -64.9549262922923],
          [103.96396396396398, -65.49546745145146],
          [103.24324324324323, -65.85582822422423],
          [104.68468468468467, -65.85582822422423],
          [105.76576576576576, -66.03600861061062],
          [107.2072072072072, -66.39636938338339],
          [108.2882882882883, -66.39636938338339],
          [109.00900900900899, -66.75673015615617],
          [110.09009009009009, -66.57654976976977],
        ],
        [
          [105.04504504504501, -77.38737295295296],
          [105.04504504504501, -79.54953758958959],
          [108.64864864864865, -79.54953758958959],
          [108.64864864864865, -77.38737295295296],
          [105.04504504504501, -77.38737295295296],
        ],
      ],
    },
    properties: {
      objectid: 27,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+7',
      map_color6: 5,
      map_color8: 1,
      note: null,
      zone: 7,
      utc_format: 'UTC+07:00',
      time_zone: 'UTC+07:00',
      iso_8601: '2012-05-31T11:33:50+07:00',
      places: 'Antarctica',
      dst_places: null,
      tz_name1st: 'Antarctica/',
      tz_namesum: 0,
      cartodb_id: 105,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [12.792792792792795, -69.81979672472474],
          [12.792792792792795, -71.80178097497497],
          [7.387387387387378, -71.80178097497497],
          [7.387387387387378, -90],
          [-7.387387387387406, -90],
          [-7.387387387387406, -71.98196136136137],
          [-7.387387387387406, -70.54051827027027],
          [-6.666666666666686, -70.1801574974975],
          [-5.585585585585591, -70.36033788388389],
          [-4.86486486486487, -70.72069865665667],
          [-5.225225225225245, -71.08105942942943],
          [-4.14414414414415, -71.08105942942943],
          [-4.14414414414415, -70.36033788388389],
          [-2.702702702702709, -69.99997711111112],
          [-1.9819819819819884, -70.1801574974975],
          [-1.9819819819819884, -70.54051827027027],
          [-0.18018018018020143, -71.26123981581583],
          [0.540540540540519, -70.90087904304305],
          [1.621621621621614, -70.90087904304305],
          [0.180180180180173, -70.1801574974975],
          [0.540540540540519, -69.81979672472474],
          [1.98198198198196, -69.81979672472474],
          [1.98198198198196, -70.36033788388389],
          [3.7837837837837753, -69.99997711111112],
          [7.387387387387378, -69.99997711111112],
          [8.828828828828819, -69.99997711111112],
          [8.828828828828819, -69.81979672472474],
          [12.792792792792795, -69.81979672472474],
        ],
      ],
    },
    properties: {
      objectid: 15,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '0',
      map_color6: 6,
      map_color8: 1,
      note: null,
      zone: 0,
      utc_format: 'UTC+00:00',
      time_zone: 'UTC+00:00',
      iso_8601: '2012-05-31T09:03:50+00:00',
      places: 'Troll Station, Maitri Station',
      dst_places: null,
      tz_name1st: 'Antarctica/Troll',
      tz_namesum: 1,
      cartodb_id: 106,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [22.522522522522507, -70.1801574974975],
          [22.522522522522507, -86.21621188588588],
          [22.522522522522507, -87.2972942042042],
          [22.522522522522507, -87.65765497697697],
          [22.522522522522507, -88.55855690890891],
          [22.522522522522507, -90],
          [7.387387387387378, -90],
          [7.387387387387378, -71.80178097497497],
          [12.792792792792795, -71.80178097497497],
          [12.792792792792795, -69.81979672472474],
          [13.513513513513516, -69.99997711111112],
          [14.594594594594582, -69.99997711111112],
          [14.954954954954957, -69.63961633833834],
          [15.675675675675677, -69.45943595195196],
          [16.756756756756744, -69.45943595195196],
          [17.117117117117118, -69.63961633833834],
          [17.117117117117118, -70.1801574974975],
          [18.198198198198185, -69.99997711111112],
          [19.639639639639626, -69.99997711111112],
          [20.360360360360346, -70.72069865665667],
          [21.44144144144144, -69.99997711111112],
          [22.522522522522507, -70.1801574974975],
        ],
      ],
    },
    properties: {
      objectid: 16,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+1',
      map_color6: 5,
      map_color8: 2,
      note: null,
      zone: 1,
      utc_format: 'UTC+01:00',
      time_zone: 'UTC+01:00',
      iso_8601: '2012-05-31T05:33:50+01:00',
      places: 'Antarctica',
      dst_places: null,
      tz_name1st: 'Antarctica/',
      tz_namesum: 0,
      cartodb_id: 107,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-127.38738738738739, -73.06304367967968],
          [-127.38738738738739, -90],
          [-142.52252252252254, -90],
          [-142.52252252252254, -75.22520831631633],
          [-140.72072072072072, -75.22520831631633],
          [-139.63963963963965, -74.86484754354355],
          [-137.47747747747746, -74.86484754354355],
          [-137.11711711711712, -74.50448677077077],
          [-134.95495495495496, -74.32430638438439],
          [-133.8738738738739, -74.50448677077077],
          [-132.7927927927928, -73.96394561161162],
          [-131.35135135135135, -73.96394561161162],
          [-130.27027027027026, -74.32430638438439],
          [-130.27027027027026, -74.68466715715716],
          [-129.1891891891892, -74.68466715715716],
          [-128.82882882882882, -74.144125997998],
          [-127.74774774774775, -74.144125997998],
          [-128.10810810810813, -73.78376522522524],
          [-128.10810810810813, -73.24322406606606],
          [-127.38738738738739, -73.06304367967968],
        ],
      ],
    },
    properties: {
      objectid: 4,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-9',
      map_color6: 3,
      map_color8: 5,
      note: null,
      zone: -9,
      utc_format: 'UTC-09:00',
      time_zone: 'UTC-09:00',
      iso_8601: '2012-05-30T19:33:50-09:00',
      places: 'Antarctica',
      dst_places: null,
      tz_name1st: 'Antarctica/',
      tz_namesum: 0,
      cartodb_id: 108,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [52.43243243243242, -90],
          [37.65765765765764, -90],
          [37.65765765765764, -69.45943595195196],
          [39.09909909909908, -69.45943595195196],
          [39.09909909909908, -68.9188947927928],
          [39.8198198198198, -68.55853402002003],
          [41.26126126126124, -68.37835363363364],
          [41.98198198198196, -68.01799286086087],
          [42.70270270270268, -67.83781247447448],
          [44.14414414414412, -67.83781247447448],
          [44.86486486486484, -67.47745170170171],
          [45.58558558558556, -67.47745170170171],
          [45.94594594594594, -67.11709092892893],
          [47.38738738738738, -67.11709092892893],
          [47.747747747747724, -66.57654976976977],
          [49.54954954954954, -66.57654976976977],
          [50.27027027027026, -66.216188996997],
          [51.351351351351354, -65.85582822422423],
          [52.43243243243242, -65.85582822422423],
          [52.43243243243242, -90],
        ],
      ],
    },
    properties: {
      objectid: 18,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+3',
      map_color6: 3,
      map_color8: 4,
      note: null,
      zone: 3,
      utc_format: 'UTC+03:00',
      time_zone: 'UTC+03:00',
      iso_8601: '2012-05-31T07:33:50+03:00',
      places: 'Antarctica',
      dst_places: null,
      tz_name1st: 'Antarctica/',
      tz_namesum: 0,
      cartodb_id: 109,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-37.657657657657666, -78.1080944984985],
          [-36.936936936936945, -78.1080944984985],
          [-35.495495495495504, -77.38737295295296],
          [-33.69369369369369, -77.02701218018018],
          [-33.69369369369369, -79.72971797597597],
          [-37.657657657657666, -79.72971797597597],
          [-37.657657657657666, -90],
          [-52.432432432432435, -90],
          [-52.432432432432435, -77.02701218018018],
          [-50.27027027027029, -77.56755333933934],
          [-45.225225225225245, -77.56755333933934],
          [-43.06306306306308, -78.1080944984985],
          [-37.657657657657666, -78.1080944984985],
        ],
      ],
    },
    properties: {
      objectid: 12,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '-3',
      map_color6: 3,
      map_color8: 6,
      note: null,
      zone: -3,
      utc_format: 'UTC-03:00',
      time_zone: 'UTC-03:00',
      iso_8601: '2012-05-31T01:33:50-03:00',
      places: 'General Belgrano, Doctor Sobral Stations',
      dst_places: null,
      tz_name1st: 'Antarctica/',
      tz_namesum: 23,
      cartodb_id: 110,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [172.4324324324324, -77.56755333933934],
          [174.59459459459458, -77.74773372572572],
          [178.9189189189189, -77.74773372572572],
          [180, -77.92791411211212],
          [180, -84.7747687947948],
          [180, -90],
          [172.4324324324324, -90],
          [172.4324324324324, -84.59458840840841],
          [172.4324324324324, -79.90989836236237],
          [161.98198198198196, -79.90989836236237],
          [161.98198198198196, -73.78376522522524],
          [161.98198198198196, -73.24322406606606],
          [166.30630630630628, -73.24322406606606],
          [166.30630630630628, -73.96394561161162],
          [165.94594594594594, -73.96394561161162],
          [165.94594594594594, -74.86484754354355],
          [164.5045045045045, -74.86484754354355],
          [163.4234234234234, -75.04502792992993],
          [163.78378378378375, -75.58556908908909],
          [163.4234234234234, -75.94592986186187],
          [163.78378378378375, -76.30629063463464],
          [163.78378378378375, -77.02701218018018],
          [165.5855855855856, -77.38737295295296],
          [165.94594594594594, -76.8468317937938],
          [167.74774774774772, -76.8468317937938],
          [167.74774774774772, -77.20719256656658],
          [169.5495495495495, -77.20719256656658],
          [170.27027027027026, -77.56755333933934],
          [172.4324324324324, -77.56755333933934],
        ],
      ],
    },
    properties: {
      objectid: 35,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+12',
      map_color6: 6,
      map_color8: 2,
      note: null,
      zone: 12,
      utc_format: 'UTC+12:00',
      time_zone: 'UTC+12:00',
      iso_8601: '2012-05-31T16:33:50+12:00',
      places: 'McMurdo Station, Scott Base, Zucchelli Station',
      dst_places: 'McMurdo Station, Scott Base, Zucchelli Station',
      tz_name1st: 'Antarctica/South_Pole',
      tz_namesum: 1,
      cartodb_id: 111,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [105.04504504504501, -77.38737295295296],
          [108.64864864864865, -77.38737295295296],
          [108.64864864864865, -79.54953758958959],
          [105.04504504504501, -79.54953758958959],
          [105.04504504504501, -77.38737295295296],
        ],
      ],
    },
    properties: {
      objectid: 0,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+6',
      map_color6: 6,
      map_color8: 8,
      note: null,
      zone: 6,
      utc_format: 'UTC+06:00',
      time_zone: 'UTC+06:00',
      iso_8601: '2012-05-30T16:33:50+06:00',
      places: 'Vostok Station',
      dst_places: null,
      tz_name1st: null,
      tz_namesum: 0,
      cartodb_id: 113,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [77.29729729729729, -68.9188947927928],
          [78.01801801801798, -68.55853402002003],
          [78.01801801801798, -68.19817324724725],
          [79.09909909909908, -68.01799286086087],
          [79.09909909909908, -69.27925556556556],
          [77.29729729729729, -69.27925556556556],
          [77.29729729729729, -68.9188947927928],
        ],
      ],
    },
    properties: {
      objectid: 0,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+7',
      map_color6: 5,
      map_color8: 1,
      note: null,
      zone: 7,
      utc_format: 'UTC+07:00',
      time_zone: 'UTC+07:00',
      iso_8601: '2012-05-30T16:33:50+07:00',
      places: 'Davis Station',
      dst_places: null,
      tz_name1st: null,
      tz_namesum: 0,
      cartodb_id: 114,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-9.909909909909913, -70.72069865665667],
          [-8.828828828828847, -71.08105942942943],
          [-7.387387387387406, -70.54051827027027],
          [-7.387387387387406, -71.98196136136137],
          [-9.909909909909913, -71.98196136136137],
          [-9.909909909909913, -70.72069865665667],
        ],
      ],
    },
    properties: {
      objectid: 0,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+1',
      map_color6: 5,
      map_color8: 2,
      note: null,
      zone: 6,
      utc_format: 'UTC+06:00',
      time_zone: 'UTC+06:00',
      iso_8601: 'ccccc',
      places: 'Neumayer Station',
      dst_places: null,
      tz_name1st: null,
      tz_namesum: 0,
      cartodb_id: 115,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-172.43243243243242, 70.54072427027023],
          [-171.7117117117117, 70.00018311111106],
          [-170.99099099099098, 69.45964195195191],
          [-170.63063063063063, 69.09928117917914],
          [-169.54954954954954, 68.55874002001997],
          [-169.54954954954954, 68.1983792472472],
          [-168.82882882882882, 68.01819886086082],
          [-168.82882882882882, 65.49567345145141],
          [-169.54954954954954, 65.31549306506503],
          [-170.63063063063063, 64.77495190590585],
          [-170.99099099099098, 64.41459113313309],
          [-171.7117117117117, 64.05423036036032],
          [-172.43243243243242, 63.69386958758756],
          [-173.15315315315314, 63.513689201201146],
          [-173.51351351351352, 63.15332842842838],
          [-174.59459459459458, 62.61278726926923],
          [-174.59459459459458, 62.43260688288285],
          [-175.3153153153153, 62.07224611011006],
          [-176.03603603603602, 61.892065723723675],
          [-176.75675675675674, 61.53170495095091],
          [-177.11711711711712, 61.35152456456453],
          [-177.47747747747746, 60.99116379179176],
          [-178.9189189189189, 60.270442246246205],
          [-179.27927927927928, 59.91008147347344],
          [-179.63963963963963, 59.72990108708706],
          [-180, 59.54972070070065],
          [-180, 75.04523392992988],
          [-178.19819819819818, 74.14433199799797],
          [-178.19819819819818, 73.96415161161156],
          [-176.3963963963964, 73.06324967967964],
          [-176.3963963963964, 72.88306929329326],
          [-174.95495495495496, 72.1623477477477],
          [-174.95495495495496, 71.98216736136132],
          [-173.51351351351352, 71.26144581581576],
          [-173.51351351351352, 71.08126542942938],
          [-172.43243243243242, 70.54072427027023],
        ],
      ],
    },
    properties: {
      objectid: 0,
      scalerank: 6,
      featurecla: 'Timezone',
      name: '+12',
      map_color6: 6,
      map_color8: 2,
      note: 'Reflects 2012 shift in daylight savings time in Russia.',
      zone: 12,
      utc_format: 'UTC-12:00',
      time_zone: 'UTC-12:00',
      iso_8601: '2012-05-30T16:33:50+12:00',
      places: 'Russia (Kamchatka Krai)',
      dst_places: null,
      tz_name1st: 'Asia/Kamchatka',
      tz_namesum: 3,
      cartodb_id: 120,
      created_at: '2014-10-19T10:00:54Z',
      updated_at: '2014-10-19T10:00:54Z',
    },
  },
]
/* eslint-enable @typescript-eslint/no-loss-of-precision */
